var e, t = function (e) {
    var t = "function" == typeof Symbol && Symbol.iterator, n = t && e[t], r = 0;
    if (n) return n.call(e);
    if (e && "number" == typeof e.length) return {
        next: function () {
            return e && r >= e.length && (e = void 0), {value: e && e[r++], done: !e}
        }
    };
    throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.")
}, n = function (e, t) {
    var n = "function" == typeof Symbol && e[Symbol.iterator];
    if (!n) return e;
    var r, i, o = n.call(e), s = [];
    try {
        for (; (void 0 === t || t-- > 0) && !(r = o.next()).done;) s.push(r.value)
    } catch (e) {
        i = {error: e}
    } finally {
        try {
            r && !r.done && (n = o.return) && n.call(o)
        } finally {
            if (i) throw i.error
        }
    }
    return s
}, r = function () {
    for (var e = [], t = 0; t < arguments.length; t++) e = e.concat(n(arguments[t]));
    return e
}, i = {VERBOSE: 1, DEBUG: 2, INFO: 3, WARN: 4, ERROR: 5};
!function (e) {
    e.DEBUG = "DEBUG", e.ERROR = "ERROR", e.INFO = "INFO", e.WARN = "WARN", e.VERBOSE = "VERBOSE"
}(e || (e = {}));
var o = function () {
    function n(t, n) {
        void 0 === n && (n = e.WARN), this.name = t, this.level = n, this._pluggables = []
    }

    return n.prototype._padding = function (e) {
        return e < 10 ? "0" + e : "" + e
    }, n.prototype._ts = function () {
        var e = new Date;
        return [this._padding(e.getMinutes()), this._padding(e.getSeconds())].join(":") + "." + e.getMilliseconds()
    }, n.prototype.configure = function (e) {
        return e ? (this._config = e, this._config) : this._config
    }, n.prototype._log = function (r) {
        for (var o, s, a = [], u = 1; u < arguments.length; u++) a[u - 1] = arguments[u];
        var c = this.level;
        n.LOG_LEVEL && (c = n.LOG_LEVEL), "undefined" != typeof window && window.LOG_LEVEL && (c = window.LOG_LEVEL);
        var l = i[c], f = i[r];
        if (f >= l) {
            var d = console.log.bind(console);
            r === e.ERROR && console.error && (d = console.error.bind(console)), r === e.WARN && console.warn && (d = console.warn.bind(console));
            var h = "[" + r + "] " + this._ts() + " " + this.name, p = "";
            if (1 === a.length && "string" == typeof a[0]) d(p = h + " - " + a[0]); else if (1 === a.length) p = h + " " + a[0], d(h, a[0]); else if ("string" == typeof a[0]) {
                var g = a.slice(1);
                1 === g.length && (g = g[0]), p = h + " - " + a[0] + " " + g, d(h + " - " + a[0], g)
            } else p = h + " " + a, d(h, a);
            try {
                for (var v = t(this._pluggables), m = v.next(); !m.done; m = v.next()) {
                    var y = m.value, S = {message: p, timestamp: Date.now()};
                    y.pushLogs([S])
                }
            } catch (e) {
                o = {error: e}
            } finally {
                try {
                    m && !m.done && (s = v.return) && s.call(v)
                } finally {
                    if (o) throw o.error
                }
            }
        }
    }, n.prototype.log = function () {
        for (var t = [], n = 0; n < arguments.length; n++) t[n] = arguments[n];
        this._log.apply(this, r([e.INFO], t))
    }, n.prototype.info = function () {
        for (var t = [], n = 0; n < arguments.length; n++) t[n] = arguments[n];
        this._log.apply(this, r([e.INFO], t))
    }, n.prototype.warn = function () {
        for (var t = [], n = 0; n < arguments.length; n++) t[n] = arguments[n];
        this._log.apply(this, r([e.WARN], t))
    }, n.prototype.error = function () {
        for (var t = [], n = 0; n < arguments.length; n++) t[n] = arguments[n];
        this._log.apply(this, r([e.ERROR], t))
    }, n.prototype.debug = function () {
        for (var t = [], n = 0; n < arguments.length; n++) t[n] = arguments[n];
        this._log.apply(this, r([e.DEBUG], t))
    }, n.prototype.verbose = function () {
        for (var t = [], n = 0; n < arguments.length; n++) t[n] = arguments[n];
        this._log.apply(this, r([e.VERBOSE], t))
    }, n.prototype.addPluggable = function (e) {
        e && "Logging" === e.getCategoryName() && (this._pluggables.push(e), e.configure(this._config))
    }, n.prototype.listPluggables = function () {
        return this._pluggables
    }, n.LOG_LEVEL = null, n
}(), s = function (e, t) {
    var n = "function" == typeof Symbol && e[Symbol.iterator];
    if (!n) return e;
    var r, i, o = n.call(e), s = [];
    try {
        for (; (void 0 === t || t-- > 0) && !(r = o.next()).done;) s.push(r.value)
    } catch (e) {
        i = {error: e}
    } finally {
        try {
            r && !r.done && (n = o.return) && n.call(o)
        } finally {
            if (i) throw i.error
        }
    }
    return s
}, a = new o("Amplify"), u = new (function () {
    function e() {
        this._components = [], this._config = {}, this._modules = {}, this.Auth = null, this.Analytics = null, this.API = null, this.Credentials = null, this.Storage = null, this.I18n = null, this.Cache = null, this.PubSub = null, this.Interactions = null, this.Pushnotification = null, this.UI = null, this.XR = null, this.Predictions = null, this.DataStore = null, this.Geo = null, this.Logger = o, this.ServiceWorker = null
    }

    return e.prototype.register = function (e) {
        a.debug("component registered in amplify", e), this._components.push(e), "function" == typeof e.getModuleName ? (this._modules[e.getModuleName()] = e, this[e.getModuleName()] = e) : a.debug("no getModuleName method for component", e), e.configure(this._config)
    }, e.prototype.configure = function (e) {
        var t = this;
        return e ? (this._config = Object.assign(this._config, e), a.debug("amplify config", this._config), Object.entries(this._modules).forEach((function (e) {
            var n = s(e, 2);
            n[0];
            var r = n[1];
            Object.keys(r).forEach((function (e) {
                t._modules[e] && (r[e] = t._modules[e])
            }))
        })), this._components.map((function (e) {
            e.configure(t._config)
        })), this._config) : this._config
    }, e.prototype.addPluggable = function (e) {
        e && e.getCategory && "function" == typeof e.getCategory && this._components.map((function (t) {
            t.addPluggable && "function" == typeof t.addPluggable && t.addPluggable(e)
        }))
    }, e
}()), c = {userAgent: "aws-amplify/4.3.11 js", product: "", navigator: null, isReactNative: !1};
if ("undefined" != typeof navigator && navigator.product) if (c.product = navigator.product || "", c.navigator = navigator || null, "ReactNative" === navigator.product) c.userAgent = "aws-amplify/4.3.11 react-native", c.isReactNative = !0; else c.userAgent = "aws-amplify/4.3.11 js", c.isReactNative = !1;
var l = function () {
        return c.userAgent
    }, f = function () {
        return f = Object.assign || function (e) {
            for (var t, n = 1, r = arguments.length; n < r; n++) for (var i in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
            return e
        }, f.apply(this, arguments)
    }, d = function (e, t) {
        var n = "function" == typeof Symbol && e[Symbol.iterator];
        if (!n) return e;
        var r, i, o = n.call(e), s = [];
        try {
            for (; (void 0 === t || t-- > 0) && !(r = o.next()).done;) s.push(r.value)
        } catch (e) {
            i = {error: e}
        } finally {
            try {
                r && !r.done && (n = o.return) && n.call(o)
            } finally {
                if (i) throw i.error
            }
        }
        return s
    }, h = function () {
        for (var e = [], t = 0; t < arguments.length; t++) e = e.concat(d(arguments[t]));
        return e
    }, p = new o("Hub"),
    g = "undefined" != typeof Symbol && "function" == typeof Symbol.for ? Symbol.for("amplify_default") : "@@amplify_default";
var v = function () {
        function e(e) {
            this.listeners = [], this.patterns = [], this.protectedChannels = ["core", "auth", "api", "analytics", "interactions", "pubsub", "storage", "xr"], this.name = e
        }

        return e.prototype.remove = function (e, t) {
            if (e instanceof RegExp) {
                var n = this.patterns.find((function (t) {
                    return t.pattern.source === e.source
                }));
                if (!n) return void p.warn("No listeners for " + e);
                this.patterns = h(this.patterns.filter((function (e) {
                    return e !== n
                })))
            } else {
                var r = this.listeners[e];
                if (!r) return void p.warn("No listeners for " + e);
                this.listeners[e] = h(r.filter((function (e) {
                    return e.callback !== t
                })))
            }
        }, e.prototype.dispatch = function (e, t, n, r) {
            (void 0 === n && (n = ""), this.protectedChannels.indexOf(e) > -1) && (r === g || p.warn("WARNING: " + e + " is protected and dispatching on it can have unintended consequences"));
            var i = {channel: e, payload: f({}, t), source: n, patternInfo: []};
            try {
                this._toListeners(i)
            } catch (e) {
                p.error(e)
            }
        }, e.prototype.listen = function (e, t, n) {
            var r, i = this;
            if (void 0 === n && (n = "noname"), function (e) {
                return void 0 !== e.onHubCapsule
            }(t)) p.warn("WARNING onHubCapsule is Deprecated. Please pass in a callback."), r = t.onHubCapsule.bind(t); else {
                if ("function" != typeof t) throw new Error("No callback supplied to Hub");
                r = t
            }
            if (e instanceof RegExp) this.patterns.push({pattern: e, callback: r}); else {
                var o = this.listeners[e];
                o || (o = [], this.listeners[e] = o), o.push({name: n, callback: r})
            }
            return function () {
                i.remove(e, r)
            }
        }, e.prototype._toListeners = function (e) {
            var t = e.channel, n = e.payload, r = this.listeners[t];
            if (r && r.forEach((function (r) {
                p.debug("Dispatching to " + t + " with ", n);
                try {
                    r.callback(e)
                } catch (e) {
                    p.error(e)
                }
            })), this.patterns.length > 0) {
                if (!n.message) return void p.warn("Cannot perform pattern matching without a message key");
                var i = n.message;
                this.patterns.forEach((function (t) {
                    var n = i.match(t.pattern);
                    if (n) {
                        var r = d(n).slice(1), o = f(f({}, e), {patternInfo: r});
                        try {
                            t.callback(o)
                        } catch (e) {
                            p.error(e)
                        }
                    }
                }))
            }
        }, e
    }(), m = new v("__default__"), y = [{type: "text/plain", ext: "txt"}, {type: "text/html", ext: "html"}, {
        type: "text/javascript",
        ext: "js"
    }, {type: "text/css", ext: "css"}, {type: "text/csv", ext: "csv"}, {type: "text/yaml", ext: "yml"}, {
        type: "text/yaml",
        ext: "yaml"
    }, {type: "text/calendar", ext: "ics"}, {type: "text/calendar", ext: "ical"}, {
        type: "image/apng",
        ext: "apng"
    }, {type: "image/bmp", ext: "bmp"}, {type: "image/gif", ext: "gif"}, {
        type: "image/x-icon",
        ext: "ico"
    }, {type: "image/x-icon", ext: "cur"}, {type: "image/jpeg", ext: "jpg"}, {
        type: "image/jpeg",
        ext: "jpeg"
    }, {type: "image/jpeg", ext: "jfif"}, {type: "image/jpeg", ext: "pjp"}, {
        type: "image/jpeg",
        ext: "pjpeg"
    }, {type: "image/png", ext: "png"}, {type: "image/svg+xml", ext: "svg"}, {
        type: "image/tiff",
        ext: "tif"
    }, {type: "image/tiff", ext: "tiff"}, {type: "image/webp", ext: "webp"}, {
        type: "application/json",
        ext: "json"
    }, {type: "application/xml", ext: "xml"}, {type: "application/x-sh", ext: "sh"}, {
        type: "application/zip",
        ext: "zip"
    }, {type: "application/x-rar-compressed", ext: "rar"}, {
        type: "application/x-tar",
        ext: "tar"
    }, {type: "application/x-bzip", ext: "bz"}, {type: "application/x-bzip2", ext: "bz2"}, {
        type: "application/pdf",
        ext: "pdf"
    }, {type: "application/java-archive", ext: "jar"}, {
        type: "application/msword",
        ext: "doc"
    }, {type: "application/vnd.ms-excel", ext: "xls"}, {
        type: "application/vnd.ms-excel",
        ext: "xlsx"
    }, {type: "message/rfc822", ext: "eml"}], S = function (e) {
        return void 0 === e && (e = {}), 0 === Object.keys(e).length
    }, w = function (e, t, n) {
        if (!e || !e.sort) return !1;
        var r = n && "desc" === n ? -1 : 1;
        return e.sort((function (e, n) {
            var i = e[t], o = n[t];
            return void 0 === o ? void 0 === i ? 0 : 1 * r : void 0 === i || i < o ? -1 * r : i > o ? 1 * r : 0
        })), !0
    }, b = function (e, t) {
        var n = Object.assign({}, e);
        return t && ("string" == typeof t ? delete n[t] : t.forEach((function (e) {
            delete n[e]
        }))), n
    }, E = function (e, t) {
        void 0 === t && (t = "application/octet-stream");
        var n = e.toLowerCase(), r = y.filter((function (e) {
            return n.endsWith("." + e.ext)
        }));
        return r.length > 0 ? r[0].type : t
    }, C = function (e) {
        var t = e.toLowerCase();
        return !!t.startsWith("text/") || ("application/json" === t || "application/xml" === t || "application/sh" === t)
    }, _ = function () {
        for (var e = "", t = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ", n = 32; n > 0; n -= 1) e += t[Math.floor(Math.random() * t.length)];
        return e
    }, A = function (e) {
        if (e.isResolved) return e;
        var t = !0, n = !1, r = !1, i = e.then((function (e) {
            return r = !0, t = !1, e
        }), (function (e) {
            throw n = !0, t = !1, e
        }));
        return i.isFullfilled = function () {
            return r
        }, i.isPending = function () {
            return t
        }, i.isRejected = function () {
            return n
        }, i
    }, P = function () {
        if ("undefined" == typeof self) return !1;
        var e = self;
        return void 0 !== e.WorkerGlobalScope && self instanceof e.WorkerGlobalScope
    }, k = function () {
        return {
            isBrowser: "undefined" != typeof window && void 0 !== window.document,
            isNode: "undefined" != typeof process && null != process.versions && null != process.versions.node
        }
    }, x = function (e, t, n) {
        if (void 0 === t && (t = []), void 0 === n && (n = []), !T(e)) return e;
        var r = {};
        for (var i in e) {
            if (e.hasOwnProperty(i)) r[t.includes(i) ? i : i[0].toLowerCase() + i.slice(1)] = n.includes(i) ? e[i] : x(e[i], t, n)
        }
        return r
    }, I = function (e, t, n) {
        if (void 0 === t && (t = []), void 0 === n && (n = []), !T(e)) return e;
        var r = {};
        for (var i in e) {
            if (e.hasOwnProperty(i)) r[t.includes(i) ? i : i[0].toUpperCase() + i.slice(1)] = n.includes(i) ? e[i] : I(e[i], t, n)
        }
        return r
    }, T = function (e) {
        return !(!(e instanceof Object) || e instanceof Array || e instanceof Function || e instanceof Number || e instanceof String || e instanceof Boolean)
    }, U = function () {
        function e() {
        }

        return e.isEmpty = S, e.sortByField = w, e.objectLessAttributes = b, e.filenameToContentType = E, e.isTextFile = C, e.generateRandomString = _, e.makeQuerablePromise = A, e.isWebWorker = P, e.browserOrNode = k, e.transferKeyToLowerCase = x, e.transferKeyToUpperCase = I, e.isStrictObject = T, e
    }(),
    O = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof self ? self : {};

function M(e) {
    return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e
}

function L(e) {
    if (e.__esModule) return e;
    var t = Object.defineProperty({}, "__esModule", {value: !0});
    return Object.keys(e).forEach((function (n) {
        var r = Object.getOwnPropertyDescriptor(e, n);
        Object.defineProperty(t, n, r.get ? r : {
            enumerable: !0, get: function () {
                return e[n]
            }
        })
    })), t
}

var R = function (e, t) {
    return R = Object.setPrototypeOf || {__proto__: []} instanceof Array && function (e, t) {
        e.__proto__ = t
    } || function (e, t) {
        for (var n in t) t.hasOwnProperty(n) && (e[n] = t[n])
    }, R(e, t)
};

function N(e, t) {
    function n() {
        this.constructor = e
    }

    R(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n)
}

var D = function () {
    return D = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var i in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
        return e
    }, D.apply(this, arguments)
};

function B(e, t) {
    var n = {};
    for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
    if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
        var i = 0;
        for (r = Object.getOwnPropertySymbols(e); i < r.length; i++) t.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[i]) && (n[r[i]] = e[r[i]])
    }
    return n
}

function j(e, t, n, r) {
    return new (n || (n = Promise))((function (i, o) {
        function s(e) {
            try {
                u(r.next(e))
            } catch (e) {
                o(e)
            }
        }

        function a(e) {
            try {
                u(r.throw(e))
            } catch (e) {
                o(e)
            }
        }

        function u(e) {
            var t;
            e.done ? i(e.value) : (t = e.value, t instanceof n ? t : new n((function (e) {
                e(t)
            }))).then(s, a)
        }

        u((r = r.apply(e, t || [])).next())
    }))
}

function F(e, t) {
    var n, r, i, o, s = {
        label: 0, sent: function () {
            if (1 & i[0]) throw i[1];
            return i[1]
        }, trys: [], ops: []
    };
    return o = {
        next: a(0),
        throw: a(1),
        return: a(2)
    }, "function" == typeof Symbol && (o[Symbol.iterator] = function () {
        return this
    }), o;

    function a(o) {
        return function (a) {
            return function (o) {
                if (n) throw new TypeError("Generator is already executing.");
                for (; s;) try {
                    if (n = 1, r && (i = 2 & o[0] ? r.return : o[0] ? r.throw || ((i = r.return) && i.call(r), 0) : r.next) && !(i = i.call(r, o[1])).done) return i;
                    switch (r = 0, i && (o = [2 & o[0], i.value]), o[0]) {
                        case 0:
                        case 1:
                            i = o;
                            break;
                        case 4:
                            return s.label++, {value: o[1], done: !1};
                        case 5:
                            s.label++, r = o[1], o = [0];
                            continue;
                        case 7:
                            o = s.ops.pop(), s.trys.pop();
                            continue;
                        default:
                            if (!(i = s.trys, (i = i.length > 0 && i[i.length - 1]) || 6 !== o[0] && 2 !== o[0])) {
                                s = 0;
                                continue
                            }
                            if (3 === o[0] && (!i || o[1] > i[0] && o[1] < i[3])) {
                                s.label = o[1];
                                break
                            }
                            if (6 === o[0] && s.label < i[1]) {
                                s.label = i[1], i = o;
                                break
                            }
                            if (i && s.label < i[2]) {
                                s.label = i[2], s.ops.push(o);
                                break
                            }
                            i[2] && s.ops.pop(), s.trys.pop();
                            continue
                    }
                    o = t.call(e, s)
                } catch (e) {
                    o = [6, e], r = 0
                } finally {
                    n = i = 0
                }
                if (5 & o[0]) throw o[1];
                return {value: o[0] ? o[1] : void 0, done: !0}
            }([o, a])
        }
    }
}

function z(e) {
    var t = "function" == typeof Symbol && Symbol.iterator, n = t && e[t], r = 0;
    if (n) return n.call(e);
    if (e && "number" == typeof e.length) return {
        next: function () {
            return e && r >= e.length && (e = void 0), {value: e && e[r++], done: !e}
        }
    };
    throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.")
}

function K(e, t) {
    var n = "function" == typeof Symbol && e[Symbol.iterator];
    if (!n) return e;
    var r, i, o = n.call(e), s = [];
    try {
        for (; (void 0 === t || t-- > 0) && !(r = o.next()).done;) s.push(r.value)
    } catch (e) {
        i = {error: e}
    } finally {
        try {
            r && !r.done && (n = o.return) && n.call(o)
        } finally {
            if (i) throw i.error
        }
    }
    return s
}

function q() {
    for (var e = [], t = 0; t < arguments.length; t++) e = e.concat(K(arguments[t]));
    return e
}

function H(e) {
    return this instanceof H ? (this.v = e, this) : new H(e)
}

function V(e, t, n) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var r, i = n.apply(e, t || []), o = [];
    return r = {}, s("next"), s("throw"), s("return"), r[Symbol.asyncIterator] = function () {
        return this
    }, r;

    function s(e) {
        i[e] && (r[e] = function (t) {
            return new Promise((function (n, r) {
                o.push([e, t, n, r]) > 1 || a(e, t)
            }))
        })
    }

    function a(e, t) {
        try {
            (n = i[e](t)).value instanceof H ? Promise.resolve(n.value.v).then(u, c) : l(o[0][2], n)
        } catch (e) {
            l(o[0][3], e)
        }
        var n
    }

    function u(e) {
        a("next", e)
    }

    function c(e) {
        a("throw", e)
    }

    function l(e, t) {
        e(t), o.shift(), o.length && a(o[0][0], o[0][1])
    }
}

function G(e) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var t, n = e[Symbol.asyncIterator];
    return n ? n.call(e) : (e = z(e), t = {}, r("next"), r("throw"), r("return"), t[Symbol.asyncIterator] = function () {
        return this
    }, t);

    function r(n) {
        t[n] = e[n] && function (t) {
            return new Promise((function (r, i) {
                (function (e, t, n, r) {
                    Promise.resolve(r).then((function (t) {
                        e({value: t, done: n})
                    }), t)
                })(r, i, (t = e[n](t)).done, t.value)
            }))
        }
    }
}

for (var W = Object.freeze({
    __proto__: null, __extends: N, get __assign() {
        return D
    }, __rest: B, __decorate: function (e, t, n, r) {
        var i, o = arguments.length, s = o < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) s = Reflect.decorate(e, t, n, r); else for (var a = e.length - 1; a >= 0; a--) (i = e[a]) && (s = (o < 3 ? i(s) : o > 3 ? i(t, n, s) : i(t, n)) || s);
        return o > 3 && s && Object.defineProperty(t, n, s), s
    }, __param: function (e, t) {
        return function (n, r) {
            t(n, r, e)
        }
    }, __metadata: function (e, t) {
        if ("object" == typeof Reflect && "function" == typeof Reflect.metadata) return Reflect.metadata(e, t)
    }, __awaiter: j, __generator: F, __createBinding: function (e, t, n, r) {
        void 0 === r && (r = n), e[r] = t[n]
    }, __exportStar: function (e, t) {
        for (var n in e) "default" === n || t.hasOwnProperty(n) || (t[n] = e[n])
    }, __values: z, __read: K, __spread: q, __spreadArrays: function () {
        for (var e = 0, t = 0, n = arguments.length; t < n; t++) e += arguments[t].length;
        var r = Array(e), i = 0;
        for (t = 0; t < n; t++) for (var o = arguments[t], s = 0, a = o.length; s < a; s++, i++) r[i] = o[s];
        return r
    }, __await: H, __asyncGenerator: V, __asyncDelegator: function (e) {
        var t, n;
        return t = {}, r("next"), r("throw", (function (e) {
            throw e
        })), r("return"), t[Symbol.iterator] = function () {
            return this
        }, t;

        function r(r, i) {
            t[r] = e[r] ? function (t) {
                return (n = !n) ? {value: H(e[r](t)), done: "return" === r} : i ? i(t) : t
            } : i
        }
    }, __asyncValues: G, __makeTemplateObject: function (e, t) {
        return Object.defineProperty ? Object.defineProperty(e, "raw", {value: t}) : e.raw = t, e
    }, __importStar: function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) Object.hasOwnProperty.call(e, n) && (t[n] = e[n]);
        return t.default = e, t
    }, __importDefault: function (e) {
        return e && e.__esModule ? e : {default: e}
    }, __classPrivateFieldGet: function (e, t) {
        if (!t.has(e)) throw new TypeError("attempted to get private field on non-instance");
        return t.get(e)
    }, __classPrivateFieldSet: function (e, t, n) {
        if (!t.has(e)) throw new TypeError("attempted to set private field on non-instance");
        return t.set(e, n), n
    }
}), $ = L(W), Y = {}, J = {}, Z = 0; Z < 256; Z++) {
    var X = Z.toString(16).toLowerCase();
    1 === X.length && (X = "0" + X), Y[Z] = X, J[X] = Z
}

function Q(e) {
    for (var t = "", n = 0; n < e.byteLength; n++) t += Y[e[n]];
    return t
}

var ee = {exports: {}};
!function (e, t) {
    !function (n) {
        var r = t && !t.nodeType && t, i = e && !e.nodeType && e, o = "object" == typeof O && O;
        o.global !== o && o.window !== o && o.self !== o || (n = o);
        var s, a, u = 2147483647, c = 36, l = /^xn--/, f = /[^\x20-\x7E]/, d = /[\x2E\u3002\uFF0E\uFF61]/g, h = {
            overflow: "Overflow: input needs wider integers to process",
            "not-basic": "Illegal input >= 0x80 (not a basic code point)",
            "invalid-input": "Invalid input"
        }, p = Math.floor, g = String.fromCharCode;

        function v(e) {
            throw RangeError(h[e])
        }

        function m(e, t) {
            for (var n = e.length, r = []; n--;) r[n] = t(e[n]);
            return r
        }

        function y(e, t) {
            var n = e.split("@"), r = "";
            return n.length > 1 && (r = n[0] + "@", e = n[1]), r + m((e = e.replace(d, ".")).split("."), t).join(".")
        }

        function S(e) {
            for (var t, n, r = [], i = 0, o = e.length; i < o;) (t = e.charCodeAt(i++)) >= 55296 && t <= 56319 && i < o ? 56320 == (64512 & (n = e.charCodeAt(i++))) ? r.push(((1023 & t) << 10) + (1023 & n) + 65536) : (r.push(t), i--) : r.push(t);
            return r
        }

        function w(e) {
            return m(e, (function (e) {
                var t = "";
                return e > 65535 && (t += g((e -= 65536) >>> 10 & 1023 | 55296), e = 56320 | 1023 & e), t += g(e)
            })).join("")
        }

        function b(e, t) {
            return e + 22 + 75 * (e < 26) - ((0 != t) << 5)
        }

        function E(e, t, n) {
            var r = 0;
            for (e = n ? p(e / 700) : e >> 1, e += p(e / t); e > 455; r += c) e = p(e / 35);
            return p(r + 36 * e / (e + 38))
        }

        function C(e) {
            var t, n, r, i, o, s, a, l, f, d, h, g = [], m = e.length, y = 0, S = 128, b = 72;
            for ((n = e.lastIndexOf("-")) < 0 && (n = 0), r = 0; r < n; ++r) e.charCodeAt(r) >= 128 && v("not-basic"), g.push(e.charCodeAt(r));
            for (i = n > 0 ? n + 1 : 0; i < m;) {
                for (o = y, s = 1, a = c; i >= m && v("invalid-input"), ((l = (h = e.charCodeAt(i++)) - 48 < 10 ? h - 22 : h - 65 < 26 ? h - 65 : h - 97 < 26 ? h - 97 : c) >= c || l > p((u - y) / s)) && v("overflow"), y += l * s, !(l < (f = a <= b ? 1 : a >= b + 26 ? 26 : a - b)); a += c) s > p(u / (d = c - f)) && v("overflow"), s *= d;
                b = E(y - o, t = g.length + 1, 0 == o), p(y / t) > u - S && v("overflow"), S += p(y / t), y %= t, g.splice(y++, 0, S)
            }
            return w(g)
        }

        function _(e) {
            var t, n, r, i, o, s, a, l, f, d, h, m, y, w, C, _ = [];
            for (m = (e = S(e)).length, t = 128, n = 0, o = 72, s = 0; s < m; ++s) (h = e[s]) < 128 && _.push(g(h));
            for (r = i = _.length, i && _.push("-"); r < m;) {
                for (a = u, s = 0; s < m; ++s) (h = e[s]) >= t && h < a && (a = h);
                for (a - t > p((u - n) / (y = r + 1)) && v("overflow"), n += (a - t) * y, t = a, s = 0; s < m; ++s) if ((h = e[s]) < t && ++n > u && v("overflow"), h == t) {
                    for (l = n, f = c; !(l < (d = f <= o ? 1 : f >= o + 26 ? 26 : f - o)); f += c) C = l - d, w = c - d, _.push(g(b(d + C % w, 0))), l = p(C / w);
                    _.push(g(b(l, 0))), o = E(n, y, r == i), n = 0, ++r
                }
                ++n, ++t
            }
            return _.join("")
        }

        if (s = {
            version: "1.3.2", ucs2: {decode: S, encode: w}, decode: C, encode: _, toASCII: function (e) {
                return y(e, (function (e) {
                    return f.test(e) ? "xn--" + _(e) : e
                }))
            }, toUnicode: function (e) {
                return y(e, (function (e) {
                    return l.test(e) ? C(e.slice(4).toLowerCase()) : e
                }))
            }
        }, r && i) if (e.exports == r) i.exports = s; else for (a in s) s.hasOwnProperty(a) && (r[a] = s[a]); else n.punycode = s
    }(O)
}(ee, ee.exports);
var te = {};

function ne(e, t) {
    return Object.prototype.hasOwnProperty.call(e, t)
}

var re = function (e) {
    switch (typeof e) {
        case"string":
            return e;
        case"boolean":
            return e ? "true" : "false";
        case"number":
            return isFinite(e) ? e : "";
        default:
            return ""
    }
};
te.decode = te.parse = function (e, t, n, r) {
    t = t || "&", n = n || "=";
    var i = {};
    if ("string" != typeof e || 0 === e.length) return i;
    var o = /\+/g;
    e = e.split(t);
    var s = 1e3;
    r && "number" == typeof r.maxKeys && (s = r.maxKeys);
    var a = e.length;
    s > 0 && a > s && (a = s);
    for (var u = 0; u < a; ++u) {
        var c, l, f, d, h = e[u].replace(o, "%20"), p = h.indexOf(n);
        p >= 0 ? (c = h.substr(0, p), l = h.substr(p + 1)) : (c = h, l = ""), f = decodeURIComponent(c), d = decodeURIComponent(l), ne(i, f) ? Array.isArray(i[f]) ? i[f].push(d) : i[f] = [i[f], d] : i[f] = d
    }
    return i
}, te.encode = te.stringify = function (e, t, n, r) {
    return t = t || "&", n = n || "=", null === e && (e = void 0), "object" == typeof e ? Object.keys(e).map((function (r) {
        var i = encodeURIComponent(re(r)) + n;
        return Array.isArray(e[r]) ? e[r].map((function (e) {
            return i + encodeURIComponent(re(e))
        })).join(t) : i + encodeURIComponent(re(e[r]))
    })).join(t) : r ? encodeURIComponent(re(r)) + n + encodeURIComponent(re(e)) : ""
};
var ie = ee.exports, oe = {
    isString: function (e) {
        return "string" == typeof e
    }, isObject: function (e) {
        return "object" == typeof e && null !== e
    }, isNull: function (e) {
        return null === e
    }, isNullOrUndefined: function (e) {
        return null == e
    }
}, se = be;

function ae() {
    this.protocol = null, this.slashes = null, this.auth = null, this.host = null, this.port = null, this.hostname = null, this.hash = null, this.search = null, this.query = null, this.pathname = null, this.path = null, this.href = null
}

var ue = /^([a-z0-9.+-]+:)/i, ce = /:[0-9]*$/, le = /^(\/\/?(?!\/)[^\?\s]*)(\?[^\s]*)?$/,
    fe = ["{", "}", "|", "\\", "^", "`"].concat(["<", ">", '"', "`", " ", "\r", "\n", "\t"]), de = ["'"].concat(fe),
    he = ["%", "/", "?", ";", "#"].concat(de), pe = ["/", "?", "#"], ge = /^[+a-z0-9A-Z_-]{0,63}$/,
    ve = /^([+a-z0-9A-Z_-]{0,63})(.*)$/, me = {javascript: !0, "javascript:": !0},
    ye = {javascript: !0, "javascript:": !0}, Se = {
        http: !0,
        https: !0,
        ftp: !0,
        gopher: !0,
        file: !0,
        "http:": !0,
        "https:": !0,
        "ftp:": !0,
        "gopher:": !0,
        "file:": !0
    }, we = te;

function be(e, t, n) {
    if (e && oe.isObject(e) && e instanceof ae) return e;
    var r = new ae;
    return r.parse(e, t, n), r
}

ae.prototype.parse = function (e, t, n) {
    if (!oe.isString(e)) throw new TypeError("Parameter 'url' must be a string, not " + typeof e);
    var r = e.indexOf("?"), i = -1 !== r && r < e.indexOf("#") ? "?" : "#", o = e.split(i);
    o[0] = o[0].replace(/\\/g, "/");
    var s = e = o.join(i);
    if (s = s.trim(), !n && 1 === e.split("#").length) {
        var a = le.exec(s);
        if (a) return this.path = s, this.href = s, this.pathname = a[1], a[2] ? (this.search = a[2], this.query = t ? we.parse(this.search.substr(1)) : this.search.substr(1)) : t && (this.search = "", this.query = {}), this
    }
    var u = ue.exec(s);
    if (u) {
        var c = (u = u[0]).toLowerCase();
        this.protocol = c, s = s.substr(u.length)
    }
    if (n || u || s.match(/^\/\/[^@\/]+@[^@\/]+/)) {
        var l = "//" === s.substr(0, 2);
        !l || u && ye[u] || (s = s.substr(2), this.slashes = !0)
    }
    if (!ye[u] && (l || u && !Se[u])) {
        for (var f, d, h = -1, p = 0; p < pe.length; p++) {
            -1 !== (g = s.indexOf(pe[p])) && (-1 === h || g < h) && (h = g)
        }
        -1 !== (d = -1 === h ? s.lastIndexOf("@") : s.lastIndexOf("@", h)) && (f = s.slice(0, d), s = s.slice(d + 1), this.auth = decodeURIComponent(f)), h = -1;
        for (p = 0; p < he.length; p++) {
            var g;
            -1 !== (g = s.indexOf(he[p])) && (-1 === h || g < h) && (h = g)
        }
        -1 === h && (h = s.length), this.host = s.slice(0, h), s = s.slice(h), this.parseHost(), this.hostname = this.hostname || "";
        var v = "[" === this.hostname[0] && "]" === this.hostname[this.hostname.length - 1];
        if (!v) for (var m = this.hostname.split(/\./), y = (p = 0, m.length); p < y; p++) {
            var S = m[p];
            if (S && !S.match(ge)) {
                for (var w = "", b = 0, E = S.length; b < E; b++) S.charCodeAt(b) > 127 ? w += "x" : w += S[b];
                if (!w.match(ge)) {
                    var C = m.slice(0, p), _ = m.slice(p + 1), A = S.match(ve);
                    A && (C.push(A[1]), _.unshift(A[2])), _.length && (s = "/" + _.join(".") + s), this.hostname = C.join(".");
                    break
                }
            }
        }
        this.hostname.length > 255 ? this.hostname = "" : this.hostname = this.hostname.toLowerCase(), v || (this.hostname = ie.toASCII(this.hostname));
        var P = this.port ? ":" + this.port : "", k = this.hostname || "";
        this.host = k + P, this.href += this.host, v && (this.hostname = this.hostname.substr(1, this.hostname.length - 2), "/" !== s[0] && (s = "/" + s))
    }
    if (!me[c]) for (p = 0, y = de.length; p < y; p++) {
        var x = de[p];
        if (-1 !== s.indexOf(x)) {
            var I = encodeURIComponent(x);
            I === x && (I = escape(x)), s = s.split(x).join(I)
        }
    }
    var T = s.indexOf("#");
    -1 !== T && (this.hash = s.substr(T), s = s.slice(0, T));
    var U = s.indexOf("?");
    if (-1 !== U ? (this.search = s.substr(U), this.query = s.substr(U + 1), t && (this.query = we.parse(this.query)), s = s.slice(0, U)) : t && (this.search = "", this.query = {}), s && (this.pathname = s), Se[c] && this.hostname && !this.pathname && (this.pathname = "/"), this.pathname || this.search) {
        P = this.pathname || "";
        var O = this.search || "";
        this.path = P + O
    }
    return this.href = this.format(), this
}, ae.prototype.format = function () {
    var e = this.auth || "";
    e && (e = (e = encodeURIComponent(e)).replace(/%3A/i, ":"), e += "@");
    var t = this.protocol || "", n = this.pathname || "", r = this.hash || "", i = !1, o = "";
    this.host ? i = e + this.host : this.hostname && (i = e + (-1 === this.hostname.indexOf(":") ? this.hostname : "[" + this.hostname + "]"), this.port && (i += ":" + this.port)), this.query && oe.isObject(this.query) && Object.keys(this.query).length && (o = we.stringify(this.query));
    var s = this.search || o && "?" + o || "";
    return t && ":" !== t.substr(-1) && (t += ":"), this.slashes || (!t || Se[t]) && !1 !== i ? (i = "//" + (i || ""), n && "/" !== n.charAt(0) && (n = "/" + n)) : i || (i = ""), r && "#" !== r.charAt(0) && (r = "#" + r), s && "?" !== s.charAt(0) && (s = "?" + s), t + i + (n = n.replace(/[?#]/g, (function (e) {
        return encodeURIComponent(e)
    }))) + (s = s.replace("#", "%23")) + r
}, ae.prototype.resolve = function (e) {
    return this.resolveObject(be(e, !1, !0)).format()
}, ae.prototype.resolveObject = function (e) {
    if (oe.isString(e)) {
        var t = new ae;
        t.parse(e, !1, !0), e = t
    }
    for (var n = new ae, r = Object.keys(this), i = 0; i < r.length; i++) {
        var o = r[i];
        n[o] = this[o]
    }
    if (n.hash = e.hash, "" === e.href) return n.href = n.format(), n;
    if (e.slashes && !e.protocol) {
        for (var s = Object.keys(e), a = 0; a < s.length; a++) {
            var u = s[a];
            "protocol" !== u && (n[u] = e[u])
        }
        return Se[n.protocol] && n.hostname && !n.pathname && (n.path = n.pathname = "/"), n.href = n.format(), n
    }
    if (e.protocol && e.protocol !== n.protocol) {
        if (!Se[e.protocol]) {
            for (var c = Object.keys(e), l = 0; l < c.length; l++) {
                var f = c[l];
                n[f] = e[f]
            }
            return n.href = n.format(), n
        }
        if (n.protocol = e.protocol, e.host || ye[e.protocol]) n.pathname = e.pathname; else {
            for (var d = (e.pathname || "").split("/"); d.length && !(e.host = d.shift());) ;
            e.host || (e.host = ""), e.hostname || (e.hostname = ""), "" !== d[0] && d.unshift(""), d.length < 2 && d.unshift(""), n.pathname = d.join("/")
        }
        if (n.search = e.search, n.query = e.query, n.host = e.host || "", n.auth = e.auth, n.hostname = e.hostname || e.host, n.port = e.port, n.pathname || n.search) {
            var h = n.pathname || "", p = n.search || "";
            n.path = h + p
        }
        return n.slashes = n.slashes || e.slashes, n.href = n.format(), n
    }
    var g = n.pathname && "/" === n.pathname.charAt(0), v = e.host || e.pathname && "/" === e.pathname.charAt(0),
        m = v || g || n.host && e.pathname, y = m, S = n.pathname && n.pathname.split("/") || [],
        w = (d = e.pathname && e.pathname.split("/") || [], n.protocol && !Se[n.protocol]);
    if (w && (n.hostname = "", n.port = null, n.host && ("" === S[0] ? S[0] = n.host : S.unshift(n.host)), n.host = "", e.protocol && (e.hostname = null, e.port = null, e.host && ("" === d[0] ? d[0] = e.host : d.unshift(e.host)), e.host = null), m = m && ("" === d[0] || "" === S[0])), v) n.host = e.host || "" === e.host ? e.host : n.host, n.hostname = e.hostname || "" === e.hostname ? e.hostname : n.hostname, n.search = e.search, n.query = e.query, S = d; else if (d.length) S || (S = []), S.pop(), S = S.concat(d), n.search = e.search, n.query = e.query; else if (!oe.isNullOrUndefined(e.search)) {
        if (w) n.hostname = n.host = S.shift(), (A = !!(n.host && n.host.indexOf("@") > 0) && n.host.split("@")) && (n.auth = A.shift(), n.host = n.hostname = A.shift());
        return n.search = e.search, n.query = e.query, oe.isNull(n.pathname) && oe.isNull(n.search) || (n.path = (n.pathname ? n.pathname : "") + (n.search ? n.search : "")), n.href = n.format(), n
    }
    if (!S.length) return n.pathname = null, n.search ? n.path = "/" + n.search : n.path = null, n.href = n.format(), n;
    for (var b = S.slice(-1)[0], E = (n.host || e.host || S.length > 1) && ("." === b || ".." === b) || "" === b, C = 0, _ = S.length; _ >= 0; _--) "." === (b = S[_]) ? S.splice(_, 1) : ".." === b ? (S.splice(_, 1), C++) : C && (S.splice(_, 1), C--);
    if (!m && !y) for (; C--; C) S.unshift("..");
    !m || "" === S[0] || S[0] && "/" === S[0].charAt(0) || S.unshift(""), E && "/" !== S.join("/").substr(-1) && S.push("");
    var A, P = "" === S[0] || S[0] && "/" === S[0].charAt(0);
    w && (n.hostname = n.host = P ? "" : S.length ? S.shift() : "", (A = !!(n.host && n.host.indexOf("@") > 0) && n.host.split("@")) && (n.auth = A.shift(), n.host = n.hostname = A.shift()));
    return (m = m || n.host && S.length) && !P && S.unshift(""), S.length ? n.pathname = S.join("/") : (n.pathname = null, n.path = null), oe.isNull(n.pathname) && oe.isNull(n.search) || (n.path = (n.pathname ? n.pathname : "") + (n.search ? n.search : "")), n.auth = e.auth || n.auth, n.slashes = n.slashes || e.slashes, n.href = n.format(), n
}, ae.prototype.parseHost = function () {
    var e = this.host, t = ce.exec(e);
    t && (":" !== (t = t[0]) && (this.port = t.substr(1)), e = e.substr(0, e.length - t.length)), e && (this.hostname = e)
};
var Ee = function () {
    var e = function (t, n) {
        return e = Object.setPrototypeOf || {__proto__: []} instanceof Array && function (e, t) {
            e.__proto__ = t
        } || function (e, t) {
            for (var n in t) t.hasOwnProperty(n) && (e[n] = t[n])
        }, e(t, n)
    };
    return function (t, n) {
        function r() {
            this.constructor = t
        }

        e(t, n), t.prototype = null === n ? Object.create(n) : (r.prototype = n.prototype, new r)
    }
}(), Ce = function (e, t, n, r) {
    return new (n || (n = Promise))((function (i, o) {
        function s(e) {
            try {
                u(r.next(e))
            } catch (e) {
                o(e)
            }
        }

        function a(e) {
            try {
                u(r.throw(e))
            } catch (e) {
                o(e)
            }
        }

        function u(e) {
            var t;
            e.done ? i(e.value) : (t = e.value, t instanceof n ? t : new n((function (e) {
                e(t)
            }))).then(s, a)
        }

        u((r = r.apply(e, t || [])).next())
    }))
}, _e = function (e, t) {
    var n, r, i, o, s = {
        label: 0, sent: function () {
            if (1 & i[0]) throw i[1];
            return i[1]
        }, trys: [], ops: []
    };
    return o = {
        next: a(0),
        throw: a(1),
        return: a(2)
    }, "function" == typeof Symbol && (o[Symbol.iterator] = function () {
        return this
    }), o;

    function a(o) {
        return function (a) {
            return function (o) {
                if (n) throw new TypeError("Generator is already executing.");
                for (; s;) try {
                    if (n = 1, r && (i = 2 & o[0] ? r.return : o[0] ? r.throw || ((i = r.return) && i.call(r), 0) : r.next) && !(i = i.call(r, o[1])).done) return i;
                    switch (r = 0, i && (o = [2 & o[0], i.value]), o[0]) {
                        case 0:
                        case 1:
                            i = o;
                            break;
                        case 4:
                            return s.label++, {value: o[1], done: !1};
                        case 5:
                            s.label++, r = o[1], o = [0];
                            continue;
                        case 7:
                            o = s.ops.pop(), s.trys.pop();
                            continue;
                        default:
                            if (!(i = s.trys, (i = i.length > 0 && i[i.length - 1]) || 6 !== o[0] && 2 !== o[0])) {
                                s = 0;
                                continue
                            }
                            if (3 === o[0] && (!i || o[1] > i[0] && o[1] < i[3])) {
                                s.label = o[1];
                                break
                            }
                            if (6 === o[0] && s.label < i[1]) {
                                s.label = i[1], i = o;
                                break
                            }
                            if (i && s.label < i[2]) {
                                s.label = i[2], s.ops.push(o);
                                break
                            }
                            i[2] && s.ops.pop(), s.trys.pop();
                            continue
                    }
                    o = t.call(e, s)
                } catch (e) {
                    o = [6, e], r = 0
                } finally {
                    n = i = 0
                }
                if (5 & o[0]) throw o[1];
                return {value: o[0] ? o[1] : void 0, done: !0}
            }([o, a])
        }
    }
}, Ae = function (e, t) {
    var n = "function" == typeof Symbol && e[Symbol.iterator];
    if (!n) return e;
    var r, i, o = n.call(e), s = [];
    try {
        for (; (void 0 === t || t-- > 0) && !(r = o.next()).done;) s.push(r.value)
    } catch (e) {
        i = {error: e}
    } finally {
        try {
            r && !r.done && (n = o.return) && n.call(o)
        } finally {
            if (i) throw i.error
        }
    }
    return s
}, Pe = function () {
    for (var e = [], t = 0; t < arguments.length; t++) e = e.concat(Ae(arguments[t]));
    return e
}, ke = new o("Util"), xe = function (e) {
    function t(t) {
        var n = e.call(this, t) || this;
        return n.nonRetryable = !0, n
    }

    return Ee(t, e), t
}(Error);

function Ie(e, t, n, r) {
    return void 0 === r && (r = 1), Ce(this, void 0, void 0, (function () {
        var i, o;
        return _e(this, (function (s) {
            switch (s.label) {
                case 0:
                    if ("function" != typeof e) throw Error("functionToRetry must be a function");
                    ke.debug(e.name + " attempt #" + r + " with this vars: " + JSON.stringify(t)), s.label = 1;
                case 1:
                    return s.trys.push([1, 3, , 8]), [4, e.apply(void 0, Pe(t))];
                case 2:
                    return [2, s.sent()];
                case 3:
                    if (i = s.sent(), ke.debug("error on " + e.name, i), (a = i) && a.nonRetryable) throw ke.debug(e.name + " non retryable error", i), i;
                    return o = n(r, t, i), ke.debug(e.name + " retrying in " + o + " ms"), !1 === o ? [3, 6] : [4, new Promise((function (e) {
                        return setTimeout(e, o)
                    }))];
                case 4:
                    return s.sent(), [4, Ie(e, t, n, r + 1)];
                case 5:
                    return [2, s.sent()];
                case 6:
                    throw i;
                case 7:
                    return [3, 8];
                case 8:
                    return [2]
            }
            var a
        }))
    }))
}

var Te = function (e, t, n) {
    return void 0 === n && (n = 3e5), Ie(e, t, function (e) {
        return function (t) {
            var n = 100 * Math.pow(2, t) + 100 * Math.random();
            return !(n > e) && n
        }
    }(n))
};
var Ue = function () {
    return Ue = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var i in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
        return e
    }, Ue.apply(this, arguments)
}, Oe = new o("Parser"), Me = function (e) {
    var t, n = {};
    if (e.aws_mobile_analytics_app_id) {
        var r = {AWSPinpoint: {appId: e.aws_mobile_analytics_app_id, region: e.aws_mobile_analytics_app_region}};
        n.Analytics = r
    }
    return (e.aws_cognito_identity_pool_id || e.aws_user_pools_id) && (n.Auth = {
        userPoolId: e.aws_user_pools_id,
        userPoolWebClientId: e.aws_user_pools_web_client_id,
        region: e.aws_cognito_region,
        identityPoolId: e.aws_cognito_identity_pool_id,
        identityPoolRegion: e.aws_cognito_region,
        mandatorySignIn: "enable" === e.aws_mandatory_sign_in
    }), t = e.aws_user_files_s3_bucket ? {
        AWSS3: {
            bucket: e.aws_user_files_s3_bucket,
            region: e.aws_user_files_s3_bucket_region,
            dangerouslyConnectToHttpEndpointForTesting: e.aws_user_files_s3_dangerously_connect_to_http_endpoint_for_testing
        }
    } : e ? e.Storage || e : {}, e.Logging && (n.Logging = Ue(Ue({}, e.Logging), {region: e.aws_project_region})), e.geo && (n.Geo = Object.assign({}, e.geo), e.geo.amazon_location_service && (n.Geo = {AmazonLocationService: e.geo.amazon_location_service})), n.Analytics = Object.assign({}, n.Analytics, e.Analytics), n.Auth = Object.assign({}, n.Auth, e.Auth), n.Storage = Object.assign({}, t), n.Logging = Object.assign({}, n.Logging, e.Logging), Oe.debug("parse config", e, "to amplifyconfig", n), n
}, Le = function () {
    function e() {
    }

    return e.parseMobilehubConfig = Me, e
}(), Re = {}, Ne = {}, De = {}, Be = {};
Object.defineProperty(Be, "__esModule", {value: !0}), Be.isEmptyData = void 0, Be.isEmptyData = function (e) {
    return "string" == typeof e ? 0 === e.length : 0 === e.byteLength
};
var je, Fe = {};
je = Fe, Object.defineProperty(je, "__esModule", {value: !0}), je.EMPTY_DATA_SHA_256 = je.SHA_256_HMAC_ALGO = je.SHA_256_HASH = void 0, je.SHA_256_HASH = {name: "SHA-256"}, je.SHA_256_HMAC_ALGO = {
    name: "HMAC",
    hash: je.SHA_256_HASH
}, je.EMPTY_DATA_SHA_256 = new Uint8Array([227, 176, 196, 66, 152, 252, 28, 20, 154, 251, 244, 200, 153, 111, 185, 36, 39, 174, 65, 228, 100, 155, 147, 76, 164, 149, 153, 27, 120, 82, 184, 85]);
var ze = function (e) {
    return "function" == typeof TextEncoder ? function (e) {
        return (new TextEncoder).encode(e)
    }(e) : function (e) {
        for (var t = [], n = 0, r = e.length; n < r; n++) {
            var i = e.charCodeAt(n);
            if (i < 128) t.push(i); else if (i < 2048) t.push(i >> 6 | 192, 63 & i | 128); else if (n + 1 < e.length && 55296 == (64512 & i) && 56320 == (64512 & e.charCodeAt(n + 1))) {
                var o = 65536 + ((1023 & i) << 10) + (1023 & e.charCodeAt(++n));
                t.push(o >> 18 | 240, o >> 12 & 63 | 128, o >> 6 & 63 | 128, 63 & o | 128)
            } else t.push(i >> 12 | 224, i >> 6 & 63 | 128, 63 & i | 128)
        }
        return Uint8Array.from(t)
    }(e)
}, Ke = function (e) {
    return "function" == typeof TextDecoder ? function (e) {
        return new TextDecoder("utf-8").decode(e)
    }(e) : function (e) {
        for (var t = "", n = 0, r = e.length; n < r; n++) {
            var i = e[n];
            if (i < 128) t += String.fromCharCode(i); else if (192 <= i && i < 224) {
                var o = e[++n];
                t += String.fromCharCode((31 & i) << 6 | 63 & o)
            } else if (240 <= i && i < 365) {
                var s = "%" + [i, e[++n], e[++n], e[++n]].map((function (e) {
                    return e.toString(16)
                })).join("%");
                t += decodeURIComponent(s)
            } else t += String.fromCharCode((15 & i) << 12 | (63 & e[++n]) << 6 | 63 & e[++n])
        }
        return t
    }(e)
}, qe = L(Object.freeze({__proto__: null, fromUtf8: ze, toUtf8: Ke})), He = {};
var Ve = L(Object.freeze({
    __proto__: null, locateWindow: function () {
        return "undefined" != typeof window ? window : "undefined" != typeof self ? self : He
    }
}));
Object.defineProperty(De, "__esModule", {value: !0}), De.Sha256 = void 0;
var Ge = Be, We = Fe, $e = qe, Ye = Ve, Je = function () {
    function e(e) {
        e ? (this.operation = function (e) {
            return new Promise((function (t, n) {
                var r = (0, Ye.locateWindow)().msCrypto.subtle.importKey("raw", Ze(e), We.SHA_256_HMAC_ALGO, !1, ["sign"]);
                r.oncomplete = function () {
                    r.result && t(r.result), n(new Error("ImportKey completed without importing key."))
                }, r.onerror = function () {
                    n(new Error("ImportKey failed to import key."))
                }
            }))
        }(e).then((function (e) {
            return (0, Ye.locateWindow)().msCrypto.subtle.sign(We.SHA_256_HMAC_ALGO, e)
        })), this.operation.catch((function () {
        }))) : this.operation = Promise.resolve((0, Ye.locateWindow)().msCrypto.subtle.digest("SHA-256"))
    }

    return e.prototype.update = function (e) {
        var t = this;
        (0, Ge.isEmptyData)(e) || (this.operation = this.operation.then((function (n) {
            return n.onerror = function () {
                t.operation = Promise.reject(new Error("Error encountered updating hash"))
            }, n.process(Ze(e)), n
        })), this.operation.catch((function () {
        })))
    }, e.prototype.digest = function () {
        return this.operation.then((function (e) {
            return new Promise((function (t, n) {
                e.onerror = function () {
                    n(new Error("Error encountered finalizing hash"))
                }, e.oncomplete = function () {
                    e.result && t(new Uint8Array(e.result)), n(new Error("Error encountered finalizing hash"))
                }, e.finish()
            }))
        }))
    }, e
}();

function Ze(e) {
    return "string" == typeof e ? (0, $e.fromUtf8)(e) : ArrayBuffer.isView(e) ? new Uint8Array(e.buffer, e.byteOffset, e.byteLength / Uint8Array.BYTES_PER_ELEMENT) : new Uint8Array(e)
}

De.Sha256 = Je;
var Xe = {}, Qe = {}, et = {};
Object.defineProperty(et, "__esModule", {value: !0}), et.convertToBuffer = void 0;
var tt = qe, nt = "undefined" != typeof Buffer && Buffer.from ? function (e) {
    return Buffer.from(e, "utf8")
} : tt.fromUtf8;
et.convertToBuffer = function (e) {
    return e instanceof Uint8Array ? e : "string" == typeof e ? nt(e) : ArrayBuffer.isView(e) ? new Uint8Array(e.buffer, e.byteOffset, e.byteLength / Uint8Array.BYTES_PER_ELEMENT) : new Uint8Array(e)
};
var rt = {};
Object.defineProperty(rt, "__esModule", {value: !0}), rt.isEmptyData = void 0, rt.isEmptyData = function (e) {
    return "string" == typeof e ? 0 === e.length : 0 === e.byteLength
};
var it = {};
Object.defineProperty(it, "__esModule", {value: !0}), it.numToUint8 = void 0, it.numToUint8 = function (e) {
    return new Uint8Array([(4278190080 & e) >> 24, (16711680 & e) >> 16, (65280 & e) >> 8, 255 & e])
};
var ot = {};
Object.defineProperty(ot, "__esModule", {value: !0}), ot.uint32ArrayFrom = void 0, ot.uint32ArrayFrom = function (e) {
    if (!Array.from) {
        for (var t = new Uint32Array(e.length); 0 < e.length;) t[0] = e[0];
        return t
    }
    return Uint32Array.from(e)
}, function (e) {
    Object.defineProperty(e, "__esModule", {value: !0}), e.uint32ArrayFrom = e.numToUint8 = e.isEmptyData = e.convertToBuffer = void 0;
    var t = et;
    Object.defineProperty(e, "convertToBuffer", {
        enumerable: !0, get: function () {
            return t.convertToBuffer
        }
    });
    var n = rt;
    Object.defineProperty(e, "isEmptyData", {
        enumerable: !0, get: function () {
            return n.isEmptyData
        }
    });
    var r = it;
    Object.defineProperty(e, "numToUint8", {
        enumerable: !0, get: function () {
            return r.numToUint8
        }
    });
    var i = ot;
    Object.defineProperty(e, "uint32ArrayFrom", {
        enumerable: !0, get: function () {
            return i.uint32ArrayFrom
        }
    })
}(Qe), Object.defineProperty(Xe, "__esModule", {value: !0}), Xe.Sha256 = void 0;
var st = Qe, at = Fe, ut = Ve, ct = function () {
    function e(e) {
        this.toHash = new Uint8Array(0), void 0 !== e && (this.key = new Promise((function (t, n) {
            (0, ut.locateWindow)().crypto.subtle.importKey("raw", (0, st.convertToBuffer)(e), at.SHA_256_HMAC_ALGO, !1, ["sign"]).then(t, n)
        })), this.key.catch((function () {
        })))
    }

    return e.prototype.update = function (e) {
        if (!(0, st.isEmptyData)(e)) {
            var t = (0, st.convertToBuffer)(e), n = new Uint8Array(this.toHash.byteLength + t.byteLength);
            n.set(this.toHash, 0), n.set(t, this.toHash.byteLength), this.toHash = n
        }
    }, e.prototype.digest = function () {
        var e = this;
        return this.key ? this.key.then((function (t) {
            return (0, ut.locateWindow)().crypto.subtle.sign(at.SHA_256_HMAC_ALGO, t, e.toHash).then((function (e) {
                return new Uint8Array(e)
            }))
        })) : (0, st.isEmptyData)(this.toHash) ? Promise.resolve(at.EMPTY_DATA_SHA_256) : Promise.resolve().then((function () {
            return (0, ut.locateWindow)().crypto.subtle.digest(at.SHA_256_HASH, e.toHash)
        })).then((function (e) {
            return Promise.resolve(new Uint8Array(e))
        }))
    }, e
}();
Xe.Sha256 = ct;
var lt = {}, ft = {}, dt = {};
Object.defineProperty(dt, "__esModule", {value: !0}), dt.MAX_HASHABLE_LENGTH = dt.INIT = dt.KEY = dt.DIGEST_LENGTH = dt.BLOCK_SIZE = void 0, dt.BLOCK_SIZE = 64, dt.DIGEST_LENGTH = 32, dt.KEY = new Uint32Array([1116352408, 1899447441, 3049323471, 3921009573, 961987163, 1508970993, 2453635748, 2870763221, 3624381080, 310598401, 607225278, 1426881987, 1925078388, 2162078206, 2614888103, 3248222580, 3835390401, 4022224774, 264347078, 604807628, 770255983, 1249150122, 1555081692, 1996064986, 2554220882, 2821834349, 2952996808, 3210313671, 3336571891, 3584528711, 113926993, 338241895, 666307205, 773529912, 1294757372, 1396182291, 1695183700, 1986661051, 2177026350, 2456956037, 2730485921, 2820302411, 3259730800, 3345764771, 3516065817, 3600352804, 4094571909, 275423344, 430227734, 506948616, 659060556, 883997877, 958139571, 1322822218, 1537002063, 1747873779, 1955562222, 2024104815, 2227730452, 2361852424, 2428436474, 2756734187, 3204031479, 3329325298]), dt.INIT = [1779033703, 3144134277, 1013904242, 2773480762, 1359893119, 2600822924, 528734635, 1541459225], dt.MAX_HASHABLE_LENGTH = Math.pow(2, 53) - 1;
var ht = {};
Object.defineProperty(ht, "__esModule", {value: !0}), ht.RawSha256 = void 0;
var pt = dt, gt = function () {
    function e() {
        this.state = Int32Array.from(pt.INIT), this.temp = new Int32Array(64), this.buffer = new Uint8Array(64), this.bufferLength = 0, this.bytesHashed = 0, this.finished = !1
    }

    return e.prototype.update = function (e) {
        if (this.finished) throw new Error("Attempted to update an already finished hash.");
        var t = 0, n = e.byteLength;
        if (this.bytesHashed += n, 8 * this.bytesHashed > pt.MAX_HASHABLE_LENGTH) throw new Error("Cannot hash more than 2^53 - 1 bits");
        for (; n > 0;) this.buffer[this.bufferLength++] = e[t++], n--, this.bufferLength === pt.BLOCK_SIZE && (this.hashBuffer(), this.bufferLength = 0)
    }, e.prototype.digest = function () {
        if (!this.finished) {
            var e = 8 * this.bytesHashed,
                t = new DataView(this.buffer.buffer, this.buffer.byteOffset, this.buffer.byteLength),
                n = this.bufferLength;
            if (t.setUint8(this.bufferLength++, 128), n % pt.BLOCK_SIZE >= pt.BLOCK_SIZE - 8) {
                for (var r = this.bufferLength; r < pt.BLOCK_SIZE; r++) t.setUint8(r, 0);
                this.hashBuffer(), this.bufferLength = 0
            }
            for (r = this.bufferLength; r < pt.BLOCK_SIZE - 8; r++) t.setUint8(r, 0);
            t.setUint32(pt.BLOCK_SIZE - 8, Math.floor(e / 4294967296), !0), t.setUint32(pt.BLOCK_SIZE - 4, e), this.hashBuffer(), this.finished = !0
        }
        var i = new Uint8Array(pt.DIGEST_LENGTH);
        for (r = 0; r < 8; r++) i[4 * r] = this.state[r] >>> 24 & 255, i[4 * r + 1] = this.state[r] >>> 16 & 255, i[4 * r + 2] = this.state[r] >>> 8 & 255, i[4 * r + 3] = this.state[r] >>> 0 & 255;
        return i
    }, e.prototype.hashBuffer = function () {
        for (var e = this.buffer, t = this.state, n = t[0], r = t[1], i = t[2], o = t[3], s = t[4], a = t[5], u = t[6], c = t[7], l = 0; l < pt.BLOCK_SIZE; l++) {
            if (l < 16) this.temp[l] = (255 & e[4 * l]) << 24 | (255 & e[4 * l + 1]) << 16 | (255 & e[4 * l + 2]) << 8 | 255 & e[4 * l + 3]; else {
                var f = this.temp[l - 2], d = (f >>> 17 | f << 15) ^ (f >>> 19 | f << 13) ^ f >>> 10,
                    h = ((f = this.temp[l - 15]) >>> 7 | f << 25) ^ (f >>> 18 | f << 14) ^ f >>> 3;
                this.temp[l] = (d + this.temp[l - 7] | 0) + (h + this.temp[l - 16] | 0)
            }
            var p = (((s >>> 6 | s << 26) ^ (s >>> 11 | s << 21) ^ (s >>> 25 | s << 7)) + (s & a ^ ~s & u) | 0) + (c + (pt.KEY[l] + this.temp[l] | 0) | 0) | 0,
                g = ((n >>> 2 | n << 30) ^ (n >>> 13 | n << 19) ^ (n >>> 22 | n << 10)) + (n & r ^ n & i ^ r & i) | 0;
            c = u, u = a, a = s, s = o + p | 0, o = i, i = r, r = n, n = p + g | 0
        }
        t[0] += n, t[1] += r, t[2] += i, t[3] += o, t[4] += s, t[5] += a, t[6] += u, t[7] += c
    }, e
}();
ht.RawSha256 = gt, Object.defineProperty(ft, "__esModule", {value: !0}), ft.Sha256 = void 0;
var vt = $, mt = dt, yt = ht, St = Qe, wt = function () {
    function e(e) {
        if (this.hash = new yt.RawSha256, e) {
            this.outer = new yt.RawSha256;
            var t = function (e) {
                var t = (0, St.convertToBuffer)(e);
                if (t.byteLength > mt.BLOCK_SIZE) {
                    var n = new yt.RawSha256;
                    n.update(t), t = n.digest()
                }
                var r = new Uint8Array(mt.BLOCK_SIZE);
                return r.set(t), r
            }(e), n = new Uint8Array(mt.BLOCK_SIZE);
            n.set(t);
            for (var r = 0; r < mt.BLOCK_SIZE; r++) t[r] ^= 54, n[r] ^= 92;
            this.hash.update(t), this.outer.update(n);
            for (r = 0; r < t.byteLength; r++) t[r] = 0
        }
    }

    return e.prototype.update = function (e) {
        if (!(0, St.isEmptyData)(e) && !this.error) try {
            this.hash.update((0, St.convertToBuffer)(e))
        } catch (e) {
            this.error = e
        }
    }, e.prototype.digestSync = function () {
        if (this.error) throw this.error;
        return this.outer ? (this.outer.finished || this.outer.update(this.hash.digest()), this.outer.digest()) : this.hash.digest()
    }, e.prototype.digest = function () {
        return (0, vt.__awaiter)(this, void 0, void 0, (function () {
            return (0, vt.__generator)(this, (function (e) {
                return [2, this.digestSync()]
            }))
        }))
    }, e
}();
ft.Sha256 = wt, function (e) {
    Object.defineProperty(e, "__esModule", {value: !0}), (0, $.__exportStar)(ft, e)
}(lt);
var bt = {}, Et = {};
Object.defineProperty(Et, "__esModule", {value: !0}), Et.supportsZeroByteGCM = Et.supportsSubtleCrypto = Et.supportsSecureRandom = Et.supportsWebCrypto = void 0;
var Ct = $, _t = ["decrypt", "digest", "encrypt", "exportKey", "generateKey", "importKey", "sign", "verify"];

function At(e) {
    return "object" == typeof e && "object" == typeof e.crypto && "function" == typeof e.crypto.getRandomValues
}

function Pt(e) {
    return e && _t.every((function (t) {
        return "function" == typeof e[t]
    }))
}

Et.supportsWebCrypto = function (e) {
    return !(!At(e) || "object" != typeof e.crypto.subtle) && Pt(e.crypto.subtle)
}, Et.supportsSecureRandom = At, Et.supportsSubtleCrypto = Pt, Et.supportsZeroByteGCM = function (e) {
    return Ct.__awaiter(this, void 0, void 0, (function () {
        var t;
        return Ct.__generator(this, (function (n) {
            switch (n.label) {
                case 0:
                    if (!Pt(e)) return [2, !1];
                    n.label = 1;
                case 1:
                    return n.trys.push([1, 4, , 5]), [4, e.generateKey({
                        name: "AES-GCM",
                        length: 128
                    }, !1, ["encrypt"])];
                case 2:
                    return t = n.sent(), [4, e.encrypt({
                        name: "AES-GCM",
                        iv: new Uint8Array(Array(12)),
                        additionalData: new Uint8Array(Array(16)),
                        tagLength: 128
                    }, t, new Uint8Array(0))];
                case 3:
                    return [2, 16 === n.sent().byteLength];
                case 4:
                    return n.sent(), [2, !1];
                case 5:
                    return [2]
            }
        }))
    }))
}, function (e) {
    Object.defineProperty(e, "__esModule", {value: !0}), $.__exportStar(Et, e)
}(bt);
var kt = {}, xt = {};
Object.defineProperty(xt, "__esModule", {value: !0});
var It = {};
Object.defineProperty(It, "__esModule", {value: !0});
var Tt = {};
Object.defineProperty(Tt, "__esModule", {value: !0});
var Ut = {};
Object.defineProperty(Ut, "__esModule", {value: !0});
var Ot = {};
Object.defineProperty(Ot, "__esModule", {value: !0}), Ot.isMsWindow = void 0;
var Mt = ["decrypt", "digest", "encrypt", "exportKey", "generateKey", "importKey", "sign", "verify"];
Ot.isMsWindow = function (e) {
    if (function (e) {
        return "MSInputMethodContext" in e && "msCrypto" in e
    }(e) && void 0 !== e.msCrypto.subtle) {
        var t = e.msCrypto, n = t.getRandomValues, r = t.subtle;
        return Mt.map((function (e) {
            return r[e]
        })).concat(n).every((function (e) {
            return "function" == typeof e
        }))
    }
    return !1
}, function (e) {
    Object.defineProperty(e, "__esModule", {value: !0});
    var t = $;
    t.__exportStar(xt, e), t.__exportStar(It, e), t.__exportStar(Tt, e), t.__exportStar(Ut, e), t.__exportStar(Ot, e)
}(kt), Object.defineProperty(Ne, "__esModule", {value: !0}), Ne.Sha256 = void 0;
var Lt = De, Rt = Xe, Nt = lt, Dt = bt, Bt = kt, jt = Ve, Ft = function () {
    function e(e) {
        (0, Dt.supportsWebCrypto)((0, jt.locateWindow)()) ? this.hash = new Rt.Sha256(e) : (0, Bt.isMsWindow)((0, jt.locateWindow)()) ? this.hash = new Lt.Sha256(e) : this.hash = new Nt.Sha256(e)
    }

    return e.prototype.update = function (e, t) {
        this.hash.update(e, t)
    }, e.prototype.digest = function () {
        return this.hash.digest()
    }, e
}();
Ne.Sha256 = Ft, function (e) {
    Object.defineProperty(e, "__esModule", {value: !0}), e.WebCryptoSha256 = e.Ie11Sha256 = void 0, (0, $.__exportStar)(Ne, e);
    var t = De;
    Object.defineProperty(e, "Ie11Sha256", {
        enumerable: !0, get: function () {
            return t.Sha256
        }
    });
    var n = Xe;
    Object.defineProperty(e, "WebCryptoSha256", {
        enumerable: !0, get: function () {
            return n.Sha256
        }
    })
}(Re);
var zt = function () {
    function e(e) {
        this.statusCode = e.statusCode, this.headers = e.headers || {}, this.body = e.body
    }

    return e.isInstance = function (e) {
        if (!e) return !1;
        var t = e;
        return "number" == typeof t.statusCode && "object" == typeof t.headers
    }, e
}(), Kt = function () {
    function e(e) {
        this.method = e.method || "GET", this.hostname = e.hostname || "localhost", this.port = e.port, this.query = e.query || {}, this.headers = e.headers || {}, this.body = e.body, this.protocol = e.protocol ? ":" !== e.protocol.substr(-1) ? e.protocol + ":" : e.protocol : "https:", this.path = e.path ? "/" !== e.path.charAt(0) ? "/" + e.path : e.path : "/"
    }

    return e.isInstance = function (e) {
        if (!e) return !1;
        var t = e;
        return "method" in t && "protocol" in t && "hostname" in t && "path" in t && "object" == typeof t.query && "object" == typeof t.headers
    }, e.prototype.clone = function () {
        var t, n = new e(D(D({}, this), {headers: D({}, this.headers)}));
        return n.query && (n.query = (t = n.query, Object.keys(t).reduce((function (e, n) {
            var r, i = t[n];
            return D(D({}, e), ((r = {})[n] = Array.isArray(i) ? q(i) : i, r))
        }), {}))), n
    }, e
}();
var qt = function (e) {
    return encodeURIComponent(e).replace(/[!'()*]/g, Ht)
}, Ht = function (e) {
    return "%" + e.charCodeAt(0).toString(16).toUpperCase()
};

function Vt(e) {
    var t, n, r = [];
    try {
        for (var i = z(Object.keys(e).sort()), o = i.next(); !o.done; o = i.next()) {
            var s = o.value, a = e[s];
            if (s = qt(s), Array.isArray(a)) for (var u = 0, c = a.length; u < c; u++) r.push(s + "=" + qt(a[u])); else {
                var l = s;
                (a || "string" == typeof a) && (l += "=" + qt(a)), r.push(l)
            }
        }
    } catch (e) {
        t = {error: e}
    } finally {
        try {
            o && !o.done && (n = i.return) && n.call(i)
        } finally {
            if (t) throw t.error
        }
    }
    return r.join("&")
}

for (var Gt = function () {
    function e(e) {
        var t = (void 0 === e ? {} : e).requestTimeout;
        this.requestTimeout = t
    }

    return e.prototype.destroy = function () {
    }, e.prototype.handle = function (e, t) {
        var n = (void 0 === t ? {} : t).abortSignal, r = this.requestTimeout;
        if (null == n ? void 0 : n.aborted) {
            var i = new Error("Request aborted");
            return i.name = "AbortError", Promise.reject(i)
        }
        var o = e.path;
        if (e.query) {
            var s = Vt(e.query);
            s && (o += "?" + s)
        }
        var a = e.port, u = e.method, c = e.protocol + "//" + e.hostname + (a ? ":" + a : "") + o,
            l = {body: "GET" === u || "HEAD" === u ? void 0 : e.body, headers: new Headers(e.headers), method: u};
        "undefined" != typeof AbortController && (l.signal = n);
        var f, d = new Request(c, l), h = [fetch(d).then((function (e) {
            var t, n, r = e.headers, i = {};
            try {
                for (var o = z(r.entries()), s = o.next(); !s.done; s = o.next()) {
                    var a = s.value;
                    i[a[0]] = a[1]
                }
            } catch (e) {
                t = {error: e}
            } finally {
                try {
                    s && !s.done && (n = o.return) && n.call(o)
                } finally {
                    if (t) throw t.error
                }
            }
            return void 0 !== e.body ? {
                response: new zt({
                    headers: i,
                    statusCode: e.status,
                    body: e.body
                })
            } : e.blob().then((function (t) {
                return {response: new zt({headers: i, statusCode: e.status, body: t})}
            }))
        })), (f = r, void 0 === f && (f = 0), new Promise((function (e, t) {
            f && setTimeout((function () {
                var e = new Error("Request did not complete within " + f + " ms");
                e.name = "TimeoutError", t(e)
            }), f)
        })))];
        return n && h.push(new Promise((function (e, t) {
            n.onabort = function () {
                var e = new Error("Request aborted");
                e.name = "AbortError", t(e)
            }
        }))), Promise.race(h)
    }, e
}(), Wt = {}, $t = new Array(64), Yt = 0, Jt = "A".charCodeAt(0), Zt = "Z".charCodeAt(0); Yt + Jt <= Zt; Yt++) {
    var Xt = String.fromCharCode(Yt + Jt);
    Wt[Xt] = Yt, $t[Yt] = Xt
}
for (Yt = 0, Jt = "a".charCodeAt(0), Zt = "z".charCodeAt(0); Yt + Jt <= Zt; Yt++) {
    Xt = String.fromCharCode(Yt + Jt);
    var Qt = Yt + 26;
    Wt[Xt] = Qt, $t[Qt] = Xt
}
for (Yt = 0; Yt < 10; Yt++) {
    Wt[Yt.toString(10)] = Yt + 52;
    Xt = Yt.toString(10), Qt = Yt + 52;
    Wt[Xt] = Qt, $t[Qt] = Xt
}
Wt["+"] = 62, $t[62] = "+", Wt["/"] = 63, $t[63] = "/";

function en(e) {
    var t = e.length / 4 * 3;
    "==" === e.substr(-2) ? t -= 2 : "=" === e.substr(-1) && t--;
    for (var n = new ArrayBuffer(t), r = new DataView(n), i = 0; i < e.length; i += 4) {
        for (var o = 0, s = 0, a = i, u = i + 3; a <= u; a++) "=" !== e[a] ? (o |= Wt[e[a]] << 6 * (u - a), s += 6) : o >>= 6;
        var c = i / 4 * 3;
        o >>= s % 8;
        for (var l = Math.floor(s / 8), f = 0; f < l; f++) {
            var d = 8 * (l - f - 1);
            r.setUint8(c + f, (o & 255 << d) >> d)
        }
    }
    return new Uint8Array(n)
}

function tn(e) {
    for (var t = "", n = 0; n < e.length; n += 3) {
        for (var r = 0, i = 0, o = n, s = Math.min(n + 3, e.length); o < s; o++) r |= e[o] << 8 * (s - o - 1), i += 8;
        var a = Math.ceil(i / 6);
        r <<= 6 * a - i;
        for (var u = 1; u <= a; u++) {
            var c = 6 * (a - u);
            t += $t[(r & 63 << c) >> c]
        }
        t += "==".slice(0, 4 - a)
    }
    return t
}

var nn = function (e) {
    return "function" == typeof Blob && e instanceof Blob ? function (e) {
        return j(this, void 0, void 0, (function () {
            var t, n;
            return F(this, (function (r) {
                switch (r.label) {
                    case 0:
                        return [4, rn(e)];
                    case 1:
                        return t = r.sent(), n = en(t), [2, new Uint8Array(n)]
                }
            }))
        }))
    }(e) : function (e) {
        return j(this, void 0, void 0, (function () {
            var t, n, r, i, o, s, a;
            return F(this, (function (u) {
                switch (u.label) {
                    case 0:
                        t = new Uint8Array(0), n = e.getReader(), r = !1, u.label = 1;
                    case 1:
                        return r ? [3, 3] : [4, n.read()];
                    case 2:
                        return i = u.sent(), o = i.done, (s = i.value) && (a = t, (t = new Uint8Array(a.length + s.length)).set(a), t.set(s, a.length)), r = o, [3, 1];
                    case 3:
                        return [2, t]
                }
            }))
        }))
    }(e)
};

function rn(e) {
    return new Promise((function (t, n) {
        var r = new FileReader;
        r.onloadend = function () {
            var e;
            if (2 !== r.readyState) return n(new Error("Reader aborted too early"));
            var i = null !== (e = r.result) && void 0 !== e ? e : "", o = i.indexOf(","), s = o > -1 ? o + 1 : i.length;
            t(i.substring(s))
        }, r.onabort = function () {
            return n(new Error("Read aborted"))
        }, r.onerror = function () {
            return n(r.error)
        }, r.readAsDataURL(e)
    }))
}

var on = function (e) {
        return function () {
            return Promise.reject(e)
        }
    }, sn = {name: "retryMiddleware", tags: ["RETRY"], step: "finalizeRequest", priority: "high", override: !0},
    an = function (e) {
        return {
            applyToStack: function (t) {
                t.add(function (e) {
                    return function (t, n) {
                        return function (r) {
                            return j(void 0, void 0, void 0, (function () {
                                var i;
                                return F(this, (function (o) {
                                    return (null === (i = null == e ? void 0 : e.retryStrategy) || void 0 === i ? void 0 : i.mode) && (n.userAgent = q(n.userAgent || [], [["cfg/retry-mode", e.retryStrategy.mode]])), [2, e.retryStrategy.retry(t, r)]
                                }))
                            }))
                        }
                    }
                }(e), sn)
            }
        }
    },
    un = ["AuthFailure", "InvalidSignatureException", "RequestExpired", "RequestInTheFuture", "RequestTimeTooSkewed", "SignatureDoesNotMatch"],
    cn = ["BandwidthLimitExceeded", "EC2ThrottledException", "LimitExceededException", "PriorRequestNotComplete", "ProvisionedThroughputExceededException", "RequestLimitExceeded", "RequestThrottled", "RequestThrottledException", "SlowDown", "ThrottledException", "Throttling", "ThrottlingException", "TooManyRequestsException", "TransactionInProgressException"],
    ln = ["AbortError", "TimeoutError", "RequestTimeout", "RequestTimeoutException"], fn = [500, 502, 503, 504],
    dn = function (e) {
        var t, n;
        return 429 === (null === (t = e.$metadata) || void 0 === t ? void 0 : t.httpStatusCode) || cn.includes(e.name) || 1 == (null === (n = e.$retryable) || void 0 === n ? void 0 : n.throttling)
    }, hn = {exports: {}},
    pn = "undefined" != typeof crypto && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || "undefined" != typeof msCrypto && "function" == typeof window.msCrypto.getRandomValues && msCrypto.getRandomValues.bind(msCrypto);
if (pn) {
    var gn = new Uint8Array(16);
    hn.exports = function () {
        return pn(gn), gn
    }
} else {
    var vn = new Array(16);
    hn.exports = function () {
        for (var e, t = 0; t < 16; t++) 0 == (3 & t) && (e = 4294967296 * Math.random()), vn[t] = e >>> ((3 & t) << 3) & 255;
        return vn
    }
}
for (var mn = [], yn = 0; yn < 256; ++yn) mn[yn] = (yn + 256).toString(16).substr(1);
var Sn, wn, bn = function (e, t) {
    var n = t || 0, r = mn;
    return [r[e[n++]], r[e[n++]], r[e[n++]], r[e[n++]], "-", r[e[n++]], r[e[n++]], "-", r[e[n++]], r[e[n++]], "-", r[e[n++]], r[e[n++]], "-", r[e[n++]], r[e[n++]], r[e[n++]], r[e[n++]], r[e[n++]], r[e[n++]]].join("")
}, En = hn.exports, Cn = bn, _n = 0, An = 0;
var Pn = function (e, t, n) {
    var r = t && n || 0, i = t || [], o = (e = e || {}).node || Sn, s = void 0 !== e.clockseq ? e.clockseq : wn;
    if (null == o || null == s) {
        var a = En();
        null == o && (o = Sn = [1 | a[0], a[1], a[2], a[3], a[4], a[5]]), null == s && (s = wn = 16383 & (a[6] << 8 | a[7]))
    }
    var u = void 0 !== e.msecs ? e.msecs : (new Date).getTime(), c = void 0 !== e.nsecs ? e.nsecs : An + 1,
        l = u - _n + (c - An) / 1e4;
    if (l < 0 && void 0 === e.clockseq && (s = s + 1 & 16383), (l < 0 || u > _n) && void 0 === e.nsecs && (c = 0), c >= 1e4) throw new Error("uuid.v1(): Can't create more than 10M uuids/sec");
    _n = u, An = c, wn = s;
    var f = (1e4 * (268435455 & (u += 122192928e5)) + c) % 4294967296;
    i[r++] = f >>> 24 & 255, i[r++] = f >>> 16 & 255, i[r++] = f >>> 8 & 255, i[r++] = 255 & f;
    var d = u / 4294967296 * 1e4 & 268435455;
    i[r++] = d >>> 8 & 255, i[r++] = 255 & d, i[r++] = d >>> 24 & 15 | 16, i[r++] = d >>> 16 & 255, i[r++] = s >>> 8 | 128, i[r++] = 255 & s;
    for (var h = 0; h < 6; ++h) i[r + h] = o[h];
    return t || Cn(i)
}, kn = hn.exports, xn = bn;
var In = function (e, t, n) {
    var r = t && n || 0;
    "string" == typeof e && (t = "binary" === e ? new Array(16) : null, e = null);
    var i = (e = e || {}).random || (e.rng || kn)();
    if (i[6] = 15 & i[6] | 64, i[8] = 63 & i[8] | 128, t) for (var o = 0; o < 16; ++o) t[r + o] = i[o];
    return t || xn(i)
}, Tn = Pn, Un = In, On = Un;
On.v1 = Tn, On.v4 = Un;
var Mn = On, Ln = function (e, t) {
    return Math.floor(Math.min(2e4, Math.random() * Math.pow(2, t) * e))
}, Rn = function (e) {
    return !!e && (function (e) {
        return void 0 !== e.$retryable
    }(e) || function (e) {
        return un.includes(e.name)
    }(e) || dn(e) || function (e) {
        var t;
        return ln.includes(e.name) || fn.includes((null === (t = e.$metadata) || void 0 === t ? void 0 : t.httpStatusCode) || 0)
    }(e))
}, Nn = function () {
    function e(e, t) {
        var n, r, i, o, s, a, u, c;
        this.maxAttemptsProvider = e, this.mode = "standard", this.retryDecider = null !== (n = null == t ? void 0 : t.retryDecider) && void 0 !== n ? n : Rn, this.delayDecider = null !== (r = null == t ? void 0 : t.delayDecider) && void 0 !== r ? r : Ln, this.retryQuota = null !== (i = null == t ? void 0 : t.retryQuota) && void 0 !== i ? i : (s = o = 500, a = o, u = function (e) {
            return "TimeoutError" === e.name ? 10 : 5
        }, c = function (e) {
            return u(e) <= a
        }, Object.freeze({
            hasRetryTokens: c, retrieveRetryTokens: function (e) {
                if (!c(e)) throw new Error("No retry token available");
                var t = u(e);
                return a -= t, t
            }, releaseRetryTokens: function (e) {
                a += null != e ? e : 1, a = Math.min(a, s)
            }
        }))
    }

    return e.prototype.shouldRetry = function (e, t, n) {
        return t < n && this.retryDecider(e) && this.retryQuota.hasRetryTokens(e)
    }, e.prototype.getMaxAttempts = function () {
        return j(this, void 0, void 0, (function () {
            var e;
            return F(this, (function (t) {
                switch (t.label) {
                    case 0:
                        return t.trys.push([0, 2, , 3]), [4, this.maxAttemptsProvider()];
                    case 1:
                        return e = t.sent(), [3, 3];
                    case 2:
                        return t.sent(), e = 3, [3, 3];
                    case 3:
                        return [2, e]
                }
            }))
        }))
    }, e.prototype.retry = function (e, t) {
        return j(this, void 0, void 0, (function () {
            var n, r, i, o, s, a, u, c;
            return F(this, (function (l) {
                switch (l.label) {
                    case 0:
                        return r = 0, i = 0, [4, this.getMaxAttempts()];
                    case 1:
                        o = l.sent(), s = t.request, Kt.isInstance(s) && (s.headers["amz-sdk-invocation-id"] = Mn.v4()), a = function () {
                            var a, c, l, f, d;
                            return F(this, (function (h) {
                                switch (h.label) {
                                    case 0:
                                        return h.trys.push([0, 2, , 5]), Kt.isInstance(s) && (s.headers["amz-sdk-request"] = "attempt=" + (r + 1) + "; max=" + o), [4, e(t)];
                                    case 1:
                                        return a = h.sent(), c = a.response, l = a.output, u.retryQuota.releaseRetryTokens(n), l.$metadata.attempts = r + 1, l.$metadata.totalRetryDelay = i, [2, {
                                            value: {
                                                response: c,
                                                output: l
                                            }
                                        }];
                                    case 2:
                                        return f = h.sent(), r++, u.shouldRetry(f, r, o) ? (n = u.retryQuota.retrieveRetryTokens(f), d = u.delayDecider(dn(f) ? 500 : 100, r), i += d, [4, new Promise((function (e) {
                                            return setTimeout(e, d)
                                        }))]) : [3, 4];
                                    case 3:
                                        return h.sent(), [2, "continue"];
                                    case 4:
                                        throw f.$metadata || (f.$metadata = {}), f.$metadata.attempts = r, f.$metadata.totalRetryDelay = i, f;
                                    case 5:
                                        return [2]
                                }
                            }))
                        }, u = this, l.label = 2;
                    case 2:
                        return [5, a()];
                    case 3:
                        return "object" == typeof (c = l.sent()) ? [2, c.value] : [3, 2];
                    case 4:
                        return [2]
                }
            }))
        }))
    }, e
}(), Dn = function (e) {
    var t = Bn(e.maxAttempts);
    return D(D({}, e), {maxAttempts: t, retryStrategy: e.retryStrategy || new Nn(t)})
}, Bn = function (e) {
    if (void 0 === e && (e = 3), "number" == typeof e) {
        var t = Promise.resolve(e);
        return function () {
            return t
        }
    }
    return e
};

function jn(e) {
    if ("string" == typeof e) {
        for (var t = e.length, n = t - 1; n >= 0; n--) {
            var r = e.charCodeAt(n);
            r > 127 && r <= 2047 ? t++ : r > 2047 && r <= 65535 && (t += 2)
        }
        return t
    }
    return "number" == typeof e.byteLength ? e.byteLength : "number" == typeof e.size ? e.size : void 0
}

var Fn = {exports: {}}, zn = M(Fn.exports = function (e) {
    var t = {};

    function n(r) {
        if (t[r]) return t[r].exports;
        var i = t[r] = {i: r, l: !1, exports: {}};
        return e[r].call(i.exports, i, i.exports, n), i.l = !0, i.exports
    }

    return n.m = e, n.c = t, n.d = function (e, t, r) {
        n.o(e, t) || Object.defineProperty(e, t, {enumerable: !0, get: r})
    }, n.r = function (e) {
        "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {value: "Module"}), Object.defineProperty(e, "__esModule", {value: !0})
    }, n.t = function (e, t) {
        if (1 & t && (e = n(e)), 8 & t) return e;
        if (4 & t && "object" == typeof e && e && e.__esModule) return e;
        var r = Object.create(null);
        if (n.r(r), Object.defineProperty(r, "default", {
            enumerable: !0,
            value: e
        }), 2 & t && "string" != typeof e) for (var i in e) n.d(r, i, function (t) {
            return e[t]
        }.bind(null, i));
        return r
    }, n.n = function (e) {
        var t = e && e.__esModule ? function () {
            return e.default
        } : function () {
            return e
        };
        return n.d(t, "a", t), t
    }, n.o = function (e, t) {
        return Object.prototype.hasOwnProperty.call(e, t)
    }, n.p = "", n(n.s = 90)
}({
    17: function (e, t, n) {
        t.__esModule = !0, t.default = void 0;
        var r = n(18), i = function () {
            function e() {
            }

            return e.getFirstMatch = function (e, t) {
                var n = t.match(e);
                return n && n.length > 0 && n[1] || ""
            }, e.getSecondMatch = function (e, t) {
                var n = t.match(e);
                return n && n.length > 1 && n[2] || ""
            }, e.matchAndReturnConst = function (e, t, n) {
                if (e.test(t)) return n
            }, e.getWindowsVersionName = function (e) {
                switch (e) {
                    case"NT":
                        return "NT";
                    case"XP":
                    case"NT 5.1":
                        return "XP";
                    case"NT 5.0":
                        return "2000";
                    case"NT 5.2":
                        return "2003";
                    case"NT 6.0":
                        return "Vista";
                    case"NT 6.1":
                        return "7";
                    case"NT 6.2":
                        return "8";
                    case"NT 6.3":
                        return "8.1";
                    case"NT 10.0":
                        return "10";
                    default:
                        return
                }
            }, e.getMacOSVersionName = function (e) {
                var t = e.split(".").splice(0, 2).map((function (e) {
                    return parseInt(e, 10) || 0
                }));
                if (t.push(0), 10 === t[0]) switch (t[1]) {
                    case 5:
                        return "Leopard";
                    case 6:
                        return "Snow Leopard";
                    case 7:
                        return "Lion";
                    case 8:
                        return "Mountain Lion";
                    case 9:
                        return "Mavericks";
                    case 10:
                        return "Yosemite";
                    case 11:
                        return "El Capitan";
                    case 12:
                        return "Sierra";
                    case 13:
                        return "High Sierra";
                    case 14:
                        return "Mojave";
                    case 15:
                        return "Catalina";
                    default:
                        return
                }
            }, e.getAndroidVersionName = function (e) {
                var t = e.split(".").splice(0, 2).map((function (e) {
                    return parseInt(e, 10) || 0
                }));
                if (t.push(0), !(1 === t[0] && t[1] < 5)) return 1 === t[0] && t[1] < 6 ? "Cupcake" : 1 === t[0] && t[1] >= 6 ? "Donut" : 2 === t[0] && t[1] < 2 ? "Eclair" : 2 === t[0] && 2 === t[1] ? "Froyo" : 2 === t[0] && t[1] > 2 ? "Gingerbread" : 3 === t[0] ? "Honeycomb" : 4 === t[0] && t[1] < 1 ? "Ice Cream Sandwich" : 4 === t[0] && t[1] < 4 ? "Jelly Bean" : 4 === t[0] && t[1] >= 4 ? "KitKat" : 5 === t[0] ? "Lollipop" : 6 === t[0] ? "Marshmallow" : 7 === t[0] ? "Nougat" : 8 === t[0] ? "Oreo" : 9 === t[0] ? "Pie" : void 0
            }, e.getVersionPrecision = function (e) {
                return e.split(".").length
            }, e.compareVersions = function (t, n, r) {
                void 0 === r && (r = !1);
                var i = e.getVersionPrecision(t), o = e.getVersionPrecision(n), s = Math.max(i, o), a = 0,
                    u = e.map([t, n], (function (t) {
                        var n = s - e.getVersionPrecision(t), r = t + new Array(n + 1).join(".0");
                        return e.map(r.split("."), (function (e) {
                            return new Array(20 - e.length).join("0") + e
                        })).reverse()
                    }));
                for (r && (a = s - Math.min(i, o)), s -= 1; s >= a;) {
                    if (u[0][s] > u[1][s]) return 1;
                    if (u[0][s] === u[1][s]) {
                        if (s === a) return 0;
                        s -= 1
                    } else if (u[0][s] < u[1][s]) return -1
                }
            }, e.map = function (e, t) {
                var n, r = [];
                if (Array.prototype.map) return Array.prototype.map.call(e, t);
                for (n = 0; n < e.length; n += 1) r.push(t(e[n]));
                return r
            }, e.find = function (e, t) {
                var n, r;
                if (Array.prototype.find) return Array.prototype.find.call(e, t);
                for (n = 0, r = e.length; n < r; n += 1) {
                    var i = e[n];
                    if (t(i, n)) return i
                }
            }, e.assign = function (e) {
                for (var t, n, r = e, i = arguments.length, o = new Array(i > 1 ? i - 1 : 0), s = 1; s < i; s++) o[s - 1] = arguments[s];
                if (Object.assign) return Object.assign.apply(Object, [e].concat(o));
                var a = function () {
                    var e = o[t];
                    "object" == typeof e && null !== e && Object.keys(e).forEach((function (t) {
                        r[t] = e[t]
                    }))
                };
                for (t = 0, n = o.length; t < n; t += 1) a();
                return e
            }, e.getBrowserAlias = function (e) {
                return r.BROWSER_ALIASES_MAP[e]
            }, e.getBrowserTypeByAlias = function (e) {
                return r.BROWSER_MAP[e] || ""
            }, e
        }();
        t.default = i, e.exports = t.default
    }, 18: function (e, t, n) {
        t.__esModule = !0, t.ENGINE_MAP = t.OS_MAP = t.PLATFORMS_MAP = t.BROWSER_MAP = t.BROWSER_ALIASES_MAP = void 0, t.BROWSER_ALIASES_MAP = {
            "Amazon Silk": "amazon_silk",
            "Android Browser": "android",
            Bada: "bada",
            BlackBerry: "blackberry",
            Chrome: "chrome",
            Chromium: "chromium",
            Electron: "electron",
            Epiphany: "epiphany",
            Firefox: "firefox",
            Focus: "focus",
            Generic: "generic",
            "Google Search": "google_search",
            Googlebot: "googlebot",
            "Internet Explorer": "ie",
            "K-Meleon": "k_meleon",
            Maxthon: "maxthon",
            "Microsoft Edge": "edge",
            "MZ Browser": "mz",
            "NAVER Whale Browser": "naver",
            Opera: "opera",
            "Opera Coast": "opera_coast",
            PhantomJS: "phantomjs",
            Puffin: "puffin",
            QupZilla: "qupzilla",
            QQ: "qq",
            QQLite: "qqlite",
            Safari: "safari",
            Sailfish: "sailfish",
            "Samsung Internet for Android": "samsung_internet",
            SeaMonkey: "seamonkey",
            Sleipnir: "sleipnir",
            Swing: "swing",
            Tizen: "tizen",
            "UC Browser": "uc",
            Vivaldi: "vivaldi",
            "WebOS Browser": "webos",
            WeChat: "wechat",
            "Yandex Browser": "yandex",
            Roku: "roku"
        }, t.BROWSER_MAP = {
            amazon_silk: "Amazon Silk",
            android: "Android Browser",
            bada: "Bada",
            blackberry: "BlackBerry",
            chrome: "Chrome",
            chromium: "Chromium",
            electron: "Electron",
            epiphany: "Epiphany",
            firefox: "Firefox",
            focus: "Focus",
            generic: "Generic",
            googlebot: "Googlebot",
            google_search: "Google Search",
            ie: "Internet Explorer",
            k_meleon: "K-Meleon",
            maxthon: "Maxthon",
            edge: "Microsoft Edge",
            mz: "MZ Browser",
            naver: "NAVER Whale Browser",
            opera: "Opera",
            opera_coast: "Opera Coast",
            phantomjs: "PhantomJS",
            puffin: "Puffin",
            qupzilla: "QupZilla",
            qq: "QQ Browser",
            qqlite: "QQ Browser Lite",
            safari: "Safari",
            sailfish: "Sailfish",
            samsung_internet: "Samsung Internet for Android",
            seamonkey: "SeaMonkey",
            sleipnir: "Sleipnir",
            swing: "Swing",
            tizen: "Tizen",
            uc: "UC Browser",
            vivaldi: "Vivaldi",
            webos: "WebOS Browser",
            wechat: "WeChat",
            yandex: "Yandex Browser"
        }, t.PLATFORMS_MAP = {
            tablet: "tablet",
            mobile: "mobile",
            desktop: "desktop",
            tv: "tv"
        }, t.OS_MAP = {
            WindowsPhone: "Windows Phone",
            Windows: "Windows",
            MacOS: "macOS",
            iOS: "iOS",
            Android: "Android",
            WebOS: "WebOS",
            BlackBerry: "BlackBerry",
            Bada: "Bada",
            Tizen: "Tizen",
            Linux: "Linux",
            ChromeOS: "Chrome OS",
            PlayStation4: "PlayStation 4",
            Roku: "Roku"
        }, t.ENGINE_MAP = {
            EdgeHTML: "EdgeHTML",
            Blink: "Blink",
            Trident: "Trident",
            Presto: "Presto",
            Gecko: "Gecko",
            WebKit: "WebKit"
        }
    }, 90: function (e, t, n) {
        t.__esModule = !0, t.default = void 0;
        var r, i = (r = n(91)) && r.__esModule ? r : {default: r}, o = n(18);

        function s(e, t) {
            for (var n = 0; n < t.length; n++) {
                var r = t[n];
                r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r)
            }
        }

        var a = function () {
            function e() {
            }

            var t, n, r;
            return e.getParser = function (e, t) {
                if (void 0 === t && (t = !1), "string" != typeof e) throw new Error("UserAgent should be a string");
                return new i.default(e, t)
            }, e.parse = function (e) {
                return new i.default(e).getResult()
            }, t = e, r = [{
                key: "BROWSER_MAP", get: function () {
                    return o.BROWSER_MAP
                }
            }, {
                key: "ENGINE_MAP", get: function () {
                    return o.ENGINE_MAP
                }
            }, {
                key: "OS_MAP", get: function () {
                    return o.OS_MAP
                }
            }, {
                key: "PLATFORMS_MAP", get: function () {
                    return o.PLATFORMS_MAP
                }
            }], (n = null) && s(t.prototype, n), r && s(t, r), e
        }();
        t.default = a, e.exports = t.default
    }, 91: function (e, t, n) {
        t.__esModule = !0, t.default = void 0;
        var r = u(n(92)), i = u(n(93)), o = u(n(94)), s = u(n(95)), a = u(n(17));

        function u(e) {
            return e && e.__esModule ? e : {default: e}
        }

        var c = function () {
            function e(e, t) {
                if (void 0 === t && (t = !1), null == e || "" === e) throw new Error("UserAgent parameter can't be empty");
                this._ua = e, this.parsedResult = {}, !0 !== t && this.parse()
            }

            var t = e.prototype;
            return t.getUA = function () {
                return this._ua
            }, t.test = function (e) {
                return e.test(this._ua)
            }, t.parseBrowser = function () {
                var e = this;
                this.parsedResult.browser = {};
                var t = a.default.find(r.default, (function (t) {
                    if ("function" == typeof t.test) return t.test(e);
                    if (t.test instanceof Array) return t.test.some((function (t) {
                        return e.test(t)
                    }));
                    throw new Error("Browser's test function is not valid")
                }));
                return t && (this.parsedResult.browser = t.describe(this.getUA())), this.parsedResult.browser
            }, t.getBrowser = function () {
                return this.parsedResult.browser ? this.parsedResult.browser : this.parseBrowser()
            }, t.getBrowserName = function (e) {
                return e ? String(this.getBrowser().name).toLowerCase() || "" : this.getBrowser().name || ""
            }, t.getBrowserVersion = function () {
                return this.getBrowser().version
            }, t.getOS = function () {
                return this.parsedResult.os ? this.parsedResult.os : this.parseOS()
            }, t.parseOS = function () {
                var e = this;
                this.parsedResult.os = {};
                var t = a.default.find(i.default, (function (t) {
                    if ("function" == typeof t.test) return t.test(e);
                    if (t.test instanceof Array) return t.test.some((function (t) {
                        return e.test(t)
                    }));
                    throw new Error("Browser's test function is not valid")
                }));
                return t && (this.parsedResult.os = t.describe(this.getUA())), this.parsedResult.os
            }, t.getOSName = function (e) {
                var t = this.getOS().name;
                return e ? String(t).toLowerCase() || "" : t || ""
            }, t.getOSVersion = function () {
                return this.getOS().version
            }, t.getPlatform = function () {
                return this.parsedResult.platform ? this.parsedResult.platform : this.parsePlatform()
            }, t.getPlatformType = function (e) {
                void 0 === e && (e = !1);
                var t = this.getPlatform().type;
                return e ? String(t).toLowerCase() || "" : t || ""
            }, t.parsePlatform = function () {
                var e = this;
                this.parsedResult.platform = {};
                var t = a.default.find(o.default, (function (t) {
                    if ("function" == typeof t.test) return t.test(e);
                    if (t.test instanceof Array) return t.test.some((function (t) {
                        return e.test(t)
                    }));
                    throw new Error("Browser's test function is not valid")
                }));
                return t && (this.parsedResult.platform = t.describe(this.getUA())), this.parsedResult.platform
            }, t.getEngine = function () {
                return this.parsedResult.engine ? this.parsedResult.engine : this.parseEngine()
            }, t.getEngineName = function (e) {
                return e ? String(this.getEngine().name).toLowerCase() || "" : this.getEngine().name || ""
            }, t.parseEngine = function () {
                var e = this;
                this.parsedResult.engine = {};
                var t = a.default.find(s.default, (function (t) {
                    if ("function" == typeof t.test) return t.test(e);
                    if (t.test instanceof Array) return t.test.some((function (t) {
                        return e.test(t)
                    }));
                    throw new Error("Browser's test function is not valid")
                }));
                return t && (this.parsedResult.engine = t.describe(this.getUA())), this.parsedResult.engine
            }, t.parse = function () {
                return this.parseBrowser(), this.parseOS(), this.parsePlatform(), this.parseEngine(), this
            }, t.getResult = function () {
                return a.default.assign({}, this.parsedResult)
            }, t.satisfies = function (e) {
                var t = this, n = {}, r = 0, i = {}, o = 0;
                if (Object.keys(e).forEach((function (t) {
                    var s = e[t];
                    "string" == typeof s ? (i[t] = s, o += 1) : "object" == typeof s && (n[t] = s, r += 1)
                })), r > 0) {
                    var s = Object.keys(n), u = a.default.find(s, (function (e) {
                        return t.isOS(e)
                    }));
                    if (u) {
                        var c = this.satisfies(n[u]);
                        if (void 0 !== c) return c
                    }
                    var l = a.default.find(s, (function (e) {
                        return t.isPlatform(e)
                    }));
                    if (l) {
                        var f = this.satisfies(n[l]);
                        if (void 0 !== f) return f
                    }
                }
                if (o > 0) {
                    var d = Object.keys(i), h = a.default.find(d, (function (e) {
                        return t.isBrowser(e, !0)
                    }));
                    if (void 0 !== h) return this.compareVersion(i[h])
                }
            }, t.isBrowser = function (e, t) {
                void 0 === t && (t = !1);
                var n = this.getBrowserName().toLowerCase(), r = e.toLowerCase(),
                    i = a.default.getBrowserTypeByAlias(r);
                return t && i && (r = i.toLowerCase()), r === n
            }, t.compareVersion = function (e) {
                var t = [0], n = e, r = !1, i = this.getBrowserVersion();
                if ("string" == typeof i) return ">" === e[0] || "<" === e[0] ? (n = e.substr(1), "=" === e[1] ? (r = !0, n = e.substr(2)) : t = [], ">" === e[0] ? t.push(1) : t.push(-1)) : "=" === e[0] ? n = e.substr(1) : "~" === e[0] && (r = !0, n = e.substr(1)), t.indexOf(a.default.compareVersions(i, n, r)) > -1
            }, t.isOS = function (e) {
                return this.getOSName(!0) === String(e).toLowerCase()
            }, t.isPlatform = function (e) {
                return this.getPlatformType(!0) === String(e).toLowerCase()
            }, t.isEngine = function (e) {
                return this.getEngineName(!0) === String(e).toLowerCase()
            }, t.is = function (e, t) {
                return void 0 === t && (t = !1), this.isBrowser(e, t) || this.isOS(e) || this.isPlatform(e)
            }, t.some = function (e) {
                var t = this;
                return void 0 === e && (e = []), e.some((function (e) {
                    return t.is(e)
                }))
            }, e
        }();
        t.default = c, e.exports = t.default
    }, 92: function (e, t, n) {
        t.__esModule = !0, t.default = void 0;
        var r, i = (r = n(17)) && r.__esModule ? r : {default: r}, o = /version\/(\d+(\.?_?\d+)+)/i, s = [{
            test: [/googlebot/i], describe: function (e) {
                var t = {name: "Googlebot"},
                    n = i.default.getFirstMatch(/googlebot\/(\d+(\.\d+))/i, e) || i.default.getFirstMatch(o, e);
                return n && (t.version = n), t
            }
        }, {
            test: [/opera/i], describe: function (e) {
                var t = {name: "Opera"},
                    n = i.default.getFirstMatch(o, e) || i.default.getFirstMatch(/(?:opera)[\s/](\d+(\.?_?\d+)+)/i, e);
                return n && (t.version = n), t
            }
        }, {
            test: [/opr\/|opios/i], describe: function (e) {
                var t = {name: "Opera"},
                    n = i.default.getFirstMatch(/(?:opr|opios)[\s/](\S+)/i, e) || i.default.getFirstMatch(o, e);
                return n && (t.version = n), t
            }
        }, {
            test: [/SamsungBrowser/i], describe: function (e) {
                var t = {name: "Samsung Internet for Android"},
                    n = i.default.getFirstMatch(o, e) || i.default.getFirstMatch(/(?:SamsungBrowser)[\s/](\d+(\.?_?\d+)+)/i, e);
                return n && (t.version = n), t
            }
        }, {
            test: [/Whale/i], describe: function (e) {
                var t = {name: "NAVER Whale Browser"},
                    n = i.default.getFirstMatch(o, e) || i.default.getFirstMatch(/(?:whale)[\s/](\d+(?:\.\d+)+)/i, e);
                return n && (t.version = n), t
            }
        }, {
            test: [/MZBrowser/i], describe: function (e) {
                var t = {name: "MZ Browser"},
                    n = i.default.getFirstMatch(/(?:MZBrowser)[\s/](\d+(?:\.\d+)+)/i, e) || i.default.getFirstMatch(o, e);
                return n && (t.version = n), t
            }
        }, {
            test: [/focus/i], describe: function (e) {
                var t = {name: "Focus"},
                    n = i.default.getFirstMatch(/(?:focus)[\s/](\d+(?:\.\d+)+)/i, e) || i.default.getFirstMatch(o, e);
                return n && (t.version = n), t
            }
        }, {
            test: [/swing/i], describe: function (e) {
                var t = {name: "Swing"},
                    n = i.default.getFirstMatch(/(?:swing)[\s/](\d+(?:\.\d+)+)/i, e) || i.default.getFirstMatch(o, e);
                return n && (t.version = n), t
            }
        }, {
            test: [/coast/i], describe: function (e) {
                var t = {name: "Opera Coast"},
                    n = i.default.getFirstMatch(o, e) || i.default.getFirstMatch(/(?:coast)[\s/](\d+(\.?_?\d+)+)/i, e);
                return n && (t.version = n), t
            }
        }, {
            test: [/opt\/\d+(?:.?_?\d+)+/i], describe: function (e) {
                var t = {name: "Opera Touch"},
                    n = i.default.getFirstMatch(/(?:opt)[\s/](\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(o, e);
                return n && (t.version = n), t
            }
        }, {
            test: [/yabrowser/i], describe: function (e) {
                var t = {name: "Yandex Browser"},
                    n = i.default.getFirstMatch(/(?:yabrowser)[\s/](\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(o, e);
                return n && (t.version = n), t
            }
        }, {
            test: [/ucbrowser/i], describe: function (e) {
                var t = {name: "UC Browser"},
                    n = i.default.getFirstMatch(o, e) || i.default.getFirstMatch(/(?:ucbrowser)[\s/](\d+(\.?_?\d+)+)/i, e);
                return n && (t.version = n), t
            }
        }, {
            test: [/Maxthon|mxios/i], describe: function (e) {
                var t = {name: "Maxthon"},
                    n = i.default.getFirstMatch(o, e) || i.default.getFirstMatch(/(?:Maxthon|mxios)[\s/](\d+(\.?_?\d+)+)/i, e);
                return n && (t.version = n), t
            }
        }, {
            test: [/epiphany/i], describe: function (e) {
                var t = {name: "Epiphany"},
                    n = i.default.getFirstMatch(o, e) || i.default.getFirstMatch(/(?:epiphany)[\s/](\d+(\.?_?\d+)+)/i, e);
                return n && (t.version = n), t
            }
        }, {
            test: [/puffin/i], describe: function (e) {
                var t = {name: "Puffin"},
                    n = i.default.getFirstMatch(o, e) || i.default.getFirstMatch(/(?:puffin)[\s/](\d+(\.?_?\d+)+)/i, e);
                return n && (t.version = n), t
            }
        }, {
            test: [/sleipnir/i], describe: function (e) {
                var t = {name: "Sleipnir"},
                    n = i.default.getFirstMatch(o, e) || i.default.getFirstMatch(/(?:sleipnir)[\s/](\d+(\.?_?\d+)+)/i, e);
                return n && (t.version = n), t
            }
        }, {
            test: [/k-meleon/i], describe: function (e) {
                var t = {name: "K-Meleon"},
                    n = i.default.getFirstMatch(o, e) || i.default.getFirstMatch(/(?:k-meleon)[\s/](\d+(\.?_?\d+)+)/i, e);
                return n && (t.version = n), t
            }
        }, {
            test: [/micromessenger/i], describe: function (e) {
                var t = {name: "WeChat"},
                    n = i.default.getFirstMatch(/(?:micromessenger)[\s/](\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(o, e);
                return n && (t.version = n), t
            }
        }, {
            test: [/qqbrowser/i], describe: function (e) {
                var t = {name: /qqbrowserlite/i.test(e) ? "QQ Browser Lite" : "QQ Browser"},
                    n = i.default.getFirstMatch(/(?:qqbrowserlite|qqbrowser)[/](\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(o, e);
                return n && (t.version = n), t
            }
        }, {
            test: [/msie|trident/i], describe: function (e) {
                var t = {name: "Internet Explorer"}, n = i.default.getFirstMatch(/(?:msie |rv:)(\d+(\.?_?\d+)+)/i, e);
                return n && (t.version = n), t
            }
        }, {
            test: [/\sedg\//i], describe: function (e) {
                var t = {name: "Microsoft Edge"}, n = i.default.getFirstMatch(/\sedg\/(\d+(\.?_?\d+)+)/i, e);
                return n && (t.version = n), t
            }
        }, {
            test: [/edg([ea]|ios)/i], describe: function (e) {
                var t = {name: "Microsoft Edge"}, n = i.default.getSecondMatch(/edg([ea]|ios)\/(\d+(\.?_?\d+)+)/i, e);
                return n && (t.version = n), t
            }
        }, {
            test: [/vivaldi/i], describe: function (e) {
                var t = {name: "Vivaldi"}, n = i.default.getFirstMatch(/vivaldi\/(\d+(\.?_?\d+)+)/i, e);
                return n && (t.version = n), t
            }
        }, {
            test: [/seamonkey/i], describe: function (e) {
                var t = {name: "SeaMonkey"}, n = i.default.getFirstMatch(/seamonkey\/(\d+(\.?_?\d+)+)/i, e);
                return n && (t.version = n), t
            }
        }, {
            test: [/sailfish/i], describe: function (e) {
                var t = {name: "Sailfish"}, n = i.default.getFirstMatch(/sailfish\s?browser\/(\d+(\.\d+)?)/i, e);
                return n && (t.version = n), t
            }
        }, {
            test: [/silk/i], describe: function (e) {
                var t = {name: "Amazon Silk"}, n = i.default.getFirstMatch(/silk\/(\d+(\.?_?\d+)+)/i, e);
                return n && (t.version = n), t
            }
        }, {
            test: [/phantom/i], describe: function (e) {
                var t = {name: "PhantomJS"}, n = i.default.getFirstMatch(/phantomjs\/(\d+(\.?_?\d+)+)/i, e);
                return n && (t.version = n), t
            }
        }, {
            test: [/slimerjs/i], describe: function (e) {
                var t = {name: "SlimerJS"}, n = i.default.getFirstMatch(/slimerjs\/(\d+(\.?_?\d+)+)/i, e);
                return n && (t.version = n), t
            }
        }, {
            test: [/blackberry|\bbb\d+/i, /rim\stablet/i], describe: function (e) {
                var t = {name: "BlackBerry"},
                    n = i.default.getFirstMatch(o, e) || i.default.getFirstMatch(/blackberry[\d]+\/(\d+(\.?_?\d+)+)/i, e);
                return n && (t.version = n), t
            }
        }, {
            test: [/(web|hpw)[o0]s/i], describe: function (e) {
                var t = {name: "WebOS Browser"},
                    n = i.default.getFirstMatch(o, e) || i.default.getFirstMatch(/w(?:eb)?[o0]sbrowser\/(\d+(\.?_?\d+)+)/i, e);
                return n && (t.version = n), t
            }
        }, {
            test: [/bada/i], describe: function (e) {
                var t = {name: "Bada"}, n = i.default.getFirstMatch(/dolfin\/(\d+(\.?_?\d+)+)/i, e);
                return n && (t.version = n), t
            }
        }, {
            test: [/tizen/i], describe: function (e) {
                var t = {name: "Tizen"},
                    n = i.default.getFirstMatch(/(?:tizen\s?)?browser\/(\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(o, e);
                return n && (t.version = n), t
            }
        }, {
            test: [/qupzilla/i], describe: function (e) {
                var t = {name: "QupZilla"},
                    n = i.default.getFirstMatch(/(?:qupzilla)[\s/](\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(o, e);
                return n && (t.version = n), t
            }
        }, {
            test: [/firefox|iceweasel|fxios/i], describe: function (e) {
                var t = {name: "Firefox"},
                    n = i.default.getFirstMatch(/(?:firefox|iceweasel|fxios)[\s/](\d+(\.?_?\d+)+)/i, e);
                return n && (t.version = n), t
            }
        }, {
            test: [/electron/i], describe: function (e) {
                var t = {name: "Electron"}, n = i.default.getFirstMatch(/(?:electron)\/(\d+(\.?_?\d+)+)/i, e);
                return n && (t.version = n), t
            }
        }, {
            test: [/MiuiBrowser/i], describe: function (e) {
                var t = {name: "Miui"}, n = i.default.getFirstMatch(/(?:MiuiBrowser)[\s/](\d+(\.?_?\d+)+)/i, e);
                return n && (t.version = n), t
            }
        }, {
            test: [/chromium/i], describe: function (e) {
                var t = {name: "Chromium"},
                    n = i.default.getFirstMatch(/(?:chromium)[\s/](\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(o, e);
                return n && (t.version = n), t
            }
        }, {
            test: [/chrome|crios|crmo/i], describe: function (e) {
                var t = {name: "Chrome"}, n = i.default.getFirstMatch(/(?:chrome|crios|crmo)\/(\d+(\.?_?\d+)+)/i, e);
                return n && (t.version = n), t
            }
        }, {
            test: [/GSA/i], describe: function (e) {
                var t = {name: "Google Search"}, n = i.default.getFirstMatch(/(?:GSA)\/(\d+(\.?_?\d+)+)/i, e);
                return n && (t.version = n), t
            }
        }, {
            test: function (e) {
                var t = !e.test(/like android/i), n = e.test(/android/i);
                return t && n
            }, describe: function (e) {
                var t = {name: "Android Browser"}, n = i.default.getFirstMatch(o, e);
                return n && (t.version = n), t
            }
        }, {
            test: [/playstation 4/i], describe: function (e) {
                var t = {name: "PlayStation 4"}, n = i.default.getFirstMatch(o, e);
                return n && (t.version = n), t
            }
        }, {
            test: [/safari|applewebkit/i], describe: function (e) {
                var t = {name: "Safari"}, n = i.default.getFirstMatch(o, e);
                return n && (t.version = n), t
            }
        }, {
            test: [/.*/i], describe: function (e) {
                var t = -1 !== e.search("\\(") ? /^(.*)\/(.*)[ \t]\((.*)/ : /^(.*)\/(.*) /;
                return {name: i.default.getFirstMatch(t, e), version: i.default.getSecondMatch(t, e)}
            }
        }];
        t.default = s, e.exports = t.default
    }, 93: function (e, t, n) {
        t.__esModule = !0, t.default = void 0;
        var r, i = (r = n(17)) && r.__esModule ? r : {default: r}, o = n(18), s = [{
            test: [/Roku\/DVP/], describe: function (e) {
                var t = i.default.getFirstMatch(/Roku\/DVP-(\d+\.\d+)/i, e);
                return {name: o.OS_MAP.Roku, version: t}
            }
        }, {
            test: [/windows phone/i], describe: function (e) {
                var t = i.default.getFirstMatch(/windows phone (?:os)?\s?(\d+(\.\d+)*)/i, e);
                return {name: o.OS_MAP.WindowsPhone, version: t}
            }
        }, {
            test: [/windows /i], describe: function (e) {
                var t = i.default.getFirstMatch(/Windows ((NT|XP)( \d\d?.\d)?)/i, e),
                    n = i.default.getWindowsVersionName(t);
                return {name: o.OS_MAP.Windows, version: t, versionName: n}
            }
        }, {
            test: [/Macintosh(.*?) FxiOS(.*?)\//], describe: function (e) {
                var t = {name: o.OS_MAP.iOS}, n = i.default.getSecondMatch(/(Version\/)(\d[\d.]+)/, e);
                return n && (t.version = n), t
            }
        }, {
            test: [/macintosh/i], describe: function (e) {
                var t = i.default.getFirstMatch(/mac os x (\d+(\.?_?\d+)+)/i, e).replace(/[_\s]/g, "."),
                    n = i.default.getMacOSVersionName(t), r = {name: o.OS_MAP.MacOS, version: t};
                return n && (r.versionName = n), r
            }
        }, {
            test: [/(ipod|iphone|ipad)/i], describe: function (e) {
                var t = i.default.getFirstMatch(/os (\d+([_\s]\d+)*) like mac os x/i, e).replace(/[_\s]/g, ".");
                return {name: o.OS_MAP.iOS, version: t}
            }
        }, {
            test: function (e) {
                var t = !e.test(/like android/i), n = e.test(/android/i);
                return t && n
            }, describe: function (e) {
                var t = i.default.getFirstMatch(/android[\s/-](\d+(\.\d+)*)/i, e),
                    n = i.default.getAndroidVersionName(t), r = {name: o.OS_MAP.Android, version: t};
                return n && (r.versionName = n), r
            }
        }, {
            test: [/(web|hpw)[o0]s/i], describe: function (e) {
                var t = i.default.getFirstMatch(/(?:web|hpw)[o0]s\/(\d+(\.\d+)*)/i, e), n = {name: o.OS_MAP.WebOS};
                return t && t.length && (n.version = t), n
            }
        }, {
            test: [/blackberry|\bbb\d+/i, /rim\stablet/i], describe: function (e) {
                var t = i.default.getFirstMatch(/rim\stablet\sos\s(\d+(\.\d+)*)/i, e) || i.default.getFirstMatch(/blackberry\d+\/(\d+([_\s]\d+)*)/i, e) || i.default.getFirstMatch(/\bbb(\d+)/i, e);
                return {name: o.OS_MAP.BlackBerry, version: t}
            }
        }, {
            test: [/bada/i], describe: function (e) {
                var t = i.default.getFirstMatch(/bada\/(\d+(\.\d+)*)/i, e);
                return {name: o.OS_MAP.Bada, version: t}
            }
        }, {
            test: [/tizen/i], describe: function (e) {
                var t = i.default.getFirstMatch(/tizen[/\s](\d+(\.\d+)*)/i, e);
                return {name: o.OS_MAP.Tizen, version: t}
            }
        }, {
            test: [/linux/i], describe: function () {
                return {name: o.OS_MAP.Linux}
            }
        }, {
            test: [/CrOS/], describe: function () {
                return {name: o.OS_MAP.ChromeOS}
            }
        }, {
            test: [/PlayStation 4/], describe: function (e) {
                var t = i.default.getFirstMatch(/PlayStation 4[/\s](\d+(\.\d+)*)/i, e);
                return {name: o.OS_MAP.PlayStation4, version: t}
            }
        }];
        t.default = s, e.exports = t.default
    }, 94: function (e, t, n) {
        t.__esModule = !0, t.default = void 0;
        var r, i = (r = n(17)) && r.__esModule ? r : {default: r}, o = n(18), s = [{
            test: [/googlebot/i], describe: function () {
                return {type: "bot", vendor: "Google"}
            }
        }, {
            test: [/huawei/i], describe: function (e) {
                var t = i.default.getFirstMatch(/(can-l01)/i, e) && "Nova",
                    n = {type: o.PLATFORMS_MAP.mobile, vendor: "Huawei"};
                return t && (n.model = t), n
            }
        }, {
            test: [/nexus\s*(?:7|8|9|10).*/i], describe: function () {
                return {type: o.PLATFORMS_MAP.tablet, vendor: "Nexus"}
            }
        }, {
            test: [/ipad/i], describe: function () {
                return {type: o.PLATFORMS_MAP.tablet, vendor: "Apple", model: "iPad"}
            }
        }, {
            test: [/Macintosh(.*?) FxiOS(.*?)\//], describe: function () {
                return {type: o.PLATFORMS_MAP.tablet, vendor: "Apple", model: "iPad"}
            }
        }, {
            test: [/kftt build/i], describe: function () {
                return {type: o.PLATFORMS_MAP.tablet, vendor: "Amazon", model: "Kindle Fire HD 7"}
            }
        }, {
            test: [/silk/i], describe: function () {
                return {type: o.PLATFORMS_MAP.tablet, vendor: "Amazon"}
            }
        }, {
            test: [/tablet(?! pc)/i], describe: function () {
                return {type: o.PLATFORMS_MAP.tablet}
            }
        }, {
            test: function (e) {
                var t = e.test(/ipod|iphone/i), n = e.test(/like (ipod|iphone)/i);
                return t && !n
            }, describe: function (e) {
                var t = i.default.getFirstMatch(/(ipod|iphone)/i, e);
                return {type: o.PLATFORMS_MAP.mobile, vendor: "Apple", model: t}
            }
        }, {
            test: [/nexus\s*[0-6].*/i, /galaxy nexus/i], describe: function () {
                return {type: o.PLATFORMS_MAP.mobile, vendor: "Nexus"}
            }
        }, {
            test: [/[^-]mobi/i], describe: function () {
                return {type: o.PLATFORMS_MAP.mobile}
            }
        }, {
            test: function (e) {
                return "blackberry" === e.getBrowserName(!0)
            }, describe: function () {
                return {type: o.PLATFORMS_MAP.mobile, vendor: "BlackBerry"}
            }
        }, {
            test: function (e) {
                return "bada" === e.getBrowserName(!0)
            }, describe: function () {
                return {type: o.PLATFORMS_MAP.mobile}
            }
        }, {
            test: function (e) {
                return "windows phone" === e.getBrowserName()
            }, describe: function () {
                return {type: o.PLATFORMS_MAP.mobile, vendor: "Microsoft"}
            }
        }, {
            test: function (e) {
                var t = Number(String(e.getOSVersion()).split(".")[0]);
                return "android" === e.getOSName(!0) && t >= 3
            }, describe: function () {
                return {type: o.PLATFORMS_MAP.tablet}
            }
        }, {
            test: function (e) {
                return "android" === e.getOSName(!0)
            }, describe: function () {
                return {type: o.PLATFORMS_MAP.mobile}
            }
        }, {
            test: function (e) {
                return "macos" === e.getOSName(!0)
            }, describe: function () {
                return {type: o.PLATFORMS_MAP.desktop, vendor: "Apple"}
            }
        }, {
            test: function (e) {
                return "windows" === e.getOSName(!0)
            }, describe: function () {
                return {type: o.PLATFORMS_MAP.desktop}
            }
        }, {
            test: function (e) {
                return "linux" === e.getOSName(!0)
            }, describe: function () {
                return {type: o.PLATFORMS_MAP.desktop}
            }
        }, {
            test: function (e) {
                return "playstation 4" === e.getOSName(!0)
            }, describe: function () {
                return {type: o.PLATFORMS_MAP.tv}
            }
        }, {
            test: function (e) {
                return "roku" === e.getOSName(!0)
            }, describe: function () {
                return {type: o.PLATFORMS_MAP.tv}
            }
        }];
        t.default = s, e.exports = t.default
    }, 95: function (e, t, n) {
        t.__esModule = !0, t.default = void 0;
        var r, i = (r = n(17)) && r.__esModule ? r : {default: r}, o = n(18), s = [{
            test: function (e) {
                return "microsoft edge" === e.getBrowserName(!0)
            }, describe: function (e) {
                if (/\sedg\//i.test(e)) return {name: o.ENGINE_MAP.Blink};
                var t = i.default.getFirstMatch(/edge\/(\d+(\.?_?\d+)+)/i, e);
                return {name: o.ENGINE_MAP.EdgeHTML, version: t}
            }
        }, {
            test: [/trident/i], describe: function (e) {
                var t = {name: o.ENGINE_MAP.Trident}, n = i.default.getFirstMatch(/trident\/(\d+(\.?_?\d+)+)/i, e);
                return n && (t.version = n), t
            }
        }, {
            test: function (e) {
                return e.test(/presto/i)
            }, describe: function (e) {
                var t = {name: o.ENGINE_MAP.Presto}, n = i.default.getFirstMatch(/presto\/(\d+(\.?_?\d+)+)/i, e);
                return n && (t.version = n), t
            }
        }, {
            test: function (e) {
                var t = e.test(/gecko/i), n = e.test(/like gecko/i);
                return t && !n
            }, describe: function (e) {
                var t = {name: o.ENGINE_MAP.Gecko}, n = i.default.getFirstMatch(/gecko\/(\d+(\.?_?\d+)+)/i, e);
                return n && (t.version = n), t
            }
        }, {
            test: [/(apple)?webkit\/537\.36/i], describe: function () {
                return {name: o.ENGINE_MAP.Blink}
            }
        }, {
            test: [/(apple)?webkit/i], describe: function (e) {
                var t = {name: o.ENGINE_MAP.WebKit}, n = i.default.getFirstMatch(/webkit\/(\d+(\.?_?\d+)+)/i, e);
                return n && (t.version = n), t
            }
        }];
        t.default = s, e.exports = t.default
    }
})), Kn = function (e) {
    var t = e.serviceId, n = e.clientVersion;
    return function () {
        return j(void 0, void 0, void 0, (function () {
            var e, r, i, o, s, a, u, c, l;
            return F(this, (function (f) {
                return e = (null === (i = null === window || void 0 === window ? void 0 : window.navigator) || void 0 === i ? void 0 : i.userAgent) ? zn.parse(window.navigator.userAgent) : void 0, r = [["aws-sdk-js", n], ["os/" + ((null === (o = null == e ? void 0 : e.os) || void 0 === o ? void 0 : o.name) || "other"), null === (s = null == e ? void 0 : e.os) || void 0 === s ? void 0 : s.version], ["lang/js"], ["md/browser", (null !== (u = null === (a = null == e ? void 0 : e.browser) || void 0 === a ? void 0 : a.name) && void 0 !== u ? u : "unknown") + "_" + (null !== (l = null === (c = null == e ? void 0 : e.browser) || void 0 === c ? void 0 : c.version) && void 0 !== l ? l : "unknown")]], t && r.push(["api/" + t, n]), [2, r]
            }))
        }))
    }
};
var qn = function (e) {
    var t, n = new URL(e), r = n.hostname, i = n.pathname, o = n.port, s = n.protocol, a = n.search;
    return a && (t = function (e) {
        var t, n, r = {};
        if (e = e.replace(/^\?/, "")) try {
            for (var i = z(e.split("&")), o = i.next(); !o.done; o = i.next()) {
                var s = K(o.value.split("="), 2), a = s[0], u = s[1], c = void 0 === u ? null : u;
                a = decodeURIComponent(a), c && (c = decodeURIComponent(c)), a in r ? Array.isArray(r[a]) ? r[a].push(c) : r[a] = [r[a], c] : r[a] = c
            }
        } catch (e) {
            t = {error: e}
        } finally {
            try {
                o && !o.done && (n = i.return) && n.call(i)
            } finally {
                if (t) throw t.error
            }
        }
        return r
    }(a)), {hostname: r, port: o ? parseInt(o) : void 0, protocol: s, path: i, query: t}
}, Hn = function (e) {
    var t;
    return D(D({}, e), {
        tls: null === (t = e.tls) || void 0 === t || t, endpoint: e.endpoint ? Vn(e) : function () {
            return Gn(e)
        }, isCustomEndpoint: !!e.endpoint
    })
}, Vn = function (e) {
    var t = e.endpoint, n = e.urlParser;
    if ("string" == typeof t) {
        var r = Promise.resolve(n(t));
        return function () {
            return r
        }
    }
    if ("object" == typeof t) {
        var i = Promise.resolve(t);
        return function () {
            return i
        }
    }
    return t
}, Gn = function (e) {
    return j(void 0, void 0, void 0, (function () {
        var t, n, r, i, o;
        return F(this, (function (s) {
            switch (s.label) {
                case 0:
                    return t = e.tls, n = void 0 === t || t, [4, e.region()];
                case 1:
                    if (r = s.sent(), !new RegExp(/^([a-zA-Z0-9]|[a-zA-Z0-9][a-zA-Z0-9-]{0,61}[a-zA-Z0-9])$/).test(r)) throw new Error("Invalid region in client config");
                    return [4, e.regionInfoProvider(r)];
                case 2:
                    if (!(i = (null !== (o = s.sent()) && void 0 !== o ? o : {}).hostname)) throw new Error("Cannot resolve hostname from client config");
                    return [2, e.urlParser((n ? "https:" : "http:") + "//" + i)]
            }
        }))
    }))
}, Wn = function (e) {
    if (!e.region) throw new Error("Region is missing");
    return D(D({}, e), {region: $n(e.region)})
}, $n = function (e) {
    if ("string" == typeof e) {
        var t = Promise.resolve(e);
        return function () {
            return t
        }
    }
    return e
};
var Yn = {step: "build", tags: ["SET_CONTENT_LENGTH", "CONTENT_LENGTH"], name: "contentLengthMiddleware", override: !0},
    Jn = function (e) {
        return {
            applyToStack: function (t) {
                t.add(function (e) {
                    var t = this;
                    return function (n) {
                        return function (r) {
                            return j(t, void 0, void 0, (function () {
                                var t, i, o, s, a;
                                return F(this, (function (u) {
                                    return t = r.request, Kt.isInstance(t) && (i = t.body, o = t.headers, i && -1 === Object.keys(o).map((function (e) {
                                        return e.toLowerCase()
                                    })).indexOf("content-length") && void 0 !== (s = e(i)) && (t.headers = D(D({}, t.headers), ((a = {})["content-length"] = String(s), a)))), [2, n(D(D({}, r), {request: t}))]
                                }))
                            }))
                        }
                    }
                }(e.bodyLengthChecker), Yn)
            }
        }
    };
var Zn = {name: "hostHeaderMiddleware", step: "build", priority: "low", tags: ["HOST"], override: !0},
    Xn = function (e) {
        return {
            applyToStack: function (t) {
                t.add(function (e) {
                    return function (t) {
                        return function (n) {
                            return j(void 0, void 0, void 0, (function () {
                                var r, i;
                                return F(this, (function (o) {
                                    return Kt.isInstance(n.request) ? (r = n.request, (void 0 === (i = (e.requestHandler.metadata || {}).handlerProtocol) ? "" : i).indexOf("h2") >= 0 && !r.headers[":authority"] ? (delete r.headers.host, r.headers[":authority"] = "") : r.headers.host || (r.headers.host = r.hostname), [2, t(n)]) : [2, t(n)]
                                }))
                            }))
                        }
                    }
                }(e), Zn)
            }
        }
    }, Qn = {name: "loggerMiddleware", tags: ["LOGGER"], step: "initialize", override: !0}, er = function (e) {
        return {
            applyToStack: function (e) {
                e.add((function (e, t) {
                    return function (n) {
                        return j(void 0, void 0, void 0, (function () {
                            var r, i, o, s, a, u, c, l, f;
                            return F(this, (function (d) {
                                switch (d.label) {
                                    case 0:
                                        return r = t.clientName, i = t.commandName, o = t.inputFilterSensitiveLog, s = t.logger, a = t.outputFilterSensitiveLog, [4, e(n)];
                                    case 1:
                                        return u = d.sent(), s ? ("function" == typeof s.info && (c = u.output, l = c.$metadata, f = B(c, ["$metadata"]), s.info({
                                            clientName: r,
                                            commandName: i,
                                            input: o(n.input),
                                            output: a(f),
                                            metadata: l
                                        })), [2, u]) : [2, u]
                                }
                            }))
                        }))
                    }
                }), Qn)
            }
        }
    }, tr = "X-Amz-Date".toLowerCase(), nr = ["authorization", tr, "date"], rr = "X-Amz-Signature".toLowerCase(),
    ir = "X-Amz-Security-Token".toLowerCase(), or = {
        authorization: !0,
        "cache-control": !0,
        connection: !0,
        expect: !0,
        from: !0,
        "keep-alive": !0,
        "max-forwards": !0,
        pragma: !0,
        referer: !0,
        te: !0,
        trailer: !0,
        "transfer-encoding": !0,
        upgrade: !0,
        "user-agent": !0,
        "x-amzn-trace-id": !0
    }, sr = /^proxy-/, ar = /^sec-/, ur = "AWS4-HMAC-SHA256-PAYLOAD", cr = {}, lr = [];

function fr(e, t, n) {
    return e + "/" + t + "/" + n + "/aws4_request"
}

function dr(e, t, n) {
    var r = new e(t);
    return r.update(n), r.digest()
}

function hr(e, t, n) {
    var r, i, o = e.headers, s = {};
    try {
        for (var a = z(Object.keys(o).sort()), u = a.next(); !u.done; u = a.next()) {
            var c = u.value, l = c.toLowerCase();
            (l in or || (null == t ? void 0 : t.has(l)) || sr.test(l) || ar.test(l)) && (!n || n && !n.has(l)) || (s[l] = o[c].trim().replace(/\s+/g, " "))
        }
    } catch (e) {
        r = {error: e}
    } finally {
        try {
            u && !u.done && (i = a.return) && i.call(a)
        } finally {
            if (r) throw r.error
        }
    }
    return s
}

function pr(e, t) {
    var n = e.headers, r = e.body;
    return j(this, void 0, void 0, (function () {
        var e, i, o, s, a, u, c;
        return F(this, (function (l) {
            switch (l.label) {
                case 0:
                    try {
                        for (e = z(Object.keys(n)), i = e.next(); !i.done; i = e.next()) if ("x-amz-content-sha256" === (o = i.value).toLowerCase()) return [2, n[o]]
                    } catch (e) {
                        u = {error: e}
                    } finally {
                        try {
                            i && !i.done && (c = e.return) && c.call(e)
                        } finally {
                            if (u) throw u.error
                        }
                    }
                    return null != r ? [3, 1] : [2, "e3b0c44298fc1c149afbf4c8996fb92427ae41e4649b934ca495991b7852b855"];
                case 1:
                    return "string" == typeof r || ArrayBuffer.isView(r) || (f = r, "function" == typeof ArrayBuffer && f instanceof ArrayBuffer || "[object ArrayBuffer]" === Object.prototype.toString.call(f)) ? ((s = new t).update(r), a = Q, [4, s.digest()]) : [3, 3];
                case 2:
                    return [2, a.apply(void 0, [l.sent()])];
                case 3:
                    return [2, "UNSIGNED-PAYLOAD"]
            }
            var f
        }))
    }))
}

function gr(e) {
    var t = e.headers, n = e.query, r = B(e, ["headers", "query"]);
    return D(D({}, r), {headers: D({}, t), query: n ? vr(n) : void 0})
}

function vr(e) {
    return Object.keys(e).reduce((function (t, n) {
        var r, i = e[n];
        return D(D({}, t), ((r = {})[n] = Array.isArray(i) ? q(i) : i, r))
    }), {})
}

function mr(e) {
    var t, n;
    e = "function" == typeof e.clone ? e.clone() : gr(e);
    try {
        for (var r = z(Object.keys(e.headers)), i = r.next(); !i.done; i = r.next()) {
            var o = i.value;
            nr.indexOf(o.toLowerCase()) > -1 && delete e.headers[o]
        }
    } catch (e) {
        t = {error: e}
    } finally {
        try {
            i && !i.done && (n = r.return) && n.call(r)
        } finally {
            if (t) throw t.error
        }
    }
    return e
}

function yr(e) {
    return function (e) {
        if ("number" == typeof e) return new Date(1e3 * e);
        if ("string" == typeof e) return Number(e) ? new Date(1e3 * Number(e)) : new Date(e);
        return e
    }(e).toISOString().replace(/\.\d{3}Z$/, "Z")
}

var Sr = function () {
    function e(e) {
        var t = e.applyChecksum, n = e.credentials, r = e.region, i = e.service, o = e.sha256, s = e.uriEscapePath,
            a = void 0 === s || s;
        this.service = i, this.sha256 = o, this.uriEscapePath = a, this.applyChecksum = "boolean" != typeof t || t, this.regionProvider = Er(r), this.credentialProvider = Cr(n)
    }

    return e.prototype.presign = function (e, t) {
        return void 0 === t && (t = {}), j(this, void 0, void 0, (function () {
            var n, r, i, o, s, a, u, c, l, f, d, h, p, g, v, m, y, S, w, b, E, C, _, A;
            return F(this, (function (P) {
                switch (P.label) {
                    case 0:
                        return n = t.signingDate, r = void 0 === n ? new Date : n, i = t.expiresIn, o = void 0 === i ? 3600 : i, s = t.unsignableHeaders, a = t.unhoistableHeaders, u = t.signableHeaders, c = t.signingRegion, l = t.signingService, [4, this.credentialProvider()];
                    case 1:
                        return f = P.sent(), null == c ? [3, 2] : (h = c, [3, 4]);
                    case 2:
                        return [4, this.regionProvider()];
                    case 3:
                        h = P.sent(), P.label = 4;
                    case 4:
                        return d = h, p = wr(r), g = p.longDate, v = p.shortDate, o > 604800 ? [2, Promise.reject("Signature version 4 presigned URLs must have an expiration date less than one week in the future")] : (m = fr(v, d, null != l ? l : this.service), y = function (e, t) {
                            var n, r, i;
                            void 0 === t && (t = {});
                            var o = "function" == typeof e.clone ? e.clone() : gr(e), s = o.headers, a = o.query,
                                u = void 0 === a ? {} : a;
                            try {
                                for (var c = z(Object.keys(s)), l = c.next(); !l.done; l = c.next()) {
                                    var f = l.value, d = f.toLowerCase();
                                    "x-amz-" !== d.substr(0, 6) || (null === (i = t.unhoistableHeaders) || void 0 === i ? void 0 : i.has(d)) || (u[f] = s[f], delete s[f])
                                }
                            } catch (e) {
                                n = {error: e}
                            } finally {
                                try {
                                    l && !l.done && (r = c.return) && r.call(c)
                                } finally {
                                    if (n) throw n.error
                                }
                            }
                            return D(D({}, e), {headers: s, query: u})
                        }(mr(e), {unhoistableHeaders: a}), f.sessionToken && (y.query["X-Amz-Security-Token"] = f.sessionToken), y.query["X-Amz-Algorithm"] = "AWS4-HMAC-SHA256", y.query["X-Amz-Credential"] = f.accessKeyId + "/" + m, y.query["X-Amz-Date"] = g, y.query["X-Amz-Expires"] = o.toString(10), S = hr(y, s, u), y.query["X-Amz-SignedHeaders"] = br(S), w = y.query, b = "X-Amz-Signature", E = this.getSignature, C = [g, m, this.getSigningKey(f, d, v, l)], _ = this.createCanonicalRequest, A = [y, S], [4, pr(e, this.sha256)]);
                    case 5:
                        return [4, E.apply(this, C.concat([_.apply(this, A.concat([P.sent()]))]))];
                    case 6:
                        return w[b] = P.sent(), [2, y]
                }
            }))
        }))
    }, e.prototype.sign = function (e, t) {
        return j(this, void 0, void 0, (function () {
            return F(this, (function (n) {
                return "string" == typeof e ? [2, this.signString(e, t)] : e.headers && e.payload ? [2, this.signEvent(e, t)] : [2, this.signRequest(e, t)]
            }))
        }))
    }, e.prototype.signEvent = function (e, t) {
        var n = e.headers, r = e.payload, i = t.signingDate, o = void 0 === i ? new Date : i, s = t.priorSignature,
            a = t.signingRegion, u = t.signingService;
        return j(this, void 0, void 0, (function () {
            var e, t, i, c, l, f, d, h, p, g, v;
            return F(this, (function (m) {
                switch (m.label) {
                    case 0:
                        return null == a ? [3, 1] : (t = a, [3, 3]);
                    case 1:
                        return [4, this.regionProvider()];
                    case 2:
                        t = m.sent(), m.label = 3;
                    case 3:
                        return e = t, i = wr(o), c = i.shortDate, l = i.longDate, f = fr(c, e, null != u ? u : this.service), [4, pr({
                            headers: {},
                            body: r
                        }, this.sha256)];
                    case 4:
                        return d = m.sent(), (h = new this.sha256).update(n), g = Q, [4, h.digest()];
                    case 5:
                        return p = g.apply(void 0, [m.sent()]), v = [ur, l, f, s, p, d].join("\n"), [2, this.signString(v, {
                            signingDate: o,
                            signingRegion: e,
                            signingService: u
                        })]
                }
            }))
        }))
    }, e.prototype.signString = function (e, t) {
        var n = void 0 === t ? {} : t, r = n.signingDate, i = void 0 === r ? new Date : r, o = n.signingRegion,
            s = n.signingService;
        return j(this, void 0, void 0, (function () {
            var t, n, r, a, u, c, l, f;
            return F(this, (function (d) {
                switch (d.label) {
                    case 0:
                        return [4, this.credentialProvider()];
                    case 1:
                        return t = d.sent(), null == o ? [3, 2] : (r = o, [3, 4]);
                    case 2:
                        return [4, this.regionProvider()];
                    case 3:
                        r = d.sent(), d.label = 4;
                    case 4:
                        return n = r, a = wr(i).shortDate, l = (c = this.sha256).bind, [4, this.getSigningKey(t, n, a, s)];
                    case 5:
                        return (u = new (l.apply(c, [void 0, d.sent()]))).update(e), f = Q, [4, u.digest()];
                    case 6:
                        return [2, f.apply(void 0, [d.sent()])]
                }
            }))
        }))
    }, e.prototype.signRequest = function (e, t) {
        var n = void 0 === t ? {} : t, r = n.signingDate, i = void 0 === r ? new Date : r, o = n.signableHeaders,
            s = n.unsignableHeaders, a = n.signingRegion, u = n.signingService;
        return j(this, void 0, void 0, (function () {
            var t, n, r, c, l, f, d, h, p, g, v;
            return F(this, (function (m) {
                switch (m.label) {
                    case 0:
                        return [4, this.credentialProvider()];
                    case 1:
                        return t = m.sent(), null == a ? [3, 2] : (r = a, [3, 4]);
                    case 2:
                        return [4, this.regionProvider()];
                    case 3:
                        r = m.sent(), m.label = 4;
                    case 4:
                        return n = r, c = mr(e), l = wr(i), f = l.longDate, d = l.shortDate, h = fr(d, n, null != u ? u : this.service), c.headers[tr] = f, t.sessionToken && (c.headers[ir] = t.sessionToken), [4, pr(c, this.sha256)];
                    case 5:
                        return p = m.sent(), !function (e, t) {
                            var n, r;
                            e = e.toLowerCase();
                            try {
                                for (var i = z(Object.keys(t)), o = i.next(); !o.done; o = i.next()) if (e === o.value.toLowerCase()) return !0
                            } catch (e) {
                                n = {error: e}
                            } finally {
                                try {
                                    o && !o.done && (r = i.return) && r.call(i)
                                } finally {
                                    if (n) throw n.error
                                }
                            }
                            return !1
                        }("x-amz-content-sha256", c.headers) && this.applyChecksum && (c.headers["x-amz-content-sha256"] = p), g = hr(c, s, o), [4, this.getSignature(f, h, this.getSigningKey(t, n, d, u), this.createCanonicalRequest(c, g, p))];
                    case 6:
                        return v = m.sent(), c.headers.authorization = "AWS4-HMAC-SHA256 Credential=" + t.accessKeyId + "/" + h + ", SignedHeaders=" + br(g) + ", Signature=" + v, [2, c]
                }
            }))
        }))
    }, e.prototype.createCanonicalRequest = function (e, t, n) {
        var r = Object.keys(t).sort();
        return e.method + "\n" + this.getCanonicalPath(e) + "\n" + function (e) {
            var t, n, r = e.query, i = void 0 === r ? {} : r, o = [], s = {}, a = function (e) {
                if (e.toLowerCase() === rr) return "continue";
                o.push(e);
                var t = i[e];
                "string" == typeof t ? s[e] = qt(e) + "=" + qt(t) : Array.isArray(t) && (s[e] = t.slice(0).sort().reduce((function (t, n) {
                    return t.concat([qt(e) + "=" + qt(n)])
                }), []).join("&"))
            };
            try {
                for (var u = z(Object.keys(i).sort()), c = u.next(); !c.done; c = u.next()) a(c.value)
            } catch (e) {
                t = {error: e}
            } finally {
                try {
                    c && !c.done && (n = u.return) && n.call(u)
                } finally {
                    if (t) throw t.error
                }
            }
            return o.map((function (e) {
                return s[e]
            })).filter((function (e) {
                return e
            })).join("&")
        }(e) + "\n" + r.map((function (e) {
            return e + ":" + t[e]
        })).join("\n") + "\n\n" + r.join(";") + "\n" + n
    }, e.prototype.createStringToSign = function (e, t, n) {
        return j(this, void 0, void 0, (function () {
            var r, i;
            return F(this, (function (o) {
                switch (o.label) {
                    case 0:
                        return (r = new this.sha256).update(n), [4, r.digest()];
                    case 1:
                        return i = o.sent(), [2, "AWS4-HMAC-SHA256\n" + e + "\n" + t + "\n" + Q(i)]
                }
            }))
        }))
    }, e.prototype.getCanonicalPath = function (e) {
        var t = e.path;
        return this.uriEscapePath ? "/" + encodeURIComponent(t.replace(/^\//, "")).replace(/%2F/g, "/") : t
    }, e.prototype.getSignature = function (e, t, n, r) {
        return j(this, void 0, void 0, (function () {
            var i, o, s, a, u;
            return F(this, (function (c) {
                switch (c.label) {
                    case 0:
                        return [4, this.createStringToSign(e, t, r)];
                    case 1:
                        return i = c.sent(), a = (s = this.sha256).bind, [4, n];
                    case 2:
                        return (o = new (a.apply(s, [void 0, c.sent()]))).update(i), u = Q, [4, o.digest()];
                    case 3:
                        return [2, u.apply(void 0, [c.sent()])]
                }
            }))
        }))
    }, e.prototype.getSigningKey = function (e, t, n, r) {
        return function (e, t, n, r, i) {
            return j(void 0, void 0, void 0, (function () {
                var o, s, a, u, c, l, f, d, h;
                return F(this, (function (p) {
                    switch (p.label) {
                        case 0:
                            return [4, dr(e, t.secretAccessKey, t.accessKeyId)];
                        case 1:
                            if (o = p.sent(), (s = n + ":" + r + ":" + i + ":" + Q(o) + ":" + t.sessionToken) in cr) return [2, cr[s]];
                            for (lr.push(s); lr.length > 50;) delete cr[lr.shift()];
                            a = "AWS4" + t.secretAccessKey, p.label = 2;
                        case 2:
                            p.trys.push([2, 7, 8, 9]), u = z([n, r, i, "aws4_request"]), c = u.next(), p.label = 3;
                        case 3:
                            return c.done ? [3, 6] : (l = c.value, [4, dr(e, a, l)]);
                        case 4:
                            a = p.sent(), p.label = 5;
                        case 5:
                            return c = u.next(), [3, 3];
                        case 6:
                            return [3, 9];
                        case 7:
                            return f = p.sent(), d = {error: f}, [3, 9];
                        case 8:
                            try {
                                c && !c.done && (h = u.return) && h.call(u)
                            } finally {
                                if (d) throw d.error
                            }
                            return [7];
                        case 9:
                            return [2, cr[s] = a]
                    }
                }))
            }))
        }(this.sha256, e, n, t, r || this.service)
    }, e
}(), wr = function (e) {
    var t = yr(e).replace(/[\-:]/g, "");
    return {longDate: t, shortDate: t.substr(0, 8)}
}, br = function (e) {
    return Object.keys(e).sort().join(";")
}, Er = function (e) {
    if ("string" == typeof e) {
        var t = Promise.resolve(e);
        return function () {
            return t
        }
    }
    return e
}, Cr = function (e) {
    if ("object" == typeof e) {
        var t = Promise.resolve(e);
        return function () {
            return t
        }
    }
    return e
};

function _r(e) {
    var t, n = this, r = Ar(e.credentials || e.credentialDefaultProvider(e)), i = e.signingEscapePath,
        o = void 0 === i || i, s = e.systemClockOffset, a = void 0 === s ? e.systemClockOffset || 0 : s, u = e.sha256;
    return t = e.signer ? Ar(e.signer) : function () {
        return Ar(e.region)().then((function (t) {
            return j(n, void 0, void 0, (function () {
                return F(this, (function (n) {
                    switch (n.label) {
                        case 0:
                            return [4, e.regionInfoProvider(t)];
                        case 1:
                            return [2, [n.sent() || {}, t]]
                    }
                }))
            }))
        })).then((function (t) {
            var n = K(t, 2), i = n[0], s = n[1], a = i.signingRegion, c = i.signingService;
            return e.signingRegion = e.signingRegion || a || s, e.signingName = e.signingName || c || e.serviceId, new Sr({
                credentials: r,
                region: e.signingRegion,
                service: e.signingName,
                sha256: u,
                uriEscapePath: o
            })
        }))
    }, D(D({}, e), {systemClockOffset: a, signingEscapePath: o, credentials: r, signer: t})
}

function Ar(e) {
    if ("object" == typeof e) {
        var t = Promise.resolve(e);
        return function () {
            return t
        }
    }
    return e
}

var Pr = function (e) {
    return new Date(Date.now() + e)
};

function kr(e) {
    return function (t, n) {
        return function (r) {
            return j(this, void 0, void 0, (function () {
                var i, o, s, a, u, c, l, f, d;
                return F(this, (function (h) {
                    switch (h.label) {
                        case 0:
                            return Kt.isInstance(r.request) ? "function" != typeof e.signer ? [3, 2] : [4, e.signer()] : [2, t(r)];
                        case 1:
                            return o = h.sent(), [3, 3];
                        case 2:
                            o = e.signer, h.label = 3;
                        case 3:
                            return i = o, a = t, u = [D({}, r)], d = {}, [4, i.sign(r.request, {
                                signingDate: new Date(Date.now() + e.systemClockOffset),
                                signingRegion: n.signing_region,
                                signingService: n.signing_service
                            })];
                        case 4:
                            return [4, a.apply(void 0, [D.apply(void 0, u.concat([(d.request = h.sent(), d)]))])];
                        case 5:
                            return s = h.sent(), c = s.response.headers, (l = c && (c.date || c.Date)) && (f = Date.parse(l), p = f, g = e.systemClockOffset, Math.abs(Pr(g).getTime() - p) >= 3e5 && (e.systemClockOffset = f - Date.now())), [2, s]
                    }
                    var p, g
                }))
            }))
        }
    }
}

var xr = {
    name: "awsAuthMiddleware",
    tags: ["SIGNATURE", "AWSAUTH"],
    relation: "after",
    toMiddleware: "retryMiddleware",
    override: !0
};

function Ir(e) {
    return D(D({}, e), {customUserAgent: "string" == typeof e.customUserAgent ? [[e.customUserAgent]] : e.customUserAgent})
}

var Tr = /[^\!\#\$\%\&\'\*\+\-\.\^\_\`\|\~\d\w]/g, Ur = function (e) {
        var t = K(e, 2), n = t[0], r = t[1], i = n.indexOf("/"), o = n.substring(0, i), s = n.substring(i + 1);
        return "api" === o && (s = s.toLowerCase()), [o, s, r].filter((function (e) {
            return e && e.length > 0
        })).map((function (e) {
            return null == e ? void 0 : e.replace(Tr, "_")
        })).join("/")
    }, Or = {
        name: "getUserAgentMiddleware",
        step: "build",
        priority: "low",
        tags: ["SET_USER_AGENT", "USER_AGENT"],
        override: !0
    }, Mr = function (e) {
        return {
            applyToStack: function (t) {
                var n;
                t.add((n = e, function (e, t) {
                    return function (r) {
                        return j(void 0, void 0, void 0, (function () {
                            var i, o, s, a, u, c, l, f;
                            return F(this, (function (d) {
                                switch (d.label) {
                                    case 0:
                                        return i = r.request, Kt.isInstance(i) ? (o = i.headers, s = (null === (l = null == t ? void 0 : t.userAgent) || void 0 === l ? void 0 : l.map(Ur)) || [], [4, n.defaultUserAgentProvider()]) : [2, e(r)];
                                    case 1:
                                        return a = d.sent().map(Ur), u = (null === (f = null == n ? void 0 : n.customUserAgent) || void 0 === f ? void 0 : f.map(Ur)) || [], o["x-amz-user-agent"] = q(a, s, u).join(" "), c = q(a.filter((function (e) {
                                            return e.startsWith("aws-sdk-")
                                        })), u).join(" "), "browser" !== n.runtime && c && (o["user-agent"] = o["user-agent"] ? o["user-agent"] + " " + c : c), [2, e(D(D({}, r), {request: i}))]
                                }
                            }))
                        }))
                    }
                }), Or)
            }
        }
    }, Lr = function () {
        var e = [], t = [], n = new Set, r = function (n) {
            return e.forEach((function (e) {
                n.add(e.middleware, D({}, e))
            })), t.forEach((function (e) {
                n.addRelativeTo(e.middleware, D({}, e))
            })), n
        }, i = function (e) {
            var t = [];
            return e.before.forEach((function (e) {
                0 === e.before.length && 0 === e.after.length ? t.push(e) : t.push.apply(t, q(i(e)))
            })), t.push(e), e.after.reverse().forEach((function (e) {
                0 === e.before.length && 0 === e.after.length ? t.push(e) : t.push.apply(t, q(i(e)))
            })), t
        }, o = function () {
            var n, r = [], o = [], s = {};
            return e.forEach((function (e) {
                var t = D(D({}, e), {before: [], after: []});
                t.name && (s[t.name] = t), r.push(t)
            })), t.forEach((function (e) {
                var t = D(D({}, e), {before: [], after: []});
                t.name && (s[t.name] = t), o.push(t)
            })), o.forEach((function (e) {
                if (e.toMiddleware) {
                    var t = s[e.toMiddleware];
                    if (void 0 === t) throw new Error(e.toMiddleware + " is not found when adding " + (e.name || "anonymous") + " middleware " + e.relation + " " + e.toMiddleware);
                    "after" === e.relation && t.after.push(e), "before" === e.relation && t.before.push(e)
                }
            })), (n = r, n.sort((function (e, t) {
                return Rr[t.step] - Rr[e.step] || Nr[t.priority || "normal"] - Nr[e.priority || "normal"]
            }))).map(i).reduce((function (e, t) {
                return e.push.apply(e, q(t)), e
            }), []).map((function (e) {
                return e.middleware
            }))
        }, s = {
            add: function (t, r) {
                void 0 === r && (r = {});
                var i = r.name, o = r.override, s = D({step: "initialize", priority: "normal", middleware: t}, r);
                if (i) {
                    if (n.has(i)) {
                        if (!o) throw new Error("Duplicate middleware name '" + i + "'");
                        var a = e.findIndex((function (e) {
                            return e.name === i
                        })), u = e[a];
                        if (u.step !== s.step || u.priority !== s.priority) throw new Error('"' + i + '" middleware with ' + u.priority + " priority in " + u.step + " step cannot be overridden by same-name middleware with " + s.priority + " priority in " + s.step + " step.");
                        e.splice(a, 1)
                    }
                    n.add(i)
                }
                e.push(s)
            }, addRelativeTo: function (e, r) {
                var i = r.name, o = r.override, s = D({middleware: e}, r);
                if (i) {
                    if (n.has(i)) {
                        if (!o) throw new Error("Duplicate middleware name '" + i + "'");
                        var a = t.findIndex((function (e) {
                            return e.name === i
                        })), u = t[a];
                        if (u.toMiddleware !== s.toMiddleware || u.relation !== s.relation) throw new Error('"' + i + '" middleware ' + u.relation + ' "' + u.toMiddleware + '" middleware cannot be overridden by same-name middleware ' + s.relation + ' "' + s.toMiddleware + '" middleware.');
                        t.splice(a, 1)
                    }
                    n.add(i)
                }
                t.push(s)
            }, clone: function () {
                return r(Lr())
            }, use: function (e) {
                e.applyToStack(s)
            }, remove: function (r) {
                return "string" == typeof r ? function (r) {
                    var i = !1, o = function (e) {
                        return !e.name || e.name !== r || (i = !0, n.delete(r), !1)
                    };
                    return e = e.filter(o), t = t.filter(o), i
                }(r) : function (r) {
                    var i = !1, o = function (e) {
                        return e.middleware !== r || (i = !0, e.name && n.delete(e.name), !1)
                    };
                    return e = e.filter(o), t = t.filter(o), i
                }(r)
            }, removeByTag: function (r) {
                var i = !1, o = function (e) {
                    var t = e.tags, o = e.name;
                    return !t || !t.includes(r) || (o && n.delete(o), i = !0, !1)
                };
                return e = e.filter(o), t = t.filter(o), i
            }, concat: function (e) {
                var t = r(Lr());
                return t.use(e), t
            }, applyToStack: r, resolve: function (e, t) {
                var n, r;
                try {
                    for (var i = z(o().reverse()), s = i.next(); !s.done; s = i.next()) {
                        e = (0, s.value)(e, t)
                    }
                } catch (e) {
                    n = {error: e}
                } finally {
                    try {
                        s && !s.done && (r = i.return) && r.call(i)
                    } finally {
                        if (n) throw n.error
                    }
                }
                return e
            }
        };
        return s
    }, Rr = {initialize: 5, serialize: 4, build: 3, finalizeRequest: 2, deserialize: 1}, Nr = {high: 3, normal: 2, low: 1},
    Dr = function () {
        function e(e) {
            this.middlewareStack = Lr(), this.config = e
        }

        return e.prototype.send = function (e, t, n) {
            var r = "function" != typeof t ? t : void 0, i = "function" == typeof t ? t : n,
                o = e.resolveMiddleware(this.middlewareStack, this.config, r);
            if (!i) return o(e).then((function (e) {
                return e.output
            }));
            o(e).then((function (e) {
                return i(null, e.output)
            }), (function (e) {
                return i(e)
            })).catch((function () {
            }))
        }, e.prototype.destroy = function () {
            this.config.requestHandler.destroy && this.config.requestHandler.destroy()
        }, e
    }(), Br = function () {
        this.middlewareStack = Lr()
    };

function jr(e) {
    return encodeURIComponent(e).replace(/[!'()*]/g, (function (e) {
        return "%" + e.charCodeAt(0).toString(16)
    }))
}

var Fr = function (e) {
    return Array.isArray(e) ? e : [e]
}, zr = function (e) {
    for (var t in e) e.hasOwnProperty(t) && void 0 !== e[t]["#text"] ? e[t] = e[t]["#text"] : "object" == typeof e[t] && null !== e[t] && (e[t] = zr(e[t]));
    return e
}, Kr = function () {
    var e = Object.getPrototypeOf(this).constructor, t = Function.bind.apply(String, q([null], arguments)), n = new t;
    return Object.setPrototypeOf(n, e.prototype), n
};
Kr.prototype = Object.create(String.prototype, {
    constructor: {
        value: Kr,
        enumerable: !1,
        writable: !0,
        configurable: !0
    }
}), Object.setPrototypeOf(Kr, String), function (e) {
    function t() {
        return null !== e && e.apply(this, arguments) || this
    }

    N(t, e), t.prototype.deserializeJSON = function () {
        return JSON.parse(e.prototype.toString.call(this))
    }, t.prototype.toJSON = function () {
        return e.prototype.toString.call(this)
    }, t.fromObject = function (e) {
        return e instanceof t ? e : new t(e instanceof String || "string" == typeof e ? e : JSON.stringify(e))
    }
}(Kr);
var qr = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
    Hr = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

function Vr(e) {
    var t = e.getUTCFullYear(), n = e.getUTCMonth(), r = e.getUTCDay(), i = e.getUTCDate(), o = e.getUTCHours(),
        s = e.getUTCMinutes(), a = e.getUTCSeconds();
    return qr[r] + ", " + (i < 10 ? "0" + i : "" + i) + " " + Hr[n] + " " + t + " " + (o < 10 ? "0" + o : "" + o) + ":" + (s < 10 ? "0" + s : "" + s) + ":" + (a < 10 ? "0" + a : "" + a) + " GMT"
}

var Gr = "***SensitiveInformation***",
    Wr = {name: "deserializerMiddleware", step: "deserialize", tags: ["DESERIALIZER"], override: !0},
    $r = {name: "serializerMiddleware", step: "serialize", tags: ["SERIALIZER"], override: !0};

function Yr(e, t, n) {
    return {
        applyToStack: function (r) {
            r.add(function (e, t) {
                return function (n, r) {
                    return function (r) {
                        return j(void 0, void 0, void 0, (function () {
                            var i, o;
                            return F(this, (function (s) {
                                switch (s.label) {
                                    case 0:
                                        return [4, n(r)];
                                    case 1:
                                        return i = s.sent().response, [4, t(i, e)];
                                    case 2:
                                        return o = s.sent(), [2, {response: i, output: o}]
                                }
                            }))
                        }))
                    }
                }
            }(e, n), Wr), r.add(function (e, t) {
                return function (n, r) {
                    return function (r) {
                        return j(void 0, void 0, void 0, (function () {
                            var i;
                            return F(this, (function (o) {
                                switch (o.label) {
                                    case 0:
                                        return [4, t(r.input, e)];
                                    case 1:
                                        return i = o.sent(), [2, n(D(D({}, r), {request: i}))]
                                }
                            }))
                        }))
                    }
                }
            }(e, t), $r)
        }
    }
}

var Jr = function (e, t, n, r) {
    return new (n || (n = Promise))((function (i, o) {
        function s(e) {
            try {
                u(r.next(e))
            } catch (e) {
                o(e)
            }
        }

        function a(e) {
            try {
                u(r.throw(e))
            } catch (e) {
                o(e)
            }
        }

        function u(e) {
            var t;
            e.done ? i(e.value) : (t = e.value, t instanceof n ? t : new n((function (e) {
                e(t)
            }))).then(s, a)
        }

        u((r = r.apply(e, t || [])).next())
    }))
}, Zr = function (e, t) {
    var n, r, i, o, s = {
        label: 0, sent: function () {
            if (1 & i[0]) throw i[1];
            return i[1]
        }, trys: [], ops: []
    };
    return o = {
        next: a(0),
        throw: a(1),
        return: a(2)
    }, "function" == typeof Symbol && (o[Symbol.iterator] = function () {
        return this
    }), o;

    function a(o) {
        return function (a) {
            return function (o) {
                if (n) throw new TypeError("Generator is already executing.");
                for (; s;) try {
                    if (n = 1, r && (i = 2 & o[0] ? r.return : o[0] ? r.throw || ((i = r.return) && i.call(r), 0) : r.next) && !(i = i.call(r, o[1])).done) return i;
                    switch (r = 0, i && (o = [2 & o[0], i.value]), o[0]) {
                        case 0:
                        case 1:
                            i = o;
                            break;
                        case 4:
                            return s.label++, {value: o[1], done: !1};
                        case 5:
                            s.label++, r = o[1], o = [0];
                            continue;
                        case 7:
                            o = s.ops.pop(), s.trys.pop();
                            continue;
                        default:
                            if (!(i = s.trys, (i = i.length > 0 && i[i.length - 1]) || 6 !== o[0] && 2 !== o[0])) {
                                s = 0;
                                continue
                            }
                            if (3 === o[0] && (!i || o[1] > i[0] && o[1] < i[3])) {
                                s.label = o[1];
                                break
                            }
                            if (6 === o[0] && s.label < i[1]) {
                                s.label = i[1], i = o;
                                break
                            }
                            if (i && s.label < i[2]) {
                                s.label = i[2], s.ops.push(o);
                                break
                            }
                            i[2] && s.ops.pop(), s.trys.pop();
                            continue
                    }
                    o = t.call(e, s)
                } catch (e) {
                    o = [6, e], r = 0
                } finally {
                    n = i = 0
                }
                if (5 & o[0]) throw o[1];
                return {value: o[0] ? o[1] : void 0, done: !0}
            }([o, a])
        }
    }
}, Xr = new o("CognitoCredentials"), Qr = new Promise((function (e, t) {
    return k().isBrowser ? (window.gapi && window.gapi.auth2 ? window.gapi.auth2 : null) ? (Xr.debug("google api already loaded"), e()) : void setTimeout((function () {
        return e()
    }), 2e3) : (Xr.debug("not in the browser, directly resolved"), e())
})), ei = function () {
    function e() {
        this.initialized = !1, this.refreshGoogleToken = this.refreshGoogleToken.bind(this), this._refreshGoogleTokenImpl = this._refreshGoogleTokenImpl.bind(this)
    }

    return e.prototype.refreshGoogleToken = function () {
        return Jr(this, void 0, void 0, (function () {
            return Zr(this, (function (e) {
                switch (e.label) {
                    case 0:
                        return this.initialized ? [3, 2] : (Xr.debug("need to wait for the Google SDK loaded"), [4, Qr]);
                    case 1:
                        e.sent(), this.initialized = !0, Xr.debug("finish waiting"), e.label = 2;
                    case 2:
                        return [2, this._refreshGoogleTokenImpl()]
                }
            }))
        }))
    }, e.prototype._refreshGoogleTokenImpl = function () {
        var e = null;
        return k().isBrowser && (e = window.gapi && window.gapi.auth2 ? window.gapi.auth2 : null), e ? new Promise((function (t, n) {
            e.getAuthInstance().then((function (e) {
                e || (Xr.debug("google Auth undefined"), n(new xe("google Auth undefined")));
                var r = e.currentUser.get();
                r.isSignedIn() ? (Xr.debug("refreshing the google access token"), r.reloadAuthResponse().then((function (e) {
                    var n = e.id_token, r = e.expires_at;
                    t({token: n, expires_at: r})
                })).catch((function (e) {
                    e && "network_error" === e.error ? n("Network error reloading google auth response") : n(new xe("Failed to reload google auth response"))
                }))) : n(new xe("User is not signed in with Google"))
            })).catch((function (e) {
                Xr.debug("Failed to refresh google token", e), n(new xe("Failed to refresh google token"))
            }))
        })) : (Xr.debug("no gapi auth2 available"), Promise.reject("no gapi auth2 available"))
    }, e
}(), ti = function (e, t, n, r) {
    return new (n || (n = Promise))((function (i, o) {
        function s(e) {
            try {
                u(r.next(e))
            } catch (e) {
                o(e)
            }
        }

        function a(e) {
            try {
                u(r.throw(e))
            } catch (e) {
                o(e)
            }
        }

        function u(e) {
            var t;
            e.done ? i(e.value) : (t = e.value, t instanceof n ? t : new n((function (e) {
                e(t)
            }))).then(s, a)
        }

        u((r = r.apply(e, t || [])).next())
    }))
}, ni = function (e, t) {
    var n, r, i, o, s = {
        label: 0, sent: function () {
            if (1 & i[0]) throw i[1];
            return i[1]
        }, trys: [], ops: []
    };
    return o = {
        next: a(0),
        throw: a(1),
        return: a(2)
    }, "function" == typeof Symbol && (o[Symbol.iterator] = function () {
        return this
    }), o;

    function a(o) {
        return function (a) {
            return function (o) {
                if (n) throw new TypeError("Generator is already executing.");
                for (; s;) try {
                    if (n = 1, r && (i = 2 & o[0] ? r.return : o[0] ? r.throw || ((i = r.return) && i.call(r), 0) : r.next) && !(i = i.call(r, o[1])).done) return i;
                    switch (r = 0, i && (o = [2 & o[0], i.value]), o[0]) {
                        case 0:
                        case 1:
                            i = o;
                            break;
                        case 4:
                            return s.label++, {value: o[1], done: !1};
                        case 5:
                            s.label++, r = o[1], o = [0];
                            continue;
                        case 7:
                            o = s.ops.pop(), s.trys.pop();
                            continue;
                        default:
                            if (!(i = s.trys, (i = i.length > 0 && i[i.length - 1]) || 6 !== o[0] && 2 !== o[0])) {
                                s = 0;
                                continue
                            }
                            if (3 === o[0] && (!i || o[1] > i[0] && o[1] < i[3])) {
                                s.label = o[1];
                                break
                            }
                            if (6 === o[0] && s.label < i[1]) {
                                s.label = i[1], i = o;
                                break
                            }
                            if (i && s.label < i[2]) {
                                s.label = i[2], s.ops.push(o);
                                break
                            }
                            i[2] && s.ops.pop(), s.trys.pop();
                            continue
                    }
                    o = t.call(e, s)
                } catch (e) {
                    o = [6, e], r = 0
                } finally {
                    n = i = 0
                }
                if (5 & o[0]) throw o[1];
                return {value: o[0] ? o[1] : void 0, done: !0}
            }([o, a])
        }
    }
}, ri = new o("CognitoCredentials"), ii = new Promise((function (e, t) {
    return k().isBrowser ? window.FB ? (ri.debug("FB SDK already loaded"), e()) : void setTimeout((function () {
        return e()
    }), 2e3) : (ri.debug("not in the browser, directly resolved"), e())
})), oi = function () {
    function e() {
        this.initialized = !1, this.refreshFacebookToken = this.refreshFacebookToken.bind(this), this._refreshFacebookTokenImpl = this._refreshFacebookTokenImpl.bind(this)
    }

    return e.prototype.refreshFacebookToken = function () {
        return ti(this, void 0, void 0, (function () {
            return ni(this, (function (e) {
                switch (e.label) {
                    case 0:
                        return this.initialized ? [3, 2] : (ri.debug("need to wait for the Facebook SDK loaded"), [4, ii]);
                    case 1:
                        e.sent(), this.initialized = !0, ri.debug("finish waiting"), e.label = 2;
                    case 2:
                        return [2, this._refreshFacebookTokenImpl()]
                }
            }))
        }))
    }, e.prototype._refreshFacebookTokenImpl = function () {
        var e = null;
        if (k().isBrowser && (e = window.FB), !e) {
            var t = "no fb sdk available";
            return ri.debug(t), Promise.reject(new xe(t))
        }
        return new Promise((function (t, n) {
            e.getLoginStatus((function (e) {
                if (e && e.authResponse) {
                    var r = e.authResponse, i = r.accessToken, o = 1e3 * r.expiresIn + (new Date).getTime();
                    if (!i) {
                        s = "the jwtToken is undefined";
                        ri.debug(s), n(new xe(s))
                    }
                    t({token: i, expires_at: o})
                } else {
                    var s = "no response from facebook when refreshing the jwt token";
                    ri.debug(s), n(new xe(s))
                }
            }), {scope: "public_profile,email"})
        }))
    }, e
}(), si = new ei, ai = new oi, ui = {}, ci = function () {
    function e() {
    }

    return e.setItem = function (e, t) {
        return ui[e] = t, ui[e]
    }, e.getItem = function (e) {
        return Object.prototype.hasOwnProperty.call(ui, e) ? ui[e] : void 0
    }, e.removeItem = function (e) {
        return delete ui[e]
    }, e.clear = function () {
        return ui = {}
    }, e
}(), li = function () {
    function e() {
        try {
            this.storageWindow = window.localStorage, this.storageWindow.setItem("aws.amplify.test-ls", 1), this.storageWindow.removeItem("aws.amplify.test-ls")
        } catch (e) {
            this.storageWindow = ci
        }
    }

    return e.prototype.getStorage = function () {
        return this.storageWindow
    }, e
}(), fi = function (e, t) {
    return fi = Object.setPrototypeOf || {__proto__: []} instanceof Array && function (e, t) {
        e.__proto__ = t
    } || function (e, t) {
        for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n])
    }, fi(e, t)
};

function di(e, t) {
    if ("function" != typeof t && null !== t) throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");

    function n() {
        this.constructor = e
    }

    fi(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n)
}

var hi = function () {
    return hi = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var i in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
        return e
    }, hi.apply(this, arguments)
};

function pi(e, t, n, r) {
    return new (n || (n = Promise))((function (i, o) {
        function s(e) {
            try {
                u(r.next(e))
            } catch (e) {
                o(e)
            }
        }

        function a(e) {
            try {
                u(r.throw(e))
            } catch (e) {
                o(e)
            }
        }

        function u(e) {
            var t;
            e.done ? i(e.value) : (t = e.value, t instanceof n ? t : new n((function (e) {
                e(t)
            }))).then(s, a)
        }

        u((r = r.apply(e, t || [])).next())
    }))
}

function gi(e, t) {
    var n, r, i, o, s = {
        label: 0, sent: function () {
            if (1 & i[0]) throw i[1];
            return i[1]
        }, trys: [], ops: []
    };
    return o = {
        next: a(0),
        throw: a(1),
        return: a(2)
    }, "function" == typeof Symbol && (o[Symbol.iterator] = function () {
        return this
    }), o;

    function a(o) {
        return function (a) {
            return function (o) {
                if (n) throw new TypeError("Generator is already executing.");
                for (; s;) try {
                    if (n = 1, r && (i = 2 & o[0] ? r.return : o[0] ? r.throw || ((i = r.return) && i.call(r), 0) : r.next) && !(i = i.call(r, o[1])).done) return i;
                    switch (r = 0, i && (o = [2 & o[0], i.value]), o[0]) {
                        case 0:
                        case 1:
                            i = o;
                            break;
                        case 4:
                            return s.label++, {value: o[1], done: !1};
                        case 5:
                            s.label++, r = o[1], o = [0];
                            continue;
                        case 7:
                            o = s.ops.pop(), s.trys.pop();
                            continue;
                        default:
                            if (!(i = s.trys, (i = i.length > 0 && i[i.length - 1]) || 6 !== o[0] && 2 !== o[0])) {
                                s = 0;
                                continue
                            }
                            if (3 === o[0] && (!i || o[1] > i[0] && o[1] < i[3])) {
                                s.label = o[1];
                                break
                            }
                            if (6 === o[0] && s.label < i[1]) {
                                s.label = i[1], i = o;
                                break
                            }
                            if (i && s.label < i[2]) {
                                s.label = i[2], s.ops.push(o);
                                break
                            }
                            i[2] && s.ops.pop(), s.trys.pop();
                            continue
                    }
                    o = t.call(e, s)
                } catch (e) {
                    o = [6, e], r = 0
                } finally {
                    n = i = 0
                }
                if (5 & o[0]) throw o[1];
                return {value: o[0] ? o[1] : void 0, done: !0}
            }([o, a])
        }
    }
}

var vi, mi, yi, Si, wi, bi, Ei, Ci, _i, Ai, Pi, ki, xi, Ii, Ti, Ui, Oi, Mi, Li, Ri, Ni, Di, Bi, ji, Fi, zi, Ki, qi, Hi,
    Vi, Gi, Wi, $i, Yi, Ji, Zi, Xi, Qi, eo, to, no, ro, io, oo, so, ao, uo, co, lo, fo, ho, po, go, vo, mo, yo, So,
    wo = "3.6.1",
    bo = new Set(["af-south-1", "ap-east-1", "ap-northeast-1", "ap-northeast-2", "ap-south-1", "ap-southeast-1", "ap-southeast-2", "ca-central-1", "eu-central-1", "eu-north-1", "eu-south-1", "eu-west-1", "eu-west-2", "eu-west-3", "me-south-1", "sa-east-1", "us-east-1", "us-east-2", "us-west-1", "us-west-2"]),
    Eo = new Set(["cn-north-1", "cn-northwest-1"]), Co = new Set(["us-iso-east-1"]), _o = new Set(["us-isob-east-1"]),
    Ao = new Set(["us-gov-east-1", "us-gov-west-1"]), Po = {
        apiVersion: "2014-06-30", disableHostPrefix: !1, logger: {}, regionInfoProvider: function (e, t) {
            var n = void 0;
            switch (e) {
                case"ap-northeast-1":
                    n = {hostname: "cognito-identity.ap-northeast-1.amazonaws.com", partition: "aws"};
                    break;
                case"ap-northeast-2":
                    n = {hostname: "cognito-identity.ap-northeast-2.amazonaws.com", partition: "aws"};
                    break;
                case"ap-south-1":
                    n = {hostname: "cognito-identity.ap-south-1.amazonaws.com", partition: "aws"};
                    break;
                case"ap-southeast-1":
                    n = {hostname: "cognito-identity.ap-southeast-1.amazonaws.com", partition: "aws"};
                    break;
                case"ap-southeast-2":
                    n = {hostname: "cognito-identity.ap-southeast-2.amazonaws.com", partition: "aws"};
                    break;
                case"ca-central-1":
                    n = {hostname: "cognito-identity.ca-central-1.amazonaws.com", partition: "aws"};
                    break;
                case"cn-north-1":
                    n = {hostname: "cognito-identity.cn-north-1.amazonaws.com.cn", partition: "aws-cn"};
                    break;
                case"eu-central-1":
                    n = {hostname: "cognito-identity.eu-central-1.amazonaws.com", partition: "aws"};
                    break;
                case"eu-north-1":
                    n = {hostname: "cognito-identity.eu-north-1.amazonaws.com", partition: "aws"};
                    break;
                case"eu-west-1":
                    n = {hostname: "cognito-identity.eu-west-1.amazonaws.com", partition: "aws"};
                    break;
                case"eu-west-2":
                    n = {hostname: "cognito-identity.eu-west-2.amazonaws.com", partition: "aws"};
                    break;
                case"eu-west-3":
                    n = {hostname: "cognito-identity.eu-west-3.amazonaws.com", partition: "aws"};
                    break;
                case"fips-us-east-1":
                    n = {
                        hostname: "cognito-identity-fips.us-east-1.amazonaws.com",
                        partition: "aws",
                        signingRegion: "us-east-1"
                    };
                    break;
                case"fips-us-east-2":
                    n = {
                        hostname: "cognito-identity-fips.us-east-2.amazonaws.com",
                        partition: "aws",
                        signingRegion: "us-east-2"
                    };
                    break;
                case"fips-us-gov-west-1":
                    n = {
                        hostname: "cognito-identity-fips.us-gov-west-1.amazonaws.com",
                        partition: "aws-us-gov",
                        signingRegion: "us-gov-west-1"
                    };
                    break;
                case"fips-us-west-2":
                    n = {
                        hostname: "cognito-identity-fips.us-west-2.amazonaws.com",
                        partition: "aws",
                        signingRegion: "us-west-2"
                    };
                    break;
                case"sa-east-1":
                    n = {hostname: "cognito-identity.sa-east-1.amazonaws.com", partition: "aws"};
                    break;
                case"us-east-1":
                    n = {hostname: "cognito-identity.us-east-1.amazonaws.com", partition: "aws"};
                    break;
                case"us-east-2":
                    n = {hostname: "cognito-identity.us-east-2.amazonaws.com", partition: "aws"};
                    break;
                case"us-gov-west-1":
                    n = {hostname: "cognito-identity.us-gov-west-1.amazonaws.com", partition: "aws-us-gov"};
                    break;
                case"us-west-1":
                    n = {hostname: "cognito-identity.us-west-1.amazonaws.com", partition: "aws"};
                    break;
                case"us-west-2":
                    n = {hostname: "cognito-identity.us-west-2.amazonaws.com", partition: "aws"};
                    break;
                default:
                    bo.has(e) && (n = {
                        hostname: "cognito-identity.{region}.amazonaws.com".replace("{region}", e),
                        partition: "aws"
                    }), Eo.has(e) && (n = {
                        hostname: "cognito-identity.{region}.amazonaws.com.cn".replace("{region}", e),
                        partition: "aws-cn"
                    }), Co.has(e) && (n = {
                        hostname: "cognito-identity.{region}.c2s.ic.gov".replace("{region}", e),
                        partition: "aws-iso"
                    }), _o.has(e) && (n = {
                        hostname: "cognito-identity.{region}.sc2s.sgov.gov".replace("{region}", e),
                        partition: "aws-iso-b"
                    }), Ao.has(e) && (n = {
                        hostname: "cognito-identity.{region}.amazonaws.com".replace("{region}", e),
                        partition: "aws-us-gov"
                    }), void 0 === n && (n = {
                        hostname: "cognito-identity.{region}.amazonaws.com".replace("{region}", e),
                        partition: "aws"
                    })
            }
            return Promise.resolve(hi({signingService: "cognito-identity"}, n))
        }, serviceId: "Cognito Identity", urlParser: qn
    }, ko = hi(hi({}, Po), {
        runtime: "browser",
        base64Decoder: en,
        base64Encoder: tn,
        bodyLengthChecker: jn,
        credentialDefaultProvider: function (e) {
            return function () {
                return Promise.reject(new Error("Credential is missing"))
            }
        },
        defaultUserAgentProvider: Kn({serviceId: Po.serviceId, clientVersion: wo}),
        maxAttempts: 3,
        region: on("Region is missing"),
        requestHandler: new Gt,
        sha256: Re.Sha256,
        streamCollector: nn,
        utf8Decoder: ze,
        utf8Encoder: Ke
    }), xo = function (e) {
        function t(t) {
            var n = this, r = hi(hi({}, ko), t), i = Wn(r), o = _r(Hn(i)), s = Ir(Dn(o));
            return (n = e.call(this, s) || this).config = s, n.middlewareStack.use(an(n.config)), n.middlewareStack.use(Jn(n.config)), n.middlewareStack.use(Xn(n.config)), n.middlewareStack.use(er(n.config)), n.middlewareStack.use(Mr(n.config)), n
        }

        return di(t, e), t.prototype.destroy = function () {
            e.prototype.destroy.call(this)
        }, t
    }(Dr);
!function (e) {
    e.AUTHENTICATED_ROLE = "AuthenticatedRole", e.DENY = "Deny"
}(vi || (vi = {})), function (e) {
    e.filterSensitiveLog = function (e) {
        return hi({}, e)
    }
}(mi || (mi = {})), function (e) {
    e.filterSensitiveLog = function (e) {
        return hi({}, e)
    }
}(yi || (yi = {})), function (e) {
    e.filterSensitiveLog = function (e) {
        return hi({}, e)
    }
}(Si || (Si = {})), function (e) {
    e.filterSensitiveLog = function (e) {
        return hi({}, e)
    }
}(wi || (wi = {})), function (e) {
    e.filterSensitiveLog = function (e) {
        return hi({}, e)
    }
}(bi || (bi = {})), function (e) {
    e.filterSensitiveLog = function (e) {
        return hi({}, e)
    }
}(Ei || (Ei = {})), function (e) {
    e.filterSensitiveLog = function (e) {
        return hi({}, e)
    }
}(Ci || (Ci = {})), function (e) {
    e.filterSensitiveLog = function (e) {
        return hi({}, e)
    }
}(_i || (_i = {})), function (e) {
    e.filterSensitiveLog = function (e) {
        return hi({}, e)
    }
}(Ai || (Ai = {})), function (e) {
    e.filterSensitiveLog = function (e) {
        return hi({}, e)
    }
}(Pi || (Pi = {})), function (e) {
    e.ACCESS_DENIED = "AccessDenied", e.INTERNAL_SERVER_ERROR = "InternalServerError"
}(ki || (ki = {})), function (e) {
    e.filterSensitiveLog = function (e) {
        return hi({}, e)
    }
}(xi || (xi = {})), function (e) {
    e.filterSensitiveLog = function (e) {
        return hi({}, e)
    }
}(Ii || (Ii = {})), function (e) {
    e.filterSensitiveLog = function (e) {
        return hi({}, e)
    }
}(Ti || (Ti = {})), function (e) {
    e.filterSensitiveLog = function (e) {
        return hi({}, e)
    }
}(Ui || (Ui = {})), function (e) {
    e.filterSensitiveLog = function (e) {
        return hi({}, e)
    }
}(Oi || (Oi = {})), function (e) {
    e.filterSensitiveLog = function (e) {
        return hi({}, e)
    }
}(Mi || (Mi = {})), function (e) {
    e.filterSensitiveLog = function (e) {
        return hi({}, e)
    }
}(Li || (Li = {})), function (e) {
    e.filterSensitiveLog = function (e) {
        return hi({}, e)
    }
}(Ri || (Ri = {})), function (e) {
    e.filterSensitiveLog = function (e) {
        return hi({}, e)
    }
}(Ni || (Ni = {})), (Di || (Di = {})).filterSensitiveLog = function (e) {
    return hi({}, e)
}, function (e) {
    e.filterSensitiveLog = function (e) {
        return hi({}, e)
    }
}(Bi || (Bi = {})), function (e) {
    e.filterSensitiveLog = function (e) {
        return hi({}, e)
    }
}(ji || (ji = {})), function (e) {
    e.filterSensitiveLog = function (e) {
        return hi({}, e)
    }
}(Fi || (Fi = {})), function (e) {
    e.filterSensitiveLog = function (e) {
        return hi({}, e)
    }
}(zi || (zi = {})), function (e) {
    e.filterSensitiveLog = function (e) {
        return hi({}, e)
    }
}(Ki || (Ki = {})), function (e) {
    e.CONTAINS = "Contains", e.EQUALS = "Equals", e.NOT_EQUAL = "NotEqual", e.STARTS_WITH = "StartsWith"
}(qi || (qi = {})), function (e) {
    e.filterSensitiveLog = function (e) {
        return hi({}, e)
    }
}(Hi || (Hi = {})), function (e) {
    e.filterSensitiveLog = function (e) {
        return hi({}, e)
    }
}(Vi || (Vi = {})), function (e) {
    e.RULES = "Rules", e.TOKEN = "Token"
}(Gi || (Gi = {})), function (e) {
    e.filterSensitiveLog = function (e) {
        return hi({}, e)
    }
}(Wi || (Wi = {})), function (e) {
    e.filterSensitiveLog = function (e) {
        return hi({}, e)
    }
}($i || ($i = {})), function (e) {
    e.filterSensitiveLog = function (e) {
        return hi({}, e)
    }
}(Yi || (Yi = {})), function (e) {
    e.filterSensitiveLog = function (e) {
        return hi({}, e)
    }
}(Ji || (Ji = {})), function (e) {
    e.filterSensitiveLog = function (e) {
        return hi({}, e)
    }
}(Zi || (Zi = {})), function (e) {
    e.filterSensitiveLog = function (e) {
        return hi({}, e)
    }
}(Xi || (Xi = {})), function (e) {
    e.filterSensitiveLog = function (e) {
        return hi({}, e)
    }
}(Qi || (Qi = {})), function (e) {
    e.filterSensitiveLog = function (e) {
        return hi({}, e)
    }
}(eo || (eo = {})), function (e) {
    e.filterSensitiveLog = function (e) {
        return hi({}, e)
    }
}(to || (to = {})), function (e) {
    e.filterSensitiveLog = function (e) {
        return hi({}, e)
    }
}(no || (no = {})), function (e) {
    e.filterSensitiveLog = function (e) {
        return hi({}, e)
    }
}(ro || (ro = {})), function (e) {
    e.filterSensitiveLog = function (e) {
        return hi({}, e)
    }
}(io || (io = {})), function (e) {
    e.filterSensitiveLog = function (e) {
        return hi({}, e)
    }
}(oo || (oo = {})), function (e) {
    e.filterSensitiveLog = function (e) {
        return hi({}, e)
    }
}(so || (so = {})), function (e) {
    e.filterSensitiveLog = function (e) {
        return hi({}, e)
    }
}(ao || (ao = {})), function (e) {
    e.filterSensitiveLog = function (e) {
        return hi({}, e)
    }
}(uo || (uo = {})), function (e) {
    e.filterSensitiveLog = function (e) {
        return hi({}, e)
    }
}(co || (co = {})), function (e) {
    e.filterSensitiveLog = function (e) {
        return hi({}, e)
    }
}(lo || (lo = {})), function (e) {
    e.filterSensitiveLog = function (e) {
        return hi({}, e)
    }
}(fo || (fo = {})), function (e) {
    e.filterSensitiveLog = function (e) {
        return hi({}, e)
    }
}(ho || (ho = {})), function (e) {
    e.filterSensitiveLog = function (e) {
        return hi({}, e)
    }
}(po || (po = {})), function (e) {
    e.filterSensitiveLog = function (e) {
        return hi({}, e)
    }
}(go || (go = {})), function (e) {
    e.filterSensitiveLog = function (e) {
        return hi({}, e)
    }
}(vo || (vo = {})), function (e) {
    e.filterSensitiveLog = function (e) {
        return hi({}, e)
    }
}(mo || (mo = {})), function (e) {
    e.filterSensitiveLog = function (e) {
        return hi({}, e)
    }
}(yo || (yo = {})), function (e) {
    e.filterSensitiveLog = function (e) {
        return hi({}, e)
    }
}(So || (So = {}));
var Io = function (e, t) {
    return pi(void 0, void 0, void 0, (function () {
        var n, r, i, o, s, a, u, c, l, f, d, h, p, g, v;
        return gi(this, (function (m) {
            switch (m.label) {
                case 0:
                    return r = [hi({}, e)], v = {}, [4, is(e.body, t)];
                case 1:
                    switch (n = hi.apply(void 0, r.concat([(v.body = m.sent(), v)])), o = "UnknownError", o = os(e, n.body), o) {
                        case"ExternalServiceException":
                        case"com.amazonaws.cognitoidentity#ExternalServiceException":
                            return [3, 2];
                        case"InternalErrorException":
                        case"com.amazonaws.cognitoidentity#InternalErrorException":
                            return [3, 4];
                        case"InvalidIdentityPoolConfigurationException":
                        case"com.amazonaws.cognitoidentity#InvalidIdentityPoolConfigurationException":
                            return [3, 6];
                        case"InvalidParameterException":
                        case"com.amazonaws.cognitoidentity#InvalidParameterException":
                            return [3, 8];
                        case"NotAuthorizedException":
                        case"com.amazonaws.cognitoidentity#NotAuthorizedException":
                            return [3, 10];
                        case"ResourceConflictException":
                        case"com.amazonaws.cognitoidentity#ResourceConflictException":
                            return [3, 12];
                        case"ResourceNotFoundException":
                        case"com.amazonaws.cognitoidentity#ResourceNotFoundException":
                            return [3, 14];
                        case"TooManyRequestsException":
                        case"com.amazonaws.cognitoidentity#TooManyRequestsException":
                            return [3, 16]
                    }
                    return [3, 18];
                case 2:
                    return s = [{}], [4, Uo(n)];
                case 3:
                    return i = hi.apply(void 0, [hi.apply(void 0, s.concat([m.sent()])), {
                        name: o,
                        $metadata: ts(e)
                    }]), [3, 19];
                case 4:
                    return a = [{}], [4, Oo(n)];
                case 5:
                    return i = hi.apply(void 0, [hi.apply(void 0, a.concat([m.sent()])), {
                        name: o,
                        $metadata: ts(e)
                    }]), [3, 19];
                case 6:
                    return u = [{}], [4, Mo(n)];
                case 7:
                    return i = hi.apply(void 0, [hi.apply(void 0, u.concat([m.sent()])), {
                        name: o,
                        $metadata: ts(e)
                    }]), [3, 19];
                case 8:
                    return c = [{}], [4, Lo(n)];
                case 9:
                    return i = hi.apply(void 0, [hi.apply(void 0, c.concat([m.sent()])), {
                        name: o,
                        $metadata: ts(e)
                    }]), [3, 19];
                case 10:
                    return l = [{}], [4, No(n)];
                case 11:
                    return i = hi.apply(void 0, [hi.apply(void 0, l.concat([m.sent()])), {
                        name: o,
                        $metadata: ts(e)
                    }]), [3, 19];
                case 12:
                    return f = [{}], [4, Do(n)];
                case 13:
                    return i = hi.apply(void 0, [hi.apply(void 0, f.concat([m.sent()])), {
                        name: o,
                        $metadata: ts(e)
                    }]), [3, 19];
                case 14:
                    return d = [{}], [4, Bo(n)];
                case 15:
                    return i = hi.apply(void 0, [hi.apply(void 0, d.concat([m.sent()])), {
                        name: o,
                        $metadata: ts(e)
                    }]), [3, 19];
                case 16:
                    return h = [{}], [4, jo(n)];
                case 17:
                    return i = hi.apply(void 0, [hi.apply(void 0, h.concat([m.sent()])), {
                        name: o,
                        $metadata: ts(e)
                    }]), [3, 19];
                case 18:
                    p = n.body, o = p.code || p.Code || o, i = hi(hi({}, p), {
                        name: "" + o,
                        message: p.message || p.Message || o,
                        $fault: "client",
                        $metadata: ts(e)
                    }), m.label = 19;
                case 19:
                    return g = i.message || i.Message || o, i.message = g, delete i.Message, [2, Promise.reject(Object.assign(new Error(g), i))]
            }
        }))
    }))
}, To = function (e, t) {
    return pi(void 0, void 0, void 0, (function () {
        var n, r, i, o, s, a, u, c, l, f, d, h, p, g, v;
        return gi(this, (function (m) {
            switch (m.label) {
                case 0:
                    return r = [hi({}, e)], v = {}, [4, is(e.body, t)];
                case 1:
                    switch (n = hi.apply(void 0, r.concat([(v.body = m.sent(), v)])), o = "UnknownError", o = os(e, n.body), o) {
                        case"ExternalServiceException":
                        case"com.amazonaws.cognitoidentity#ExternalServiceException":
                            return [3, 2];
                        case"InternalErrorException":
                        case"com.amazonaws.cognitoidentity#InternalErrorException":
                            return [3, 4];
                        case"InvalidParameterException":
                        case"com.amazonaws.cognitoidentity#InvalidParameterException":
                            return [3, 6];
                        case"LimitExceededException":
                        case"com.amazonaws.cognitoidentity#LimitExceededException":
                            return [3, 8];
                        case"NotAuthorizedException":
                        case"com.amazonaws.cognitoidentity#NotAuthorizedException":
                            return [3, 10];
                        case"ResourceConflictException":
                        case"com.amazonaws.cognitoidentity#ResourceConflictException":
                            return [3, 12];
                        case"ResourceNotFoundException":
                        case"com.amazonaws.cognitoidentity#ResourceNotFoundException":
                            return [3, 14];
                        case"TooManyRequestsException":
                        case"com.amazonaws.cognitoidentity#TooManyRequestsException":
                            return [3, 16]
                    }
                    return [3, 18];
                case 2:
                    return s = [{}], [4, Uo(n)];
                case 3:
                    return i = hi.apply(void 0, [hi.apply(void 0, s.concat([m.sent()])), {
                        name: o,
                        $metadata: ts(e)
                    }]), [3, 19];
                case 4:
                    return a = [{}], [4, Oo(n)];
                case 5:
                    return i = hi.apply(void 0, [hi.apply(void 0, a.concat([m.sent()])), {
                        name: o,
                        $metadata: ts(e)
                    }]), [3, 19];
                case 6:
                    return u = [{}], [4, Lo(n)];
                case 7:
                    return i = hi.apply(void 0, [hi.apply(void 0, u.concat([m.sent()])), {
                        name: o,
                        $metadata: ts(e)
                    }]), [3, 19];
                case 8:
                    return c = [{}], [4, Ro(n)];
                case 9:
                    return i = hi.apply(void 0, [hi.apply(void 0, c.concat([m.sent()])), {
                        name: o,
                        $metadata: ts(e)
                    }]), [3, 19];
                case 10:
                    return l = [{}], [4, No(n)];
                case 11:
                    return i = hi.apply(void 0, [hi.apply(void 0, l.concat([m.sent()])), {
                        name: o,
                        $metadata: ts(e)
                    }]), [3, 19];
                case 12:
                    return f = [{}], [4, Do(n)];
                case 13:
                    return i = hi.apply(void 0, [hi.apply(void 0, f.concat([m.sent()])), {
                        name: o,
                        $metadata: ts(e)
                    }]), [3, 19];
                case 14:
                    return d = [{}], [4, Bo(n)];
                case 15:
                    return i = hi.apply(void 0, [hi.apply(void 0, d.concat([m.sent()])), {
                        name: o,
                        $metadata: ts(e)
                    }]), [3, 19];
                case 16:
                    return h = [{}], [4, jo(n)];
                case 17:
                    return i = hi.apply(void 0, [hi.apply(void 0, h.concat([m.sent()])), {
                        name: o,
                        $metadata: ts(e)
                    }]), [3, 19];
                case 18:
                    p = n.body, o = p.code || p.Code || o, i = hi(hi({}, p), {
                        name: "" + o,
                        message: p.message || p.Message || o,
                        $fault: "client",
                        $metadata: ts(e)
                    }), m.label = 19;
                case 19:
                    return g = i.message || i.Message || o, i.message = g, delete i.Message, [2, Promise.reject(Object.assign(new Error(g), i))]
            }
        }))
    }))
}, Uo = function (e, t) {
    return pi(void 0, void 0, void 0, (function () {
        var t, n;
        return gi(this, (function (r) {
            return t = e.body, n = Ho(t), [2, hi({
                name: "ExternalServiceException",
                $fault: "client",
                $metadata: ts(e)
            }, n)]
        }))
    }))
}, Oo = function (e, t) {
    return pi(void 0, void 0, void 0, (function () {
        var t, n;
        return gi(this, (function (r) {
            return t = e.body, n = Wo(t), [2, hi({
                name: "InternalErrorException",
                $fault: "server",
                $metadata: ts(e)
            }, n)]
        }))
    }))
}, Mo = function (e, t) {
    return pi(void 0, void 0, void 0, (function () {
        var t, n;
        return gi(this, (function (r) {
            return t = e.body, n = $o(t), [2, hi({
                name: "InvalidIdentityPoolConfigurationException",
                $fault: "client",
                $metadata: ts(e)
            }, n)]
        }))
    }))
}, Lo = function (e, t) {
    return pi(void 0, void 0, void 0, (function () {
        var t, n;
        return gi(this, (function (r) {
            return t = e.body, n = Yo(t), [2, hi({
                name: "InvalidParameterException",
                $fault: "client",
                $metadata: ts(e)
            }, n)]
        }))
    }))
}, Ro = function (e, t) {
    return pi(void 0, void 0, void 0, (function () {
        var t, n;
        return gi(this, (function (r) {
            return t = e.body, n = Jo(t), [2, hi({
                name: "LimitExceededException",
                $fault: "client",
                $metadata: ts(e)
            }, n)]
        }))
    }))
}, No = function (e, t) {
    return pi(void 0, void 0, void 0, (function () {
        var t, n;
        return gi(this, (function (r) {
            return t = e.body, n = Zo(t), [2, hi({
                name: "NotAuthorizedException",
                $fault: "client",
                $metadata: ts(e)
            }, n)]
        }))
    }))
}, Do = function (e, t) {
    return pi(void 0, void 0, void 0, (function () {
        var t, n;
        return gi(this, (function (r) {
            return t = e.body, n = Xo(t), [2, hi({
                name: "ResourceConflictException",
                $fault: "client",
                $metadata: ts(e)
            }, n)]
        }))
    }))
}, Bo = function (e, t) {
    return pi(void 0, void 0, void 0, (function () {
        var t, n;
        return gi(this, (function (r) {
            return t = e.body, n = Qo(t), [2, hi({
                name: "ResourceNotFoundException",
                $fault: "client",
                $metadata: ts(e)
            }, n)]
        }))
    }))
}, jo = function (e, t) {
    return pi(void 0, void 0, void 0, (function () {
        var t, n;
        return gi(this, (function (r) {
            return t = e.body, n = es(t), [2, hi({
                name: "TooManyRequestsException",
                $fault: "client",
                $metadata: ts(e)
            }, n)]
        }))
    }))
}, Fo = function (e, t) {
    return hi(hi(hi({}, void 0 !== e.CustomRoleArn && null !== e.CustomRoleArn && {CustomRoleArn: e.CustomRoleArn}), void 0 !== e.IdentityId && null !== e.IdentityId && {IdentityId: e.IdentityId}), void 0 !== e.Logins && null !== e.Logins && {Logins: Ko(e.Logins)})
}, zo = function (e, t) {
    return hi(hi(hi({}, void 0 !== e.AccountId && null !== e.AccountId && {AccountId: e.AccountId}), void 0 !== e.IdentityPoolId && null !== e.IdentityPoolId && {IdentityPoolId: e.IdentityPoolId}), void 0 !== e.Logins && null !== e.Logins && {Logins: Ko(e.Logins)})
}, Ko = function (e, t) {
    return Object.entries(e).reduce((function (e, t) {
        var n, r = function (e, t) {
            var n = "function" == typeof Symbol && e[Symbol.iterator];
            if (!n) return e;
            var r, i, o = n.call(e), s = [];
            try {
                for (; (void 0 === t || t-- > 0) && !(r = o.next()).done;) s.push(r.value)
            } catch (e) {
                i = {error: e}
            } finally {
                try {
                    r && !r.done && (n = o.return) && n.call(o)
                } finally {
                    if (i) throw i.error
                }
            }
            return s
        }(t, 2), i = r[0], o = r[1];
        return null === o ? e : hi(hi({}, e), ((n = {})[i] = o, n))
    }), {})
}, qo = function (e, t) {
    return {
        AccessKeyId: void 0 !== e.AccessKeyId && null !== e.AccessKeyId ? e.AccessKeyId : void 0,
        Expiration: void 0 !== e.Expiration && null !== e.Expiration ? new Date(Math.round(1e3 * e.Expiration)) : void 0,
        SecretKey: void 0 !== e.SecretKey && null !== e.SecretKey ? e.SecretKey : void 0,
        SessionToken: void 0 !== e.SessionToken && null !== e.SessionToken ? e.SessionToken : void 0
    }
}, Ho = function (e, t) {
    return {message: void 0 !== e.message && null !== e.message ? e.message : void 0}
}, Vo = function (e, t) {
    return {
        Credentials: void 0 !== e.Credentials && null !== e.Credentials ? qo(e.Credentials) : void 0,
        IdentityId: void 0 !== e.IdentityId && null !== e.IdentityId ? e.IdentityId : void 0
    }
}, Go = function (e, t) {
    return {IdentityId: void 0 !== e.IdentityId && null !== e.IdentityId ? e.IdentityId : void 0}
}, Wo = function (e, t) {
    return {message: void 0 !== e.message && null !== e.message ? e.message : void 0}
}, $o = function (e, t) {
    return {message: void 0 !== e.message && null !== e.message ? e.message : void 0}
}, Yo = function (e, t) {
    return {message: void 0 !== e.message && null !== e.message ? e.message : void 0}
}, Jo = function (e, t) {
    return {message: void 0 !== e.message && null !== e.message ? e.message : void 0}
}, Zo = function (e, t) {
    return {message: void 0 !== e.message && null !== e.message ? e.message : void 0}
}, Xo = function (e, t) {
    return {message: void 0 !== e.message && null !== e.message ? e.message : void 0}
}, Qo = function (e, t) {
    return {message: void 0 !== e.message && null !== e.message ? e.message : void 0}
}, es = function (e, t) {
    return {message: void 0 !== e.message && null !== e.message ? e.message : void 0}
}, ts = function (e) {
    var t;
    return {
        httpStatusCode: e.statusCode,
        requestId: null !== (t = e.headers["x-amzn-requestid"]) && void 0 !== t ? t : e.headers["x-amzn-request-id"],
        extendedRequestId: e.headers["x-amz-id-2"],
        cfId: e.headers["x-amz-cf-id"]
    }
}, ns = function (e, t) {
    return function (e, t) {
        return void 0 === e && (e = new Uint8Array), e instanceof Uint8Array ? Promise.resolve(e) : t.streamCollector(e) || Promise.resolve(new Uint8Array)
    }(e, t).then((function (e) {
        return t.utf8Encoder(e)
    }))
}, rs = function (e, t, n, r, i) {
    return pi(void 0, void 0, void 0, (function () {
        var o, s, a, u, c, l;
        return gi(this, (function (f) {
            switch (f.label) {
                case 0:
                    return [4, e.endpoint()];
                case 1:
                    return o = f.sent(), s = o.hostname, a = o.protocol, u = void 0 === a ? "https" : a, c = o.port, l = {
                        protocol: u,
                        hostname: s,
                        port: c,
                        method: "POST",
                        path: n,
                        headers: t
                    }, void 0 !== r && (l.hostname = r), void 0 !== i && (l.body = i), [2, new Kt(l)]
            }
        }))
    }))
}, is = function (e, t) {
    return ns(e, t).then((function (e) {
        return e.length ? JSON.parse(e) : {}
    }))
}, os = function (e, t) {
    var n, r, i = function (e) {
        var t = e;
        return t.indexOf(":") >= 0 && (t = t.split(":")[0]), t.indexOf("#") >= 0 && (t = t.split("#")[1]), t
    }, o = (n = e.headers, r = "x-amzn-errortype", Object.keys(n).find((function (e) {
        return e.toLowerCase() === r.toLowerCase()
    })));
    return void 0 !== o ? i(e.headers[o]) : void 0 !== t.code ? i(t.code) : void 0 !== t.__type ? i(t.__type) : ""
}, ss = function (e) {
    function t(t) {
        var n = e.call(this) || this;
        return n.input = t, n
    }

    return di(t, e), t.prototype.resolveMiddleware = function (e, t, n) {
        this.middlewareStack.use(Yr(t, this.serialize, this.deserialize));
        var r = e.concat(this.middlewareStack), i = {
            logger: t.logger,
            clientName: "CognitoIdentityClient",
            commandName: "GetCredentialsForIdentityCommand",
            inputFilterSensitiveLog: Ni.filterSensitiveLog,
            outputFilterSensitiveLog: Bi.filterSensitiveLog
        }, o = t.requestHandler;
        return r.resolve((function (e) {
            return o.handle(e.request, n || {})
        }), i)
    }, t.prototype.serialize = function (e, t) {
        return function (e, t) {
            return pi(void 0, void 0, void 0, (function () {
                var n, r;
                return gi(this, (function (i) {
                    return n = {
                        "content-type": "application/x-amz-json-1.1",
                        "x-amz-target": "AWSCognitoIdentityService.GetCredentialsForIdentity"
                    }, r = JSON.stringify(Fo(e)), [2, rs(t, n, "/", void 0, r)]
                }))
            }))
        }(e, t)
    }, t.prototype.deserialize = function (e, t) {
        return function (e, t) {
            return pi(void 0, void 0, void 0, (function () {
                var n, r, i;
                return gi(this, (function (o) {
                    switch (o.label) {
                        case 0:
                            return e.statusCode >= 300 ? [2, Io(e, t)] : [4, is(e.body, t)];
                        case 1:
                            return n = o.sent(), r = Vo(n), i = hi({$metadata: ts(e)}, r), [2, Promise.resolve(i)]
                    }
                }))
            }))
        }(e, t)
    }, t
}(Br), as = function (e) {
    function t(t) {
        var n = e.call(this) || this;
        return n.input = t, n
    }

    return di(t, e), t.prototype.resolveMiddleware = function (e, t, n) {
        this.middlewareStack.use(Yr(t, this.serialize, this.deserialize));
        var r = e.concat(this.middlewareStack), i = {
            logger: t.logger,
            clientName: "CognitoIdentityClient",
            commandName: "GetIdCommand",
            inputFilterSensitiveLog: Fi.filterSensitiveLog,
            outputFilterSensitiveLog: zi.filterSensitiveLog
        }, o = t.requestHandler;
        return r.resolve((function (e) {
            return o.handle(e.request, n || {})
        }), i)
    }, t.prototype.serialize = function (e, t) {
        return function (e, t) {
            return pi(void 0, void 0, void 0, (function () {
                var n, r;
                return gi(this, (function (i) {
                    return n = {
                        "content-type": "application/x-amz-json-1.1",
                        "x-amz-target": "AWSCognitoIdentityService.GetId"
                    }, r = JSON.stringify(zo(e)), [2, rs(t, n, "/", void 0, r)]
                }))
            }))
        }(e, t)
    }, t.prototype.deserialize = function (e, t) {
        return function (e, t) {
            return pi(void 0, void 0, void 0, (function () {
                var n, r, i;
                return gi(this, (function (o) {
                    switch (o.label) {
                        case 0:
                            return e.statusCode >= 300 ? [2, To(e, t)] : [4, is(e.body, t)];
                        case 1:
                            return n = o.sent(), r = Go(n), i = hi({$metadata: ts(e)}, r), [2, Promise.resolve(i)]
                    }
                }))
            }))
        }(e, t)
    }, t
}(Br), us = function (e) {
    function t(t, n) {
        void 0 === n && (n = !0);
        var r = e.call(this, t) || this;
        return r.tryNextLink = n, r
    }

    return N(t, e), t
}(Error);

function cs(e) {
    return Promise.all(Object.keys(e).reduce((function (t, n) {
        var r = e[n];
        return "string" == typeof r ? t.push([n, r]) : t.push(r().then((function (e) {
            return [n, e]
        }))), t
    }), [])).then((function (e) {
        return e.reduce((function (e, t) {
            var n = K(t, 2), r = n[0], i = n[1];
            return e[r] = i, e
        }), {})
    }))
}

function ls(e) {
    var t = this;
    return function () {
        return j(t, void 0, void 0, (function () {
            var t, n, r, i, o, s, a, u, c, l, f, d, h;
            return F(this, (function (p) {
                switch (p.label) {
                    case 0:
                        return l = (c = e.client).send, f = ss.bind, h = {
                            CustomRoleArn: e.customRoleArn,
                            IdentityId: e.identityId
                        }, e.logins ? [4, cs(e.logins)] : [3, 2];
                    case 1:
                        return d = p.sent(), [3, 3];
                    case 2:
                        d = void 0, p.label = 3;
                    case 3:
                        return [4, l.apply(c, [new (f.apply(ss, [void 0, (h.Logins = d, h)]))])];
                    case 4:
                        return t = p.sent().Credentials, n = void 0 === t ? function () {
                            throw new us("Response from Amazon Cognito contained no credentials")
                        }() : t, r = n.AccessKeyId, i = void 0 === r ? function () {
                            throw new us("Response from Amazon Cognito contained no access key ID")
                        }() : r, o = n.Expiration, s = n.SecretKey, a = void 0 === s ? function () {
                            throw new us("Response from Amazon Cognito contained no secret key")
                        }() : s, u = n.SessionToken, [2, {
                            identityId: e.identityId,
                            accessKeyId: i,
                            secretAccessKey: a,
                            sessionToken: u,
                            expiration: o
                        }]
                }
            }))
        }))
    }
}

var fs = function () {
    function e(e) {
        void 0 === e && (e = "aws:cognito-identity-ids"), this.dbName = e
    }

    return e.prototype.getItem = function (e) {
        return this.withObjectStore("readonly", (function (t) {
            var n = t.get(e);
            return new Promise((function (e) {
                n.onerror = function () {
                    return e(null)
                }, n.onsuccess = function () {
                    return e(n.result ? n.result.value : null)
                }
            }))
        })).catch((function () {
            return null
        }))
    }, e.prototype.removeItem = function (e) {
        return this.withObjectStore("readwrite", (function (t) {
            var n = t.delete(e);
            return new Promise((function (e, t) {
                n.onerror = function () {
                    return t(n.error)
                }, n.onsuccess = function () {
                    return e()
                }
            }))
        }))
    }, e.prototype.setItem = function (e, t) {
        return this.withObjectStore("readwrite", (function (n) {
            var r = n.put({id: e, value: t});
            return new Promise((function (e, t) {
                r.onerror = function () {
                    return t(r.error)
                }, r.onsuccess = function () {
                    return e()
                }
            }))
        }))
    }, e.prototype.getDb = function () {
        var e = self.indexedDB.open(this.dbName, 1);
        return new Promise((function (t, n) {
            e.onsuccess = function () {
                t(e.result)
            }, e.onerror = function () {
                n(e.error)
            }, e.onblocked = function () {
                n(new Error("Unable to access DB"))
            }, e.onupgradeneeded = function () {
                var t = e.result;
                t.onerror = function () {
                    n(new Error("Failed to create object store"))
                }, t.createObjectStore("IdentityIds", {keyPath: "id"})
            }
        }))
    }, e.prototype.withObjectStore = function (e, t) {
        return this.getDb().then((function (n) {
            var r = n.transaction("IdentityIds", e);
            return r.oncomplete = function () {
                return n.close()
            }, new Promise((function (e, n) {
                r.onerror = function () {
                    return n(r.error)
                }, e(t(r.objectStore("IdentityIds")))
            })).catch((function (e) {
                throw n.close(), e
            }))
        }))
    }, e
}(), ds = new (function () {
    function e(e) {
        void 0 === e && (e = {}), this.store = e
    }

    return e.prototype.getItem = function (e) {
        return e in this.store ? this.store[e] : null
    }, e.prototype.removeItem = function (e) {
        delete this.store[e]
    }, e.prototype.setItem = function (e, t) {
        this.store[e] = t
    }, e
}());

function hs(e) {
    var t = this, n = e.accountId, r = e.cache,
        i = void 0 === r ? "object" == typeof self && self.indexedDB ? new fs : "object" == typeof window && window.localStorage ? window.localStorage : ds : r,
        o = e.client, s = e.customRoleArn, a = e.identityPoolId, u = e.logins, c = e.userIdentifier,
        l = void 0 === c ? u && 0 !== Object.keys(u).length ? void 0 : "ANONYMOUS" : c,
        f = l ? "aws:cognito-identity-credentials:" + a + ":" + l : void 0, d = function () {
            return j(t, void 0, void 0, (function () {
                var e, t, r, c, l, h, p, g, v;
                return F(this, (function (m) {
                    switch (m.label) {
                        case 0:
                            return (t = f) ? [4, i.getItem(f)] : [3, 2];
                        case 1:
                            t = m.sent(), m.label = 2;
                        case 2:
                            return (e = t) ? [3, 7] : (h = (l = o).send, p = as.bind, v = {
                                AccountId: n,
                                IdentityPoolId: a
                            }, u ? [4, cs(u)] : [3, 4]);
                        case 3:
                            return g = m.sent(), [3, 5];
                        case 4:
                            g = void 0, m.label = 5;
                        case 5:
                            return [4, h.apply(l, [new (p.apply(as, [void 0, (v.Logins = g, v)]))])];
                        case 6:
                            r = m.sent().IdentityId, c = void 0 === r ? function () {
                                throw new us("Response from Amazon Cognito contained no identity ID")
                            }() : r, e = c, f && Promise.resolve(i.setItem(f, e)).catch((function () {
                            })), m.label = 7;
                        case 7:
                            return [2, (d = ls({client: o, customRoleArn: s, logins: u, identityId: e}))()]
                    }
                }))
            }))
        };
    return function () {
        return d().catch((function (e) {
            return j(t, void 0, void 0, (function () {
                return F(this, (function (t) {
                    throw f && Promise.resolve(i.removeItem(f)).catch((function () {
                    })), e
                }))
            }))
        }))
    }
}

var ps = function () {
    return ps = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var i in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
        return e
    }, ps.apply(this, arguments)
}, gs = function (e, t, n, r) {
    return new (n || (n = Promise))((function (i, o) {
        function s(e) {
            try {
                u(r.next(e))
            } catch (e) {
                o(e)
            }
        }

        function a(e) {
            try {
                u(r.throw(e))
            } catch (e) {
                o(e)
            }
        }

        function u(e) {
            var t;
            e.done ? i(e.value) : (t = e.value, t instanceof n ? t : new n((function (e) {
                e(t)
            }))).then(s, a)
        }

        u((r = r.apply(e, t || [])).next())
    }))
}, vs = function (e, t) {
    var n, r, i, o, s = {
        label: 0, sent: function () {
            if (1 & i[0]) throw i[1];
            return i[1]
        }, trys: [], ops: []
    };
    return o = {
        next: a(0),
        throw: a(1),
        return: a(2)
    }, "function" == typeof Symbol && (o[Symbol.iterator] = function () {
        return this
    }), o;

    function a(o) {
        return function (a) {
            return function (o) {
                if (n) throw new TypeError("Generator is already executing.");
                for (; s;) try {
                    if (n = 1, r && (i = 2 & o[0] ? r.return : o[0] ? r.throw || ((i = r.return) && i.call(r), 0) : r.next) && !(i = i.call(r, o[1])).done) return i;
                    switch (r = 0, i && (o = [2 & o[0], i.value]), o[0]) {
                        case 0:
                        case 1:
                            i = o;
                            break;
                        case 4:
                            return s.label++, {value: o[1], done: !1};
                        case 5:
                            s.label++, r = o[1], o = [0];
                            continue;
                        case 7:
                            o = s.ops.pop(), s.trys.pop();
                            continue;
                        default:
                            if (!(i = s.trys, (i = i.length > 0 && i[i.length - 1]) || 6 !== o[0] && 2 !== o[0])) {
                                s = 0;
                                continue
                            }
                            if (3 === o[0] && (!i || o[1] > i[0] && o[1] < i[3])) {
                                s.label = o[1];
                                break
                            }
                            if (6 === o[0] && s.label < i[1]) {
                                s.label = i[1], i = o;
                                break
                            }
                            if (i && s.label < i[2]) {
                                s.label = i[2], s.ops.push(o);
                                break
                            }
                            i[2] && s.ops.pop(), s.trys.pop();
                            continue
                    }
                    o = t.call(e, s)
                } catch (e) {
                    o = [6, e], r = 0
                } finally {
                    n = i = 0
                }
                if (5 & o[0]) throw o[1];
                return {value: o[0] ? o[1] : void 0, done: !0}
            }([o, a])
        }
    }
}, ms = new o("Credentials"), ys = function () {
    function e(e) {
        this._gettingCredPromise = null, this._refreshHandlers = {}, this.Auth = void 0, this.configure(e), this._refreshHandlers.google = si.refreshGoogleToken, this._refreshHandlers.facebook = ai.refreshFacebookToken
    }

    return e.prototype.getModuleName = function () {
        return "Credentials"
    }, e.prototype.getCredSource = function () {
        return this._credentials_source
    }, e.prototype.configure = function (e) {
        if (!e) return this._config || {};
        this._config = Object.assign({}, this._config, e);
        var t = this._config.refreshHandlers;
        return t && (this._refreshHandlers = ps(ps({}, this._refreshHandlers), t)), this._storage = this._config.storage, this._storage || (this._storage = (new li).getStorage()), this._storageSync = Promise.resolve(), "function" == typeof this._storage.sync && (this._storageSync = this._storage.sync()), this._config
    }, e.prototype.get = function () {
        return ms.debug("getting credentials"), this._pickupCredentials()
    }, e.prototype._getCognitoIdentityIdStorageKey = function (e) {
        return "CognitoIdentityId-" + e
    }, e.prototype._pickupCredentials = function () {
        return ms.debug("picking up credentials"), this._gettingCredPromise && this._gettingCredPromise.isPending() ? ms.debug("getting old cred promise") : (ms.debug("getting new cred promise"), this._gettingCredPromise = A(this._keepAlive())), this._gettingCredPromise
    }, e.prototype._keepAlive = function () {
        return gs(this, void 0, void 0, (function () {
            var e, t, n, r, i, o, s;
            return vs(this, (function (a) {
                switch (a.label) {
                    case 0:
                        if (ms.debug("checking if credentials exists and not expired"), (e = this._credentials) && !this._isExpired(e) && !this._isPastTTL()) return ms.debug("credentials not changed and not expired, directly return"), [2, Promise.resolve(e)];
                        if (ms.debug("need to get a new credential or refresh the existing one"), t = this.Auth, !(n = void 0 === t ? u.Auth : t) || "function" != typeof n.currentUserCredentials) return [2, Promise.reject("No Auth module registered in Amplify")];
                        if (this._isExpired(e) || !this._isPastTTL()) return [3, 6];
                        ms.debug("ttl has passed but token is not yet expired"), a.label = 1;
                    case 1:
                        return a.trys.push([1, 5, , 6]), [4, n.currentUserPoolUser()];
                    case 2:
                        return r = a.sent(), [4, n.currentSession()];
                    case 3:
                        return i = a.sent(), o = i.refreshToken, [4, new Promise((function (e, t) {
                            r.refreshSession(o, (function (n, r) {
                                return n ? t(n) : e(r)
                            }))
                        }))];
                    case 4:
                        return a.sent(), [3, 6];
                    case 5:
                        return s = a.sent(), ms.debug("Error attempting to refreshing the session", s), [3, 6];
                    case 6:
                        return [2, n.currentUserCredentials()]
                }
            }))
        }))
    }, e.prototype.refreshFederatedToken = function (e) {
        ms.debug("Getting federated credentials");
        var t = e.provider, n = e.user, r = e.token, i = e.identity_id, o = e.expires_at;
        o = 1970 === new Date(o).getFullYear() ? 1e3 * o : o;
        var s = this;
        return ms.debug("checking if federated jwt token expired"), o > (new Date).getTime() ? (ms.debug("token not expired"), this._setCredentialsFromFederation({
            provider: t,
            token: r,
            user: n,
            identity_id: i,
            expires_at: o
        })) : s._refreshHandlers[t] && "function" == typeof s._refreshHandlers[t] ? (ms.debug("getting refreshed jwt token from federation provider"), this._providerRefreshWithRetry({
            refreshHandler: s._refreshHandlers[t],
            provider: t,
            user: n
        })) : (ms.debug("no refresh handler for provider:", t), this.clear(), Promise.reject("no refresh handler for provider"))
    }, e.prototype._providerRefreshWithRetry = function (e) {
        var t = this, n = e.refreshHandler, r = e.provider, i = e.user;
        return Te(n, [], 1e4).then((function (e) {
            return ms.debug("refresh federated token sucessfully", e), t._setCredentialsFromFederation({
                provider: r,
                token: e.token,
                user: i,
                identity_id: e.identity_id,
                expires_at: e.expires_at
            })
        })).catch((function (e) {
            return "string" == typeof e && 0 === e.toLowerCase().lastIndexOf("network error", e.length) || t.clear(), ms.debug("refresh federated token failed", e), Promise.reject("refreshing federation token failed: " + e)
        }))
    }, e.prototype._isExpired = function (e) {
        if (!e) return ms.debug("no credentials for expiration check"), !0;
        ms.debug("are these credentials expired?", e);
        var t = Date.now();
        return e.expiration.getTime() <= t
    }, e.prototype._isPastTTL = function () {
        return this._nextCredentialsRefresh <= Date.now()
    }, e.prototype._setCredentialsForGuest = function () {
        return gs(this, void 0, void 0, (function () {
            var e, t, n, r, i, o, s, a, u = this;
            return vs(this, (function (c) {
                switch (c.label) {
                    case 0:
                        return ms.debug("setting credentials for guest"), e = this._config, t = e.identityPoolId, n = e.region, e.mandatorySignIn ? [2, Promise.reject("cannot get guest credentials when mandatory signin enabled")] : t ? n ? (i = this, [4, this._getGuestIdentityId()]) : (ms.debug("region is not configured for getting the credentials"), [2, Promise.reject("region is not configured for getting the credentials")]) : (ms.debug("No Cognito Identity pool provided for unauthenticated access"), [2, Promise.reject("No Cognito Identity pool provided for unauthenticated access")]);
                    case 1:
                        return r = i._identityId = c.sent(), o = new xo({
                            region: n,
                            customUserAgent: l()
                        }), s = void 0, r ? s = ls({identityId: r, client: o})() : (a = function () {
                            return gs(u, void 0, void 0, (function () {
                                var e;
                                return vs(this, (function (n) {
                                    switch (n.label) {
                                        case 0:
                                            return [4, o.send(new as({IdentityPoolId: t}))];
                                        case 1:
                                            return e = n.sent().IdentityId, this._identityId = e, [2, ls({
                                                client: o,
                                                identityId: e
                                            })()]
                                    }
                                }))
                            }))
                        }, s = a().catch((function (e) {
                            return gs(u, void 0, void 0, (function () {
                                return vs(this, (function (t) {
                                    throw e
                                }))
                            }))
                        }))), [2, this._loadCredentials(s, "guest", !1, null).then((function (e) {
                            return e
                        })).catch((function (e) {
                            return gs(u, void 0, void 0, (function () {
                                var n, i = this;
                                return vs(this, (function (a) {
                                    switch (a.label) {
                                        case 0:
                                            return "ResourceNotFoundException" !== e.name || e.message !== "Identity '" + r + "' not found." ? [3, 2] : (ms.debug("Failed to load guest credentials"), [4, this._removeGuestIdentityId()]);
                                        case 1:
                                            return a.sent(), n = function () {
                                                return gs(i, void 0, void 0, (function () {
                                                    var e;
                                                    return vs(this, (function (n) {
                                                        switch (n.label) {
                                                            case 0:
                                                                return [4, o.send(new as({IdentityPoolId: t}))];
                                                            case 1:
                                                                return e = n.sent().IdentityId, this._identityId = e, [2, ls({
                                                                    client: o,
                                                                    identityId: e
                                                                })()]
                                                        }
                                                    }))
                                                }))
                                            }, s = n().catch((function (e) {
                                                return gs(i, void 0, void 0, (function () {
                                                    return vs(this, (function (t) {
                                                        throw e
                                                    }))
                                                }))
                                            })), [2, this._loadCredentials(s, "guest", !1, null)];
                                        case 2:
                                            return [2, e]
                                    }
                                }))
                            }))
                        }))]
                }
            }))
        }))
    }, e.prototype._setCredentialsFromFederation = function (e) {
        var t = e.provider, n = e.token, r = e.identity_id, i = {
            google: "accounts.google.com",
            facebook: "graph.facebook.com",
            amazon: "www.amazon.com",
            developer: "cognito-identity.amazonaws.com"
        }[t] || t;
        if (!i) return Promise.reject("You must specify a federated provider");
        var o = {};
        o[i] = n;
        var s = this._config, a = s.identityPoolId, u = s.region;
        if (!a) return ms.debug("No Cognito Federated Identity pool provided"), Promise.reject("No Cognito Federated Identity pool provided");
        if (!u) return ms.debug("region is not configured for getting the credentials"), Promise.reject("region is not configured for getting the credentials");
        var c = new xo({region: u, customUserAgent: l()}), f = void 0;
        r ? f = ls({identityId: r, logins: o, client: c})() : f = hs({logins: o, identityPoolId: a, client: c})();
        return this._loadCredentials(f, "federated", !0, e)
    }, e.prototype._setCredentialsFromSession = function (e) {
        var t = this;
        ms.debug("set credentials from session");
        var n = e.getIdToken().getJwtToken(), r = this._config, i = r.region, o = r.userPoolId, s = r.identityPoolId;
        if (!s) return ms.debug("No Cognito Federated Identity pool provided"), Promise.reject("No Cognito Federated Identity pool provided");
        if (!i) return ms.debug("region is not configured for getting the credentials"), Promise.reject("region is not configured for getting the credentials");
        var a = {};
        a["cognito-idp." + i + ".amazonaws.com/" + o] = n;
        var u = new xo({region: i, customUserAgent: l()}), c = gs(t, void 0, void 0, (function () {
            var e, t, n, r, i, o, c, l, f, d;
            return vs(this, (function (h) {
                switch (h.label) {
                    case 0:
                        return [4, this._getGuestIdentityId()];
                    case 1:
                        return (e = h.sent()) ? [3, 3] : [4, u.send(new as({IdentityPoolId: s, Logins: a}))];
                    case 2:
                        n = h.sent().IdentityId, t = n, h.label = 3;
                    case 3:
                        return [4, u.send(new ss({IdentityId: e || t, Logins: a}))];
                    case 4:
                        return r = h.sent(), i = r.Credentials, o = i.AccessKeyId, c = i.Expiration, l = i.SecretKey, f = i.SessionToken, d = r.IdentityId, this._identityId = d, e ? (ms.debug("The guest identity " + e + " has been successfully linked to the logins"), e === d && ms.debug("The guest identity " + e + " has become the primary identity"), [4, this._removeGuestIdentityId()]) : [3, 6];
                    case 5:
                        h.sent(), h.label = 6;
                    case 6:
                        return [2, {accessKeyId: o, secretAccessKey: l, sessionToken: f, expiration: c, identityId: d}]
                }
            }))
        })).catch((function (e) {
            return gs(t, void 0, void 0, (function () {
                return vs(this, (function (t) {
                    throw e
                }))
            }))
        }));
        return this._loadCredentials(c, "userPool", !0, null)
    }, e.prototype._loadCredentials = function (e, t, n, r) {
        var i = this, o = this;
        return new Promise((function (s, a) {
            e.then((function (e) {
                return gs(i, void 0, void 0, (function () {
                    var i, a, u, c, l;
                    return vs(this, (function (f) {
                        switch (f.label) {
                            case 0:
                                if (ms.debug("Load credentials successfully", e), this._identityId && !e.identityId && (e.identityId = this._identityId), o._credentials = e, o._credentials.authenticated = n, o._credentials_source = t, o._nextCredentialsRefresh = (new Date).getTime() + 3e6, "federated" === t) {
                                    i = Object.assign({id: this._credentials.identityId}, r.user), a = r.provider, u = r.token, c = r.expires_at, l = r.identity_id;
                                    try {
                                        this._storage.setItem("aws-amplify-federatedInfo", JSON.stringify({
                                            provider: a,
                                            token: u,
                                            user: i,
                                            expires_at: c,
                                            identity_id: l
                                        }))
                                    } catch (e) {
                                        ms.debug("Failed to put federated info into auth storage", e)
                                    }
                                }
                                return "guest" !== t ? [3, 2] : [4, this._setGuestIdentityId(e.identityId)];
                            case 1:
                                f.sent(), f.label = 2;
                            case 2:
                                return s(o._credentials), [2]
                        }
                    }))
                }))
            })).catch((function (t) {
                if (t) return ms.debug("Failed to load credentials", e), ms.debug("Error loading credentials", t), void a(t)
            }))
        }))
    }, e.prototype.set = function (e, t) {
        return "session" === t ? this._setCredentialsFromSession(e) : "federation" === t ? this._setCredentialsFromFederation(e) : "guest" === t ? this._setCredentialsForGuest() : (ms.debug("no source specified for setting credentials"), Promise.reject("invalid source"))
    }, e.prototype.clear = function () {
        return gs(this, void 0, void 0, (function () {
            return vs(this, (function (e) {
                return this._credentials = null, this._credentials_source = null, ms.debug("removing aws-amplify-federatedInfo from storage"), this._storage.removeItem("aws-amplify-federatedInfo"), [2]
            }))
        }))
    }, e.prototype._getGuestIdentityId = function () {
        return gs(this, void 0, void 0, (function () {
            var e, t;
            return vs(this, (function (n) {
                switch (n.label) {
                    case 0:
                        e = this._config.identityPoolId, n.label = 1;
                    case 1:
                        return n.trys.push([1, 3, , 4]), [4, this._storageSync];
                    case 2:
                        return n.sent(), [2, this._storage.getItem(this._getCognitoIdentityIdStorageKey(e))];
                    case 3:
                        return t = n.sent(), ms.debug("Failed to get the cached guest identityId", t), [3, 4];
                    case 4:
                        return [2]
                }
            }))
        }))
    }, e.prototype._setGuestIdentityId = function (e) {
        return gs(this, void 0, void 0, (function () {
            var t, n;
            return vs(this, (function (r) {
                switch (r.label) {
                    case 0:
                        t = this._config.identityPoolId, r.label = 1;
                    case 1:
                        return r.trys.push([1, 3, , 4]), [4, this._storageSync];
                    case 2:
                        return r.sent(), this._storage.setItem(this._getCognitoIdentityIdStorageKey(t), e), [3, 4];
                    case 3:
                        return n = r.sent(), ms.debug("Failed to cache guest identityId", n), [3, 4];
                    case 4:
                        return [2]
                }
            }))
        }))
    }, e.prototype._removeGuestIdentityId = function () {
        return gs(this, void 0, void 0, (function () {
            var e;
            return vs(this, (function (t) {
                return e = this._config.identityPoolId, ms.debug("removing " + this._getCognitoIdentityIdStorageKey(e) + " from storage"), this._storage.removeItem(this._getCognitoIdentityIdStorageKey(e)), [2]
            }))
        }))
    }, e.prototype.shear = function (e) {
        return {
            accessKeyId: e.accessKeyId,
            sessionToken: e.sessionToken,
            secretAccessKey: e.secretAccessKey,
            identityId: e.identityId,
            authenticated: e.authenticated
        }
    }, e
}(), Ss = new ys(null);
u.register(Ss);
var ws = function (e, t) {
    if ("string" != typeof e) throw new TypeError("argument str must be a string");
    for (var n = {}, r = t || {}, i = e.split(_s), o = r.decode || Es, s = 0; s < i.length; s++) {
        var a = i[s], u = a.indexOf("=");
        if (!(u < 0)) {
            var c = a.substr(0, u).trim(), l = a.substr(++u, a.length).trim();
            '"' == l[0] && (l = l.slice(1, -1)), null == n[c] && (n[c] = Ps(l, o))
        }
    }
    return n
}, bs = function (e, t, n) {
    var r = n || {}, i = r.encode || Cs;
    if ("function" != typeof i) throw new TypeError("option encode is invalid");
    if (!As.test(e)) throw new TypeError("argument name is invalid");
    var o = i(t);
    if (o && !As.test(o)) throw new TypeError("argument val is invalid");
    var s = e + "=" + o;
    if (null != r.maxAge) {
        var a = r.maxAge - 0;
        if (isNaN(a) || !isFinite(a)) throw new TypeError("option maxAge is invalid");
        s += "; Max-Age=" + Math.floor(a)
    }
    if (r.domain) {
        if (!As.test(r.domain)) throw new TypeError("option domain is invalid");
        s += "; Domain=" + r.domain
    }
    if (r.path) {
        if (!As.test(r.path)) throw new TypeError("option path is invalid");
        s += "; Path=" + r.path
    }
    if (r.expires) {
        if ("function" != typeof r.expires.toUTCString) throw new TypeError("option expires is invalid");
        s += "; Expires=" + r.expires.toUTCString()
    }
    r.httpOnly && (s += "; HttpOnly");
    r.secure && (s += "; Secure");
    if (r.sameSite) {
        switch ("string" == typeof r.sameSite ? r.sameSite.toLowerCase() : r.sameSite) {
            case!0:
                s += "; SameSite=Strict";
                break;
            case"lax":
                s += "; SameSite=Lax";
                break;
            case"strict":
                s += "; SameSite=Strict";
                break;
            case"none":
                s += "; SameSite=None";
                break;
            default:
                throw new TypeError("option sameSite is invalid")
        }
    }
    return s
}, Es = decodeURIComponent, Cs = encodeURIComponent, _s = /; */, As = /^[\u0009\u0020-\u007e\u0080-\u00ff]+$/;

function Ps(e, t) {
    try {
        return t(e)
    } catch (t) {
        return e
    }
}

function ks(e, t) {
    void 0 === t && (t = {});
    var n = function (e) {
        if (e && "j" === e[0] && ":" === e[1]) return e.substr(2);
        return e
    }(e);
    if (function (e, t) {
        return void 0 === t && (t = !e || "{" !== e[0] && "[" !== e[0] && '"' !== e[0]), !t
    }(n, t.doNotParse)) try {
        return JSON.parse(n)
    } catch (e) {
    }
    return e
}

var xs, Is, Ts = function () {
    return Ts = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var i in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
        return e
    }, Ts.apply(this, arguments)
}, Us = function () {
    function e(e, t) {
        var n = this;
        this.changeListeners = [], this.HAS_DOCUMENT_COOKIE = !1, this.cookies = function (e, t) {
            return "string" == typeof e ? ws(e, t) : "object" == typeof e && null !== e ? e : {}
        }(e, t), new Promise((function () {
            n.HAS_DOCUMENT_COOKIE = "object" == typeof document && "string" == typeof document.cookie
        })).catch((function () {
        }))
    }

    return e.prototype._updateBrowserValues = function (e) {
        this.HAS_DOCUMENT_COOKIE && (this.cookies = ws(document.cookie, e))
    }, e.prototype._emitChange = function (e) {
        for (var t = 0; t < this.changeListeners.length; ++t) this.changeListeners[t](e)
    }, e.prototype.get = function (e, t, n) {
        return void 0 === t && (t = {}), this._updateBrowserValues(n), ks(this.cookies[e], t)
    }, e.prototype.getAll = function (e, t) {
        void 0 === e && (e = {}), this._updateBrowserValues(t);
        var n = {};
        for (var r in this.cookies) n[r] = ks(this.cookies[r], e);
        return n
    }, e.prototype.set = function (e, t, n) {
        var r;
        "object" == typeof t && (t = JSON.stringify(t)), this.cookies = Ts(Ts({}, this.cookies), ((r = {})[e] = t, r)), this.HAS_DOCUMENT_COOKIE && (document.cookie = bs(e, t, n)), this._emitChange({
            name: e,
            value: t,
            options: n
        })
    }, e.prototype.remove = function (e, t) {
        var n = t = Ts(Ts({}, t), {expires: new Date(1970, 1, 1, 0, 0, 1), maxAge: 0});
        this.cookies = Ts({}, this.cookies), delete this.cookies[e], this.HAS_DOCUMENT_COOKIE && (document.cookie = bs(e, "", n)), this._emitChange({
            name: e,
            value: void 0,
            options: t
        })
    }, e.prototype.addChangeListener = function (e) {
        this.changeListeners.push(e)
    }, e.prototype.removeChangeListener = function (e) {
        var t = this.changeListeners.indexOf(e);
        t >= 0 && this.changeListeners.splice(t, 1)
    }, e
}(), Os = Us, Ms = k().isBrowser, Ls = function () {
    function e(e) {
        void 0 === e && (e = {}), this.cookies = new Os, this.store = Ms ? window.localStorage : Object.create(null), this.cookies = e.req ? new Os(e.req.headers.cookie) : new Os, Object.assign(this.store, this.cookies.getAll())
    }

    return Object.defineProperty(e.prototype, "length", {
        get: function () {
            return Object.entries(this.store).length
        }, enumerable: !0, configurable: !0
    }), e.prototype.clear = function () {
        var e = this;
        Array.from(new Array(this.length)).map((function (t, n) {
            return e.key(n)
        })).forEach((function (t) {
            return e.removeItem(t)
        }))
    }, e.prototype.getItem = function (e) {
        return this.getLocalItem(e)
    }, e.prototype.getLocalItem = function (e) {
        return Object.prototype.hasOwnProperty.call(this.store, e) ? this.store[e] : null
    }, e.prototype.getUniversalItem = function (e) {
        return this.cookies.get(e)
    }, e.prototype.key = function (e) {
        return Object.keys(this.store)[e]
    }, e.prototype.removeItem = function (e) {
        this.removeLocalItem(e), this.removeUniversalItem(e)
    }, e.prototype.removeLocalItem = function (e) {
        delete this.store[e]
    }, e.prototype.removeUniversalItem = function (e) {
        this.cookies.remove(e, {path: "/"})
    }, e.prototype.setItem = function (e, t) {
        switch (this.setLocalItem(e, t), e.split(".").pop()) {
            case"LastAuthUser":
            case"accessToken":
            case"refreshToken":
            case"idToken":
                Ms ? this.setUniversalItem(e, t) : this.setLocalItem(e, t)
        }
    }, e.prototype.setLocalItem = function (e, t) {
        this.store[e] = t
    }, e.prototype.setUniversalItem = function (e, t) {
        this.cookies.set(e, t, {path: "/", sameSite: !0, secure: "localhost" !== window.location.hostname})
    }, e
}();

function Rs(e) {
    return e && !!["provider"].find((function (t) {
        return e.hasOwnProperty(t)
    }))
}

function Ns(e) {
    return void 0 !== e.redirectSignIn
}

!function (e) {
    e.Cognito = "COGNITO", e.Google = "Google", e.Facebook = "Facebook", e.Amazon = "LoginWithAmazon", e.Apple = "SignInWithApple"
}(xs || (xs = {})), function (e) {
    e.NoConfig = "noConfig", e.MissingAuthConfig = "missingAuthConfig", e.EmptyUsername = "emptyUsername", e.InvalidUsername = "invalidUsername", e.EmptyPassword = "emptyPassword", e.EmptyCode = "emptyCode", e.SignUpError = "signUpError", e.NoMFA = "noMFA", e.InvalidMFA = "invalidMFA", e.EmptyChallengeResponse = "emptyChallengeResponse", e.NoUserSession = "noUserSession", e.Default = "default", e.DeviceConfig = "deviceConfig", e.NetworkError = "networkError"
}(Is || (Is = {}));
for (var Ds = function () {
    function e(e) {
        var t = e || {}, n = t.ValidationData, r = t.Username, i = t.Password, o = t.AuthParameters,
            s = t.ClientMetadata;
        this.validationData = n || {}, this.authParameters = o || {}, this.clientMetadata = s || {}, this.username = r, this.password = i
    }

    var t = e.prototype;
    return t.getUsername = function () {
        return this.username
    }, t.getPassword = function () {
        return this.password
    }, t.getValidationData = function () {
        return this.validationData
    }, t.getAuthParameters = function () {
        return this.authParameters
    }, t.getClientMetadata = function () {
        return this.clientMetadata
    }, e
}(), Bs = {}, js = {
    byteLength: function (e) {
        var t = Gs(e), n = t[0], r = t[1];
        return 3 * (n + r) / 4 - r
    }, toByteArray: function (e) {
        var t, n, r = Gs(e), i = r[0], o = r[1], s = new Ks(function (e, t, n) {
            return 3 * (t + n) / 4 - n
        }(0, i, o)), a = 0, u = o > 0 ? i - 4 : i;
        for (n = 0; n < u; n += 4) t = zs[e.charCodeAt(n)] << 18 | zs[e.charCodeAt(n + 1)] << 12 | zs[e.charCodeAt(n + 2)] << 6 | zs[e.charCodeAt(n + 3)], s[a++] = t >> 16 & 255, s[a++] = t >> 8 & 255, s[a++] = 255 & t;
        2 === o && (t = zs[e.charCodeAt(n)] << 2 | zs[e.charCodeAt(n + 1)] >> 4, s[a++] = 255 & t);
        1 === o && (t = zs[e.charCodeAt(n)] << 10 | zs[e.charCodeAt(n + 1)] << 4 | zs[e.charCodeAt(n + 2)] >> 2, s[a++] = t >> 8 & 255, s[a++] = 255 & t);
        return s
    }, fromByteArray: function (e) {
        for (var t, n = e.length, r = n % 3, i = [], o = 16383, s = 0, a = n - r; s < a; s += o) i.push(Ws(e, s, s + o > a ? a : s + o));
        1 === r ? (t = e[n - 1], i.push(Fs[t >> 2] + Fs[t << 4 & 63] + "==")) : 2 === r && (t = (e[n - 2] << 8) + e[n - 1], i.push(Fs[t >> 10] + Fs[t >> 4 & 63] + Fs[t << 2 & 63] + "="));
        return i.join("")
    }
}, Fs = [], zs = [], Ks = "undefined" != typeof Uint8Array ? Uint8Array : Array, qs = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", Hs = 0, Vs = qs.length; Hs < Vs; ++Hs) Fs[Hs] = qs[Hs], zs[qs.charCodeAt(Hs)] = Hs;

function Gs(e) {
    var t = e.length;
    if (t % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
    var n = e.indexOf("=");
    return -1 === n && (n = t), [n, n === t ? 0 : 4 - n % 4]
}

function Ws(e, t, n) {
    for (var r, i, o = [], s = t; s < n; s += 3) r = (e[s] << 16 & 16711680) + (e[s + 1] << 8 & 65280) + (255 & e[s + 2]), o.push(Fs[(i = r) >> 18 & 63] + Fs[i >> 12 & 63] + Fs[i >> 6 & 63] + Fs[63 & i]);
    return o.join("")
}

zs["-".charCodeAt(0)] = 62, zs["_".charCodeAt(0)] = 63;
var $s = {
    read: function (e, t, n, r, i) {
        var o, s, a = 8 * i - r - 1, u = (1 << a) - 1, c = u >> 1, l = -7, f = n ? i - 1 : 0, d = n ? -1 : 1,
            h = e[t + f];
        for (f += d, o = h & (1 << -l) - 1, h >>= -l, l += a; l > 0; o = 256 * o + e[t + f], f += d, l -= 8) ;
        for (s = o & (1 << -l) - 1, o >>= -l, l += r; l > 0; s = 256 * s + e[t + f], f += d, l -= 8) ;
        if (0 === o) o = 1 - c; else {
            if (o === u) return s ? NaN : 1 / 0 * (h ? -1 : 1);
            s += Math.pow(2, r), o -= c
        }
        return (h ? -1 : 1) * s * Math.pow(2, o - r)
    }, write: function (e, t, n, r, i, o) {
        var s, a, u, c = 8 * o - i - 1, l = (1 << c) - 1, f = l >> 1,
            d = 23 === i ? Math.pow(2, -24) - Math.pow(2, -77) : 0, h = r ? 0 : o - 1, p = r ? 1 : -1,
            g = t < 0 || 0 === t && 1 / t < 0 ? 1 : 0;
        for (t = Math.abs(t), isNaN(t) || t === 1 / 0 ? (a = isNaN(t) ? 1 : 0, s = l) : (s = Math.floor(Math.log(t) / Math.LN2), t * (u = Math.pow(2, -s)) < 1 && (s--, u *= 2), (t += s + f >= 1 ? d / u : d * Math.pow(2, 1 - f)) * u >= 2 && (s++, u /= 2), s + f >= l ? (a = 0, s = l) : s + f >= 1 ? (a = (t * u - 1) * Math.pow(2, i), s += f) : (a = t * Math.pow(2, f - 1) * Math.pow(2, i), s = 0)); i >= 8; e[n + h] = 255 & a, h += p, a /= 256, i -= 8) ;
        for (s = s << i | a, c += i; c > 0; e[n + h] = 255 & s, h += p, s /= 256, c -= 8) ;
        e[n + h - p] |= 128 * g
    }
}, Ys = {}.toString, Js = Array.isArray || function (e) {
    return "[object Array]" == Ys.call(e)
};
!function (e) {
    var t = js, n = $s, r = Js;

    function i() {
        return s.TYPED_ARRAY_SUPPORT ? 2147483647 : 1073741823
    }

    function o(e, t) {
        if (i() < t) throw new RangeError("Invalid typed array length");
        return s.TYPED_ARRAY_SUPPORT ? (e = new Uint8Array(t)).__proto__ = s.prototype : (null === e && (e = new s(t)), e.length = t), e
    }

    function s(e, t, n) {
        if (!(s.TYPED_ARRAY_SUPPORT || this instanceof s)) return new s(e, t, n);
        if ("number" == typeof e) {
            if ("string" == typeof t) throw new Error("If encoding is specified then the first argument must be a string");
            return c(this, e)
        }
        return a(this, e, t, n)
    }

    function a(e, t, n, i) {
        if ("number" == typeof t) throw new TypeError('"value" argument must not be a number');
        return "undefined" != typeof ArrayBuffer && t instanceof ArrayBuffer ? function (e, t, n, r) {
            if (t.byteLength, n < 0 || t.byteLength < n) throw new RangeError("'offset' is out of bounds");
            if (t.byteLength < n + (r || 0)) throw new RangeError("'length' is out of bounds");
            t = void 0 === n && void 0 === r ? new Uint8Array(t) : void 0 === r ? new Uint8Array(t, n) : new Uint8Array(t, n, r);
            s.TYPED_ARRAY_SUPPORT ? (e = t).__proto__ = s.prototype : e = l(e, t);
            return e
        }(e, t, n, i) : "string" == typeof t ? function (e, t, n) {
            "string" == typeof n && "" !== n || (n = "utf8");
            if (!s.isEncoding(n)) throw new TypeError('"encoding" must be a valid string encoding');
            var r = 0 | d(t, n), i = (e = o(e, r)).write(t, n);
            i !== r && (e = e.slice(0, i));
            return e
        }(e, t, n) : function (e, t) {
            if (s.isBuffer(t)) {
                var n = 0 | f(t.length);
                return 0 === (e = o(e, n)).length || t.copy(e, 0, 0, n), e
            }
            if (t) {
                if ("undefined" != typeof ArrayBuffer && t.buffer instanceof ArrayBuffer || "length" in t) return "number" != typeof t.length || (i = t.length) != i ? o(e, 0) : l(e, t);
                if ("Buffer" === t.type && r(t.data)) return l(e, t.data)
            }
            var i;
            throw new TypeError("First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.")
        }(e, t)
    }

    function u(e) {
        if ("number" != typeof e) throw new TypeError('"size" argument must be a number');
        if (e < 0) throw new RangeError('"size" argument must not be negative')
    }

    function c(e, t) {
        if (u(t), e = o(e, t < 0 ? 0 : 0 | f(t)), !s.TYPED_ARRAY_SUPPORT) for (var n = 0; n < t; ++n) e[n] = 0;
        return e
    }

    function l(e, t) {
        var n = t.length < 0 ? 0 : 0 | f(t.length);
        e = o(e, n);
        for (var r = 0; r < n; r += 1) e[r] = 255 & t[r];
        return e
    }

    function f(e) {
        if (e >= i()) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + i().toString(16) + " bytes");
        return 0 | e
    }

    function d(e, t) {
        if (s.isBuffer(e)) return e.length;
        if ("undefined" != typeof ArrayBuffer && "function" == typeof ArrayBuffer.isView && (ArrayBuffer.isView(e) || e instanceof ArrayBuffer)) return e.byteLength;
        "string" != typeof e && (e = "" + e);
        var n = e.length;
        if (0 === n) return 0;
        for (var r = !1; ;) switch (t) {
            case"ascii":
            case"latin1":
            case"binary":
                return n;
            case"utf8":
            case"utf-8":
            case void 0:
                return F(e).length;
            case"ucs2":
            case"ucs-2":
            case"utf16le":
            case"utf-16le":
                return 2 * n;
            case"hex":
                return n >>> 1;
            case"base64":
                return z(e).length;
            default:
                if (r) return F(e).length;
                t = ("" + t).toLowerCase(), r = !0
        }
    }

    function h(e, t, n) {
        var r = !1;
        if ((void 0 === t || t < 0) && (t = 0), t > this.length) return "";
        if ((void 0 === n || n > this.length) && (n = this.length), n <= 0) return "";
        if ((n >>>= 0) <= (t >>>= 0)) return "";
        for (e || (e = "utf8"); ;) switch (e) {
            case"hex":
                return x(this, t, n);
            case"utf8":
            case"utf-8":
                return _(this, t, n);
            case"ascii":
                return P(this, t, n);
            case"latin1":
            case"binary":
                return k(this, t, n);
            case"base64":
                return C(this, t, n);
            case"ucs2":
            case"ucs-2":
            case"utf16le":
            case"utf-16le":
                return I(this, t, n);
            default:
                if (r) throw new TypeError("Unknown encoding: " + e);
                e = (e + "").toLowerCase(), r = !0
        }
    }

    function p(e, t, n) {
        var r = e[t];
        e[t] = e[n], e[n] = r
    }

    function g(e, t, n, r, i) {
        if (0 === e.length) return -1;
        if ("string" == typeof n ? (r = n, n = 0) : n > 2147483647 ? n = 2147483647 : n < -2147483648 && (n = -2147483648), n = +n, isNaN(n) && (n = i ? 0 : e.length - 1), n < 0 && (n = e.length + n), n >= e.length) {
            if (i) return -1;
            n = e.length - 1
        } else if (n < 0) {
            if (!i) return -1;
            n = 0
        }
        if ("string" == typeof t && (t = s.from(t, r)), s.isBuffer(t)) return 0 === t.length ? -1 : v(e, t, n, r, i);
        if ("number" == typeof t) return t &= 255, s.TYPED_ARRAY_SUPPORT && "function" == typeof Uint8Array.prototype.indexOf ? i ? Uint8Array.prototype.indexOf.call(e, t, n) : Uint8Array.prototype.lastIndexOf.call(e, t, n) : v(e, [t], n, r, i);
        throw new TypeError("val must be string, number or Buffer")
    }

    function v(e, t, n, r, i) {
        var o, s = 1, a = e.length, u = t.length;
        if (void 0 !== r && ("ucs2" === (r = String(r).toLowerCase()) || "ucs-2" === r || "utf16le" === r || "utf-16le" === r)) {
            if (e.length < 2 || t.length < 2) return -1;
            s = 2, a /= 2, u /= 2, n /= 2
        }

        function c(e, t) {
            return 1 === s ? e[t] : e.readUInt16BE(t * s)
        }

        if (i) {
            var l = -1;
            for (o = n; o < a; o++) if (c(e, o) === c(t, -1 === l ? 0 : o - l)) {
                if (-1 === l && (l = o), o - l + 1 === u) return l * s
            } else -1 !== l && (o -= o - l), l = -1
        } else for (n + u > a && (n = a - u), o = n; o >= 0; o--) {
            for (var f = !0, d = 0; d < u; d++) if (c(e, o + d) !== c(t, d)) {
                f = !1;
                break
            }
            if (f) return o
        }
        return -1
    }

    function m(e, t, n, r) {
        n = Number(n) || 0;
        var i = e.length - n;
        r ? (r = Number(r)) > i && (r = i) : r = i;
        var o = t.length;
        if (o % 2 != 0) throw new TypeError("Invalid hex string");
        r > o / 2 && (r = o / 2);
        for (var s = 0; s < r; ++s) {
            var a = parseInt(t.substr(2 * s, 2), 16);
            if (isNaN(a)) return s;
            e[n + s] = a
        }
        return s
    }

    function y(e, t, n, r) {
        return K(F(t, e.length - n), e, n, r)
    }

    function S(e, t, n, r) {
        return K(function (e) {
            for (var t = [], n = 0; n < e.length; ++n) t.push(255 & e.charCodeAt(n));
            return t
        }(t), e, n, r)
    }

    function w(e, t, n, r) {
        return S(e, t, n, r)
    }

    function b(e, t, n, r) {
        return K(z(t), e, n, r)
    }

    function E(e, t, n, r) {
        return K(function (e, t) {
            for (var n, r, i, o = [], s = 0; s < e.length && !((t -= 2) < 0); ++s) r = (n = e.charCodeAt(s)) >> 8, i = n % 256, o.push(i), o.push(r);
            return o
        }(t, e.length - n), e, n, r)
    }

    function C(e, n, r) {
        return 0 === n && r === e.length ? t.fromByteArray(e) : t.fromByteArray(e.slice(n, r))
    }

    function _(e, t, n) {
        n = Math.min(e.length, n);
        for (var r = [], i = t; i < n;) {
            var o, s, a, u, c = e[i], l = null, f = c > 239 ? 4 : c > 223 ? 3 : c > 191 ? 2 : 1;
            if (i + f <= n) switch (f) {
                case 1:
                    c < 128 && (l = c);
                    break;
                case 2:
                    128 == (192 & (o = e[i + 1])) && (u = (31 & c) << 6 | 63 & o) > 127 && (l = u);
                    break;
                case 3:
                    o = e[i + 1], s = e[i + 2], 128 == (192 & o) && 128 == (192 & s) && (u = (15 & c) << 12 | (63 & o) << 6 | 63 & s) > 2047 && (u < 55296 || u > 57343) && (l = u);
                    break;
                case 4:
                    o = e[i + 1], s = e[i + 2], a = e[i + 3], 128 == (192 & o) && 128 == (192 & s) && 128 == (192 & a) && (u = (15 & c) << 18 | (63 & o) << 12 | (63 & s) << 6 | 63 & a) > 65535 && u < 1114112 && (l = u)
            }
            null === l ? (l = 65533, f = 1) : l > 65535 && (l -= 65536, r.push(l >>> 10 & 1023 | 55296), l = 56320 | 1023 & l), r.push(l), i += f
        }
        return function (e) {
            var t = e.length;
            if (t <= A) return String.fromCharCode.apply(String, e);
            var n = "", r = 0;
            for (; r < t;) n += String.fromCharCode.apply(String, e.slice(r, r += A));
            return n
        }(r)
    }

    e.Buffer = s, e.SlowBuffer = function (e) {
        +e != e && (e = 0);
        return s.alloc(+e)
    }, e.INSPECT_MAX_BYTES = 50, s.TYPED_ARRAY_SUPPORT = void 0 !== O.TYPED_ARRAY_SUPPORT ? O.TYPED_ARRAY_SUPPORT : function () {
        try {
            var e = new Uint8Array(1);
            return e.__proto__ = {
                __proto__: Uint8Array.prototype, foo: function () {
                    return 42
                }
            }, 42 === e.foo() && "function" == typeof e.subarray && 0 === e.subarray(1, 1).byteLength
        } catch (e) {
            return !1
        }
    }(), e.kMaxLength = i(), s.poolSize = 8192, s._augment = function (e) {
        return e.__proto__ = s.prototype, e
    }, s.from = function (e, t, n) {
        return a(null, e, t, n)
    }, s.TYPED_ARRAY_SUPPORT && (s.prototype.__proto__ = Uint8Array.prototype, s.__proto__ = Uint8Array, "undefined" != typeof Symbol && Symbol.species && s[Symbol.species] === s && Object.defineProperty(s, Symbol.species, {
        value: null,
        configurable: !0
    })), s.alloc = function (e, t, n) {
        return function (e, t, n, r) {
            return u(t), t <= 0 ? o(e, t) : void 0 !== n ? "string" == typeof r ? o(e, t).fill(n, r) : o(e, t).fill(n) : o(e, t)
        }(null, e, t, n)
    }, s.allocUnsafe = function (e) {
        return c(null, e)
    }, s.allocUnsafeSlow = function (e) {
        return c(null, e)
    }, s.isBuffer = function (e) {
        return !(null == e || !e._isBuffer)
    }, s.compare = function (e, t) {
        if (!s.isBuffer(e) || !s.isBuffer(t)) throw new TypeError("Arguments must be Buffers");
        if (e === t) return 0;
        for (var n = e.length, r = t.length, i = 0, o = Math.min(n, r); i < o; ++i) if (e[i] !== t[i]) {
            n = e[i], r = t[i];
            break
        }
        return n < r ? -1 : r < n ? 1 : 0
    }, s.isEncoding = function (e) {
        switch (String(e).toLowerCase()) {
            case"hex":
            case"utf8":
            case"utf-8":
            case"ascii":
            case"latin1":
            case"binary":
            case"base64":
            case"ucs2":
            case"ucs-2":
            case"utf16le":
            case"utf-16le":
                return !0;
            default:
                return !1
        }
    }, s.concat = function (e, t) {
        if (!r(e)) throw new TypeError('"list" argument must be an Array of Buffers');
        if (0 === e.length) return s.alloc(0);
        var n;
        if (void 0 === t) for (t = 0, n = 0; n < e.length; ++n) t += e[n].length;
        var i = s.allocUnsafe(t), o = 0;
        for (n = 0; n < e.length; ++n) {
            var a = e[n];
            if (!s.isBuffer(a)) throw new TypeError('"list" argument must be an Array of Buffers');
            a.copy(i, o), o += a.length
        }
        return i
    }, s.byteLength = d, s.prototype._isBuffer = !0, s.prototype.swap16 = function () {
        var e = this.length;
        if (e % 2 != 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
        for (var t = 0; t < e; t += 2) p(this, t, t + 1);
        return this
    }, s.prototype.swap32 = function () {
        var e = this.length;
        if (e % 4 != 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
        for (var t = 0; t < e; t += 4) p(this, t, t + 3), p(this, t + 1, t + 2);
        return this
    }, s.prototype.swap64 = function () {
        var e = this.length;
        if (e % 8 != 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
        for (var t = 0; t < e; t += 8) p(this, t, t + 7), p(this, t + 1, t + 6), p(this, t + 2, t + 5), p(this, t + 3, t + 4);
        return this
    }, s.prototype.toString = function () {
        var e = 0 | this.length;
        return 0 === e ? "" : 0 === arguments.length ? _(this, 0, e) : h.apply(this, arguments)
    }, s.prototype.equals = function (e) {
        if (!s.isBuffer(e)) throw new TypeError("Argument must be a Buffer");
        return this === e || 0 === s.compare(this, e)
    }, s.prototype.inspect = function () {
        var t = "", n = e.INSPECT_MAX_BYTES;
        return this.length > 0 && (t = this.toString("hex", 0, n).match(/.{2}/g).join(" "), this.length > n && (t += " ... ")), "<Buffer " + t + ">"
    }, s.prototype.compare = function (e, t, n, r, i) {
        if (!s.isBuffer(e)) throw new TypeError("Argument must be a Buffer");
        if (void 0 === t && (t = 0), void 0 === n && (n = e ? e.length : 0), void 0 === r && (r = 0), void 0 === i && (i = this.length), t < 0 || n > e.length || r < 0 || i > this.length) throw new RangeError("out of range index");
        if (r >= i && t >= n) return 0;
        if (r >= i) return -1;
        if (t >= n) return 1;
        if (this === e) return 0;
        for (var o = (i >>>= 0) - (r >>>= 0), a = (n >>>= 0) - (t >>>= 0), u = Math.min(o, a), c = this.slice(r, i), l = e.slice(t, n), f = 0; f < u; ++f) if (c[f] !== l[f]) {
            o = c[f], a = l[f];
            break
        }
        return o < a ? -1 : a < o ? 1 : 0
    }, s.prototype.includes = function (e, t, n) {
        return -1 !== this.indexOf(e, t, n)
    }, s.prototype.indexOf = function (e, t, n) {
        return g(this, e, t, n, !0)
    }, s.prototype.lastIndexOf = function (e, t, n) {
        return g(this, e, t, n, !1)
    }, s.prototype.write = function (e, t, n, r) {
        if (void 0 === t) r = "utf8", n = this.length, t = 0; else if (void 0 === n && "string" == typeof t) r = t, n = this.length, t = 0; else {
            if (!isFinite(t)) throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
            t |= 0, isFinite(n) ? (n |= 0, void 0 === r && (r = "utf8")) : (r = n, n = void 0)
        }
        var i = this.length - t;
        if ((void 0 === n || n > i) && (n = i), e.length > 0 && (n < 0 || t < 0) || t > this.length) throw new RangeError("Attempt to write outside buffer bounds");
        r || (r = "utf8");
        for (var o = !1; ;) switch (r) {
            case"hex":
                return m(this, e, t, n);
            case"utf8":
            case"utf-8":
                return y(this, e, t, n);
            case"ascii":
                return S(this, e, t, n);
            case"latin1":
            case"binary":
                return w(this, e, t, n);
            case"base64":
                return b(this, e, t, n);
            case"ucs2":
            case"ucs-2":
            case"utf16le":
            case"utf-16le":
                return E(this, e, t, n);
            default:
                if (o) throw new TypeError("Unknown encoding: " + r);
                r = ("" + r).toLowerCase(), o = !0
        }
    }, s.prototype.toJSON = function () {
        return {type: "Buffer", data: Array.prototype.slice.call(this._arr || this, 0)}
    };
    var A = 4096;

    function P(e, t, n) {
        var r = "";
        n = Math.min(e.length, n);
        for (var i = t; i < n; ++i) r += String.fromCharCode(127 & e[i]);
        return r
    }

    function k(e, t, n) {
        var r = "";
        n = Math.min(e.length, n);
        for (var i = t; i < n; ++i) r += String.fromCharCode(e[i]);
        return r
    }

    function x(e, t, n) {
        var r = e.length;
        (!t || t < 0) && (t = 0), (!n || n < 0 || n > r) && (n = r);
        for (var i = "", o = t; o < n; ++o) i += j(e[o]);
        return i
    }

    function I(e, t, n) {
        for (var r = e.slice(t, n), i = "", o = 0; o < r.length; o += 2) i += String.fromCharCode(r[o] + 256 * r[o + 1]);
        return i
    }

    function T(e, t, n) {
        if (e % 1 != 0 || e < 0) throw new RangeError("offset is not uint");
        if (e + t > n) throw new RangeError("Trying to access beyond buffer length")
    }

    function U(e, t, n, r, i, o) {
        if (!s.isBuffer(e)) throw new TypeError('"buffer" argument must be a Buffer instance');
        if (t > i || t < o) throw new RangeError('"value" argument is out of bounds');
        if (n + r > e.length) throw new RangeError("Index out of range")
    }

    function M(e, t, n, r) {
        t < 0 && (t = 65535 + t + 1);
        for (var i = 0, o = Math.min(e.length - n, 2); i < o; ++i) e[n + i] = (t & 255 << 8 * (r ? i : 1 - i)) >>> 8 * (r ? i : 1 - i)
    }

    function L(e, t, n, r) {
        t < 0 && (t = 4294967295 + t + 1);
        for (var i = 0, o = Math.min(e.length - n, 4); i < o; ++i) e[n + i] = t >>> 8 * (r ? i : 3 - i) & 255
    }

    function R(e, t, n, r, i, o) {
        if (n + r > e.length) throw new RangeError("Index out of range");
        if (n < 0) throw new RangeError("Index out of range")
    }

    function N(e, t, r, i, o) {
        return o || R(e, 0, r, 4), n.write(e, t, r, i, 23, 4), r + 4
    }

    function D(e, t, r, i, o) {
        return o || R(e, 0, r, 8), n.write(e, t, r, i, 52, 8), r + 8
    }

    s.prototype.slice = function (e, t) {
        var n, r = this.length;
        if ((e = ~~e) < 0 ? (e += r) < 0 && (e = 0) : e > r && (e = r), (t = void 0 === t ? r : ~~t) < 0 ? (t += r) < 0 && (t = 0) : t > r && (t = r), t < e && (t = e), s.TYPED_ARRAY_SUPPORT) (n = this.subarray(e, t)).__proto__ = s.prototype; else {
            var i = t - e;
            n = new s(i, void 0);
            for (var o = 0; o < i; ++o) n[o] = this[o + e]
        }
        return n
    }, s.prototype.readUIntLE = function (e, t, n) {
        e |= 0, t |= 0, n || T(e, t, this.length);
        for (var r = this[e], i = 1, o = 0; ++o < t && (i *= 256);) r += this[e + o] * i;
        return r
    }, s.prototype.readUIntBE = function (e, t, n) {
        e |= 0, t |= 0, n || T(e, t, this.length);
        for (var r = this[e + --t], i = 1; t > 0 && (i *= 256);) r += this[e + --t] * i;
        return r
    }, s.prototype.readUInt8 = function (e, t) {
        return t || T(e, 1, this.length), this[e]
    }, s.prototype.readUInt16LE = function (e, t) {
        return t || T(e, 2, this.length), this[e] | this[e + 1] << 8
    }, s.prototype.readUInt16BE = function (e, t) {
        return t || T(e, 2, this.length), this[e] << 8 | this[e + 1]
    }, s.prototype.readUInt32LE = function (e, t) {
        return t || T(e, 4, this.length), (this[e] | this[e + 1] << 8 | this[e + 2] << 16) + 16777216 * this[e + 3]
    }, s.prototype.readUInt32BE = function (e, t) {
        return t || T(e, 4, this.length), 16777216 * this[e] + (this[e + 1] << 16 | this[e + 2] << 8 | this[e + 3])
    }, s.prototype.readIntLE = function (e, t, n) {
        e |= 0, t |= 0, n || T(e, t, this.length);
        for (var r = this[e], i = 1, o = 0; ++o < t && (i *= 256);) r += this[e + o] * i;
        return r >= (i *= 128) && (r -= Math.pow(2, 8 * t)), r
    }, s.prototype.readIntBE = function (e, t, n) {
        e |= 0, t |= 0, n || T(e, t, this.length);
        for (var r = t, i = 1, o = this[e + --r]; r > 0 && (i *= 256);) o += this[e + --r] * i;
        return o >= (i *= 128) && (o -= Math.pow(2, 8 * t)), o
    }, s.prototype.readInt8 = function (e, t) {
        return t || T(e, 1, this.length), 128 & this[e] ? -1 * (255 - this[e] + 1) : this[e]
    }, s.prototype.readInt16LE = function (e, t) {
        t || T(e, 2, this.length);
        var n = this[e] | this[e + 1] << 8;
        return 32768 & n ? 4294901760 | n : n
    }, s.prototype.readInt16BE = function (e, t) {
        t || T(e, 2, this.length);
        var n = this[e + 1] | this[e] << 8;
        return 32768 & n ? 4294901760 | n : n
    }, s.prototype.readInt32LE = function (e, t) {
        return t || T(e, 4, this.length), this[e] | this[e + 1] << 8 | this[e + 2] << 16 | this[e + 3] << 24
    }, s.prototype.readInt32BE = function (e, t) {
        return t || T(e, 4, this.length), this[e] << 24 | this[e + 1] << 16 | this[e + 2] << 8 | this[e + 3]
    }, s.prototype.readFloatLE = function (e, t) {
        return t || T(e, 4, this.length), n.read(this, e, !0, 23, 4)
    }, s.prototype.readFloatBE = function (e, t) {
        return t || T(e, 4, this.length), n.read(this, e, !1, 23, 4)
    }, s.prototype.readDoubleLE = function (e, t) {
        return t || T(e, 8, this.length), n.read(this, e, !0, 52, 8)
    }, s.prototype.readDoubleBE = function (e, t) {
        return t || T(e, 8, this.length), n.read(this, e, !1, 52, 8)
    }, s.prototype.writeUIntLE = function (e, t, n, r) {
        (e = +e, t |= 0, n |= 0, r) || U(this, e, t, n, Math.pow(2, 8 * n) - 1, 0);
        var i = 1, o = 0;
        for (this[t] = 255 & e; ++o < n && (i *= 256);) this[t + o] = e / i & 255;
        return t + n
    }, s.prototype.writeUIntBE = function (e, t, n, r) {
        (e = +e, t |= 0, n |= 0, r) || U(this, e, t, n, Math.pow(2, 8 * n) - 1, 0);
        var i = n - 1, o = 1;
        for (this[t + i] = 255 & e; --i >= 0 && (o *= 256);) this[t + i] = e / o & 255;
        return t + n
    }, s.prototype.writeUInt8 = function (e, t, n) {
        return e = +e, t |= 0, n || U(this, e, t, 1, 255, 0), s.TYPED_ARRAY_SUPPORT || (e = Math.floor(e)), this[t] = 255 & e, t + 1
    }, s.prototype.writeUInt16LE = function (e, t, n) {
        return e = +e, t |= 0, n || U(this, e, t, 2, 65535, 0), s.TYPED_ARRAY_SUPPORT ? (this[t] = 255 & e, this[t + 1] = e >>> 8) : M(this, e, t, !0), t + 2
    }, s.prototype.writeUInt16BE = function (e, t, n) {
        return e = +e, t |= 0, n || U(this, e, t, 2, 65535, 0), s.TYPED_ARRAY_SUPPORT ? (this[t] = e >>> 8, this[t + 1] = 255 & e) : M(this, e, t, !1), t + 2
    }, s.prototype.writeUInt32LE = function (e, t, n) {
        return e = +e, t |= 0, n || U(this, e, t, 4, 4294967295, 0), s.TYPED_ARRAY_SUPPORT ? (this[t + 3] = e >>> 24, this[t + 2] = e >>> 16, this[t + 1] = e >>> 8, this[t] = 255 & e) : L(this, e, t, !0), t + 4
    }, s.prototype.writeUInt32BE = function (e, t, n) {
        return e = +e, t |= 0, n || U(this, e, t, 4, 4294967295, 0), s.TYPED_ARRAY_SUPPORT ? (this[t] = e >>> 24, this[t + 1] = e >>> 16, this[t + 2] = e >>> 8, this[t + 3] = 255 & e) : L(this, e, t, !1), t + 4
    }, s.prototype.writeIntLE = function (e, t, n, r) {
        if (e = +e, t |= 0, !r) {
            var i = Math.pow(2, 8 * n - 1);
            U(this, e, t, n, i - 1, -i)
        }
        var o = 0, s = 1, a = 0;
        for (this[t] = 255 & e; ++o < n && (s *= 256);) e < 0 && 0 === a && 0 !== this[t + o - 1] && (a = 1), this[t + o] = (e / s >> 0) - a & 255;
        return t + n
    }, s.prototype.writeIntBE = function (e, t, n, r) {
        if (e = +e, t |= 0, !r) {
            var i = Math.pow(2, 8 * n - 1);
            U(this, e, t, n, i - 1, -i)
        }
        var o = n - 1, s = 1, a = 0;
        for (this[t + o] = 255 & e; --o >= 0 && (s *= 256);) e < 0 && 0 === a && 0 !== this[t + o + 1] && (a = 1), this[t + o] = (e / s >> 0) - a & 255;
        return t + n
    }, s.prototype.writeInt8 = function (e, t, n) {
        return e = +e, t |= 0, n || U(this, e, t, 1, 127, -128), s.TYPED_ARRAY_SUPPORT || (e = Math.floor(e)), e < 0 && (e = 255 + e + 1), this[t] = 255 & e, t + 1
    }, s.prototype.writeInt16LE = function (e, t, n) {
        return e = +e, t |= 0, n || U(this, e, t, 2, 32767, -32768), s.TYPED_ARRAY_SUPPORT ? (this[t] = 255 & e, this[t + 1] = e >>> 8) : M(this, e, t, !0), t + 2
    }, s.prototype.writeInt16BE = function (e, t, n) {
        return e = +e, t |= 0, n || U(this, e, t, 2, 32767, -32768), s.TYPED_ARRAY_SUPPORT ? (this[t] = e >>> 8, this[t + 1] = 255 & e) : M(this, e, t, !1), t + 2
    }, s.prototype.writeInt32LE = function (e, t, n) {
        return e = +e, t |= 0, n || U(this, e, t, 4, 2147483647, -2147483648), s.TYPED_ARRAY_SUPPORT ? (this[t] = 255 & e, this[t + 1] = e >>> 8, this[t + 2] = e >>> 16, this[t + 3] = e >>> 24) : L(this, e, t, !0), t + 4
    }, s.prototype.writeInt32BE = function (e, t, n) {
        return e = +e, t |= 0, n || U(this, e, t, 4, 2147483647, -2147483648), e < 0 && (e = 4294967295 + e + 1), s.TYPED_ARRAY_SUPPORT ? (this[t] = e >>> 24, this[t + 1] = e >>> 16, this[t + 2] = e >>> 8, this[t + 3] = 255 & e) : L(this, e, t, !1), t + 4
    }, s.prototype.writeFloatLE = function (e, t, n) {
        return N(this, e, t, !0, n)
    }, s.prototype.writeFloatBE = function (e, t, n) {
        return N(this, e, t, !1, n)
    }, s.prototype.writeDoubleLE = function (e, t, n) {
        return D(this, e, t, !0, n)
    }, s.prototype.writeDoubleBE = function (e, t, n) {
        return D(this, e, t, !1, n)
    }, s.prototype.copy = function (e, t, n, r) {
        if (n || (n = 0), r || 0 === r || (r = this.length), t >= e.length && (t = e.length), t || (t = 0), r > 0 && r < n && (r = n), r === n) return 0;
        if (0 === e.length || 0 === this.length) return 0;
        if (t < 0) throw new RangeError("targetStart out of bounds");
        if (n < 0 || n >= this.length) throw new RangeError("sourceStart out of bounds");
        if (r < 0) throw new RangeError("sourceEnd out of bounds");
        r > this.length && (r = this.length), e.length - t < r - n && (r = e.length - t + n);
        var i, o = r - n;
        if (this === e && n < t && t < r) for (i = o - 1; i >= 0; --i) e[i + t] = this[i + n]; else if (o < 1e3 || !s.TYPED_ARRAY_SUPPORT) for (i = 0; i < o; ++i) e[i + t] = this[i + n]; else Uint8Array.prototype.set.call(e, this.subarray(n, n + o), t);
        return o
    }, s.prototype.fill = function (e, t, n, r) {
        if ("string" == typeof e) {
            if ("string" == typeof t ? (r = t, t = 0, n = this.length) : "string" == typeof n && (r = n, n = this.length), 1 === e.length) {
                var i = e.charCodeAt(0);
                i < 256 && (e = i)
            }
            if (void 0 !== r && "string" != typeof r) throw new TypeError("encoding must be a string");
            if ("string" == typeof r && !s.isEncoding(r)) throw new TypeError("Unknown encoding: " + r)
        } else "number" == typeof e && (e &= 255);
        if (t < 0 || this.length < t || this.length < n) throw new RangeError("Out of range index");
        if (n <= t) return this;
        var o;
        if (t >>>= 0, n = void 0 === n ? this.length : n >>> 0, e || (e = 0), "number" == typeof e) for (o = t; o < n; ++o) this[o] = e; else {
            var a = s.isBuffer(e) ? e : F(new s(e, r).toString()), u = a.length;
            for (o = 0; o < n - t; ++o) this[o + t] = a[o % u]
        }
        return this
    };
    var B = /[^+\/0-9A-Za-z-_]/g;

    function j(e) {
        return e < 16 ? "0" + e.toString(16) : e.toString(16)
    }

    function F(e, t) {
        var n;
        t = t || 1 / 0;
        for (var r = e.length, i = null, o = [], s = 0; s < r; ++s) {
            if ((n = e.charCodeAt(s)) > 55295 && n < 57344) {
                if (!i) {
                    if (n > 56319) {
                        (t -= 3) > -1 && o.push(239, 191, 189);
                        continue
                    }
                    if (s + 1 === r) {
                        (t -= 3) > -1 && o.push(239, 191, 189);
                        continue
                    }
                    i = n;
                    continue
                }
                if (n < 56320) {
                    (t -= 3) > -1 && o.push(239, 191, 189), i = n;
                    continue
                }
                n = 65536 + (i - 55296 << 10 | n - 56320)
            } else i && (t -= 3) > -1 && o.push(239, 191, 189);
            if (i = null, n < 128) {
                if ((t -= 1) < 0) break;
                o.push(n)
            } else if (n < 2048) {
                if ((t -= 2) < 0) break;
                o.push(n >> 6 | 192, 63 & n | 128)
            } else if (n < 65536) {
                if ((t -= 3) < 0) break;
                o.push(n >> 12 | 224, n >> 6 & 63 | 128, 63 & n | 128)
            } else {
                if (!(n < 1114112)) throw new Error("Invalid code point");
                if ((t -= 4) < 0) break;
                o.push(n >> 18 | 240, n >> 12 & 63 | 128, n >> 6 & 63 | 128, 63 & n | 128)
            }
        }
        return o
    }

    function z(e) {
        return t.toByteArray(function (e) {
            if ((e = function (e) {
                return e.trim ? e.trim() : e.replace(/^\s+|\s+$/g, "")
            }(e).replace(B, "")).length < 2) return "";
            for (; e.length % 4 != 0;) e += "=";
            return e
        }(e))
    }

    function K(e, t, n, r) {
        for (var i = 0; i < r && !(i + n >= t.length || i >= e.length); ++i) t[i + n] = e[i];
        return i
    }
}(Bs);
var Zs = {exports: {}}, Xs = L(Object.freeze({__proto__: null, default: {}})), Qs = Zs.exports = function () {
    var e = e || function (e, t) {
        var n;
        if ("undefined" != typeof window && window.crypto && (n = window.crypto), "undefined" != typeof self && self.crypto && (n = self.crypto), "undefined" != typeof globalThis && globalThis.crypto && (n = globalThis.crypto), !n && "undefined" != typeof window && window.msCrypto && (n = window.msCrypto), !n && void 0 !== O && O.crypto && (n = O.crypto), !n) try {
            n = Xs
        } catch (e) {
        }
        var r = function () {
            if (n) {
                if ("function" == typeof n.getRandomValues) try {
                    return n.getRandomValues(new Uint32Array(1))[0]
                } catch (e) {
                }
                if ("function" == typeof n.randomBytes) try {
                    return n.randomBytes(4).readInt32LE()
                } catch (e) {
                }
            }
            throw new Error("Native crypto module could not be used to get secure random number.")
        }, i = Object.create || function () {
            function e() {
            }

            return function (t) {
                var n;
                return e.prototype = t, n = new e, e.prototype = null, n
            }
        }(), o = {}, s = o.lib = {}, a = s.Base = {
            extend: function (e) {
                var t = i(this);
                return e && t.mixIn(e), t.hasOwnProperty("init") && this.init !== t.init || (t.init = function () {
                    t.$super.init.apply(this, arguments)
                }), t.init.prototype = t, t.$super = this, t
            }, create: function () {
                var e = this.extend();
                return e.init.apply(e, arguments), e
            }, init: function () {
            }, mixIn: function (e) {
                for (var t in e) e.hasOwnProperty(t) && (this[t] = e[t]);
                e.hasOwnProperty("toString") && (this.toString = e.toString)
            }, clone: function () {
                return this.init.prototype.extend(this)
            }
        }, u = s.WordArray = a.extend({
            init: function (e, n) {
                e = this.words = e || [], this.sigBytes = n != t ? n : 4 * e.length
            }, toString: function (e) {
                return (e || l).stringify(this)
            }, concat: function (e) {
                var t = this.words, n = e.words, r = this.sigBytes, i = e.sigBytes;
                if (this.clamp(), r % 4) for (var o = 0; o < i; o++) {
                    var s = n[o >>> 2] >>> 24 - o % 4 * 8 & 255;
                    t[r + o >>> 2] |= s << 24 - (r + o) % 4 * 8
                } else for (var a = 0; a < i; a += 4) t[r + a >>> 2] = n[a >>> 2];
                return this.sigBytes += i, this
            }, clamp: function () {
                var t = this.words, n = this.sigBytes;
                t[n >>> 2] &= 4294967295 << 32 - n % 4 * 8, t.length = e.ceil(n / 4)
            }, clone: function () {
                var e = a.clone.call(this);
                return e.words = this.words.slice(0), e
            }, random: function (e) {
                for (var t = [], n = 0; n < e; n += 4) t.push(r());
                return new u.init(t, e)
            }
        }), c = o.enc = {}, l = c.Hex = {
            stringify: function (e) {
                for (var t = e.words, n = e.sigBytes, r = [], i = 0; i < n; i++) {
                    var o = t[i >>> 2] >>> 24 - i % 4 * 8 & 255;
                    r.push((o >>> 4).toString(16)), r.push((15 & o).toString(16))
                }
                return r.join("")
            }, parse: function (e) {
                for (var t = e.length, n = [], r = 0; r < t; r += 2) n[r >>> 3] |= parseInt(e.substr(r, 2), 16) << 24 - r % 8 * 4;
                return new u.init(n, t / 2)
            }
        }, f = c.Latin1 = {
            stringify: function (e) {
                for (var t = e.words, n = e.sigBytes, r = [], i = 0; i < n; i++) {
                    var o = t[i >>> 2] >>> 24 - i % 4 * 8 & 255;
                    r.push(String.fromCharCode(o))
                }
                return r.join("")
            }, parse: function (e) {
                for (var t = e.length, n = [], r = 0; r < t; r++) n[r >>> 2] |= (255 & e.charCodeAt(r)) << 24 - r % 4 * 8;
                return new u.init(n, t)
            }
        }, d = c.Utf8 = {
            stringify: function (e) {
                try {
                    return decodeURIComponent(escape(f.stringify(e)))
                } catch (e) {
                    throw new Error("Malformed UTF-8 data")
                }
            }, parse: function (e) {
                return f.parse(unescape(encodeURIComponent(e)))
            }
        }, h = s.BufferedBlockAlgorithm = a.extend({
            reset: function () {
                this._data = new u.init, this._nDataBytes = 0
            }, _append: function (e) {
                "string" == typeof e && (e = d.parse(e)), this._data.concat(e), this._nDataBytes += e.sigBytes
            }, _process: function (t) {
                var n, r = this._data, i = r.words, o = r.sigBytes, s = this.blockSize, a = o / (4 * s),
                    c = (a = t ? e.ceil(a) : e.max((0 | a) - this._minBufferSize, 0)) * s, l = e.min(4 * c, o);
                if (c) {
                    for (var f = 0; f < c; f += s) this._doProcessBlock(i, f);
                    n = i.splice(0, c), r.sigBytes -= l
                }
                return new u.init(n, l)
            }, clone: function () {
                var e = a.clone.call(this);
                return e._data = this._data.clone(), e
            }, _minBufferSize: 0
        });
        s.Hasher = h.extend({
            cfg: a.extend(), init: function (e) {
                this.cfg = this.cfg.extend(e), this.reset()
            }, reset: function () {
                h.reset.call(this), this._doReset()
            }, update: function (e) {
                return this._append(e), this._process(), this
            }, finalize: function (e) {
                return e && this._append(e), this._doFinalize()
            }, blockSize: 16, _createHelper: function (e) {
                return function (t, n) {
                    return new e.init(n).finalize(t)
                }
            }, _createHmacHelper: function (e) {
                return function (t, n) {
                    return new p.HMAC.init(e, n).finalize(t)
                }
            }
        });
        var p = o.algo = {};
        return o
    }(Math);
    return e
}();
!function (e) {
    (function () {
        if ("function" == typeof ArrayBuffer) {
            var t = e.lib.WordArray, n = t.init, r = t.init = function (e) {
                if (e instanceof ArrayBuffer && (e = new Uint8Array(e)), (e instanceof Int8Array || "undefined" != typeof Uint8ClampedArray && e instanceof Uint8ClampedArray || e instanceof Int16Array || e instanceof Uint16Array || e instanceof Int32Array || e instanceof Uint32Array || e instanceof Float32Array || e instanceof Float64Array) && (e = new Uint8Array(e.buffer, e.byteOffset, e.byteLength)), e instanceof Uint8Array) {
                    for (var t = e.byteLength, r = [], i = 0; i < t; i++) r[i >>> 2] |= e[i] << 24 - i % 4 * 8;
                    n.call(this, r, t)
                } else n.apply(this, arguments)
            };
            r.prototype = t
        }
    })(), e.lib.WordArray
}(Zs.exports);
var ea = {exports: {}}, ta = ea.exports = function (e) {
    return function (t) {
        var n = e, r = n.lib, i = r.WordArray, o = r.Hasher, s = n.algo, a = [], u = [];
        !function () {
            function e(e) {
                for (var n = t.sqrt(e), r = 2; r <= n; r++) if (!(e % r)) return !1;
                return !0
            }

            function n(e) {
                return 4294967296 * (e - (0 | e)) | 0
            }

            for (var r = 2, i = 0; i < 64;) e(r) && (i < 8 && (a[i] = n(t.pow(r, .5))), u[i] = n(t.pow(r, 1 / 3)), i++), r++
        }();
        var c = [], l = s.SHA256 = o.extend({
            _doReset: function () {
                this._hash = new i.init(a.slice(0))
            }, _doProcessBlock: function (e, t) {
                for (var n = this._hash.words, r = n[0], i = n[1], o = n[2], s = n[3], a = n[4], l = n[5], f = n[6], d = n[7], h = 0; h < 64; h++) {
                    if (h < 16) c[h] = 0 | e[t + h]; else {
                        var p = c[h - 15], g = (p << 25 | p >>> 7) ^ (p << 14 | p >>> 18) ^ p >>> 3, v = c[h - 2],
                            m = (v << 15 | v >>> 17) ^ (v << 13 | v >>> 19) ^ v >>> 10;
                        c[h] = g + c[h - 7] + m + c[h - 16]
                    }
                    var y = r & i ^ r & o ^ i & o,
                        S = (r << 30 | r >>> 2) ^ (r << 19 | r >>> 13) ^ (r << 10 | r >>> 22),
                        w = d + ((a << 26 | a >>> 6) ^ (a << 21 | a >>> 11) ^ (a << 7 | a >>> 25)) + (a & l ^ ~a & f) + u[h] + c[h];
                    d = f, f = l, l = a, a = s + w | 0, s = o, o = i, i = r, r = w + (S + y) | 0
                }
                n[0] = n[0] + r | 0, n[1] = n[1] + i | 0, n[2] = n[2] + o | 0, n[3] = n[3] + s | 0, n[4] = n[4] + a | 0, n[5] = n[5] + l | 0, n[6] = n[6] + f | 0, n[7] = n[7] + d | 0
            }, _doFinalize: function () {
                var e = this._data, n = e.words, r = 8 * this._nDataBytes, i = 8 * e.sigBytes;
                return n[i >>> 5] |= 128 << 24 - i % 32, n[14 + (i + 64 >>> 9 << 4)] = t.floor(r / 4294967296), n[15 + (i + 64 >>> 9 << 4)] = r, e.sigBytes = 4 * n.length, this._process(), this._hash
            }, clone: function () {
                var e = o.clone.call(this);
                return e._hash = this._hash.clone(), e
            }
        });
        n.SHA256 = o._createHelper(l), n.HmacSHA256 = o._createHmacHelper(l)
    }(Math), e.SHA256
}(Zs.exports), na = {exports: {}}, ra = {exports: {}};
ra.exports = function (e) {
    var t, n, r;
    n = (t = e).lib.Base, r = t.enc.Utf8, t.algo.HMAC = n.extend({
        init: function (e, t) {
            e = this._hasher = new e.init, "string" == typeof t && (t = r.parse(t));
            var n = e.blockSize, i = 4 * n;
            t.sigBytes > i && (t = e.finalize(t)), t.clamp();
            for (var o = this._oKey = t.clone(), s = this._iKey = t.clone(), a = o.words, u = s.words, c = 0; c < n; c++) a[c] ^= 1549556828, u[c] ^= 909522486;
            o.sigBytes = s.sigBytes = i, this.reset()
        }, reset: function () {
            var e = this._hasher;
            e.reset(), e.update(this._iKey)
        }, update: function (e) {
            return this._hasher.update(e), this
        }, finalize: function (e) {
            var t = this._hasher, n = t.finalize(e);
            return t.reset(), t.finalize(this._oKey.clone().concat(n))
        }
    })
}(Zs.exports);
var ia, oa = na.exports = function (e) {
    return e.HmacSHA256
}(Zs.exports);
if ("undefined" != typeof window && window.crypto && (ia = window.crypto), !ia && "undefined" != typeof window && window.msCrypto && (ia = window.msCrypto), !ia && "undefined" != typeof global && global.crypto && (ia = global.crypto), !ia && "function" == typeof require) try {
    ia = require("crypto")
} catch (e) {
}

function sa() {
    if (ia) {
        if ("function" == typeof ia.getRandomValues) try {
            return ia.getRandomValues(new Uint32Array(1))[0]
        } catch (e) {
        }
        if ("function" == typeof ia.randomBytes) try {
            return ia.randomBytes(4).readInt32LE()
        } catch (e) {
        }
    }
    throw new Error("Native crypto module could not be used to get secure random number.")
}

var aa, ua = function () {
    function e(e, t) {
        e = this.words = e || [], this.sigBytes = null != t ? t : 4 * e.length
    }

    var t = e.prototype;
    return t.random = function (t) {
        for (var n = [], r = 0; r < t; r += 4) n.push(sa());
        return new e(n, t)
    }, t.toString = function () {
        return function (e) {
            for (var t = e.words, n = e.sigBytes, r = [], i = 0; i < n; i++) {
                var o = t[i >>> 2] >>> 24 - i % 4 * 8 & 255;
                r.push((o >>> 4).toString(16)), r.push((15 & o).toString(16))
            }
            return r.join("")
        }(this)
    }, e
}();

function ca(e, t) {
    null != e && this.fromString(e, t)
}

function la() {
    return new ca(null)
}

var fa = "undefined" != typeof navigator;
fa && "Microsoft Internet Explorer" == navigator.appName ? (ca.prototype.am = function (e, t, n, r, i, o) {
    for (var s = 32767 & t, a = t >> 15; --o >= 0;) {
        var u = 32767 & this[e], c = this[e++] >> 15, l = a * u + c * s;
        i = ((u = s * u + ((32767 & l) << 15) + n[r] + (1073741823 & i)) >>> 30) + (l >>> 15) + a * c + (i >>> 30), n[r++] = 1073741823 & u
    }
    return i
}, aa = 30) : fa && "Netscape" != navigator.appName ? (ca.prototype.am = function (e, t, n, r, i, o) {
    for (; --o >= 0;) {
        var s = t * this[e++] + n[r] + i;
        i = Math.floor(s / 67108864), n[r++] = 67108863 & s
    }
    return i
}, aa = 26) : (ca.prototype.am = function (e, t, n, r, i, o) {
    for (var s = 16383 & t, a = t >> 14; --o >= 0;) {
        var u = 16383 & this[e], c = this[e++] >> 14, l = a * u + c * s;
        i = ((u = s * u + ((16383 & l) << 14) + n[r] + i) >> 28) + (l >> 14) + a * c, n[r++] = 268435455 & u
    }
    return i
}, aa = 28), ca.prototype.DB = aa, ca.prototype.DM = (1 << aa) - 1, ca.prototype.DV = 1 << aa;
ca.prototype.FV = Math.pow(2, 52), ca.prototype.F1 = 52 - aa, ca.prototype.F2 = 2 * aa - 52;
var da, ha, pa = new Array;
for (da = "0".charCodeAt(0), ha = 0; ha <= 9; ++ha) pa[da++] = ha;
for (da = "a".charCodeAt(0), ha = 10; ha < 36; ++ha) pa[da++] = ha;
for (da = "A".charCodeAt(0), ha = 10; ha < 36; ++ha) pa[da++] = ha;

function ga(e) {
    return "0123456789abcdefghijklmnopqrstuvwxyz".charAt(e)
}

function va(e, t) {
    var n = pa[e.charCodeAt(t)];
    return null == n ? -1 : n
}

function ma(e) {
    var t = la();
    return t.fromInt(e), t
}

function ya(e) {
    var t, n = 1;
    return 0 != (t = e >>> 16) && (e = t, n += 16), 0 != (t = e >> 8) && (e = t, n += 8), 0 != (t = e >> 4) && (e = t, n += 4), 0 != (t = e >> 2) && (e = t, n += 2), 0 != (t = e >> 1) && (e = t, n += 1), n
}

function Sa(e) {
    this.m = e, this.mp = e.invDigit(), this.mpl = 32767 & this.mp, this.mph = this.mp >> 15, this.um = (1 << e.DB - 15) - 1, this.mt2 = 2 * e.t
}

function wa(e) {
    return Bs.Buffer.from((new ua).random(e).toString(), "hex")
}

Sa.prototype.convert = function (e) {
    var t = la();
    return e.abs().dlShiftTo(this.m.t, t), t.divRemTo(this.m, null, t), e.s < 0 && t.compareTo(ca.ZERO) > 0 && this.m.subTo(t, t), t
}, Sa.prototype.revert = function (e) {
    var t = la();
    return e.copyTo(t), this.reduce(t), t
}, Sa.prototype.reduce = function (e) {
    for (; e.t <= this.mt2;) e[e.t++] = 0;
    for (var t = 0; t < this.m.t; ++t) {
        var n = 32767 & e[t], r = n * this.mpl + ((n * this.mph + (e[t] >> 15) * this.mpl & this.um) << 15) & e.DM;
        for (e[n = t + this.m.t] += this.m.am(0, r, e, t, 0, this.m.t); e[n] >= e.DV;) e[n] -= e.DV, e[++n]++
    }
    e.clamp(), e.drShiftTo(this.m.t, e), e.compareTo(this.m) >= 0 && e.subTo(this.m, e)
}, Sa.prototype.mulTo = function (e, t, n) {
    e.multiplyTo(t, n), this.reduce(n)
}, Sa.prototype.sqrTo = function (e, t) {
    e.squareTo(t), this.reduce(t)
}, ca.prototype.copyTo = function (e) {
    for (var t = this.t - 1; t >= 0; --t) e[t] = this[t];
    e.t = this.t, e.s = this.s
}, ca.prototype.fromInt = function (e) {
    this.t = 1, this.s = e < 0 ? -1 : 0, e > 0 ? this[0] = e : e < -1 ? this[0] = e + this.DV : this.t = 0
}, ca.prototype.fromString = function (e, t) {
    var n;
    if (16 == t) n = 4; else if (8 == t) n = 3; else if (2 == t) n = 1; else if (32 == t) n = 5; else {
        if (4 != t) throw new Error("Only radix 2, 4, 8, 16, 32 are supported");
        n = 2
    }
    this.t = 0, this.s = 0;
    for (var r = e.length, i = !1, o = 0; --r >= 0;) {
        var s = va(e, r);
        s < 0 ? "-" == e.charAt(r) && (i = !0) : (i = !1, 0 == o ? this[this.t++] = s : o + n > this.DB ? (this[this.t - 1] |= (s & (1 << this.DB - o) - 1) << o, this[this.t++] = s >> this.DB - o) : this[this.t - 1] |= s << o, (o += n) >= this.DB && (o -= this.DB))
    }
    this.clamp(), i && ca.ZERO.subTo(this, this)
}, ca.prototype.clamp = function () {
    for (var e = this.s & this.DM; this.t > 0 && this[this.t - 1] == e;) --this.t
}, ca.prototype.dlShiftTo = function (e, t) {
    var n;
    for (n = this.t - 1; n >= 0; --n) t[n + e] = this[n];
    for (n = e - 1; n >= 0; --n) t[n] = 0;
    t.t = this.t + e, t.s = this.s
}, ca.prototype.drShiftTo = function (e, t) {
    for (var n = e; n < this.t; ++n) t[n - e] = this[n];
    t.t = Math.max(this.t - e, 0), t.s = this.s
}, ca.prototype.lShiftTo = function (e, t) {
    var n, r = e % this.DB, i = this.DB - r, o = (1 << i) - 1, s = Math.floor(e / this.DB), a = this.s << r & this.DM;
    for (n = this.t - 1; n >= 0; --n) t[n + s + 1] = this[n] >> i | a, a = (this[n] & o) << r;
    for (n = s - 1; n >= 0; --n) t[n] = 0;
    t[s] = a, t.t = this.t + s + 1, t.s = this.s, t.clamp()
}, ca.prototype.rShiftTo = function (e, t) {
    t.s = this.s;
    var n = Math.floor(e / this.DB);
    if (n >= this.t) t.t = 0; else {
        var r = e % this.DB, i = this.DB - r, o = (1 << r) - 1;
        t[0] = this[n] >> r;
        for (var s = n + 1; s < this.t; ++s) t[s - n - 1] |= (this[s] & o) << i, t[s - n] = this[s] >> r;
        r > 0 && (t[this.t - n - 1] |= (this.s & o) << i), t.t = this.t - n, t.clamp()
    }
}, ca.prototype.subTo = function (e, t) {
    for (var n = 0, r = 0, i = Math.min(e.t, this.t); n < i;) r += this[n] - e[n], t[n++] = r & this.DM, r >>= this.DB;
    if (e.t < this.t) {
        for (r -= e.s; n < this.t;) r += this[n], t[n++] = r & this.DM, r >>= this.DB;
        r += this.s
    } else {
        for (r += this.s; n < e.t;) r -= e[n], t[n++] = r & this.DM, r >>= this.DB;
        r -= e.s
    }
    t.s = r < 0 ? -1 : 0, r < -1 ? t[n++] = this.DV + r : r > 0 && (t[n++] = r), t.t = n, t.clamp()
}, ca.prototype.multiplyTo = function (e, t) {
    var n = this.abs(), r = e.abs(), i = n.t;
    for (t.t = i + r.t; --i >= 0;) t[i] = 0;
    for (i = 0; i < r.t; ++i) t[i + n.t] = n.am(0, r[i], t, i, 0, n.t);
    t.s = 0, t.clamp(), this.s != e.s && ca.ZERO.subTo(t, t)
}, ca.prototype.squareTo = function (e) {
    for (var t = this.abs(), n = e.t = 2 * t.t; --n >= 0;) e[n] = 0;
    for (n = 0; n < t.t - 1; ++n) {
        var r = t.am(n, t[n], e, 2 * n, 0, 1);
        (e[n + t.t] += t.am(n + 1, 2 * t[n], e, 2 * n + 1, r, t.t - n - 1)) >= t.DV && (e[n + t.t] -= t.DV, e[n + t.t + 1] = 1)
    }
    e.t > 0 && (e[e.t - 1] += t.am(n, t[n], e, 2 * n, 0, 1)), e.s = 0, e.clamp()
}, ca.prototype.divRemTo = function (e, t, n) {
    var r = e.abs();
    if (!(r.t <= 0)) {
        var i = this.abs();
        if (i.t < r.t) return null != t && t.fromInt(0), void (null != n && this.copyTo(n));
        null == n && (n = la());
        var o = la(), s = this.s, a = e.s, u = this.DB - ya(r[r.t - 1]);
        u > 0 ? (r.lShiftTo(u, o), i.lShiftTo(u, n)) : (r.copyTo(o), i.copyTo(n));
        var c = o.t, l = o[c - 1];
        if (0 != l) {
            var f = l * (1 << this.F1) + (c > 1 ? o[c - 2] >> this.F2 : 0), d = this.FV / f, h = (1 << this.F1) / f,
                p = 1 << this.F2, g = n.t, v = g - c, m = null == t ? la() : t;
            for (o.dlShiftTo(v, m), n.compareTo(m) >= 0 && (n[n.t++] = 1, n.subTo(m, n)), ca.ONE.dlShiftTo(c, m), m.subTo(o, o); o.t < c;) o[o.t++] = 0;
            for (; --v >= 0;) {
                var y = n[--g] == l ? this.DM : Math.floor(n[g] * d + (n[g - 1] + p) * h);
                if ((n[g] += o.am(0, y, n, v, 0, c)) < y) for (o.dlShiftTo(v, m), n.subTo(m, n); n[g] < --y;) n.subTo(m, n)
            }
            null != t && (n.drShiftTo(c, t), s != a && ca.ZERO.subTo(t, t)), n.t = c, n.clamp(), u > 0 && n.rShiftTo(u, n), s < 0 && ca.ZERO.subTo(n, n)
        }
    }
}, ca.prototype.invDigit = function () {
    if (this.t < 1) return 0;
    var e = this[0];
    if (0 == (1 & e)) return 0;
    var t = 3 & e;
    return (t = (t = (t = (t = t * (2 - (15 & e) * t) & 15) * (2 - (255 & e) * t) & 255) * (2 - ((65535 & e) * t & 65535)) & 65535) * (2 - e * t % this.DV) % this.DV) > 0 ? this.DV - t : -t
}, ca.prototype.addTo = function (e, t) {
    for (var n = 0, r = 0, i = Math.min(e.t, this.t); n < i;) r += this[n] + e[n], t[n++] = r & this.DM, r >>= this.DB;
    if (e.t < this.t) {
        for (r += e.s; n < this.t;) r += this[n], t[n++] = r & this.DM, r >>= this.DB;
        r += this.s
    } else {
        for (r += this.s; n < e.t;) r += e[n], t[n++] = r & this.DM, r >>= this.DB;
        r += e.s
    }
    t.s = r < 0 ? -1 : 0, r > 0 ? t[n++] = r : r < -1 && (t[n++] = this.DV + r), t.t = n, t.clamp()
}, ca.prototype.toString = function (e) {
    if (this.s < 0) return "-" + this.negate().toString(e);
    var t;
    if (16 == e) t = 4; else if (8 == e) t = 3; else if (2 == e) t = 1; else if (32 == e) t = 5; else {
        if (4 != e) throw new Error("Only radix 2, 4, 8, 16, 32 are supported");
        t = 2
    }
    var n, r = (1 << t) - 1, i = !1, o = "", s = this.t, a = this.DB - s * this.DB % t;
    if (s-- > 0) for (a < this.DB && (n = this[s] >> a) > 0 && (i = !0, o = ga(n)); s >= 0;) a < t ? (n = (this[s] & (1 << a) - 1) << t - a, n |= this[--s] >> (a += this.DB - t)) : (n = this[s] >> (a -= t) & r, a <= 0 && (a += this.DB, --s)), n > 0 && (i = !0), i && (o += ga(n));
    return i ? o : "0"
}, ca.prototype.negate = function () {
    var e = la();
    return ca.ZERO.subTo(this, e), e
}, ca.prototype.abs = function () {
    return this.s < 0 ? this.negate() : this
}, ca.prototype.compareTo = function (e) {
    var t = this.s - e.s;
    if (0 != t) return t;
    var n = this.t;
    if (0 != (t = n - e.t)) return this.s < 0 ? -t : t;
    for (; --n >= 0;) if (0 != (t = this[n] - e[n])) return t;
    return 0
}, ca.prototype.bitLength = function () {
    return this.t <= 0 ? 0 : this.DB * (this.t - 1) + ya(this[this.t - 1] ^ this.s & this.DM)
}, ca.prototype.mod = function (e) {
    var t = la();
    return this.abs().divRemTo(e, null, t), this.s < 0 && t.compareTo(ca.ZERO) > 0 && e.subTo(t, t), t
}, ca.prototype.equals = function (e) {
    return 0 == this.compareTo(e)
}, ca.prototype.add = function (e) {
    var t = la();
    return this.addTo(e, t), t
}, ca.prototype.subtract = function (e) {
    var t = la();
    return this.subTo(e, t), t
}, ca.prototype.multiply = function (e) {
    var t = la();
    return this.multiplyTo(e, t), t
}, ca.prototype.divide = function (e) {
    var t = la();
    return this.divRemTo(e, t, null), t
}, ca.prototype.modPow = function (e, t, n) {
    var r, i = e.bitLength(), o = ma(1), s = new Sa(t);
    if (i <= 0) return o;
    r = i < 18 ? 1 : i < 48 ? 3 : i < 144 ? 4 : i < 768 ? 5 : 6;
    var a = new Array, u = 3, c = r - 1, l = (1 << r) - 1;
    if (a[1] = s.convert(this), r > 1) {
        var f = la();
        for (s.sqrTo(a[1], f); u <= l;) a[u] = la(), s.mulTo(f, a[u - 2], a[u]), u += 2
    }
    var d, h, p = e.t - 1, g = !0, v = la();
    for (i = ya(e[p]) - 1; p >= 0;) {
        for (i >= c ? d = e[p] >> i - c & l : (d = (e[p] & (1 << i + 1) - 1) << c - i, p > 0 && (d |= e[p - 1] >> this.DB + i - c)), u = r; 0 == (1 & d);) d >>= 1, --u;
        if ((i -= u) < 0 && (i += this.DB, --p), g) a[d].copyTo(o), g = !1; else {
            for (; u > 1;) s.sqrTo(o, v), s.sqrTo(v, o), u -= 2;
            u > 0 ? s.sqrTo(o, v) : (h = o, o = v, v = h), s.mulTo(v, a[d], o)
        }
        for (; p >= 0 && 0 == (e[p] & 1 << i);) s.sqrTo(o, v), h = o, o = v, v = h, --i < 0 && (i = this.DB - 1, --p)
    }
    var m = s.revert(o);
    return n(null, m), m
}, ca.ZERO = ma(0), ca.ONE = ma(1);
var ba = /^[89a-f]/i, Ea = function () {
    function e(e) {
        this.N = new ca("FFFFFFFFFFFFFFFFC90FDAA22168C234C4C6628B80DC1CD129024E088A67CC74020BBEA63B139B22514A08798E3404DDEF9519B3CD3A431B302B0A6DF25F14374FE1356D6D51C245E485B576625E7EC6F44C42E9A637ED6B0BFF5CB6F406B7EDEE386BFB5A899FA5AE9F24117C4B1FE649286651ECE45B3DC2007CB8A163BF0598DA48361C55D39A69163FA8FD24CF5F83655D23DCA3AD961C62F356208552BB9ED529077096966D670C354E4ABC9804F1746C08CA18217C32905E462E36CE3BE39E772C180E86039B2783A2EC07A28FB5C55DF06F4C52C9DE2BCBF6955817183995497CEA956AE515D2261898FA051015728E5A8AAAC42DAD33170D04507A33A85521ABDF1CBA64ECFB850458DBEF0A8AEA71575D060C7DB3970F85A6E1E4C7ABF5AE8CDB0933D71E8C94E04A25619DCEE3D2261AD2EE6BF12FFA06D98A0864D87602733EC86A64521F2B18177B200CBBE117577A615D6C770988C0BAD946E208E24FA074E5AB3143DB5BFCE0FD108E4B82D120A93AD2CAFFFFFFFFFFFFFFFF", 16), this.g = new ca("2", 16), this.k = new ca(this.hexHash("" + this.padHex(this.N) + this.padHex(this.g)), 16), this.smallAValue = this.generateRandomSmallA(), this.getLargeAValue((function () {
        })), this.infoBits = Bs.Buffer.from("Caldera Derived Key", "utf8"), this.poolName = e
    }

    var t = e.prototype;
    return t.getSmallAValue = function () {
        return this.smallAValue
    }, t.getLargeAValue = function (e) {
        var t = this;
        this.largeAValue ? e(null, this.largeAValue) : this.calculateA(this.smallAValue, (function (n, r) {
            n && e(n, null), t.largeAValue = r, e(null, t.largeAValue)
        }))
    }, t.generateRandomSmallA = function () {
        return new ca(wa(128).toString("hex"), 16)
    }, t.generateRandomString = function () {
        return wa(40).toString("base64")
    }, t.getRandomPassword = function () {
        return this.randomPassword
    }, t.getSaltDevices = function () {
        return this.SaltToHashDevices
    }, t.getVerifierDevices = function () {
        return this.verifierDevices
    }, t.generateHashDevice = function (e, t, n) {
        var r = this;
        this.randomPassword = this.generateRandomString();
        var i = "" + e + t + ":" + this.randomPassword, o = this.hash(i), s = wa(16).toString("hex");
        this.SaltToHashDevices = this.padHex(new ca(s, 16)), this.g.modPow(new ca(this.hexHash(this.SaltToHashDevices + o), 16), this.N, (function (e, t) {
            e && n(e, null), r.verifierDevices = r.padHex(t), n(null, null)
        }))
    }, t.calculateA = function (e, t) {
        var n = this;
        this.g.modPow(e, this.N, (function (e, r) {
            e && t(e, null), r.mod(n.N).equals(ca.ZERO) && t(new Error("Illegal paramater. A mod N cannot be 0."), null), t(null, r)
        }))
    }, t.calculateU = function (e, t) {
        return this.UHexHash = this.hexHash(this.padHex(e) + this.padHex(t)), new ca(this.UHexHash, 16)
    }, t.hash = function (e) {
        var t = e instanceof Bs.Buffer ? Qs.lib.WordArray.create(e) : e, n = ta(t).toString();
        return new Array(64 - n.length).join("0") + n
    }, t.hexHash = function (e) {
        return this.hash(Bs.Buffer.from(e, "hex"))
    }, t.computehkdf = function (e, t) {
        var n = Qs.lib.WordArray.create(Bs.Buffer.concat([this.infoBits, Bs.Buffer.from(String.fromCharCode(1), "utf8")])),
            r = e instanceof Bs.Buffer ? Qs.lib.WordArray.create(e) : e,
            i = t instanceof Bs.Buffer ? Qs.lib.WordArray.create(t) : t, o = oa(r, i), s = oa(n, o);
        return Bs.Buffer.from(s.toString(), "hex").slice(0, 16)
    }, t.getPasswordAuthenticationKey = function (e, t, n, r, i) {
        var o = this;
        if (n.mod(this.N).equals(ca.ZERO)) throw new Error("B cannot be zero.");
        if (this.UValue = this.calculateU(this.largeAValue, n), this.UValue.equals(ca.ZERO)) throw new Error("U cannot be zero.");
        var s = "" + this.poolName + e + ":" + t, a = this.hash(s), u = new ca(this.hexHash(this.padHex(r) + a), 16);
        this.calculateS(u, n, (function (e, t) {
            e && i(e, null);
            var n = o.computehkdf(Bs.Buffer.from(o.padHex(t), "hex"), Bs.Buffer.from(o.padHex(o.UValue), "hex"));
            i(null, n)
        }))
    }, t.calculateS = function (e, t, n) {
        var r = this;
        this.g.modPow(e, this.N, (function (i, o) {
            i && n(i, null), t.subtract(r.k.multiply(o)).modPow(r.smallAValue.add(r.UValue.multiply(e)), r.N, (function (e, t) {
                e && n(e, null), n(null, t.mod(r.N))
            }))
        }))
    }, t.getNewPasswordRequiredChallengeUserAttributePrefix = function () {
        return "userAttributes."
    }, t.padHex = function (e) {
        if (!(e instanceof ca)) throw new Error("Not a BigInteger");
        var t = e.compareTo(ca.ZERO) < 0, n = e.abs().toString(16);
        if (n = n.length % 2 != 0 ? "0" + n : n, n = ba.test(n) ? "00" + n : n, t) {
            var r = n.split("").map((function (e) {
                var t = 15 & ~parseInt(e, 16);
                return "0123456789ABCDEF".charAt(t)
            })).join("");
            (n = new ca(r, 16).add(ca.ONE).toString(16)).toUpperCase().startsWith("FF8") && (n = n.substring(2))
        }
        return n
    }, e
}(), Ca = function () {
    function e(e) {
        this.jwtToken = e || "", this.payload = this.decodePayload()
    }

    var t = e.prototype;
    return t.getJwtToken = function () {
        return this.jwtToken
    }, t.getExpiration = function () {
        return this.payload.exp
    }, t.getIssuedAt = function () {
        return this.payload.iat
    }, t.decodePayload = function () {
        var e = this.jwtToken.split(".")[1];
        try {
            return JSON.parse(Bs.Buffer.from(e, "base64").toString("utf8"))
        } catch (e) {
            return {}
        }
    }, e
}();

function _a(e, t) {
    return _a = Object.setPrototypeOf || function (e, t) {
        return e.__proto__ = t, e
    }, _a(e, t)
}

var Aa = function (e) {
    var t, n;

    function r(t) {
        var n = (void 0 === t ? {} : t).AccessToken;
        return e.call(this, n || "") || this
    }

    return n = e, (t = r).prototype = Object.create(n.prototype), t.prototype.constructor = t, _a(t, n), r
}(Ca);

function Pa(e, t) {
    return Pa = Object.setPrototypeOf || function (e, t) {
        return e.__proto__ = t, e
    }, Pa(e, t)
}

var ka = function (e) {
        var t, n;

        function r(t) {
            var n = (void 0 === t ? {} : t).IdToken;
            return e.call(this, n || "") || this
        }

        return n = e, (t = r).prototype = Object.create(n.prototype), t.prototype.constructor = t, Pa(t, n), r
    }(Ca), xa = function () {
        function e(e) {
            var t = (void 0 === e ? {} : e).RefreshToken;
            this.token = t || ""
        }

        return e.prototype.getToken = function () {
            return this.token
        }, e
    }(), Ia = {exports: {}}, Ta = Ia.exports = function (e) {
        return function () {
            var t = e, n = t.lib.WordArray;

            function r(e, t, r) {
                for (var i = [], o = 0, s = 0; s < t; s++) if (s % 4) {
                    var a = r[e.charCodeAt(s - 1)] << s % 4 * 2 | r[e.charCodeAt(s)] >>> 6 - s % 4 * 2;
                    i[o >>> 2] |= a << 24 - o % 4 * 8, o++
                }
                return n.create(i, o)
            }

            t.enc.Base64 = {
                stringify: function (e) {
                    var t = e.words, n = e.sigBytes, r = this._map;
                    e.clamp();
                    for (var i = [], o = 0; o < n; o += 3) for (var s = (t[o >>> 2] >>> 24 - o % 4 * 8 & 255) << 16 | (t[o + 1 >>> 2] >>> 24 - (o + 1) % 4 * 8 & 255) << 8 | t[o + 2 >>> 2] >>> 24 - (o + 2) % 4 * 8 & 255, a = 0; a < 4 && o + .75 * a < n; a++) i.push(r.charAt(s >>> 6 * (3 - a) & 63));
                    var u = r.charAt(64);
                    if (u) for (; i.length % 4;) i.push(u);
                    return i.join("")
                }, parse: function (e) {
                    var t = e.length, n = this._map, i = this._reverseMap;
                    if (!i) {
                        i = this._reverseMap = [];
                        for (var o = 0; o < n.length; o++) i[n.charCodeAt(o)] = o
                    }
                    var s = n.charAt(64);
                    if (s) {
                        var a = e.indexOf(s);
                        -1 !== a && (t = a)
                    }
                    return r(e, t, i)
                }, _map: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/="
            }
        }(), e.enc.Base64
    }(Zs.exports), Ua = function () {
        function e(e) {
            var t = void 0 === e ? {} : e, n = t.IdToken, r = t.RefreshToken, i = t.AccessToken, o = t.ClockDrift;
            if (null == i || null == n) throw new Error("Id token and Access Token must be present.");
            this.idToken = n, this.refreshToken = r, this.accessToken = i, this.clockDrift = void 0 === o ? this.calculateClockDrift() : o
        }

        var t = e.prototype;
        return t.getIdToken = function () {
            return this.idToken
        }, t.getRefreshToken = function () {
            return this.refreshToken
        }, t.getAccessToken = function () {
            return this.accessToken
        }, t.getClockDrift = function () {
            return this.clockDrift
        }, t.calculateClockDrift = function () {
            return Math.floor(new Date / 1e3) - Math.min(this.accessToken.getIssuedAt(), this.idToken.getIssuedAt())
        }, t.isValid = function () {
            var e = Math.floor(new Date / 1e3) - this.clockDrift;
            return e < this.accessToken.getExpiration() && e < this.idToken.getExpiration()
        }, e
    }(), Oa = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
    Ma = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"], La = function () {
        function e() {
        }

        return e.prototype.getNowString = function () {
            var e = new Date, t = Ma[e.getUTCDay()], n = Oa[e.getUTCMonth()], r = e.getUTCDate(), i = e.getUTCHours();
            i < 10 && (i = "0" + i);
            var o = e.getUTCMinutes();
            o < 10 && (o = "0" + o);
            var s = e.getUTCSeconds();
            return s < 10 && (s = "0" + s), t + " " + n + " " + r + " " + i + ":" + o + ":" + s + " UTC " + e.getUTCFullYear()
        }, e
    }(), Ra = function () {
        function e(e) {
            var t = void 0 === e ? {} : e, n = t.Name, r = t.Value;
            this.Name = n || "", this.Value = r || ""
        }

        var t = e.prototype;
        return t.getValue = function () {
            return this.Value
        }, t.setValue = function (e) {
            return this.Value = e, this
        }, t.getName = function () {
            return this.Name
        }, t.setName = function (e) {
            return this.Name = e, this
        }, t.toString = function () {
            return JSON.stringify(this)
        }, t.toJSON = function () {
            return {Name: this.Name, Value: this.Value}
        }, e
    }(), Na = {}, Da = function () {
        function e() {
        }

        return e.setItem = function (e, t) {
            return Na[e] = t, Na[e]
        }, e.getItem = function (e) {
            return Object.prototype.hasOwnProperty.call(Na, e) ? Na[e] : void 0
        }, e.removeItem = function (e) {
            return delete Na[e]
        }, e.clear = function () {
            return Na = {}
        }, e
    }(), Ba = function () {
        function e() {
            try {
                this.storageWindow = window.localStorage, this.storageWindow.setItem("aws.cognito.test-ls", 1), this.storageWindow.removeItem("aws.cognito.test-ls")
            } catch (e) {
                this.storageWindow = Da
            }
        }

        return e.prototype.getStorage = function () {
            return this.storageWindow
        }, e
    }(), ja = "undefined" != typeof navigator ? navigator.userAgent : "nodejs", Fa = function () {
        function e(e) {
            if (null == e || null == e.Username || null == e.Pool) throw new Error("Username and Pool information are required.");
            this.username = e.Username || "", this.pool = e.Pool, this.Session = null, this.client = e.Pool.client, this.signInUserSession = null, this.authenticationFlowType = "USER_SRP_AUTH", this.storage = e.Storage || (new Ba).getStorage(), this.keyPrefix = "CognitoIdentityServiceProvider." + this.pool.getClientId(), this.userDataKey = this.keyPrefix + "." + this.username + ".userData"
        }

        var t = e.prototype;
        return t.setSignInUserSession = function (e) {
            this.clearCachedUserData(), this.signInUserSession = e, this.cacheTokens()
        }, t.getSignInUserSession = function () {
            return this.signInUserSession
        }, t.getUsername = function () {
            return this.username
        }, t.getAuthenticationFlowType = function () {
            return this.authenticationFlowType
        }, t.setAuthenticationFlowType = function (e) {
            this.authenticationFlowType = e
        }, t.initiateAuth = function (e, t) {
            var n = this, r = e.getAuthParameters();
            r.USERNAME = this.username;
            var i = 0 !== Object.keys(e.getValidationData()).length ? e.getValidationData() : e.getClientMetadata(),
                o = {AuthFlow: "CUSTOM_AUTH", ClientId: this.pool.getClientId(), AuthParameters: r, ClientMetadata: i};
            this.getUserContextData() && (o.UserContextData = this.getUserContextData()), this.client.request("InitiateAuth", o, (function (e, r) {
                if (e) return t.onFailure(e);
                var i = r.ChallengeName, o = r.ChallengeParameters;
                return "CUSTOM_CHALLENGE" === i ? (n.Session = r.Session, t.customChallenge(o)) : (n.signInUserSession = n.getCognitoUserSession(r.AuthenticationResult), n.cacheTokens(), t.onSuccess(n.signInUserSession))
            }))
        }, t.authenticateUser = function (e, t) {
            return "USER_PASSWORD_AUTH" === this.authenticationFlowType ? this.authenticateUserPlainUsernamePassword(e, t) : "USER_SRP_AUTH" === this.authenticationFlowType || "CUSTOM_AUTH" === this.authenticationFlowType ? this.authenticateUserDefaultAuth(e, t) : t.onFailure(new Error("Authentication flow type is invalid."))
        }, t.authenticateUserDefaultAuth = function (e, t) {
            var n, r, i = this, o = new Ea(this.pool.getUserPoolId().split("_")[1]), s = new La, a = {};
            null != this.deviceKey && (a.DEVICE_KEY = this.deviceKey), a.USERNAME = this.username, o.getLargeAValue((function (u, c) {
                u && t.onFailure(u), a.SRP_A = c.toString(16), "CUSTOM_AUTH" === i.authenticationFlowType && (a.CHALLENGE_NAME = "SRP_A");
                var l = 0 !== Object.keys(e.getValidationData()).length ? e.getValidationData() : e.getClientMetadata(),
                    f = {
                        AuthFlow: i.authenticationFlowType,
                        ClientId: i.pool.getClientId(),
                        AuthParameters: a,
                        ClientMetadata: l
                    };
                i.getUserContextData(i.username) && (f.UserContextData = i.getUserContextData(i.username)), i.client.request("InitiateAuth", f, (function (a, u) {
                    if (a) return t.onFailure(a);
                    var c = u.ChallengeParameters;
                    i.username = c.USER_ID_FOR_SRP, i.userDataKey = i.keyPrefix + "." + i.username + ".userData", n = new ca(c.SRP_B, 16), r = new ca(c.SALT, 16), i.getCachedDeviceKeyAndPassword(), o.getPasswordAuthenticationKey(i.username, e.getPassword(), n, r, (function (e, n) {
                        e && t.onFailure(e);
                        var r = s.getNowString(),
                            a = Qs.lib.WordArray.create(Bs.Buffer.concat([Bs.Buffer.from(i.pool.getUserPoolId().split("_")[1], "utf8"), Bs.Buffer.from(i.username, "utf8"), Bs.Buffer.from(c.SECRET_BLOCK, "base64"), Bs.Buffer.from(r, "utf8")])),
                            f = Qs.lib.WordArray.create(n), d = Ta.stringify(oa(a, f)), h = {};
                        h.USERNAME = i.username, h.PASSWORD_CLAIM_SECRET_BLOCK = c.SECRET_BLOCK, h.TIMESTAMP = r, h.PASSWORD_CLAIM_SIGNATURE = d, null != i.deviceKey && (h.DEVICE_KEY = i.deviceKey);
                        var p = {
                            ChallengeName: "PASSWORD_VERIFIER",
                            ClientId: i.pool.getClientId(),
                            ChallengeResponses: h,
                            Session: u.Session,
                            ClientMetadata: l
                        };
                        i.getUserContextData() && (p.UserContextData = i.getUserContextData()), function e(t, n) {
                            return i.client.request("RespondToAuthChallenge", t, (function (r, o) {
                                return r && "ResourceNotFoundException" === r.code && -1 !== r.message.toLowerCase().indexOf("device") ? (h.DEVICE_KEY = null, i.deviceKey = null, i.randomPassword = null, i.deviceGroupKey = null, i.clearCachedDeviceKeyAndPassword(), e(t, n)) : n(r, o)
                            }))
                        }(p, (function (e, n) {
                            return e ? t.onFailure(e) : i.authenticateUserInternal(n, o, t)
                        }))
                    }))
                }))
            }))
        }, t.authenticateUserPlainUsernamePassword = function (e, t) {
            var n = this, r = {};
            if (r.USERNAME = this.username, r.PASSWORD = e.getPassword(), r.PASSWORD) {
                var i = new Ea(this.pool.getUserPoolId().split("_")[1]);
                this.getCachedDeviceKeyAndPassword(), null != this.deviceKey && (r.DEVICE_KEY = this.deviceKey);
                var o = 0 !== Object.keys(e.getValidationData()).length ? e.getValidationData() : e.getClientMetadata(),
                    s = {
                        AuthFlow: "USER_PASSWORD_AUTH",
                        ClientId: this.pool.getClientId(),
                        AuthParameters: r,
                        ClientMetadata: o
                    };
                this.getUserContextData(this.username) && (s.UserContextData = this.getUserContextData(this.username)), this.client.request("InitiateAuth", s, (function (e, r) {
                    return e ? t.onFailure(e) : n.authenticateUserInternal(r, i, t)
                }))
            } else t.onFailure(new Error("PASSWORD parameter is required"))
        }, t.authenticateUserInternal = function (e, t, n) {
            var r = this, i = e.ChallengeName, o = e.ChallengeParameters;
            if ("SMS_MFA" === i) return this.Session = e.Session, n.mfaRequired(i, o);
            if ("SELECT_MFA_TYPE" === i) return this.Session = e.Session, n.selectMFAType(i, o);
            if ("MFA_SETUP" === i) return this.Session = e.Session, n.mfaSetup(i, o);
            if ("SOFTWARE_TOKEN_MFA" === i) return this.Session = e.Session, n.totpRequired(i, o);
            if ("CUSTOM_CHALLENGE" === i) return this.Session = e.Session, n.customChallenge(o);
            if ("NEW_PASSWORD_REQUIRED" === i) {
                this.Session = e.Session;
                var s = null, a = null, u = [], c = t.getNewPasswordRequiredChallengeUserAttributePrefix();
                if (o && (s = JSON.parse(e.ChallengeParameters.userAttributes), a = JSON.parse(e.ChallengeParameters.requiredAttributes)), a) for (var l = 0; l < a.length; l++) u[l] = a[l].substr(c.length);
                return n.newPasswordRequired(s, u)
            }
            if ("DEVICE_SRP_AUTH" === i) return this.Session = e.Session, void this.getDeviceResponse(n);
            this.signInUserSession = this.getCognitoUserSession(e.AuthenticationResult), this.challengeName = i, this.cacheTokens();
            var f = e.AuthenticationResult.NewDeviceMetadata;
            if (null == f) return n.onSuccess(this.signInUserSession);
            t.generateHashDevice(e.AuthenticationResult.NewDeviceMetadata.DeviceGroupKey, e.AuthenticationResult.NewDeviceMetadata.DeviceKey, (function (i) {
                if (i) return n.onFailure(i);
                var o = {
                    Salt: Bs.Buffer.from(t.getSaltDevices(), "hex").toString("base64"),
                    PasswordVerifier: Bs.Buffer.from(t.getVerifierDevices(), "hex").toString("base64")
                };
                r.verifierDevices = o.PasswordVerifier, r.deviceGroupKey = f.DeviceGroupKey, r.randomPassword = t.getRandomPassword(), r.client.request("ConfirmDevice", {
                    DeviceKey: f.DeviceKey,
                    AccessToken: r.signInUserSession.getAccessToken().getJwtToken(),
                    DeviceSecretVerifierConfig: o,
                    DeviceName: ja
                }, (function (t, i) {
                    return t ? n.onFailure(t) : (r.deviceKey = e.AuthenticationResult.NewDeviceMetadata.DeviceKey, r.cacheDeviceKeyAndPassword(), !0 === i.UserConfirmationNecessary ? n.onSuccess(r.signInUserSession, i.UserConfirmationNecessary) : n.onSuccess(r.signInUserSession))
                }))
            }))
        }, t.completeNewPasswordChallenge = function (e, t, n, r) {
            var i = this;
            if (!e) return n.onFailure(new Error("New password is required."));
            var o = new Ea(this.pool.getUserPoolId().split("_")[1]),
                s = o.getNewPasswordRequiredChallengeUserAttributePrefix(), a = {};
            t && Object.keys(t).forEach((function (e) {
                a[s + e] = t[e]
            })), a.NEW_PASSWORD = e, a.USERNAME = this.username;
            var u = {
                ChallengeName: "NEW_PASSWORD_REQUIRED",
                ClientId: this.pool.getClientId(),
                ChallengeResponses: a,
                Session: this.Session,
                ClientMetadata: r
            };
            this.getUserContextData() && (u.UserContextData = this.getUserContextData()), this.client.request("RespondToAuthChallenge", u, (function (e, t) {
                return e ? n.onFailure(e) : i.authenticateUserInternal(t, o, n)
            }))
        }, t.getDeviceResponse = function (e, t) {
            var n = this, r = new Ea(this.deviceGroupKey), i = new La, o = {};
            o.USERNAME = this.username, o.DEVICE_KEY = this.deviceKey, r.getLargeAValue((function (s, a) {
                s && e.onFailure(s), o.SRP_A = a.toString(16);
                var u = {
                    ChallengeName: "DEVICE_SRP_AUTH",
                    ClientId: n.pool.getClientId(),
                    ChallengeResponses: o,
                    ClientMetadata: t,
                    Session: n.Session
                };
                n.getUserContextData() && (u.UserContextData = n.getUserContextData()), n.client.request("RespondToAuthChallenge", u, (function (t, o) {
                    if (t) return e.onFailure(t);
                    var s = o.ChallengeParameters, a = new ca(s.SRP_B, 16), u = new ca(s.SALT, 16);
                    r.getPasswordAuthenticationKey(n.deviceKey, n.randomPassword, a, u, (function (t, r) {
                        if (t) return e.onFailure(t);
                        var a = i.getNowString(),
                            u = Qs.lib.WordArray.create(Bs.Buffer.concat([Bs.Buffer.from(n.deviceGroupKey, "utf8"), Bs.Buffer.from(n.deviceKey, "utf8"), Bs.Buffer.from(s.SECRET_BLOCK, "base64"), Bs.Buffer.from(a, "utf8")])),
                            c = Qs.lib.WordArray.create(r), l = Ta.stringify(oa(u, c)), f = {};
                        f.USERNAME = n.username, f.PASSWORD_CLAIM_SECRET_BLOCK = s.SECRET_BLOCK, f.TIMESTAMP = a, f.PASSWORD_CLAIM_SIGNATURE = l, f.DEVICE_KEY = n.deviceKey;
                        var d = {
                            ChallengeName: "DEVICE_PASSWORD_VERIFIER",
                            ClientId: n.pool.getClientId(),
                            ChallengeResponses: f,
                            Session: o.Session
                        };
                        n.getUserContextData() && (d.UserContextData = n.getUserContextData()), n.client.request("RespondToAuthChallenge", d, (function (t, r) {
                            return t ? e.onFailure(t) : (n.signInUserSession = n.getCognitoUserSession(r.AuthenticationResult), n.cacheTokens(), e.onSuccess(n.signInUserSession))
                        }))
                    }))
                }))
            }))
        }, t.confirmRegistration = function (e, t, n, r) {
            var i = {
                ClientId: this.pool.getClientId(),
                ConfirmationCode: e,
                Username: this.username,
                ForceAliasCreation: t,
                ClientMetadata: r
            };
            this.getUserContextData() && (i.UserContextData = this.getUserContextData()), this.client.request("ConfirmSignUp", i, (function (e) {
                return e ? n(e, null) : n(null, "SUCCESS")
            }))
        }, t.sendCustomChallengeAnswer = function (e, t, n) {
            var r = this, i = {};
            i.USERNAME = this.username, i.ANSWER = e;
            var o = new Ea(this.pool.getUserPoolId().split("_")[1]);
            this.getCachedDeviceKeyAndPassword(), null != this.deviceKey && (i.DEVICE_KEY = this.deviceKey);
            var s = {
                ChallengeName: "CUSTOM_CHALLENGE",
                ChallengeResponses: i,
                ClientId: this.pool.getClientId(),
                Session: this.Session,
                ClientMetadata: n
            };
            this.getUserContextData() && (s.UserContextData = this.getUserContextData()), this.client.request("RespondToAuthChallenge", s, (function (e, n) {
                return e ? t.onFailure(e) : r.authenticateUserInternal(n, o, t)
            }))
        }, t.sendMFACode = function (e, t, n, r) {
            var i = this, o = {};
            o.USERNAME = this.username, o.SMS_MFA_CODE = e;
            var s = n || "SMS_MFA";
            "SOFTWARE_TOKEN_MFA" === s && (o.SOFTWARE_TOKEN_MFA_CODE = e), null != this.deviceKey && (o.DEVICE_KEY = this.deviceKey);
            var a = {
                ChallengeName: s,
                ChallengeResponses: o,
                ClientId: this.pool.getClientId(),
                Session: this.Session,
                ClientMetadata: r
            };
            this.getUserContextData() && (a.UserContextData = this.getUserContextData()), this.client.request("RespondToAuthChallenge", a, (function (e, n) {
                if (e) return t.onFailure(e);
                if ("DEVICE_SRP_AUTH" !== n.ChallengeName) {
                    if (i.signInUserSession = i.getCognitoUserSession(n.AuthenticationResult), i.cacheTokens(), null == n.AuthenticationResult.NewDeviceMetadata) return t.onSuccess(i.signInUserSession);
                    var r = new Ea(i.pool.getUserPoolId().split("_")[1]);
                    r.generateHashDevice(n.AuthenticationResult.NewDeviceMetadata.DeviceGroupKey, n.AuthenticationResult.NewDeviceMetadata.DeviceKey, (function (e) {
                        if (e) return t.onFailure(e);
                        var o = {
                            Salt: Bs.Buffer.from(r.getSaltDevices(), "hex").toString("base64"),
                            PasswordVerifier: Bs.Buffer.from(r.getVerifierDevices(), "hex").toString("base64")
                        };
                        i.verifierDevices = o.PasswordVerifier, i.deviceGroupKey = n.AuthenticationResult.NewDeviceMetadata.DeviceGroupKey, i.randomPassword = r.getRandomPassword(), i.client.request("ConfirmDevice", {
                            DeviceKey: n.AuthenticationResult.NewDeviceMetadata.DeviceKey,
                            AccessToken: i.signInUserSession.getAccessToken().getJwtToken(),
                            DeviceSecretVerifierConfig: o,
                            DeviceName: ja
                        }, (function (e, r) {
                            return e ? t.onFailure(e) : (i.deviceKey = n.AuthenticationResult.NewDeviceMetadata.DeviceKey, i.cacheDeviceKeyAndPassword(), !0 === r.UserConfirmationNecessary ? t.onSuccess(i.signInUserSession, r.UserConfirmationNecessary) : t.onSuccess(i.signInUserSession))
                        }))
                    }))
                } else i.getDeviceResponse(t)
            }))
        }, t.changePassword = function (e, t, n, r) {
            if (null == this.signInUserSession || !this.signInUserSession.isValid()) return n(new Error("User is not authenticated"), null);
            this.client.request("ChangePassword", {
                PreviousPassword: e,
                ProposedPassword: t,
                AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
                ClientMetadata: r
            }, (function (e) {
                return e ? n(e, null) : n(null, "SUCCESS")
            }))
        }, t.enableMFA = function (e) {
            if (null == this.signInUserSession || !this.signInUserSession.isValid()) return e(new Error("User is not authenticated"), null);
            var t = [];
            t.push({
                DeliveryMedium: "SMS",
                AttributeName: "phone_number"
            }), this.client.request("SetUserSettings", {
                MFAOptions: t,
                AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
            }, (function (t) {
                return t ? e(t, null) : e(null, "SUCCESS")
            }))
        }, t.setUserMfaPreference = function (e, t, n) {
            if (null == this.signInUserSession || !this.signInUserSession.isValid()) return n(new Error("User is not authenticated"), null);
            this.client.request("SetUserMFAPreference", {
                SMSMfaSettings: e,
                SoftwareTokenMfaSettings: t,
                AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
            }, (function (e) {
                return e ? n(e, null) : n(null, "SUCCESS")
            }))
        }, t.disableMFA = function (e) {
            if (null == this.signInUserSession || !this.signInUserSession.isValid()) return e(new Error("User is not authenticated"), null);
            this.client.request("SetUserSettings", {
                MFAOptions: [],
                AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
            }, (function (t) {
                return t ? e(t, null) : e(null, "SUCCESS")
            }))
        }, t.deleteUser = function (e, t) {
            var n = this;
            if (null == this.signInUserSession || !this.signInUserSession.isValid()) return e(new Error("User is not authenticated"), null);
            this.client.request("DeleteUser", {
                AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
                ClientMetadata: t
            }, (function (t) {
                return t ? e(t, null) : (n.clearCachedUser(), e(null, "SUCCESS"))
            }))
        }, t.updateAttributes = function (e, t, n) {
            var r = this;
            if (null == this.signInUserSession || !this.signInUserSession.isValid()) return t(new Error("User is not authenticated"), null);
            this.client.request("UpdateUserAttributes", {
                AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
                UserAttributes: e,
                ClientMetadata: n
            }, (function (e) {
                return e ? t(e, null) : r.getUserData((function () {
                    return t(null, "SUCCESS")
                }), {bypassCache: !0})
            }))
        }, t.getUserAttributes = function (e) {
            if (null == this.signInUserSession || !this.signInUserSession.isValid()) return e(new Error("User is not authenticated"), null);
            this.client.request("GetUser", {AccessToken: this.signInUserSession.getAccessToken().getJwtToken()}, (function (t, n) {
                if (t) return e(t, null);
                for (var r = [], i = 0; i < n.UserAttributes.length; i++) {
                    var o = {Name: n.UserAttributes[i].Name, Value: n.UserAttributes[i].Value}, s = new Ra(o);
                    r.push(s)
                }
                return e(null, r)
            }))
        }, t.getMFAOptions = function (e) {
            if (null == this.signInUserSession || !this.signInUserSession.isValid()) return e(new Error("User is not authenticated"), null);
            this.client.request("GetUser", {AccessToken: this.signInUserSession.getAccessToken().getJwtToken()}, (function (t, n) {
                return t ? e(t, null) : e(null, n.MFAOptions)
            }))
        }, t.createGetUserRequest = function () {
            return this.client.promisifyRequest("GetUser", {AccessToken: this.signInUserSession.getAccessToken().getJwtToken()})
        }, t.refreshSessionIfPossible = function (e) {
            var t = this;
            return void 0 === e && (e = {}), new Promise((function (n) {
                var r = t.signInUserSession.getRefreshToken();
                r && r.getToken() ? t.refreshSession(r, n, e.clientMetadata) : n()
            }))
        }, t.getUserData = function (e, t) {
            var n = this;
            if (null == this.signInUserSession || !this.signInUserSession.isValid()) return this.clearCachedUserData(), e(new Error("User is not authenticated"), null);
            var r = this.getUserDataFromCache();
            if (r) if (this.isFetchUserDataAndTokenRequired(t)) this.fetchUserData().then((function (e) {
                return n.refreshSessionIfPossible(t).then((function () {
                    return e
                }))
            })).then((function (t) {
                return e(null, t)
            })).catch(e); else try {
                return void e(null, JSON.parse(r))
            } catch (t) {
                return this.clearCachedUserData(), void e(t, null)
            } else this.fetchUserData().then((function (t) {
                e(null, t)
            })).catch(e)
        }, t.getUserDataFromCache = function () {
            return this.storage.getItem(this.userDataKey)
        }, t.isFetchUserDataAndTokenRequired = function (e) {
            var t = (e || {}).bypassCache;
            return void 0 !== t && t
        }, t.fetchUserData = function () {
            var e = this;
            return this.createGetUserRequest().then((function (t) {
                return e.cacheUserData(t), t
            }))
        }, t.deleteAttributes = function (e, t) {
            var n = this;
            if (null == this.signInUserSession || !this.signInUserSession.isValid()) return t(new Error("User is not authenticated"), null);
            this.client.request("DeleteUserAttributes", {
                UserAttributeNames: e,
                AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
            }, (function (e) {
                return e ? t(e, null) : n.getUserData((function () {
                    return t(null, "SUCCESS")
                }), {bypassCache: !0})
            }))
        }, t.resendConfirmationCode = function (e, t) {
            var n = {ClientId: this.pool.getClientId(), Username: this.username, ClientMetadata: t};
            this.client.request("ResendConfirmationCode", n, (function (t, n) {
                return t ? e(t, null) : e(null, n)
            }))
        }, t.getSession = function (e, t) {
            if (void 0 === t && (t = {}), null == this.username) return e(new Error("Username is null. Cannot retrieve a new session"), null);
            if (null != this.signInUserSession && this.signInUserSession.isValid()) return e(null, this.signInUserSession);
            var n = "CognitoIdentityServiceProvider." + this.pool.getClientId() + "." + this.username, r = n + ".idToken",
                i = n + ".accessToken", o = n + ".refreshToken", s = n + ".clockDrift";
            if (this.storage.getItem(r)) {
                var a = new ka({IdToken: this.storage.getItem(r)}), u = new Aa({AccessToken: this.storage.getItem(i)}),
                    c = new xa({RefreshToken: this.storage.getItem(o)}), l = parseInt(this.storage.getItem(s), 0) || 0,
                    f = new Ua({IdToken: a, AccessToken: u, RefreshToken: c, ClockDrift: l});
                if (f.isValid()) return this.signInUserSession = f, e(null, this.signInUserSession);
                if (!c.getToken()) return e(new Error("Cannot retrieve a new session. Please authenticate."), null);
                this.refreshSession(c, e, t.clientMetadata)
            } else e(new Error("Local storage is missing an ID Token, Please authenticate"), null)
        }, t.refreshSession = function (e, t, n) {
            var r = this, i = this.pool.wrapRefreshSessionCallback ? this.pool.wrapRefreshSessionCallback(t) : t, o = {};
            o.REFRESH_TOKEN = e.getToken();
            var s = "CognitoIdentityServiceProvider." + this.pool.getClientId(), a = s + ".LastAuthUser";
            if (this.storage.getItem(a)) {
                this.username = this.storage.getItem(a);
                var u = s + "." + this.username + ".deviceKey";
                this.deviceKey = this.storage.getItem(u), o.DEVICE_KEY = this.deviceKey
            }
            var c = {
                ClientId: this.pool.getClientId(),
                AuthFlow: "REFRESH_TOKEN_AUTH",
                AuthParameters: o,
                ClientMetadata: n
            };
            this.getUserContextData() && (c.UserContextData = this.getUserContextData()), this.client.request("InitiateAuth", c, (function (t, n) {
                if (t) return "NotAuthorizedException" === t.code && r.clearCachedUser(), i(t, null);
                if (n) {
                    var o = n.AuthenticationResult;
                    return Object.prototype.hasOwnProperty.call(o, "RefreshToken") || (o.RefreshToken = e.getToken()), r.signInUserSession = r.getCognitoUserSession(o), r.cacheTokens(), i(null, r.signInUserSession)
                }
            }))
        }, t.cacheTokens = function () {
            var e = "CognitoIdentityServiceProvider." + this.pool.getClientId(), t = e + "." + this.username + ".idToken",
                n = e + "." + this.username + ".accessToken", r = e + "." + this.username + ".refreshToken",
                i = e + "." + this.username + ".clockDrift", o = e + ".LastAuthUser";
            this.storage.setItem(t, this.signInUserSession.getIdToken().getJwtToken()), this.storage.setItem(n, this.signInUserSession.getAccessToken().getJwtToken()), this.storage.setItem(r, this.signInUserSession.getRefreshToken().getToken()), this.storage.setItem(i, "" + this.signInUserSession.getClockDrift()), this.storage.setItem(o, this.username)
        }, t.cacheUserData = function (e) {
            this.storage.setItem(this.userDataKey, JSON.stringify(e))
        }, t.clearCachedUserData = function () {
            this.storage.removeItem(this.userDataKey)
        }, t.clearCachedUser = function () {
            this.clearCachedTokens(), this.clearCachedUserData()
        }, t.cacheDeviceKeyAndPassword = function () {
            var e = "CognitoIdentityServiceProvider." + this.pool.getClientId() + "." + this.username, t = e + ".deviceKey",
                n = e + ".randomPasswordKey", r = e + ".deviceGroupKey";
            this.storage.setItem(t, this.deviceKey), this.storage.setItem(n, this.randomPassword), this.storage.setItem(r, this.deviceGroupKey)
        }, t.getCachedDeviceKeyAndPassword = function () {
            var e = "CognitoIdentityServiceProvider." + this.pool.getClientId() + "." + this.username, t = e + ".deviceKey",
                n = e + ".randomPasswordKey", r = e + ".deviceGroupKey";
            this.storage.getItem(t) && (this.deviceKey = this.storage.getItem(t), this.randomPassword = this.storage.getItem(n), this.deviceGroupKey = this.storage.getItem(r))
        }, t.clearCachedDeviceKeyAndPassword = function () {
            var e = "CognitoIdentityServiceProvider." + this.pool.getClientId() + "." + this.username, t = e + ".deviceKey",
                n = e + ".randomPasswordKey", r = e + ".deviceGroupKey";
            this.storage.removeItem(t), this.storage.removeItem(n), this.storage.removeItem(r)
        }, t.clearCachedTokens = function () {
            var e = "CognitoIdentityServiceProvider." + this.pool.getClientId(), t = e + "." + this.username + ".idToken",
                n = e + "." + this.username + ".accessToken", r = e + "." + this.username + ".refreshToken",
                i = e + ".LastAuthUser", o = e + "." + this.username + ".clockDrift";
            this.storage.removeItem(t), this.storage.removeItem(n), this.storage.removeItem(r), this.storage.removeItem(i), this.storage.removeItem(o)
        }, t.getCognitoUserSession = function (e) {
            var t = new ka(e), n = new Aa(e), r = new xa(e);
            return new Ua({IdToken: t, AccessToken: n, RefreshToken: r})
        }, t.forgotPassword = function (e, t) {
            var n = {ClientId: this.pool.getClientId(), Username: this.username, ClientMetadata: t};
            this.getUserContextData() && (n.UserContextData = this.getUserContextData()), this.client.request("ForgotPassword", n, (function (t, n) {
                return t ? e.onFailure(t) : "function" == typeof e.inputVerificationCode ? e.inputVerificationCode(n) : e.onSuccess(n)
            }))
        }, t.confirmPassword = function (e, t, n, r) {
            var i = {
                ClientId: this.pool.getClientId(),
                Username: this.username,
                ConfirmationCode: e,
                Password: t,
                ClientMetadata: r
            };
            this.getUserContextData() && (i.UserContextData = this.getUserContextData()), this.client.request("ConfirmForgotPassword", i, (function (e) {
                return e ? n.onFailure(e) : n.onSuccess("SUCCESS")
            }))
        }, t.getAttributeVerificationCode = function (e, t, n) {
            if (null == this.signInUserSession || !this.signInUserSession.isValid()) return t.onFailure(new Error("User is not authenticated"));
            this.client.request("GetUserAttributeVerificationCode", {
                AttributeName: e,
                AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
                ClientMetadata: n
            }, (function (e, n) {
                return e ? t.onFailure(e) : "function" == typeof t.inputVerificationCode ? t.inputVerificationCode(n) : t.onSuccess("SUCCESS")
            }))
        }, t.verifyAttribute = function (e, t, n) {
            if (null == this.signInUserSession || !this.signInUserSession.isValid()) return n.onFailure(new Error("User is not authenticated"));
            this.client.request("VerifyUserAttribute", {
                AttributeName: e,
                Code: t,
                AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
            }, (function (e) {
                return e ? n.onFailure(e) : n.onSuccess("SUCCESS")
            }))
        }, t.getDevice = function (e) {
            if (null == this.signInUserSession || !this.signInUserSession.isValid()) return e.onFailure(new Error("User is not authenticated"));
            this.client.request("GetDevice", {
                AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
                DeviceKey: this.deviceKey
            }, (function (t, n) {
                return t ? e.onFailure(t) : e.onSuccess(n)
            }))
        }, t.forgetSpecificDevice = function (e, t) {
            if (null == this.signInUserSession || !this.signInUserSession.isValid()) return t.onFailure(new Error("User is not authenticated"));
            this.client.request("ForgetDevice", {
                AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
                DeviceKey: e
            }, (function (e) {
                return e ? t.onFailure(e) : t.onSuccess("SUCCESS")
            }))
        }, t.forgetDevice = function (e) {
            var t = this;
            this.forgetSpecificDevice(this.deviceKey, {
                onFailure: e.onFailure, onSuccess: function (n) {
                    return t.deviceKey = null, t.deviceGroupKey = null, t.randomPassword = null, t.clearCachedDeviceKeyAndPassword(), e.onSuccess(n)
                }
            })
        }, t.setDeviceStatusRemembered = function (e) {
            if (null == this.signInUserSession || !this.signInUserSession.isValid()) return e.onFailure(new Error("User is not authenticated"));
            this.client.request("UpdateDeviceStatus", {
                AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
                DeviceKey: this.deviceKey,
                DeviceRememberedStatus: "remembered"
            }, (function (t) {
                return t ? e.onFailure(t) : e.onSuccess("SUCCESS")
            }))
        }, t.setDeviceStatusNotRemembered = function (e) {
            if (null == this.signInUserSession || !this.signInUserSession.isValid()) return e.onFailure(new Error("User is not authenticated"));
            this.client.request("UpdateDeviceStatus", {
                AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
                DeviceKey: this.deviceKey,
                DeviceRememberedStatus: "not_remembered"
            }, (function (t) {
                return t ? e.onFailure(t) : e.onSuccess("SUCCESS")
            }))
        }, t.listDevices = function (e, t, n) {
            if (null == this.signInUserSession || !this.signInUserSession.isValid()) return n.onFailure(new Error("User is not authenticated"));
            var r = {AccessToken: this.signInUserSession.getAccessToken().getJwtToken(), Limit: e};
            t && (r.PaginationToken = t), this.client.request("ListDevices", r, (function (e, t) {
                return e ? n.onFailure(e) : n.onSuccess(t)
            }))
        }, t.globalSignOut = function (e) {
            var t = this;
            if (null == this.signInUserSession || !this.signInUserSession.isValid()) return e.onFailure(new Error("User is not authenticated"));
            this.client.request("GlobalSignOut", {AccessToken: this.signInUserSession.getAccessToken().getJwtToken()}, (function (n) {
                return n ? e.onFailure(n) : (t.clearCachedUser(), e.onSuccess("SUCCESS"))
            }))
        }, t.signOut = function (e) {
            var t = this;
            e && "function" == typeof e ? this.getSession((function (n, r) {
                if (n) return e(n);
                t.revokeTokens((function (n) {
                    t.cleanClientData(), e(n)
                }))
            })) : this.cleanClientData()
        }, t.revokeTokens = function (e) {
            if (void 0 === e && (e = function () {
            }), "function" != typeof e) throw new Error("Invalid revokeTokenCallback. It should be a function.");
            if (!this.signInUserSession) return e(new Error("User is not authenticated"));
            if (!this.signInUserSession.getAccessToken()) return e(new Error("No Access token available"));
            var t = this.signInUserSession.getRefreshToken().getToken(), n = this.signInUserSession.getAccessToken();
            if (this.isSessionRevocable(n) && t) return this.revokeToken({token: t, callback: e});
            e()
        }, t.isSessionRevocable = function (e) {
            if (e && "function" == typeof e.decodePayload) try {
                return !!e.decodePayload().origin_jti
            } catch (e) {
            }
            return !1
        }, t.cleanClientData = function () {
            this.signInUserSession = null, this.clearCachedUser()
        }, t.revokeToken = function (e) {
            var t = e.token, n = e.callback;
            this.client.requestWithRetry("RevokeToken", {Token: t, ClientId: this.pool.getClientId()}, (function (e) {
                if (e) return n(e);
                n()
            }))
        }, t.sendMFASelectionAnswer = function (e, t) {
            var n = this, r = {};
            r.USERNAME = this.username, r.ANSWER = e;
            var i = {
                ChallengeName: "SELECT_MFA_TYPE",
                ChallengeResponses: r,
                ClientId: this.pool.getClientId(),
                Session: this.Session
            };
            this.getUserContextData() && (i.UserContextData = this.getUserContextData()), this.client.request("RespondToAuthChallenge", i, (function (r, i) {
                return r ? t.onFailure(r) : (n.Session = i.Session, "SMS_MFA" === e ? t.mfaRequired(i.ChallengeName, i.ChallengeParameters) : "SOFTWARE_TOKEN_MFA" === e ? t.totpRequired(i.ChallengeName, i.ChallengeParameters) : void 0)
            }))
        }, t.getUserContextData = function () {
            return this.pool.getUserContextData(this.username)
        }, t.associateSoftwareToken = function (e) {
            var t = this;
            null != this.signInUserSession && this.signInUserSession.isValid() ? this.client.request("AssociateSoftwareToken", {AccessToken: this.signInUserSession.getAccessToken().getJwtToken()}, (function (t, n) {
                return t ? e.onFailure(t) : e.associateSecretCode(n.SecretCode)
            })) : this.client.request("AssociateSoftwareToken", {Session: this.Session}, (function (n, r) {
                return n ? e.onFailure(n) : (t.Session = r.Session, e.associateSecretCode(r.SecretCode))
            }))
        }, t.verifySoftwareToken = function (e, t, n) {
            var r = this;
            null != this.signInUserSession && this.signInUserSession.isValid() ? this.client.request("VerifySoftwareToken", {
                AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
                UserCode: e,
                FriendlyDeviceName: t
            }, (function (e, t) {
                return e ? n.onFailure(e) : n.onSuccess(t)
            })) : this.client.request("VerifySoftwareToken", {
                Session: this.Session,
                UserCode: e,
                FriendlyDeviceName: t
            }, (function (e, t) {
                if (e) return n.onFailure(e);
                r.Session = t.Session;
                var i = {};
                i.USERNAME = r.username;
                var o = {
                    ChallengeName: "MFA_SETUP",
                    ClientId: r.pool.getClientId(),
                    ChallengeResponses: i,
                    Session: r.Session
                };
                r.getUserContextData() && (o.UserContextData = r.getUserContextData()), r.client.request("RespondToAuthChallenge", o, (function (e, t) {
                    return e ? n.onFailure(e) : (r.signInUserSession = r.getCognitoUserSession(t.AuthenticationResult), r.cacheTokens(), n.onSuccess(r.signInUserSession))
                }))
            }))
        }, e
    }();
var za = Object.freeze({
    __proto__: null, default: function (e, t) {
        return t = t || {}, new Promise((function (n, r) {
            var i = new XMLHttpRequest, o = [], s = [], a = {}, u = function () {
                return {
                    ok: 2 == (i.status / 100 | 0),
                    statusText: i.statusText,
                    status: i.status,
                    url: i.responseURL,
                    text: function () {
                        return Promise.resolve(i.responseText)
                    },
                    json: function () {
                        return Promise.resolve(i.responseText).then(JSON.parse)
                    },
                    blob: function () {
                        return Promise.resolve(new Blob([i.response]))
                    },
                    clone: u,
                    headers: {
                        keys: function () {
                            return o
                        }, entries: function () {
                            return s
                        }, get: function (e) {
                            return a[e.toLowerCase()]
                        }, has: function (e) {
                            return e.toLowerCase() in a
                        }
                    }
                }
            };
            for (var c in i.open(t.method || "get", e, !0), i.onload = function () {
                i.getAllResponseHeaders().replace(/^(.*?):[^\S\n]*([\s\S]*?)$/gm, (function (e, t, n) {
                    o.push(t = t.toLowerCase()), s.push([t, n]), a[t] = a[t] ? a[t] + "," + n : n
                })), n(u())
            }, i.onerror = r, i.withCredentials = "include" == t.credentials, t.headers) i.setRequestHeader(c, t.headers[c]);
            i.send(t.body || null)
        }))
    }
}), Ka = L(za);
self.fetch || (self.fetch = Ka.default || Ka);
var qa = {userAgent: "aws-amplify/5.0.4 js", product: "", navigator: null, isReactNative: !1};
if ("undefined" != typeof navigator && navigator.product) if (qa.product = navigator.product || "", qa.navigator = navigator || null, "ReactNative" === navigator.product) qa.userAgent = "aws-amplify/5.0.4 react-native", qa.isReactNative = !0; else qa.userAgent = "aws-amplify/5.0.4 js", qa.isReactNative = !1;

function Ha() {
}

function Va(e) {
    var t = "function" == typeof Map ? new Map : void 0;
    return Va = function (e) {
        if (null === e || (n = e, -1 === Function.toString.call(n).indexOf("[native code]"))) return e;
        var n;
        if ("function" != typeof e) throw new TypeError("Super expression must either be null or a function");
        if (void 0 !== t) {
            if (t.has(e)) return t.get(e);
            t.set(e, r)
        }

        function r() {
            return Ga(e, arguments, Ya(this).constructor)
        }

        return r.prototype = Object.create(e.prototype, {
            constructor: {
                value: r,
                enumerable: !1,
                writable: !0,
                configurable: !0
            }
        }), $a(r, e)
    }, Va(e)
}

function Ga(e, t, n) {
    return Ga = Wa() ? Reflect.construct : function (e, t, n) {
        var r = [null];
        r.push.apply(r, t);
        var i = new (Function.bind.apply(e, r));
        return n && $a(i, n.prototype), i
    }, Ga.apply(null, arguments)
}

function Wa() {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;
    try {
        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], (function () {
        }))), !0
    } catch (e) {
        return !1
    }
}

function $a(e, t) {
    return $a = Object.setPrototypeOf || function (e, t) {
        return e.__proto__ = t, e
    }, $a(e, t)
}

function Ya(e) {
    return Ya = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e)
    }, Ya(e)
}

Ha.prototype.userAgent = qa.userAgent;
var Ja = function (e) {
    var t, n;

    function r(t, n, r, i) {
        var o;
        return (o = e.call(this, t) || this).code = n, o.name = r, o.statusCode = i, o
    }

    return n = e, (t = r).prototype = Object.create(n.prototype), t.prototype.constructor = t, $a(t, n), r
}(Va(Error)), Za = function () {
    function e(e, t, n) {
        this.endpoint = t || "https://cognito-idp." + e + ".amazonaws.com/";
        var r = (n || {}).credentials;
        this.fetchOptions = r ? {credentials: r} : {}
    }

    var t = e.prototype;
    return t.promisifyRequest = function (e, t) {
        var n = this;
        return new Promise((function (r, i) {
            n.request(e, t, (function (e, t) {
                e ? i(new Ja(e.message, e.code, e.name, e.statusCode)) : r(t)
            }))
        }))
    }, t.requestWithRetry = function (e, t, n) {
        var r = this;
        (function (e, t, n) {
            void 0 === n && (n = 3e5);
            return Qa(e, t, function (e) {
                var t = 100, n = 100;
                return function (r) {
                    var i = Math.pow(2, r) * t + n * Math.random();
                    return !(i > e) && i
                }
            }(n))
        })((function (t) {
            return new Promise((function (n, i) {
                r.request(e, t, (function (e, t) {
                    e ? i(e) : n(t)
                }))
            }))
        }), [t], 5e3).then((function (e) {
            return n(null, e)
        })).catch((function (e) {
            return n(e)
        }))
    }, t.request = function (e, t, n) {
        var r, i = {
            "Content-Type": "application/x-amz-json-1.1",
            "X-Amz-Target": "AWSCognitoIdentityProviderService." + e,
            "X-Amz-User-Agent": Ha.prototype.userAgent
        }, o = Object.assign({}, this.fetchOptions, {
            headers: i,
            method: "POST",
            mode: "cors",
            cache: "no-cache",
            body: JSON.stringify(t)
        });
        fetch(this.endpoint, o).then((function (e) {
            return r = e, e
        }), (function (e) {
            if (e instanceof TypeError) throw new Error("Network error");
            throw e
        })).then((function (e) {
            return e.json().catch((function () {
                return {}
            }))
        })).then((function (e) {
            if (r.ok) return n(null, e);
            var t = (e.__type || e.code).split("#").pop(), i = new Error(e.message || e.Message || null);
            return i.name = t, i.code = t, n(i)
        })).catch((function (e) {
            if (r && r.headers && r.headers.get("x-amzn-errortype")) try {
                var t = r.headers.get("x-amzn-errortype").split(":")[0],
                    i = new Error(r.status ? r.status.toString() : null);
                return i.code = t, i.name = t, i.statusCode = r.status, n(i)
            } catch (t) {
                return n(e)
            } else e instanceof Error && "Network error" === e.message && (e.code = "NetworkError");
            return n(e)
        }))
    }, e
}(), Xa = function () {
};

function Qa(e, t, n, r) {
    if (void 0 === r && (r = 1), "function" != typeof e) throw Error("functionToRetry must be a function");
    return Xa(e.name + " attempt #" + r + " with args: " + JSON.stringify(t)), e.apply(void 0, t).catch((function (i) {
        if (Xa("error on " + e.name, i), (o = i) && o.nonRetryable) throw Xa(e.name + " non retryable error", i), i;
        var o, s = n(r, t, i);
        if (Xa(e.name + " retrying in " + s + " ms"), !1 !== s) return new Promise((function (e) {
            return setTimeout(e, s)
        })).then((function () {
            return Qa(e, t, n, r + 1)
        }));
        throw i
    }))
}

var eu, tu = function () {
    function e(e, t) {
        var n = e || {}, r = n.UserPoolId, i = n.ClientId, o = n.endpoint, s = n.fetchOptions,
            a = n.AdvancedSecurityDataCollectionFlag;
        if (!r || !i) throw new Error("Both UserPoolId and ClientId are required.");
        if (r.length > 55 || !/^[\w-]+_[0-9a-zA-Z]+$/.test(r)) throw new Error("Invalid UserPoolId format.");
        var u = r.split("_")[0];
        this.userPoolId = r, this.clientId = i, this.client = new Za(u, o, s), this.advancedSecurityDataCollectionFlag = !1 !== a, this.storage = e.Storage || (new Ba).getStorage(), t && (this.wrapRefreshSessionCallback = t)
    }

    var t = e.prototype;
    return t.getUserPoolId = function () {
        return this.userPoolId
    }, t.getClientId = function () {
        return this.clientId
    }, t.signUp = function (e, t, n, r, i, o) {
        var s = this, a = {
            ClientId: this.clientId,
            Username: e,
            Password: t,
            UserAttributes: n,
            ValidationData: r,
            ClientMetadata: o
        };
        this.getUserContextData(e) && (a.UserContextData = this.getUserContextData(e)), this.client.request("SignUp", a, (function (t, n) {
            if (t) return i(t, null);
            var r = {Username: e, Pool: s, Storage: s.storage}, o = {
                user: new Fa(r),
                userConfirmed: n.UserConfirmed,
                userSub: n.UserSub,
                codeDeliveryDetails: n.CodeDeliveryDetails
            };
            return i(null, o)
        }))
    }, t.getCurrentUser = function () {
        var e = "CognitoIdentityServiceProvider." + this.clientId + ".LastAuthUser", t = this.storage.getItem(e);
        if (t) {
            var n = {Username: t, Pool: this, Storage: this.storage};
            return new Fa(n)
        }
        return null
    }, t.getUserContextData = function (e) {
        if ("undefined" != typeof AmazonCognitoAdvancedSecurityData) {
            var t = AmazonCognitoAdvancedSecurityData;
            if (this.advancedSecurityDataCollectionFlag) {
                var n = t.getData(e, this.userPoolId, this.clientId);
                if (n) return {EncodedData: n}
            }
            return {}
        }
    }, e
}(), nu = {exports: {}};
eu = function () {
    function e() {
        for (var e = 0, t = {}; e < arguments.length; e++) {
            var n = arguments[e];
            for (var r in n) t[r] = n[r]
        }
        return t
    }

    function t(e) {
        return e.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent)
    }

    return function n(r) {
        function i() {
        }

        function o(t, n, o) {
            if ("undefined" != typeof document) {
                "number" == typeof (o = e({path: "/"}, i.defaults, o)).expires && (o.expires = new Date(1 * new Date + 864e5 * o.expires)), o.expires = o.expires ? o.expires.toUTCString() : "";
                try {
                    var s = JSON.stringify(n);
                    /^[\{\[]/.test(s) && (n = s)
                } catch (e) {
                }
                n = r.write ? r.write(n, t) : encodeURIComponent(String(n)).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent), t = encodeURIComponent(String(t)).replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent).replace(/[\(\)]/g, escape);
                var a = "";
                for (var u in o) o[u] && (a += "; " + u, !0 !== o[u] && (a += "=" + o[u].split(";")[0]));
                return document.cookie = t + "=" + n + a
            }
        }

        function s(e, n) {
            if ("undefined" != typeof document) {
                for (var i = {}, o = document.cookie ? document.cookie.split("; ") : [], s = 0; s < o.length; s++) {
                    var a = o[s].split("="), u = a.slice(1).join("=");
                    n || '"' !== u.charAt(0) || (u = u.slice(1, -1));
                    try {
                        var c = t(a[0]);
                        if (u = (r.read || r)(u, c) || t(u), n) try {
                            u = JSON.parse(u)
                        } catch (e) {
                        }
                        if (i[c] = u, e === c) break
                    } catch (e) {
                    }
                }
                return e ? i[e] : i
            }
        }

        return i.set = o, i.get = function (e) {
            return s(e, !1)
        }, i.getJSON = function (e) {
            return s(e, !0)
        }, i.remove = function (t, n) {
            o(t, "", e(n, {expires: -1}))
        }, i.defaults = {}, i.withConverter = n, i
    }((function () {
    }))
}, nu.exports = eu();
var ru, iu = function () {
        function e(e) {
            if (!e.domain) throw new Error("The domain of cookieStorage can not be undefined.");
            if (this.domain = e.domain, e.path ? this.path = e.path : this.path = "/", Object.prototype.hasOwnProperty.call(e, "expires") ? this.expires = e.expires : this.expires = 365, Object.prototype.hasOwnProperty.call(e, "secure") ? this.secure = e.secure : this.secure = !0, Object.prototype.hasOwnProperty.call(e, "sameSite")) {
                if (!["strict", "lax", "none"].includes(e.sameSite)) throw new Error('The sameSite value of cookieStorage must be "lax", "strict" or "none".');
                if ("none" === e.sameSite && !this.secure) throw new Error("sameSite = None requires the Secure attribute in latest browser versions.");
                this.sameSite = e.sameSite
            } else this.sameSite = null
        }

        var t = e.prototype;
        return t.setItem = function (e, t) {
            var n = {path: this.path, expires: this.expires, domain: this.domain, secure: this.secure};
            return this.sameSite && (n.sameSite = this.sameSite), nu.exports.set(e, t, n), nu.exports.get(e)
        }, t.getItem = function (e) {
            return nu.exports.get(e)
        }, t.removeItem = function (e) {
            var t = {path: this.path, expires: this.expires, domain: this.domain, secure: this.secure};
            return this.sameSite && (t.sameSite = this.sameSite), nu.exports.remove(e, t)
        }, t.clear = function () {
            for (var e = nu.exports.get(), t = Object.keys(e).length, n = 0; n < t; ++n) this.removeItem(Object.keys(e)[n]);
            return {}
        }, e
    }(), ou = function (e) {
        var t = window.open(e, "_self");
        return t ? Promise.resolve(t) : Promise.reject()
    }, su = function () {
        return su = Object.assign || function (e) {
            for (var t, n = 1, r = arguments.length; n < r; n++) for (var i in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
            return e
        }, su.apply(this, arguments)
    }, au = function (e, t, n, r) {
        return new (n || (n = Promise))((function (i, o) {
            function s(e) {
                try {
                    u(r.next(e))
                } catch (e) {
                    o(e)
                }
            }

            function a(e) {
                try {
                    u(r.throw(e))
                } catch (e) {
                    o(e)
                }
            }

            function u(e) {
                var t;
                e.done ? i(e.value) : (t = e.value, t instanceof n ? t : new n((function (e) {
                    e(t)
                }))).then(s, a)
            }

            u((r = r.apply(e, t || [])).next())
        }))
    }, uu = function (e, t) {
        var n, r, i, o, s = {
            label: 0, sent: function () {
                if (1 & i[0]) throw i[1];
                return i[1]
            }, trys: [], ops: []
        };
        return o = {
            next: a(0),
            throw: a(1),
            return: a(2)
        }, "function" == typeof Symbol && (o[Symbol.iterator] = function () {
            return this
        }), o;

        function a(o) {
            return function (a) {
                return function (o) {
                    if (n) throw new TypeError("Generator is already executing.");
                    for (; s;) try {
                        if (n = 1, r && (i = 2 & o[0] ? r.return : o[0] ? r.throw || ((i = r.return) && i.call(r), 0) : r.next) && !(i = i.call(r, o[1])).done) return i;
                        switch (r = 0, i && (o = [2 & o[0], i.value]), o[0]) {
                            case 0:
                            case 1:
                                i = o;
                                break;
                            case 4:
                                return s.label++, {value: o[1], done: !1};
                            case 5:
                                s.label++, r = o[1], o = [0];
                                continue;
                            case 7:
                                o = s.ops.pop(), s.trys.pop();
                                continue;
                            default:
                                if (!(i = s.trys, (i = i.length > 0 && i[i.length - 1]) || 6 !== o[0] && 2 !== o[0])) {
                                    s = 0;
                                    continue
                                }
                                if (3 === o[0] && (!i || o[1] > i[0] && o[1] < i[3])) {
                                    s.label = o[1];
                                    break
                                }
                                if (6 === o[0] && s.label < i[1]) {
                                    s.label = i[1], i = o;
                                    break
                                }
                                if (i && s.label < i[2]) {
                                    s.label = i[2], s.ops.push(o);
                                    break
                                }
                                i[2] && s.ops.pop(), s.trys.pop();
                                continue
                        }
                        o = t.call(e, s)
                    } catch (e) {
                        o = [6, e], r = 0
                    } finally {
                        n = i = 0
                    }
                    if (5 & o[0]) throw o[1];
                    return {value: o[0] ? o[1] : void 0, done: !0}
                }([o, a])
            }
        }
    }, cu = function (e, t) {
        var n = "function" == typeof Symbol && e[Symbol.iterator];
        if (!n) return e;
        var r, i, o = n.call(e), s = [];
        try {
            for (; (void 0 === t || t-- > 0) && !(r = o.next()).done;) s.push(r.value)
        } catch (e) {
            i = {error: e}
        } finally {
            try {
                r && !r.done && (n = o.return) && n.call(o)
            } finally {
                if (i) throw i.error
            }
        }
        return s
    },
    lu = "undefined" != typeof Symbol && "function" == typeof Symbol.for ? Symbol.for("amplify_default") : "@@amplify_default",
    fu = function (e, t, n) {
        m.dispatch("auth", {event: e, data: t, message: n}, "Auth", lu)
    }, du = new o("OAuth"), hu = function () {
        function e(e) {
            var t = e.config, n = e.cognitoClientId, r = e.scopes, i = void 0 === r ? [] : r;
            if (this._urlOpener = t.urlOpener || ou, this._config = t, this._cognitoClientId = n, !this.isValidScopes(i)) throw Error("scopes must be a String Array");
            this._scopes = i
        }

        return e.prototype.isValidScopes = function (e) {
            return Array.isArray(e) && e.every((function (e) {
                return "string" == typeof e
            }))
        }, e.prototype.oauthSignIn = function (e, t, n, r, i, o) {
            void 0 === e && (e = "code"), void 0 === i && (i = xs.Cognito);
            var s = this._generateState(32), a = o ? s + "-" + o.split("").map((function (e) {
                return e.charCodeAt(0).toString(16).padStart(2, "0")
            })).join("") : s;
            !function (e) {
                window.sessionStorage.setItem("oauth_state", e)
            }(a);
            var u, c = this._generateRandom(128);
            u = c, window.sessionStorage.setItem("ouath_pkce_key", u);
            var l = this._generateChallenge(c), f = this._scopes.join(" "),
                d = "https://" + t + "/oauth2/authorize?" + Object.entries(su(su({
                    redirect_uri: n,
                    response_type: e,
                    client_id: r,
                    identity_provider: i,
                    scope: f,
                    state: a
                }, "code" === e ? {code_challenge: l} : {}), "code" === e ? {code_challenge_method: "S256"} : {})).map((function (e) {
                    var t = cu(e, 2), n = t[0], r = t[1];
                    return encodeURIComponent(n) + "=" + encodeURIComponent(r)
                })).join("&");
            du.debug("Redirecting to " + d), this._urlOpener(d, n)
        }, e.prototype._handleCodeFlow = function (e) {
            return au(this, void 0, void 0, (function () {
                var t, n, r, i, o, s, a, u, c, l, f, d, h, p;
                return uu(this, (function (g) {
                    switch (g.label) {
                        case 0:
                            return t = (se(e).query || "").split("&").map((function (e) {
                                return e.split("=")
                            })).reduce((function (e, t) {
                                var n, r = cu(t, 2), i = r[0], o = r[1];
                                return su(su({}, e), ((n = {})[i] = o, n))
                            }), {code: void 0}).code, n = se(e).pathname || "/", r = se(this._config.redirectSignIn).pathname || "/", t && n === r ? (i = "https://" + this._config.domain + "/oauth2/token", fu("codeFlow", {}, "Retrieving tokens from " + i), o = Ns(this._config) ? this._cognitoClientId : this._config.clientID, s = Ns(this._config) ? this._config.redirectSignIn : this._config.redirectUri, v = window.sessionStorage.getItem("ouath_pkce_key"), window.sessionStorage.removeItem("ouath_pkce_key"), u = su({
                                grant_type: "authorization_code",
                                code: t,
                                client_id: o,
                                redirect_uri: s
                            }, (a = v) ? {code_verifier: a} : {}), du.debug("Calling token endpoint: " + i + " with", u), c = Object.entries(u).map((function (e) {
                                var t = cu(e, 2), n = t[0], r = t[1];
                                return encodeURIComponent(n) + "=" + encodeURIComponent(r)
                            })).join("&"), [4, fetch(i, {
                                method: "POST",
                                headers: {"Content-Type": "application/x-www-form-urlencoded"},
                                body: c
                            })]) : [2];
                        case 1:
                            return [4, g.sent().json()];
                        case 2:
                            if (l = g.sent(), f = l.access_token, d = l.refresh_token, h = l.id_token, p = l.error) throw new Error(p);
                            return [2, {accessToken: f, refreshToken: d, idToken: h}]
                    }
                    var v
                }))
            }))
        }, e.prototype._handleImplicitFlow = function (e) {
            return au(this, void 0, void 0, (function () {
                var t, n, r;
                return uu(this, (function (i) {
                    return t = (se(e).hash || "#").substr(1).split("&").map((function (e) {
                        return e.split("=")
                    })).reduce((function (e, t) {
                        var n, r = cu(t, 2), i = r[0], o = r[1];
                        return su(su({}, e), ((n = {})[i] = o, n))
                    }), {
                        id_token: void 0,
                        access_token: void 0
                    }), n = t.id_token, r = t.access_token, fu("implicitFlow", {}, "Got tokens from " + e), du.debug("Retrieving implicit tokens from " + e + " with"), [2, {
                        accessToken: r,
                        idToken: n,
                        refreshToken: null
                    }]
                }))
            }))
        }, e.prototype.handleAuthResponse = function (e) {
            return au(this, void 0, void 0, (function () {
                var t, n, r, i, o, s, a;
                return uu(this, (function (u) {
                    switch (u.label) {
                        case 0:
                            if (u.trys.push([0, 5, , 6]), t = e ? su(su({}, (se(e).hash || "#").substr(1).split("&").map((function (e) {
                                return e.split("=")
                            })).reduce((function (e, t) {
                                var n = cu(t, 2), r = n[0], i = n[1];
                                return e[r] = i, e
                            }), {})), (se(e).query || "").split("&").map((function (e) {
                                return e.split("=")
                            })).reduce((function (e, t) {
                                var n = cu(t, 2), r = n[0], i = n[1];
                                return e[r] = i, e
                            }), {})) : {}, n = t.error, r = t.error_description, n) throw new Error(r);
                            return i = this._validateState(t), du.debug("Starting " + this._config.responseType + " flow with " + e), "code" !== this._config.responseType ? [3, 2] : (o = [{}], [4, this._handleCodeFlow(e)]);
                        case 1:
                            return [2, su.apply(void 0, [su.apply(void 0, o.concat([u.sent()])), {state: i}])];
                        case 2:
                            return s = [{}], [4, this._handleImplicitFlow(e)];
                        case 3:
                            return [2, su.apply(void 0, [su.apply(void 0, s.concat([u.sent()])), {state: i}])];
                        case 4:
                            return [3, 6];
                        case 5:
                            throw a = u.sent(), du.error("Error handling auth response.", a), a;
                        case 6:
                            return [2]
                    }
                }))
            }))
        }, e.prototype._validateState = function (e) {
            if (e) {
                var t,
                    n = (t = window.sessionStorage.getItem("oauth_state"), window.sessionStorage.removeItem("oauth_state"), t),
                    r = e.state;
                if (n && n !== r) throw new Error("Invalid state in OAuth flow");
                return r
            }
        }, e.prototype.signOut = function () {
            return au(this, void 0, void 0, (function () {
                var e, t, n;
                return uu(this, (function (r) {
                    return e = "https://" + this._config.domain + "/logout?", t = Ns(this._config) ? this._cognitoClientId : this._config.oauth.clientID, n = Ns(this._config) ? this._config.redirectSignOut : this._config.returnTo, e += Object.entries({
                        client_id: t,
                        logout_uri: encodeURIComponent(n)
                    }).map((function (e) {
                        var t = cu(e, 2);
                        return t[0] + "=" + t[1]
                    })).join("&"), fu("oAuthSignOut", {oAuth: "signOut"}, "Signing out from " + e), du.debug("Signing out from " + e), [2, this._urlOpener(e, n)]
                }))
            }))
        }, e.prototype._generateState = function (e) {
            for (var t = "", n = e, r = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ"; n > 0; --n) t += r[Math.round(Math.random() * (r.length - 1))];
            return t
        }, e.prototype._generateChallenge = function (e) {
            return this._base64URL(ta(e))
        }, e.prototype._base64URL = function (e) {
            return e.toString(Ta).replace(/=/g, "").replace(/\+/g, "-").replace(/\//g, "_")
        }, e.prototype._generateRandom = function (e) {
            var t = new Uint8Array(e);
            if ("undefined" != typeof window && window.crypto) window.crypto.getRandomValues(t); else for (var n = 0; n < e; n += 1) t[n] = Math.random() * "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-._~".length | 0;
            return this._bufferToString(t)
        }, e.prototype._bufferToString = function (e) {
            for (var t = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789", n = [], r = 0; r < e.byteLength; r += 1) {
                var i = e[r] % t.length;
                n.push(t[i])
            }
            return n.join("")
        }, e
    }(), pu = hu;
!function (e) {
    e.DEFAULT_MSG = "Authentication Error", e.EMPTY_EMAIL = "Email cannot be empty", e.EMPTY_PHONE = "Phone number cannot be empty", e.EMPTY_USERNAME = "Username cannot be empty", e.INVALID_USERNAME = "The username should either be a string or one of the sign in types", e.EMPTY_PASSWORD = "Password cannot be empty", e.EMPTY_CODE = "Confirmation code cannot be empty", e.SIGN_UP_ERROR = "Error creating account", e.NO_MFA = "No valid MFA method provided", e.INVALID_MFA = "Invalid MFA type", e.EMPTY_CHALLENGE = "Challenge response cannot be empty", e.NO_USER_SESSION = "Failed to get the session because the user is empty", e.NETWORK_ERROR = "Network Error", e.DEVICE_CONFIG = "Device tracking has not been configured in this User Pool"
}(ru || (ru = {}));
var gu = function () {
        var e = function (t, n) {
            return e = Object.setPrototypeOf || {__proto__: []} instanceof Array && function (e, t) {
                e.__proto__ = t
            } || function (e, t) {
                for (var n in t) t.hasOwnProperty(n) && (e[n] = t[n])
            }, e(t, n)
        };
        return function (t, n) {
            function r() {
                this.constructor = t
            }

            e(t, n), t.prototype = null === n ? Object.create(n) : (r.prototype = n.prototype, new r)
        }
    }(), vu = new o("AuthError"), mu = function (e) {
        function t(n) {
            var r = this, i = Su[n], o = i.message, s = i.log;
            return (r = e.call(this, o) || this).constructor = t, Object.setPrototypeOf(r, t.prototype), r.name = "AuthError", r.log = s || o, vu.error(r.log), r
        }

        return gu(t, e), t
    }(Error), yu = function (e) {
        function t(n) {
            var r = e.call(this, n) || this;
            return r.constructor = t, Object.setPrototypeOf(r, t.prototype), r.name = "NoUserPoolError", r
        }

        return gu(t, e), t
    }(mu), Su = {
        noConfig: {
            message: ru.DEFAULT_MSG,
            log: "\n            Error: Amplify has not been configured correctly.\n            This error is typically caused by one of the following scenarios:\n\n            1. Make sure you're passing the awsconfig object to Amplify.configure() in your app's entry point\n                See https://aws-amplify.github.io/docs/js/authentication#configure-your-app for more information\n            \n            2. There might be multiple conflicting versions of amplify packages in your node_modules.\n\t\t\t\tRefer to our docs site for help upgrading Amplify packages (https://docs.amplify.aws/lib/troubleshooting/upgrading/q/platform/js)\n        "
        },
        missingAuthConfig: {
            message: ru.DEFAULT_MSG,
            log: "\n            Error: Amplify has not been configured correctly. \n            The configuration object is missing required auth properties.\n            This error is typically caused by one of the following scenarios:\n\n            1. Did you run `amplify push` after adding auth via `amplify add auth`?\n                See https://aws-amplify.github.io/docs/js/authentication#amplify-project-setup for more information\n\n            2. This could also be caused by multiple conflicting versions of amplify packages, see (https://docs.amplify.aws/lib/troubleshooting/upgrading/q/platform/js) for help upgrading Amplify packages.\n        "
        },
        emptyUsername: {message: ru.EMPTY_USERNAME},
        invalidUsername: {message: ru.INVALID_USERNAME},
        emptyPassword: {message: ru.EMPTY_PASSWORD},
        emptyCode: {message: ru.EMPTY_CODE},
        signUpError: {message: ru.SIGN_UP_ERROR, log: "The first parameter should either be non-null string or object"},
        noMFA: {message: ru.NO_MFA},
        invalidMFA: {message: ru.INVALID_MFA},
        emptyChallengeResponse: {message: ru.EMPTY_CHALLENGE},
        noUserSession: {message: ru.NO_USER_SESSION},
        deviceConfig: {message: ru.DEVICE_CONFIG},
        networkError: {message: ru.NETWORK_ERROR},
        default: {message: ru.DEFAULT_MSG}
    }, wu = function () {
        return wu = Object.assign || function (e) {
            for (var t, n = 1, r = arguments.length; n < r; n++) for (var i in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
            return e
        }, wu.apply(this, arguments)
    }, bu = function (e, t, n, r) {
        return new (n || (n = Promise))((function (i, o) {
            function s(e) {
                try {
                    u(r.next(e))
                } catch (e) {
                    o(e)
                }
            }

            function a(e) {
                try {
                    u(r.throw(e))
                } catch (e) {
                    o(e)
                }
            }

            function u(e) {
                var t;
                e.done ? i(e.value) : (t = e.value, t instanceof n ? t : new n((function (e) {
                    e(t)
                }))).then(s, a)
            }

            u((r = r.apply(e, t || [])).next())
        }))
    }, Eu = function (e, t) {
        var n, r, i, o, s = {
            label: 0, sent: function () {
                if (1 & i[0]) throw i[1];
                return i[1]
            }, trys: [], ops: []
        };
        return o = {
            next: a(0),
            throw: a(1),
            return: a(2)
        }, "function" == typeof Symbol && (o[Symbol.iterator] = function () {
            return this
        }), o;

        function a(o) {
            return function (a) {
                return function (o) {
                    if (n) throw new TypeError("Generator is already executing.");
                    for (; s;) try {
                        if (n = 1, r && (i = 2 & o[0] ? r.return : o[0] ? r.throw || ((i = r.return) && i.call(r), 0) : r.next) && !(i = i.call(r, o[1])).done) return i;
                        switch (r = 0, i && (o = [2 & o[0], i.value]), o[0]) {
                            case 0:
                            case 1:
                                i = o;
                                break;
                            case 4:
                                return s.label++, {value: o[1], done: !1};
                            case 5:
                                s.label++, r = o[1], o = [0];
                                continue;
                            case 7:
                                o = s.ops.pop(), s.trys.pop();
                                continue;
                            default:
                                if (!(i = s.trys, (i = i.length > 0 && i[i.length - 1]) || 6 !== o[0] && 2 !== o[0])) {
                                    s = 0;
                                    continue
                                }
                                if (3 === o[0] && (!i || o[1] > i[0] && o[1] < i[3])) {
                                    s.label = o[1];
                                    break
                                }
                                if (6 === o[0] && s.label < i[1]) {
                                    s.label = i[1], i = o;
                                    break
                                }
                                if (i && s.label < i[2]) {
                                    s.label = i[2], s.ops.push(o);
                                    break
                                }
                                i[2] && s.ops.pop(), s.trys.pop();
                                continue
                        }
                        o = t.call(e, s)
                    } catch (e) {
                        o = [6, e], r = 0
                    } finally {
                        n = i = 0
                    }
                    if (5 & o[0]) throw o[1];
                    return {value: o[0] ? o[1] : void 0, done: !0}
                }([o, a])
            }
        }
    }, Cu = function (e, t) {
        var n = "function" == typeof Symbol && e[Symbol.iterator];
        if (!n) return e;
        var r, i, o = n.call(e), s = [];
        try {
            for (; (void 0 === t || t-- > 0) && !(r = o.next()).done;) s.push(r.value)
        } catch (e) {
            i = {error: e}
        } finally {
            try {
                r && !r.done && (n = o.return) && n.call(o)
            } finally {
                if (i) throw i.error
            }
        }
        return s
    }, _u = new o("AuthClass"),
    Au = "undefined" != typeof Symbol && "function" == typeof Symbol.for ? Symbol.for("amplify_default") : "@@amplify_default",
    Pu = function (e, t, n) {
        m.dispatch("auth", {event: e, data: t, message: n}, "Auth", Au)
    }, ku = function () {
        function e(e) {
            var t = this;
            this.userPool = null, this.user = null, this.oAuthFlowInProgress = !1, this.Credentials = Ss, this.wrapRefreshSessionCallback = function (e) {
                return function (t, n) {
                    return n ? Pu("tokenRefresh", void 0, "New token retrieved") : Pu("tokenRefresh_failure", t, "Failed to retrieve new token"), e(t, n)
                }
            }, this.configure(e), this.currentCredentials = this.currentCredentials.bind(this), this.currentUserCredentials = this.currentUserCredentials.bind(this), m.listen("auth", (function (e) {
                switch (e.payload.event) {
                    case"signIn":
                        t._storage.setItem("amplify-signin-with-hostedUI", "false");
                        break;
                    case"signOut":
                        t._storage.removeItem("amplify-signin-with-hostedUI");
                        break;
                    case"cognitoHostedUI":
                        t._storage.setItem("amplify-signin-with-hostedUI", "true")
                }
            }))
        }

        return e.prototype.getModuleName = function () {
            return "Auth"
        }, e.prototype.configure = function (e) {
            var t = this;
            if (!e) return this._config || {};
            _u.debug("configure Auth");
            var n = Object.assign({}, this._config, Le.parseMobilehubConfig(e).Auth, e);
            this._config = n;
            var r = this._config, i = r.userPoolId, o = r.userPoolWebClientId, s = r.cookieStorage, a = r.oauth,
                u = r.region, c = r.identityPoolId, l = r.mandatorySignIn, f = r.refreshHandlers, d = r.identityPoolRegion,
                h = r.clientMetadata, p = r.endpoint;
            if (this._config.storage) {
                if (!this._isValidAuthStorage(this._config.storage)) throw _u.error("The storage in the Auth config is not valid!"), new Error("Empty storage object");
                this._storage = this._config.storage
            } else this._storage = s ? new iu(s) : e.ssr ? new Ls : (new li).getStorage();
            if (this._storageSync = Promise.resolve(), "function" == typeof this._storage.sync && (this._storageSync = this._storage.sync()), i) {
                var g = {UserPoolId: i, ClientId: o, endpoint: p};
                g.Storage = this._storage, this.userPool = new tu(g, this.wrapRefreshSessionCallback)
            }
            this.Credentials.configure({
                mandatorySignIn: l,
                region: d || u,
                userPoolId: i,
                identityPoolId: c,
                refreshHandlers: f,
                storage: this._storage
            });
            var v = a ? Ns(this._config.oauth) ? a : a.awsCognito : void 0;
            if (v) {
                var m = Object.assign({
                    cognitoClientId: o,
                    UserPoolId: i,
                    domain: v.domain,
                    scopes: v.scope,
                    redirectSignIn: v.redirectSignIn,
                    redirectSignOut: v.redirectSignOut,
                    responseType: v.responseType,
                    Storage: this._storage,
                    urlOpener: v.urlOpener,
                    clientMetadata: h
                }, v.options);
                this._oAuthHandler = new pu({scopes: m.scopes, config: m, cognitoClientId: m.cognitoClientId});
                var y = {};
                !function (e) {
                    if (U.browserOrNode().isBrowser && window.location) e({url: window.location.href}); else if (!U.browserOrNode().isNode) throw new Error("Not supported")
                }((function (e) {
                    var n = e.url;
                    y[n] || (y[n] = !0, t._handleAuthResponse(n))
                }))
            }
            return Pu("configured", null, "The Auth category has been configured successfully"), this._config
        }, e.prototype.signUp = function (e) {
            for (var t = this, n = [], r = 1; r < arguments.length; r++) n[r - 1] = arguments[r];
            if (!this.userPool) return this.rejectNoUserPool();
            var i, o = null, s = null, a = [], u = null;
            if (e && "string" == typeof e) {
                o = e, s = n ? n[0] : null;
                var c = n ? n[1] : null, l = n ? n[2] : null;
                c && a.push(new Ra({Name: "email", Value: c})), l && a.push(new Ra({Name: "phone_number", Value: l}))
            } else {
                if (!e || "object" != typeof e) return this.rejectAuthError(Is.SignUpError);
                o = e.username, s = e.password, e && e.clientMetadata ? i = e.clientMetadata : this._config.clientMetadata && (i = this._config.clientMetadata);
                var f = e.attributes;
                f && Object.keys(f).map((function (e) {
                    a.push(new Ra({Name: e, Value: f[e]}))
                }));
                var d = e.validationData;
                d && (u = [], Object.keys(d).map((function (e) {
                    u.push(new Ra({Name: e, Value: d[e]}))
                })))
            }
            return o ? s ? (_u.debug("signUp attrs:", a), _u.debug("signUp validation data:", u), new Promise((function (e, n) {
                t.userPool.signUp(o, s, a, u, (function (t, r) {
                    t ? (Pu("signUp_failure", t, o + " failed to signup"), n(t)) : (Pu("signUp", r, o + " has signed up successfully"), e(r))
                }), i)
            }))) : this.rejectAuthError(Is.EmptyPassword) : this.rejectAuthError(Is.EmptyUsername)
        }, e.prototype.confirmSignUp = function (e, t, n) {
            if (!this.userPool) return this.rejectNoUserPool();
            if (!e) return this.rejectAuthError(Is.EmptyUsername);
            if (!t) return this.rejectAuthError(Is.EmptyCode);
            var r, i = this.createCognitoUser(e),
                o = !n || "boolean" != typeof n.forceAliasCreation || n.forceAliasCreation;
            return n && n.clientMetadata ? r = n.clientMetadata : this._config.clientMetadata && (r = this._config.clientMetadata), new Promise((function (e, n) {
                i.confirmRegistration(t, o, (function (t, r) {
                    t ? n(t) : e(r)
                }), r)
            }))
        }, e.prototype.resendSignUp = function (e, t) {
            if (void 0 === t && (t = this._config.clientMetadata), !this.userPool) return this.rejectNoUserPool();
            if (!e) return this.rejectAuthError(Is.EmptyUsername);
            var n = this.createCognitoUser(e);
            return new Promise((function (e, r) {
                n.resendConfirmationCode((function (t, n) {
                    t ? r(t) : e(n)
                }), t)
            }))
        }, e.prototype.signIn = function (e, t, n) {
            if (void 0 === n && (n = this._config.clientMetadata), !this.userPool) return this.rejectNoUserPool();
            var r = null, i = null, o = {};
            if ("string" == typeof e) r = e, i = t; else {
                if (!e.username) return this.rejectAuthError(Is.InvalidUsername);
                void 0 !== t && _u.warn("The password should be defined under the first parameter object!"), r = e.username, i = e.password, o = e.validationData
            }
            if (!r) return this.rejectAuthError(Is.EmptyUsername);
            var s = new Ds({Username: r, Password: i, ValidationData: o, ClientMetadata: n});
            return i ? this.signInWithPassword(s) : this.signInWithoutPassword(s)
        }, e.prototype.authCallbacks = function (e, t, n) {
            var r = this, i = this;
            return {
                onSuccess: function (o) {
                    return bu(r, void 0, void 0, (function () {
                        var r, s, a, u;
                        return Eu(this, (function (c) {
                            switch (c.label) {
                                case 0:
                                    _u.debug(o), delete e.challengeName, delete e.challengeParam, c.label = 1;
                                case 1:
                                    return c.trys.push([1, 4, 5, 9]), [4, this.Credentials.clear()];
                                case 2:
                                    return c.sent(), [4, this.Credentials.set(o, "session")];
                                case 3:
                                    return r = c.sent(), _u.debug("succeed to get cognito credentials", r), [3, 9];
                                case 4:
                                    return s = c.sent(), _u.debug("cannot get cognito credentials", s), [3, 9];
                                case 5:
                                    return c.trys.push([5, 7, , 8]), [4, this.currentUserPoolUser()];
                                case 6:
                                    return a = c.sent(), i.user = a, Pu("signIn", a, "A user " + e.getUsername() + " has been signed in"), t(a), [3, 8];
                                case 7:
                                    return u = c.sent(), _u.error("Failed to get the signed in user", u), n(u), [3, 8];
                                case 8:
                                    return [7];
                                case 9:
                                    return [2]
                            }
                        }))
                    }))
                }, onFailure: function (t) {
                    _u.debug("signIn failure", t), Pu("signIn_failure", t, e.getUsername() + " failed to signin"), n(t)
                }, customChallenge: function (n) {
                    _u.debug("signIn custom challenge answer required"), e.challengeName = "CUSTOM_CHALLENGE", e.challengeParam = n, t(e)
                }, mfaRequired: function (n, r) {
                    _u.debug("signIn MFA required"), e.challengeName = n, e.challengeParam = r, t(e)
                }, mfaSetup: function (n, r) {
                    _u.debug("signIn mfa setup", n), e.challengeName = n, e.challengeParam = r, t(e)
                }, newPasswordRequired: function (n, r) {
                    _u.debug("signIn new password"), e.challengeName = "NEW_PASSWORD_REQUIRED", e.challengeParam = {
                        userAttributes: n,
                        requiredAttributes: r
                    }, t(e)
                }, totpRequired: function (n, r) {
                    _u.debug("signIn totpRequired"), e.challengeName = n, e.challengeParam = r, t(e)
                }, selectMFAType: function (n, r) {
                    _u.debug("signIn selectMFAType", n), e.challengeName = n, e.challengeParam = r, t(e)
                }
            }
        }, e.prototype.signInWithPassword = function (e) {
            var t = this;
            if (this.pendingSignIn) throw new Error("Pending sign-in attempt already in progress");
            var n = this.createCognitoUser(e.getUsername());
            return this.pendingSignIn = new Promise((function (r, i) {
                n.authenticateUser(e, t.authCallbacks(n, (function (e) {
                    t.pendingSignIn = null, r(e)
                }), (function (e) {
                    t.pendingSignIn = null, i(e)
                })))
            })), this.pendingSignIn
        }, e.prototype.signInWithoutPassword = function (e) {
            var t = this, n = this.createCognitoUser(e.getUsername());
            return n.setAuthenticationFlowType("CUSTOM_AUTH"), new Promise((function (r, i) {
                n.initiateAuth(e, t.authCallbacks(n, r, i))
            }))
        }, e.prototype.getMFAOptions = function (e) {
            return new Promise((function (t, n) {
                e.getMFAOptions((function (e, r) {
                    if (e) return _u.debug("get MFA Options failed", e), void n(e);
                    _u.debug("get MFA options success", r), t(r)
                }))
            }))
        }, e.prototype.getPreferredMFA = function (e, t) {
            var n = this, r = this;
            return new Promise((function (i, o) {
                var s = n._config.clientMetadata, a = !!t && t.bypassCache;
                e.getUserData((function (e, t) {
                    if (e) return _u.debug("getting preferred mfa failed", e), void o(e);
                    var n = r._getMfaTypeFromUserData(t);
                    return n ? void i(n) : void o("invalid MFA Type")
                }), {bypassCache: a, clientMetadata: s})
            }))
        }, e.prototype._getMfaTypeFromUserData = function (e) {
            var t = null, n = e.PreferredMfaSetting;
            if (n) t = n; else {
                var r = e.UserMFASettingList;
                if (r) 0 === r.length ? t = "NOMFA" : _u.debug("invalid case for getPreferredMFA", e); else t = e.MFAOptions ? "SMS_MFA" : "NOMFA"
            }
            return t
        }, e.prototype._getUserData = function (e, t) {
            return new Promise((function (n, r) {
                e.getUserData((function (e, t) {
                    return e ? (_u.debug("getting user data failed", e), void r(e)) : void n(t)
                }), t)
            }))
        }, e.prototype.setPreferredMFA = function (e, t) {
            return bu(this, void 0, void 0, (function () {
                var n, r, i, o, s, a;
                return Eu(this, (function (u) {
                    switch (u.label) {
                        case 0:
                            return n = this._config.clientMetadata, [4, this._getUserData(e, {
                                bypassCache: !0,
                                clientMetadata: n
                            })];
                        case 1:
                            switch (r = u.sent(), i = null, o = null, t) {
                                case"TOTP":
                                case"SOFTWARE_TOKEN_MFA":
                                    return [3, 2];
                                case"SMS":
                                case"SMS_MFA":
                                    return [3, 3];
                                case"NOMFA":
                                    return [3, 4]
                            }
                            return [3, 6];
                        case 2:
                            return o = {PreferredMfa: !0, Enabled: !0}, [3, 7];
                        case 3:
                            return i = {PreferredMfa: !0, Enabled: !0}, [3, 7];
                        case 4:
                            return s = r.UserMFASettingList, [4, this._getMfaTypeFromUserData(r)];
                        case 5:
                            if ("NOMFA" === (a = u.sent())) return [2, Promise.resolve("No change for mfa type")];
                            if ("SMS_MFA" === a) i = {PreferredMfa: !1, Enabled: !1}; else {
                                if ("SOFTWARE_TOKEN_MFA" !== a) return [2, this.rejectAuthError(Is.InvalidMFA)];
                                o = {PreferredMfa: !1, Enabled: !1}
                            }
                            return s && 0 !== s.length && s.forEach((function (e) {
                                "SMS_MFA" === e ? i = {
                                    PreferredMfa: !1,
                                    Enabled: !1
                                } : "SOFTWARE_TOKEN_MFA" === e && (o = {PreferredMfa: !1, Enabled: !1})
                            })), [3, 7];
                        case 6:
                            return _u.debug("no validmfa method provided"), [2, this.rejectAuthError(Is.NoMFA)];
                        case 7:
                            return [2, new Promise((function (t, r) {
                                e.setUserMfaPreference(i, o, (function (i, o) {
                                    if (i) return _u.debug("Set user mfa preference error", i), r(i);
                                    _u.debug("Set user mfa success", o), _u.debug("Caching the latest user data into local"), e.getUserData((function (e, n) {
                                        return e ? (_u.debug("getting user data failed", e), r(e)) : t(o)
                                    }), {bypassCache: !0, clientMetadata: n})
                                }))
                            }))]
                    }
                }))
            }))
        }, e.prototype.disableSMS = function (e) {
            return new Promise((function (t, n) {
                e.disableMFA((function (e, r) {
                    if (e) return _u.debug("disable mfa failed", e), void n(e);
                    _u.debug("disable mfa succeed", r), t(r)
                }))
            }))
        }, e.prototype.enableSMS = function (e) {
            return new Promise((function (t, n) {
                e.enableMFA((function (e, r) {
                    if (e) return _u.debug("enable mfa failed", e), void n(e);
                    _u.debug("enable mfa succeed", r), t(r)
                }))
            }))
        }, e.prototype.setupTOTP = function (e) {
            return new Promise((function (t, n) {
                e.associateSoftwareToken({
                    onFailure: function (e) {
                        _u.debug("associateSoftwareToken failed", e), n(e)
                    }, associateSecretCode: function (e) {
                        _u.debug("associateSoftwareToken sucess", e), t(e)
                    }
                })
            }))
        }, e.prototype.verifyTotpToken = function (e, t) {
            return _u.debug("verification totp token", e, t), new Promise((function (n, r) {
                e.verifySoftwareToken(t, "My TOTP device", {
                    onFailure: function (e) {
                        _u.debug("verifyTotpToken failed", e), r(e)
                    }, onSuccess: function (t) {
                        Pu("signIn", e, "A user " + e.getUsername() + " has been signed in"), _u.debug("verifyTotpToken success", t), n(t)
                    }
                })
            }))
        }, e.prototype.confirmSignIn = function (e, t, n, r) {
            var i = this;
            if (void 0 === r && (r = this._config.clientMetadata), !t) return this.rejectAuthError(Is.EmptyCode);
            var o = this;
            return new Promise((function (s, a) {
                e.sendMFACode(t, {
                    onSuccess: function (t) {
                        return bu(i, void 0, void 0, (function () {
                            var n, r;
                            return Eu(this, (function (i) {
                                switch (i.label) {
                                    case 0:
                                        _u.debug(t), i.label = 1;
                                    case 1:
                                        return i.trys.push([1, 4, 5, 6]), [4, this.Credentials.clear()];
                                    case 2:
                                        return i.sent(), [4, this.Credentials.set(t, "session")];
                                    case 3:
                                        return n = i.sent(), _u.debug("succeed to get cognito credentials", n), [3, 6];
                                    case 4:
                                        return r = i.sent(), _u.debug("cannot get cognito credentials", r), [3, 6];
                                    case 5:
                                        return o.user = e, Pu("signIn", e, "A user " + e.getUsername() + " has been signed in"), s(e), [7];
                                    case 6:
                                        return [2]
                                }
                            }))
                        }))
                    }, onFailure: function (e) {
                        _u.debug("confirm signIn failure", e), a(e)
                    }
                }, n, r)
            }))
        }, e.prototype.completeNewPassword = function (e, t, n, r) {
            var i = this;
            if (void 0 === n && (n = {}), void 0 === r && (r = this._config.clientMetadata), !t) return this.rejectAuthError(Is.EmptyPassword);
            var o = this;
            return new Promise((function (s, a) {
                e.completeNewPasswordChallenge(t, n, {
                    onSuccess: function (t) {
                        return bu(i, void 0, void 0, (function () {
                            var n, r;
                            return Eu(this, (function (i) {
                                switch (i.label) {
                                    case 0:
                                        _u.debug(t), i.label = 1;
                                    case 1:
                                        return i.trys.push([1, 4, 5, 6]), [4, this.Credentials.clear()];
                                    case 2:
                                        return i.sent(), [4, this.Credentials.set(t, "session")];
                                    case 3:
                                        return n = i.sent(), _u.debug("succeed to get cognito credentials", n), [3, 6];
                                    case 4:
                                        return r = i.sent(), _u.debug("cannot get cognito credentials", r), [3, 6];
                                    case 5:
                                        return o.user = e, Pu("signIn", e, "A user " + e.getUsername() + " has been signed in"), s(e), [7];
                                    case 6:
                                        return [2]
                                }
                            }))
                        }))
                    }, onFailure: function (e) {
                        _u.debug("completeNewPassword failure", e), Pu("completeNewPassword_failure", e, i.user + " failed to complete the new password flow"), a(e)
                    }, mfaRequired: function (t, n) {
                        _u.debug("signIn MFA required"), e.challengeName = t, e.challengeParam = n, s(e)
                    }, mfaSetup: function (t, n) {
                        _u.debug("signIn mfa setup", t), e.challengeName = t, e.challengeParam = n, s(e)
                    }, totpRequired: function (t, n) {
                        _u.debug("signIn mfa setup", t), e.challengeName = t, e.challengeParam = n, s(e)
                    }
                }, r)
            }))
        }, e.prototype.sendCustomChallengeAnswer = function (e, t, n) {
            var r = this;
            return void 0 === n && (n = this._config.clientMetadata), this.userPool ? t ? new Promise((function (i, o) {
                e.sendCustomChallengeAnswer(t, r.authCallbacks(e, i, o), n)
            })) : this.rejectAuthError(Is.EmptyChallengeResponse) : this.rejectNoUserPool()
        }, e.prototype.deleteUserAttributes = function (e, t) {
            var n = this;
            return new Promise((function (r, i) {
                n.userSession(e).then((function (n) {
                    e.deleteAttributes(t, (function (e, t) {
                        return e ? i(e) : r(t)
                    }))
                }))
            }))
        }, e.prototype.updateUserAttributes = function (e, t, n) {
            void 0 === n && (n = this._config.clientMetadata);
            var r = [], i = this;
            return new Promise((function (o, s) {
                i.userSession(e).then((function (i) {
                    for (var a in t) if ("sub" !== a && a.indexOf("_verified") < 0) {
                        var u = {Name: a, Value: t[a]};
                        r.push(u)
                    }
                    e.updateAttributes(r, (function (e, t) {
                        return e ? s(e) : o(t)
                    }), n)
                }))
            }))
        }, e.prototype.userAttributes = function (e) {
            var t = this;
            return new Promise((function (n, r) {
                t.userSession(e).then((function (t) {
                    e.getUserAttributes((function (e, t) {
                        e ? r(e) : n(t)
                    }))
                }))
            }))
        }, e.prototype.verifiedContact = function (e) {
            var t = this;
            return this.userAttributes(e).then((function (e) {
                var n = t.attributesToObject(e), r = {}, i = {};
                return n.email && (n.email_verified ? i.email = n.email : r.email = n.email), n.phone_number && (n.phone_number_verified ? i.phone_number = n.phone_number : r.phone_number = n.phone_number), {
                    verified: i,
                    unverified: r
                }
            }))
        }, e.prototype.currentUserPoolUser = function (e) {
            var t = this;
            return this.userPool ? new Promise((function (n, r) {
                t._storageSync.then((function () {
                    return bu(t, void 0, void 0, (function () {
                        var t, i, o = this;
                        return Eu(this, (function (s) {
                            switch (s.label) {
                                case 0:
                                    return this.isOAuthInProgress() ? (_u.debug("OAuth signIn in progress, waiting for resolution..."), [4, new Promise((function (e) {
                                        var t = setTimeout((function () {
                                            _u.debug("OAuth signIn in progress timeout"), m.remove("auth", n), e()
                                        }), 1e4);

                                        function n(r) {
                                            var i = r.payload.event;
                                            "cognitoHostedUI" !== i && "cognitoHostedUI_failure" !== i || (_u.debug("OAuth signIn resolved: " + i), clearTimeout(t), m.remove("auth", n), e())
                                        }

                                        m.listen("auth", n)
                                    }))]) : [3, 2];
                                case 1:
                                    s.sent(), s.label = 2;
                                case 2:
                                    return (t = this.userPool.getCurrentUser()) ? (i = this._config.clientMetadata, t.getSession((function (i, s) {
                                        return bu(o, void 0, void 0, (function () {
                                            var o, a, u, c = this;
                                            return Eu(this, (function (l) {
                                                switch (l.label) {
                                                    case 0:
                                                        return i ? (_u.debug("Failed to get the user session", i), r(i), [2]) : (o = !!e && e.bypassCache) ? [4, this.Credentials.clear()] : [3, 2];
                                                    case 1:
                                                        l.sent(), l.label = 2;
                                                    case 2:
                                                        return a = this._config.clientMetadata, u = s.getAccessToken().decodePayload().scope, (void 0 === u ? "" : u).split(" ").includes("aws.cognito.signin.user.admin") ? (t.getUserData((function (e, i) {
                                                            if (e) return _u.debug("getting user data failed", e), void ("User is disabled." === e.message || "User does not exist." === e.message || "Access Token has been revoked" === e.message ? r(e) : n(t));
                                                            for (var o = i.PreferredMfaSetting || "NOMFA", s = [], a = 0; a < i.UserAttributes.length; a++) {
                                                                var u = {
                                                                    Name: i.UserAttributes[a].Name,
                                                                    Value: i.UserAttributes[a].Value
                                                                }, l = new Ra(u);
                                                                s.push(l)
                                                            }
                                                            var f = c.attributesToObject(s);
                                                            return Object.assign(t, {attributes: f, preferredMFA: o}), n(t)
                                                        }), {
                                                            bypassCache: o,
                                                            clientMetadata: a
                                                        }), [2]) : (_u.debug("Unable to get the user data because the aws.cognito.signin.user.admin is not in the scopes of the access token"), [2, n(t)])
                                                }
                                            }))
                                        }))
                                    }), {clientMetadata: i}), [2]) : (_u.debug("Failed to get user from user pool"), r("No current user"), [2])
                            }
                        }))
                    }))
                })).catch((function (e) {
                    return _u.debug("Failed to sync cache info into memory", e), r(e)
                }))
            })) : this.rejectNoUserPool()
        }, e.prototype.isOAuthInProgress = function () {
            return this.oAuthFlowInProgress
        }, e.prototype.currentAuthenticatedUser = function (e) {
            return bu(this, void 0, void 0, (function () {
                var t, n, r, i, o;
                return Eu(this, (function (s) {
                    switch (s.label) {
                        case 0:
                            _u.debug("getting current authenticated user"), t = null, s.label = 1;
                        case 1:
                            return s.trys.push([1, 3, , 4]), [4, this._storageSync];
                        case 2:
                            return s.sent(), [3, 4];
                        case 3:
                            throw n = s.sent(), _u.debug("Failed to sync cache info into memory", n), n;
                        case 4:
                            try {
                                (r = JSON.parse(this._storage.getItem("aws-amplify-federatedInfo"))) && (t = wu(wu({}, r.user), {token: r.token}))
                            } catch (e) {
                                _u.debug("cannot load federated user from auth storage")
                            }
                            return t ? (this.user = t, _u.debug("get current authenticated federated user", this.user), [2, this.user]) : [3, 5];
                        case 5:
                            _u.debug("get current authenticated userpool user"), i = null, s.label = 6;
                        case 6:
                            return s.trys.push([6, 8, , 9]), [4, this.currentUserPoolUser(e)];
                        case 7:
                            return i = s.sent(), [3, 9];
                        case 8:
                            return "No userPool" === (o = s.sent()) && _u.error("Cannot get the current user because the user pool is missing. Please make sure the Auth module is configured with a valid Cognito User Pool ID"), _u.debug("The user is not authenticated by the error", o), [2, Promise.reject("The user is not authenticated")];
                        case 9:
                            return this.user = i, [2, this.user]
                    }
                }))
            }))
        }, e.prototype.currentSession = function () {
            var e = this;
            return _u.debug("Getting current session"), this.userPool ? new Promise((function (t, n) {
                e.currentUserPoolUser().then((function (r) {
                    e.userSession(r).then((function (e) {
                        t(e)
                    })).catch((function (e) {
                        _u.debug("Failed to get the current session", e), n(e)
                    }))
                })).catch((function (e) {
                    _u.debug("Failed to get the current user", e), n(e)
                }))
            })) : Promise.reject()
        }, e.prototype.userSession = function (e) {
            if (!e) return _u.debug("the user is null"), this.rejectAuthError(Is.NoUserSession);
            var t = this._config.clientMetadata;
            return new Promise((function (n, r) {
                _u.debug("Getting the session from this user:", e), e.getSession((function (t, i) {
                    return t ? (_u.debug("Failed to get the session from user", e), void r(t)) : (_u.debug("Succeed to get the user session", i), void n(i))
                }), {clientMetadata: t})
            }))
        }, e.prototype.currentUserCredentials = function () {
            return bu(this, void 0, void 0, (function () {
                var e, t, n = this;
                return Eu(this, (function (r) {
                    switch (r.label) {
                        case 0:
                            _u.debug("Getting current user credentials"), r.label = 1;
                        case 1:
                            return r.trys.push([1, 3, , 4]), [4, this._storageSync];
                        case 2:
                            return r.sent(), [3, 4];
                        case 3:
                            throw e = r.sent(), _u.debug("Failed to sync cache info into memory", e), e;
                        case 4:
                            t = null;
                            try {
                                t = JSON.parse(this._storage.getItem("aws-amplify-federatedInfo"))
                            } catch (e) {
                                _u.debug("failed to get or parse item aws-amplify-federatedInfo", e)
                            }
                            return t ? [2, this.Credentials.refreshFederatedToken(t)] : [2, this.currentSession().then((function (e) {
                                return _u.debug("getting session success", e), n.Credentials.set(e, "session")
                            })).catch((function (e) {
                                return _u.debug("getting session failed", e), n.Credentials.set(null, "guest")
                            }))]
                    }
                }))
            }))
        }, e.prototype.currentCredentials = function () {
            return _u.debug("getting current credentials"), this.Credentials.get()
        }, e.prototype.verifyUserAttribute = function (e, t, n) {
            return void 0 === n && (n = this._config.clientMetadata), new Promise((function (r, i) {
                e.getAttributeVerificationCode(t, {
                    onSuccess: function (e) {
                        return r(e)
                    }, onFailure: function (e) {
                        return i(e)
                    }
                }, n)
            }))
        }, e.prototype.verifyUserAttributeSubmit = function (e, t, n) {
            return n ? new Promise((function (r, i) {
                e.verifyAttribute(t, n, {
                    onSuccess: function (e) {
                        r(e)
                    }, onFailure: function (e) {
                        i(e)
                    }
                })
            })) : this.rejectAuthError(Is.EmptyCode)
        }, e.prototype.verifyCurrentUserAttribute = function (e) {
            var t = this;
            return t.currentUserPoolUser().then((function (n) {
                return t.verifyUserAttribute(n, e)
            }))
        }, e.prototype.verifyCurrentUserAttributeSubmit = function (e, t) {
            var n = this;
            return n.currentUserPoolUser().then((function (r) {
                return n.verifyUserAttributeSubmit(r, e, t)
            }))
        }, e.prototype.cognitoIdentitySignOut = function (e, t) {
            return bu(this, void 0, void 0, (function () {
                var n, r, i = this;
                return Eu(this, (function (o) {
                    switch (o.label) {
                        case 0:
                            return o.trys.push([0, 2, , 3]), [4, this._storageSync];
                        case 1:
                            return o.sent(), [3, 3];
                        case 2:
                            throw n = o.sent(), _u.debug("Failed to sync cache info into memory", n), n;
                        case 3:
                            return r = this._oAuthHandler && "true" === this._storage.getItem("amplify-signin-with-hostedUI"), [2, new Promise((function (n, o) {
                                if (e && e.global) {
                                    _u.debug("user global sign out", t);
                                    var s = i._config.clientMetadata;
                                    t.getSession((function (e, s) {
                                        if (e) return _u.debug("failed to get the user session", e), o(e);
                                        t.globalSignOut({
                                            onSuccess: function (e) {
                                                if (_u.debug("global sign out success"), !r) return n();
                                                i.oAuthSignOutRedirect(n, o)
                                            }, onFailure: function (e) {
                                                return _u.debug("global sign out failed", e), o(e)
                                            }
                                        })
                                    }), {clientMetadata: s})
                                } else _u.debug("user sign out", t), t.signOut((function () {
                                    if (!r) return n();
                                    i.oAuthSignOutRedirect(n, o)
                                }))
                            }))]
                    }
                }))
            }))
        }, e.prototype.oAuthSignOutRedirect = function (e, t) {
            U.browserOrNode().isBrowser ? this.oAuthSignOutRedirectOrReject(t) : this.oAuthSignOutAndResolve(e)
        }, e.prototype.oAuthSignOutAndResolve = function (e) {
            this._oAuthHandler.signOut(), e()
        }, e.prototype.oAuthSignOutRedirectOrReject = function (e) {
            this._oAuthHandler.signOut(), setTimeout((function () {
                return e("Signout timeout fail")
            }), 3e3)
        }, e.prototype.signOut = function (e) {
            return bu(this, void 0, void 0, (function () {
                var t;
                return Eu(this, (function (n) {
                    switch (n.label) {
                        case 0:
                            return n.trys.push([0, 2, , 3]), [4, this.cleanCachedItems()];
                        case 1:
                            return n.sent(), [3, 3];
                        case 2:
                            return n.sent(), _u.debug("failed to clear cached items"), [3, 3];
                        case 3:
                            return this.userPool ? (t = this.userPool.getCurrentUser()) ? [4, this.cognitoIdentitySignOut(e, t)] : [3, 5] : [3, 7];
                        case 4:
                            return n.sent(), [3, 6];
                        case 5:
                            _u.debug("no current Cognito user"), n.label = 6;
                        case 6:
                            return [3, 8];
                        case 7:
                            _u.debug("no Congito User pool"), n.label = 8;
                        case 8:
                            return Pu("signOut", this.user, "A user has been signed out"), this.user = null, [2]
                    }
                }))
            }))
        }, e.prototype.cleanCachedItems = function () {
            return bu(this, void 0, void 0, (function () {
                return Eu(this, (function (e) {
                    switch (e.label) {
                        case 0:
                            return [4, this.Credentials.clear()];
                        case 1:
                            return e.sent(), [2]
                    }
                }))
            }))
        }, e.prototype.changePassword = function (e, t, n, r) {
            var i = this;
            return void 0 === r && (r = this._config.clientMetadata), new Promise((function (o, s) {
                i.userSession(e).then((function (i) {
                    e.changePassword(t, n, (function (e, t) {
                        return e ? (_u.debug("change password failure", e), s(e)) : o(t)
                    }), r)
                }))
            }))
        }, e.prototype.forgotPassword = function (e, t) {
            if (void 0 === t && (t = this._config.clientMetadata), !this.userPool) return this.rejectNoUserPool();
            if (!e) return this.rejectAuthError(Is.EmptyUsername);
            var n = this.createCognitoUser(e);
            return new Promise((function (r, i) {
                n.forgotPassword({
                    onSuccess: function () {
                        r()
                    }, onFailure: function (t) {
                        _u.debug("forgot password failure", t), Pu("forgotPassword_failure", t, e + " forgotPassword failed"), i(t)
                    }, inputVerificationCode: function (t) {
                        Pu("forgotPassword", n, e + " has initiated forgot password flow"), r(t)
                    }
                }, t)
            }))
        }, e.prototype.forgotPasswordSubmit = function (e, t, n, r) {
            if (void 0 === r && (r = this._config.clientMetadata), !this.userPool) return this.rejectNoUserPool();
            if (!e) return this.rejectAuthError(Is.EmptyUsername);
            if (!t) return this.rejectAuthError(Is.EmptyCode);
            if (!n) return this.rejectAuthError(Is.EmptyPassword);
            var i = this.createCognitoUser(e);
            return new Promise((function (o, s) {
                i.confirmPassword(t, n, {
                    onSuccess: function (t) {
                        Pu("forgotPasswordSubmit", i, e + " forgotPasswordSubmit successful"), o(t)
                    }, onFailure: function (t) {
                        Pu("forgotPasswordSubmit_failure", t, e + " forgotPasswordSubmit failed"), s(t)
                    }
                }, r)
            }))
        }, e.prototype.currentUserInfo = function () {
            return bu(this, void 0, void 0, (function () {
                var e, t, n, r, i, o, s;
                return Eu(this, (function (a) {
                    switch (a.label) {
                        case 0:
                            return (e = this.Credentials.getCredSource()) && "aws" !== e && "userPool" !== e ? [3, 9] : [4, this.currentUserPoolUser().catch((function (e) {
                                return _u.error(e)
                            }))];
                        case 1:
                            if (!(s = a.sent())) return [2, null];
                            a.label = 2;
                        case 2:
                            return a.trys.push([2, 8, , 9]), [4, this.userAttributes(s)];
                        case 3:
                            t = a.sent(), n = this.attributesToObject(t), r = null, a.label = 4;
                        case 4:
                            return a.trys.push([4, 6, , 7]), [4, this.currentCredentials()];
                        case 5:
                            return r = a.sent(), [3, 7];
                        case 6:
                            return i = a.sent(), _u.debug("Failed to retrieve credentials while getting current user info", i), [3, 7];
                        case 7:
                            return [2, {id: r ? r.identityId : void 0, username: s.getUsername(), attributes: n}];
                        case 8:
                            return o = a.sent(), _u.error("currentUserInfo error", o), [2, {}];
                        case 9:
                            return "federated" === e ? [2, (s = this.user) || {}] : [2]
                    }
                }))
            }))
        }, e.prototype.federatedSignIn = function (e, t, n) {
            return bu(this, void 0, void 0, (function () {
                var r, i, o, s, a, u, c, l, f, d, h;
                return Eu(this, (function (p) {
                    switch (p.label) {
                        case 0:
                            if (!this._config.identityPoolId && !this._config.userPoolId) throw new Error("Federation requires either a User Pool or Identity Pool in config");
                            if (void 0 === e && this._config.identityPoolId && !this._config.userPoolId) throw new Error("Federation with Identity Pools requires tokens passed as arguments");
                            return Rs(e) || (g = e) && ["customProvider"].find((function (e) {
                                return g.hasOwnProperty(e)
                            })) || function (e) {
                                return e && !!["customState"].find((function (t) {
                                    return e.hasOwnProperty(t)
                                }))
                            }(e) || void 0 === e ? (r = e || {provider: xs.Cognito}, a = Rs(r) ? r.provider : r.customProvider, Rs(r), i = r.customState, this._config.userPoolId && (o = Ns(this._config.oauth) ? this._config.userPoolWebClientId : this._config.oauth.clientID, s = Ns(this._config.oauth) ? this._config.oauth.redirectSignIn : this._config.oauth.redirectUri, this._oAuthHandler.oauthSignIn(this._config.oauth.responseType, this._config.oauth.domain, s, o, a, i)), [3, 4]) : [3, 1];
                        case 1:
                            a = e;
                            try {
                                (u = JSON.stringify(JSON.parse(this._storage.getItem("aws-amplify-federatedInfo")).user)) && _u.warn("There is already a signed in user: " + u + " in your app.\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tYou should not call Auth.federatedSignIn method again as it may cause unexpected behavior.")
                            } catch (e) {
                            }
                            return c = t.token, l = t.identity_id, f = t.expires_at, [4, this.Credentials.set({
                                provider: a,
                                token: c,
                                identity_id: l,
                                user: n,
                                expires_at: f
                            }, "federation")];
                        case 2:
                            return d = p.sent(), [4, this.currentAuthenticatedUser()];
                        case 3:
                            return h = p.sent(), Pu("signIn", h, "A user " + h.username + " has been signed in"), _u.debug("federated sign in credentials", d), [2, d];
                        case 4:
                            return [2]
                    }
                    var g
                }))
            }))
        }, e.prototype._handleAuthResponse = function (e) {
            return bu(this, void 0, void 0, (function () {
                var t, n, r, i, o, s, a, u, c, l, f, d, h, p;
                return Eu(this, (function (g) {
                    switch (g.label) {
                        case 0:
                            if (this.oAuthFlowInProgress) return _u.debug("Skipping URL " + e + " current flow in progress"), [2];
                            g.label = 1;
                        case 1:
                            if (g.trys.push([1, , 8, 9]), this.oAuthFlowInProgress = !0, !this._config.userPoolId) throw new Error("OAuth responses require a User Pool defined in config");
                            if (Pu("parsingCallbackUrl", {url: e}, "The callback url is being parsed"), t = e || (U.browserOrNode().isBrowser ? window.location.href : ""), n = !!(se(t).query || "").split("&").map((function (e) {
                                return e.split("=")
                            })).find((function (e) {
                                var t = Cu(e, 1)[0];
                                return "code" === t || "error" === t
                            })), r = !!(se(t).hash || "#").substr(1).split("&").map((function (e) {
                                return e.split("=")
                            })).find((function (e) {
                                var t = Cu(e, 1)[0];
                                return "access_token" === t || "error" === t
                            })), !n && !r) return [3, 7];
                            this._storage.setItem("amplify-redirected-from-hosted-ui", "true"), g.label = 2;
                        case 2:
                            return g.trys.push([2, 6, , 7]), [4, this._oAuthHandler.handleAuthResponse(t)];
                        case 3:
                            return i = g.sent(), o = i.accessToken, s = i.idToken, a = i.refreshToken, u = i.state, c = new Ua({
                                IdToken: new ka({IdToken: s}),
                                RefreshToken: new xa({RefreshToken: a}),
                                AccessToken: new Aa({AccessToken: o})
                            }), l = void 0, this._config.identityPoolId ? [4, this.Credentials.set(c, "session")] : [3, 5];
                        case 4:
                            l = g.sent(), _u.debug("AWS credentials", l), g.label = 5;
                        case 5:
                            return f = /-/.test(u), (d = this.createCognitoUser(c.getIdToken().decodePayload()["cognito:username"])).setSignInUserSession(c), window && void 0 !== window.history && window.history.replaceState({}, null, this._config.oauth.redirectSignIn), Pu("signIn", d, "A user " + d.getUsername() + " has been signed in"), Pu("cognitoHostedUI", d, "A user " + d.getUsername() + " has been signed in via Cognito Hosted UI"), f && (h = u.split("-").splice(1).join("-"), Pu("customOAuthState", h.match(/.{2}/g).map((function (e) {
                                return String.fromCharCode(parseInt(e, 16))
                            })).join(""), "State for user " + d.getUsername())), [2, l];
                        case 6:
                            return p = g.sent(), _u.debug("Error in cognito hosted auth response", p), window && void 0 !== window.history && window.history.replaceState({}, null, this._config.oauth.redirectSignIn), Pu("signIn_failure", p, "The OAuth response flow failed"), Pu("cognitoHostedUI_failure", p, "A failure occurred when returning to the Cognito Hosted UI"), Pu("customState_failure", p, "A failure occurred when returning state"), [3, 7];
                        case 7:
                            return [3, 9];
                        case 8:
                            return this.oAuthFlowInProgress = !1, [7];
                        case 9:
                            return [2]
                    }
                }))
            }))
        }, e.prototype.essentialCredentials = function (e) {
            return {
                accessKeyId: e.accessKeyId,
                sessionToken: e.sessionToken,
                secretAccessKey: e.secretAccessKey,
                identityId: e.identityId,
                authenticated: e.authenticated
            }
        }, e.prototype.attributesToObject = function (e) {
            var t = this, n = {};
            return e && e.map((function (e) {
                "email_verified" === e.Name || "phone_number_verified" === e.Name ? n[e.Name] = t.isTruthyString(e.Value) || !0 === e.Value : n[e.Name] = e.Value
            })), n
        }, e.prototype.isTruthyString = function (e) {
            return "function" == typeof e.toLowerCase && "true" === e.toLowerCase()
        }, e.prototype.createCognitoUser = function (e) {
            var t = {Username: e, Pool: this.userPool};
            t.Storage = this._storage;
            var n = this._config.authenticationFlowType, r = new Fa(t);
            return n && r.setAuthenticationFlowType(n), r
        }, e.prototype._isValidAuthStorage = function (e) {
            return !!e && "function" == typeof e.getItem && "function" == typeof e.setItem && "function" == typeof e.removeItem && "function" == typeof e.clear
        }, e.prototype.noUserPoolErrorHandler = function (e) {
            return !e || e.userPoolId && e.identityPoolId ? Is.NoConfig : Is.MissingAuthConfig
        }, e.prototype.rejectAuthError = function (e) {
            return Promise.reject(new mu(e))
        }, e.prototype.rejectNoUserPool = function () {
            var e = this.noUserPoolErrorHandler(this._config);
            return Promise.reject(new yu(e))
        }, e.prototype.rememberDevice = function () {
            return bu(this, void 0, void 0, (function () {
                var e, t;
                return Eu(this, (function (n) {
                    switch (n.label) {
                        case 0:
                            return n.trys.push([0, 2, , 3]), [4, this.currentUserPoolUser()];
                        case 1:
                            return e = n.sent(), [3, 3];
                        case 2:
                            return t = n.sent(), _u.debug("The user is not authenticated by the error", t), [2, Promise.reject("The user is not authenticated")];
                        case 3:
                            return e.getCachedDeviceKeyAndPassword(), [2, new Promise((function (t, n) {
                                e.setDeviceStatusRemembered({
                                    onSuccess: function (e) {
                                        t(e)
                                    }, onFailure: function (e) {
                                        "InvalidParameterException" === e.code ? n(new mu(Is.DeviceConfig)) : "NetworkError" === e.code ? n(new mu(Is.NetworkError)) : n(e)
                                    }
                                })
                            }))]
                    }
                }))
            }))
        }, e.prototype.forgetDevice = function () {
            return bu(this, void 0, void 0, (function () {
                var e, t;
                return Eu(this, (function (n) {
                    switch (n.label) {
                        case 0:
                            return n.trys.push([0, 2, , 3]), [4, this.currentUserPoolUser()];
                        case 1:
                            return e = n.sent(), [3, 3];
                        case 2:
                            return t = n.sent(), _u.debug("The user is not authenticated by the error", t), [2, Promise.reject("The user is not authenticated")];
                        case 3:
                            return e.getCachedDeviceKeyAndPassword(), [2, new Promise((function (t, n) {
                                e.forgetDevice({
                                    onSuccess: function (e) {
                                        t(e)
                                    }, onFailure: function (e) {
                                        "InvalidParameterException" === e.code ? n(new mu(Is.DeviceConfig)) : "NetworkError" === e.code ? n(new mu(Is.NetworkError)) : n(e)
                                    }
                                })
                            }))]
                    }
                }))
            }))
        }, e.prototype.fetchDevices = function () {
            return bu(this, void 0, void 0, (function () {
                var e, t;
                return Eu(this, (function (n) {
                    switch (n.label) {
                        case 0:
                            return n.trys.push([0, 2, , 3]), [4, this.currentUserPoolUser()];
                        case 1:
                            return e = n.sent(), [3, 3];
                        case 2:
                            throw t = n.sent(), _u.debug("The user is not authenticated by the error", t), new Error("The user is not authenticated");
                        case 3:
                            return e.getCachedDeviceKeyAndPassword(), [2, new Promise((function (t, n) {
                                var r = {
                                    onSuccess: function (e) {
                                        var n = e.Devices.map((function (e) {
                                            var t = e.DeviceAttributes.find((function (e) {
                                                return "device_name" === e.Name
                                            })) || {};
                                            return {id: e.DeviceKey, name: t.Value}
                                        }));
                                        t(n)
                                    }, onFailure: function (e) {
                                        "InvalidParameterException" === e.code ? n(new mu(Is.DeviceConfig)) : "NetworkError" === e.code ? n(new mu(Is.NetworkError)) : n(e)
                                    }
                                };
                                e.listDevices(60, null, r)
                            }))]
                    }
                }))
            }))
        }, e
    }(), xu = new ku(null);
u.register(xu);
var Iu = {}, Tu = {};
Object.defineProperty(Tu, "__esModule", {value: !0}), Tu.AwsCrc32 = void 0;
var Uu = $, Ou = Qe, Mu = Iu, Lu = function () {
    function e() {
        this.crc32 = new Mu.Crc32
    }

    return e.prototype.update = function (e) {
        (0, Ou.isEmptyData)(e) || this.crc32.update((0, Ou.convertToBuffer)(e))
    }, e.prototype.digest = function () {
        return (0, Uu.__awaiter)(this, void 0, void 0, (function () {
            return (0, Uu.__generator)(this, (function (e) {
                return [2, (0, Ou.numToUint8)(this.crc32.digest())]
            }))
        }))
    }, e
}();
Tu.AwsCrc32 = Lu, function (e) {
    Object.defineProperty(e, "__esModule", {value: !0}), e.AwsCrc32 = e.Crc32 = e.crc32 = void 0;
    var t = $, n = Qe;
    e.crc32 = function (e) {
        return (new r).update(e).digest()
    };
    var r = function () {
        function e() {
            this.checksum = 4294967295
        }

        return e.prototype.update = function (e) {
            var n, r;
            try {
                for (var o = (0, t.__values)(e), s = o.next(); !s.done; s = o.next()) {
                    var a = s.value;
                    this.checksum = this.checksum >>> 8 ^ i[255 & (this.checksum ^ a)]
                }
            } catch (e) {
                n = {error: e}
            } finally {
                try {
                    s && !s.done && (r = o.return) && r.call(o)
                } finally {
                    if (n) throw n.error
                }
            }
            return this
        }, e.prototype.digest = function () {
            return (4294967295 ^ this.checksum) >>> 0
        }, e
    }();
    e.Crc32 = r;
    var i = (0, n.uint32ArrayFrom)([0, 1996959894, 3993919788, 2567524794, 124634137, 1886057615, 3915621685, 2657392035, 249268274, 2044508324, 3772115230, 2547177864, 162941995, 2125561021, 3887607047, 2428444049, 498536548, 1789927666, 4089016648, 2227061214, 450548861, 1843258603, 4107580753, 2211677639, 325883990, 1684777152, 4251122042, 2321926636, 335633487, 1661365465, 4195302755, 2366115317, 997073096, 1281953886, 3579855332, 2724688242, 1006888145, 1258607687, 3524101629, 2768942443, 901097722, 1119000684, 3686517206, 2898065728, 853044451, 1172266101, 3705015759, 2882616665, 651767980, 1373503546, 3369554304, 3218104598, 565507253, 1454621731, 3485111705, 3099436303, 671266974, 1594198024, 3322730930, 2970347812, 795835527, 1483230225, 3244367275, 3060149565, 1994146192, 31158534, 2563907772, 4023717930, 1907459465, 112637215, 2680153253, 3904427059, 2013776290, 251722036, 2517215374, 3775830040, 2137656763, 141376813, 2439277719, 3865271297, 1802195444, 476864866, 2238001368, 4066508878, 1812370925, 453092731, 2181625025, 4111451223, 1706088902, 314042704, 2344532202, 4240017532, 1658658271, 366619977, 2362670323, 4224994405, 1303535960, 984961486, 2747007092, 3569037538, 1256170817, 1037604311, 2765210733, 3554079995, 1131014506, 879679996, 2909243462, 3663771856, 1141124467, 855842277, 2852801631, 3708648649, 1342533948, 654459306, 3188396048, 3373015174, 1466479909, 544179635, 3110523913, 3462522015, 1591671054, 702138776, 2966460450, 3352799412, 1504918807, 783551873, 3082640443, 3233442989, 3988292384, 2596254646, 62317068, 1957810842, 3939845945, 2647816111, 81470997, 1943803523, 3814918930, 2489596804, 225274430, 2053790376, 3826175755, 2466906013, 167816743, 2097651377, 4027552580, 2265490386, 503444072, 1762050814, 4150417245, 2154129355, 426522225, 1852507879, 4275313526, 2312317920, 282753626, 1742555852, 4189708143, 2394877945, 397917763, 1622183637, 3604390888, 2714866558, 953729732, 1340076626, 3518719985, 2797360999, 1068828381, 1219638859, 3624741850, 2936675148, 906185462, 1090812512, 3747672003, 2825379669, 829329135, 1181335161, 3412177804, 3160834842, 628085408, 1382605366, 3423369109, 3138078467, 570562233, 1426400815, 3317316542, 2998733608, 733239954, 1555261956, 3268935591, 3050360625, 752459403, 1541320221, 2607071920, 3965973030, 1969922972, 40735498, 2617837225, 3943577151, 1913087877, 83908371, 2512341634, 3803740692, 2075208622, 213261112, 2463272603, 3855990285, 2094854071, 198958881, 2262029012, 4057260610, 1759359992, 534414190, 2176718541, 4139329115, 1873836001, 414664567, 2282248934, 4279200368, 1711684554, 285281116, 2405801727, 4167216745, 1634467795, 376229701, 2685067896, 3608007406, 1308918612, 956543938, 2808555105, 3495958263, 1231636301, 1047427035, 2932959818, 3654703836, 1088359270, 936918e3, 2847714899, 3736837829, 1202900863, 817233897, 3183342108, 3401237130, 1404277552, 615818150, 3134207493, 3453421203, 1423857449, 601450431, 3009837614, 3294710456, 1567103746, 711928724, 3020668471, 3272380065, 1510334235, 755167117]),
        o = Tu;
    Object.defineProperty(e, "AwsCrc32", {
        enumerable: !0, get: function () {
            return o.AwsCrc32
        }
    })
}(Iu);
var Ru = function () {
    function e(e) {
        if (this.bytes = e, 8 !== e.byteLength) throw new Error("Int64 buffers must be exactly 8 bytes")
    }

    return e.fromNumber = function (t) {
        if (t > 0x8000000000000000 || t < -0x8000000000000000) throw new Error(t + " is too large (or, if negative, too small) to represent as an Int64");
        for (var n = new Uint8Array(8), r = 7, i = Math.abs(Math.round(t)); r > -1 && i > 0; r--, i /= 256) n[r] = i;
        return t < 0 && Nu(n), new e(n)
    }, e.prototype.valueOf = function () {
        var e = this.bytes.slice(0), t = 128 & e[0];
        return t && Nu(e), parseInt(Q(e), 16) * (t ? -1 : 1)
    }, e.prototype.toString = function () {
        return String(this.valueOf())
    }, e
}();

function Nu(e) {
    for (var t = 0; t < 8; t++) e[t] ^= 255;
    for (t = 7; t > -1 && (e[t]++, 0 === e[t]); t--) ;
}

var Du, Bu = function () {
    function e(e, t) {
        this.toUtf8 = e, this.fromUtf8 = t
    }

    return e.prototype.format = function (e) {
        var t, n, r, i, o = [];
        try {
            for (var s = z(Object.keys(e)), a = s.next(); !a.done; a = s.next()) {
                var u = a.value, c = this.fromUtf8(u);
                o.push(Uint8Array.from([c.byteLength]), c, this.formatHeaderValue(e[u]))
            }
        } catch (e) {
            t = {error: e}
        } finally {
            try {
                a && !a.done && (n = s.return) && n.call(s)
            } finally {
                if (t) throw t.error
            }
        }
        var l = new Uint8Array(o.reduce((function (e, t) {
            return e + t.byteLength
        }), 0)), f = 0;
        try {
            for (var d = z(o), h = d.next(); !h.done; h = d.next()) {
                var p = h.value;
                l.set(p, f), f += p.byteLength
            }
        } catch (e) {
            r = {error: e}
        } finally {
            try {
                h && !h.done && (i = d.return) && i.call(d)
            } finally {
                if (r) throw r.error
            }
        }
        return l
    }, e.prototype.formatHeaderValue = function (e) {
        switch (e.type) {
            case"boolean":
                return Uint8Array.from([e.value ? 0 : 1]);
            case"byte":
                return Uint8Array.from([2, e.value]);
            case"short":
                var t = new DataView(new ArrayBuffer(3));
                return t.setUint8(0, 3), t.setInt16(1, e.value, !1), new Uint8Array(t.buffer);
            case"integer":
                var n = new DataView(new ArrayBuffer(5));
                return n.setUint8(0, 4), n.setInt32(1, e.value, !1), new Uint8Array(n.buffer);
            case"long":
                var r = new Uint8Array(9);
                return r[0] = 5, r.set(e.value.bytes, 1), r;
            case"binary":
                var i = new DataView(new ArrayBuffer(3 + e.value.byteLength));
                i.setUint8(0, 6), i.setUint16(1, e.value.byteLength, !1);
                var o = new Uint8Array(i.buffer);
                return o.set(e.value, 3), o;
            case"string":
                var s = this.fromUtf8(e.value), a = new DataView(new ArrayBuffer(3 + s.byteLength));
                a.setUint8(0, 7), a.setUint16(1, s.byteLength, !1);
                var u = new Uint8Array(a.buffer);
                return u.set(s, 3), u;
            case"timestamp":
                var c = new Uint8Array(9);
                return c[0] = 8, c.set(Ru.fromNumber(e.value.valueOf()).bytes, 1), c;
            case"uuid":
                if (!$u.test(e.value)) throw new Error("Invalid UUID received: " + e.value);
                var l = new Uint8Array(17);
                return l[0] = 9, l.set(function (e) {
                    if (e.length % 2 != 0) throw new Error("Hex encoded strings must have an even number length");
                    for (var t = new Uint8Array(e.length / 2), n = 0; n < e.length; n += 2) {
                        var r = e.substr(n, 2).toLowerCase();
                        if (!(r in J)) throw new Error("Cannot decode unrecognized sequence " + r + " as hexadecimal");
                        t[n / 2] = J[r]
                    }
                    return t
                }(e.value.replace(/\-/g, "")), 1), l
        }
    }, e.prototype.parse = function (e) {
        for (var t = {}, n = 0; n < e.byteLength;) {
            var r = e.getUint8(n++), i = this.toUtf8(new Uint8Array(e.buffer, e.byteOffset + n, r));
            switch (n += r, e.getUint8(n++)) {
                case 0:
                    t[i] = {type: ju, value: !0};
                    break;
                case 1:
                    t[i] = {type: ju, value: !1};
                    break;
                case 2:
                    t[i] = {type: Fu, value: e.getInt8(n++)};
                    break;
                case 3:
                    t[i] = {type: zu, value: e.getInt16(n, !1)}, n += 2;
                    break;
                case 4:
                    t[i] = {type: Ku, value: e.getInt32(n, !1)}, n += 4;
                    break;
                case 5:
                    t[i] = {type: qu, value: new Ru(new Uint8Array(e.buffer, e.byteOffset + n, 8))}, n += 8;
                    break;
                case 6:
                    var o = e.getUint16(n, !1);
                    n += 2, t[i] = {type: Hu, value: new Uint8Array(e.buffer, e.byteOffset + n, o)}, n += o;
                    break;
                case 7:
                    var s = e.getUint16(n, !1);
                    n += 2, t[i] = {
                        type: Vu,
                        value: this.toUtf8(new Uint8Array(e.buffer, e.byteOffset + n, s))
                    }, n += s;
                    break;
                case 8:
                    t[i] = {
                        type: Gu,
                        value: new Date(new Ru(new Uint8Array(e.buffer, e.byteOffset + n, 8)).valueOf())
                    }, n += 8;
                    break;
                case 9:
                    var a = new Uint8Array(e.buffer, e.byteOffset + n, 16);
                    n += 16, t[i] = {
                        type: Wu,
                        value: Q(a.subarray(0, 4)) + "-" + Q(a.subarray(4, 6)) + "-" + Q(a.subarray(6, 8)) + "-" + Q(a.subarray(8, 10)) + "-" + Q(a.subarray(10))
                    };
                    break;
                default:
                    throw new Error("Unrecognized header type tag")
            }
        }
        return t
    }, e
}();
!function (e) {
    e[e.boolTrue = 0] = "boolTrue", e[e.boolFalse = 1] = "boolFalse", e[e.byte = 2] = "byte", e[e.short = 3] = "short", e[e.integer = 4] = "integer", e[e.long = 5] = "long", e[e.byteArray = 6] = "byteArray", e[e.string = 7] = "string", e[e.timestamp = 8] = "timestamp", e[e.uuid = 9] = "uuid"
}(Du || (Du = {}));
var ju = "boolean", Fu = "byte", zu = "short", Ku = "integer", qu = "long", Hu = "binary", Vu = "string",
    Gu = "timestamp", Wu = "uuid", $u = /^[a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12}$/;
var Yu = function () {
    function e(e, t) {
        this.headerMarshaller = new Bu(e, t)
    }

    return e.prototype.marshall = function (e) {
        var t = e.headers, n = e.body, r = this.headerMarshaller.format(t), i = r.byteLength + n.byteLength + 16,
            o = new Uint8Array(i), s = new DataView(o.buffer, o.byteOffset, o.byteLength), a = new Iu.Crc32;
        return s.setUint32(0, i, !1), s.setUint32(4, r.byteLength, !1), s.setUint32(8, a.update(o.subarray(0, 8)).digest(), !1), o.set(r, 12), o.set(n, r.byteLength + 12), s.setUint32(i - 4, a.update(o.subarray(8, i - 4)).digest(), !1), o
    }, e.prototype.unmarshall = function (e) {
        var t = function (e) {
            var t = e.byteLength, n = e.byteOffset, r = e.buffer;
            if (t < 16) throw new Error("Provided message too short to accommodate event stream message overhead");
            var i = new DataView(r, n, t), o = i.getUint32(0, !1);
            if (t !== o) throw new Error("Reported message length does not match received message length");
            var s = i.getUint32(4, !1), a = i.getUint32(8, !1), u = i.getUint32(t - 4, !1),
                c = (new Iu.Crc32).update(new Uint8Array(r, n, 8));
            if (a !== c.digest()) throw new Error("The prelude checksum specified in the message (" + a + ") does not match the calculated CRC32 checksum (" + c.digest() + ")");
            if (c.update(new Uint8Array(r, n + 8, t - 12)), u !== c.digest()) throw new Error("The message checksum (" + c.digest() + ") did not match the expected value of " + u);
            return {headers: new DataView(r, n + 8 + 4, s), body: new Uint8Array(r, n + 8 + 4 + s, o - s - 16)}
        }(e), n = t.headers, r = t.body;
        return {headers: this.headerMarshaller.parse(n), body: r}
    }, e.prototype.formatHeaders = function (e) {
        return this.headerMarshaller.format(e)
    }, e
}();
var Ju = function () {
    function e(e) {
        var t = e.utf8Encoder, n = e.utf8Decoder;
        this.eventMarshaller = new Yu(t, n), this.utfEncoder = t
    }

    return e.prototype.deserialize = function (e, t) {
        var n, r, i, o, s, a, u, c = (n = e, i = 0, o = 0, s = null, a = null, u = function (e) {
            if ("number" != typeof e) throw new Error("Attempted to allocate an event message where size was not a number: " + e);
            i = e, o = 4, s = new Uint8Array(e), new DataView(s.buffer).setUint32(0, e, !1)
        }, (r = {})[Symbol.asyncIterator] = function () {
            return V(this, arguments, (function () {
                var e, t, r, c, l, f, d, h;
                return F(this, (function (p) {
                    switch (p.label) {
                        case 0:
                            e = n[Symbol.asyncIterator](), p.label = 1;
                        case 1:
                            return [4, H(e.next())];
                        case 2:
                            return t = p.sent(), r = t.value, t.done ? i ? [3, 4] : [4, H(void 0)] : [3, 10];
                        case 3:
                            return [2, p.sent()];
                        case 4:
                            return i !== o ? [3, 7] : [4, H(s)];
                        case 5:
                            return [4, p.sent()];
                        case 6:
                            return p.sent(), [3, 8];
                        case 7:
                            throw new Error("Truncated event message received.");
                        case 8:
                            return [4, H(void 0)];
                        case 9:
                            return [2, p.sent()];
                        case 10:
                            c = r.length, l = 0, p.label = 11;
                        case 11:
                            if (!(l < c)) return [3, 15];
                            if (!s) {
                                if (f = c - l, a || (a = new Uint8Array(4)), d = Math.min(4 - o, f), a.set(r.slice(l, l + d), o), l += d, (o += d) < 4) return [3, 15];
                                u(new DataView(a.buffer).getUint32(0, !1)), a = null
                            }
                            return h = Math.min(i - o, c - l), s.set(r.slice(l, l + h), o), o += h, l += h, i && i === o ? [4, H(s)] : [3, 14];
                        case 12:
                            return [4, p.sent()];
                        case 13:
                            p.sent(), s = null, i = 0, o = 0, p.label = 14;
                        case 14:
                            return [3, 11];
                        case 15:
                            return [3, 1];
                        case 16:
                            return [2]
                    }
                }))
            }))
        }, r), l = function (e, t) {
            var n;
            return (n = {})[Symbol.asyncIterator] = function () {
                return V(this, arguments, (function () {
                    var n, r, i, o, s, a, u, c, l, f, d, h, p, g, v, m, y;
                    return F(this, (function (S) {
                        switch (S.label) {
                            case 0:
                                S.trys.push([0, 12, 13, 18]), n = G(e), S.label = 1;
                            case 1:
                                return [4, H(n.next())];
                            case 2:
                                if ((r = S.sent()).done) return [3, 11];
                                if (i = r.value, o = t.eventMarshaller.unmarshall(i), "error" !== (s = o.headers[":message-type"].value)) return [3, 3];
                                throw(a = new Error(o.headers[":error-message"].value || "UnknownError")).name = o.headers[":error-code"].value, a;
                            case 3:
                                return "exception" !== s ? [3, 5] : (u = o.headers[":exception-type"].value, (g = {})[u] = o, c = g, [4, H(t.deserializer(c))]);
                            case 4:
                                if ((l = S.sent()).$unknown) throw(f = new Error(t.toUtf8(o.body))).name = u, f;
                                throw l[u];
                            case 5:
                                return "event" !== s ? [3, 9] : ((v = {})[o.headers[":event-type"].value] = o, d = v, [4, H(t.deserializer(d))]);
                            case 6:
                                return (h = S.sent()).$unknown ? [3, 10] : [4, H(h)];
                            case 7:
                                return [4, S.sent()];
                            case 8:
                                return S.sent(), [3, 10];
                            case 9:
                                throw Error("Unrecognizable event type: " + o.headers[":event-type"].value);
                            case 10:
                                return [3, 1];
                            case 11:
                                return [3, 18];
                            case 12:
                                return p = S.sent(), m = {error: p}, [3, 18];
                            case 13:
                                return S.trys.push([13, , 16, 17]), r && !r.done && (y = n.return) ? [4, H(y.call(n))] : [3, 15];
                            case 14:
                                S.sent(), S.label = 15;
                            case 15:
                                return [3, 17];
                            case 16:
                                if (m) throw m.error;
                                return [7];
                            case 17:
                                return [7];
                            case 18:
                                return [2]
                        }
                    }))
                }))
            }, n
        }(c, {eventMarshaller: this.eventMarshaller, deserializer: t, toUtf8: this.utfEncoder});
        return l
    }, e.prototype.serialize = function (e, t) {
        var n, r = this;
        return (n = {})[Symbol.asyncIterator] = function () {
            return V(this, arguments, (function () {
                var n, i, o, s, a, u;
                return F(this, (function (c) {
                    switch (c.label) {
                        case 0:
                            c.trys.push([0, 7, 8, 13]), n = G(e), c.label = 1;
                        case 1:
                            return [4, H(n.next())];
                        case 2:
                            return (i = c.sent()).done ? [3, 6] : (o = i.value, [4, H(r.eventMarshaller.marshall(t(o)))]);
                        case 3:
                            return [4, c.sent()];
                        case 4:
                            c.sent(), c.label = 5;
                        case 5:
                            return [3, 1];
                        case 6:
                            return [3, 13];
                        case 7:
                            return s = c.sent(), a = {error: s}, [3, 13];
                        case 8:
                            return c.trys.push([8, , 11, 12]), i && !i.done && (u = n.return) ? [4, H(u.call(n))] : [3, 10];
                        case 9:
                            c.sent(), c.label = 10;
                        case 10:
                            return [3, 12];
                        case 11:
                            if (a) throw a.error;
                            return [7];
                        case 12:
                            return [7];
                        case 13:
                            return [4, H(new Uint8Array(0))];
                        case 14:
                            return [4, c.sent()];
                        case 15:
                            return c.sent(), [2]
                    }
                }))
            }))
        }, n
    }, e
}(), Zu = function () {
    function e(e) {
        var t = e.utf8Encoder, n = e.utf8Decoder;
        this.eventMarshaller = new Yu(t, n), this.universalMarshaller = new Ju({utf8Decoder: n, utf8Encoder: t})
    }

    return e.prototype.deserialize = function (e, t) {
        var n, r, i = Xu(e) ? (n = e, (r = {})[Symbol.asyncIterator] = function () {
            return V(this, arguments, (function () {
                var e, t, r, i;
                return F(this, (function (o) {
                    switch (o.label) {
                        case 0:
                            e = n.getReader(), o.label = 1;
                        case 1:
                            o.trys.push([1, , 9, 10]), o.label = 2;
                        case 2:
                            return [4, H(e.read())];
                        case 3:
                            return t = o.sent(), r = t.done, i = t.value, r ? [4, H(void 0)] : [3, 5];
                        case 4:
                            return [2, o.sent()];
                        case 5:
                            return [4, H(i)];
                        case 6:
                            return [4, o.sent()];
                        case 7:
                            return o.sent(), [3, 2];
                        case 8:
                            return [3, 10];
                        case 9:
                            return e.releaseLock(), [7];
                        case 10:
                            return [2]
                    }
                }))
            }))
        }, r) : e;
        return this.universalMarshaller.deserialize(i, t)
    }, e.prototype.serialize = function (e, t) {
        var n, r = this.universalMarshaller.serialize(e, t);
        return "function" == typeof ReadableStream ? (n = r[Symbol.asyncIterator](), new ReadableStream({
            pull: function (e) {
                return j(this, void 0, void 0, (function () {
                    var t, r, i;
                    return F(this, (function (o) {
                        switch (o.label) {
                            case 0:
                                return [4, n.next()];
                            case 1:
                                return t = o.sent(), r = t.done, i = t.value, r ? [2, e.close()] : (e.enqueue(i), [2])
                        }
                    }))
                }))
            }
        })) : r
    }, e
}(), Xu = function (e) {
    return "function" == typeof ReadableStream && e instanceof ReadableStream
}, Qu = function (e, t) {
    return Qu = Object.setPrototypeOf || {__proto__: []} instanceof Array && function (e, t) {
        e.__proto__ = t
    } || function (e, t) {
        for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n])
    }, Qu(e, t)
};

function ec(e, t) {
    if ("function" != typeof t && null !== t) throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");

    function n() {
        this.constructor = e
    }

    Qu(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n)
}

var tc = function () {
    return tc = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var i in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
        return e
    }, tc.apply(this, arguments)
};

function nc(e, t, n, r) {
    return new (n || (n = Promise))((function (i, o) {
        function s(e) {
            try {
                u(r.next(e))
            } catch (e) {
                o(e)
            }
        }

        function a(e) {
            try {
                u(r.throw(e))
            } catch (e) {
                o(e)
            }
        }

        function u(e) {
            var t;
            e.done ? i(e.value) : (t = e.value, t instanceof n ? t : new n((function (e) {
                e(t)
            }))).then(s, a)
        }

        u((r = r.apply(e, t || [])).next())
    }))
}

function rc(e, t) {
    var n, r, i, o, s = {
        label: 0, sent: function () {
            if (1 & i[0]) throw i[1];
            return i[1]
        }, trys: [], ops: []
    };
    return o = {
        next: a(0),
        throw: a(1),
        return: a(2)
    }, "function" == typeof Symbol && (o[Symbol.iterator] = function () {
        return this
    }), o;

    function a(o) {
        return function (a) {
            return function (o) {
                if (n) throw new TypeError("Generator is already executing.");
                for (; s;) try {
                    if (n = 1, r && (i = 2 & o[0] ? r.return : o[0] ? r.throw || ((i = r.return) && i.call(r), 0) : r.next) && !(i = i.call(r, o[1])).done) return i;
                    switch (r = 0, i && (o = [2 & o[0], i.value]), o[0]) {
                        case 0:
                        case 1:
                            i = o;
                            break;
                        case 4:
                            return s.label++, {value: o[1], done: !1};
                        case 5:
                            s.label++, r = o[1], o = [0];
                            continue;
                        case 7:
                            o = s.ops.pop(), s.trys.pop();
                            continue;
                        default:
                            if (!(i = s.trys, (i = i.length > 0 && i[i.length - 1]) || 6 !== o[0] && 2 !== o[0])) {
                                s = 0;
                                continue
                            }
                            if (3 === o[0] && (!i || o[1] > i[0] && o[1] < i[3])) {
                                s.label = o[1];
                                break
                            }
                            if (6 === o[0] && s.label < i[1]) {
                                s.label = i[1], i = o;
                                break
                            }
                            if (i && s.label < i[2]) {
                                s.label = i[2], s.ops.push(o);
                                break
                            }
                            i[2] && s.ops.pop(), s.trys.pop();
                            continue
                    }
                    o = t.call(e, s)
                } catch (e) {
                    o = [6, e], r = 0
                } finally {
                    n = i = 0
                }
                if (5 & o[0]) throw o[1];
                return {value: o[0] ? o[1] : void 0, done: !0}
            }([o, a])
        }
    }
}

var ic = "3.6.1";

function oc(e, t, n) {
    return void 0 === n && (n = 1048576), new Promise((function (r, i) {
        var o = new FileReader;
        o.addEventListener("error", i), o.addEventListener("abort", i);
        var s = e.size, a = 0;

        function u() {
            a >= s ? r() : o.readAsArrayBuffer(e.slice(a, Math.min(s, a + n)))
        }

        o.addEventListener("load", (function (e) {
            var n = e.target.result;
            t(new Uint8Array(n)), a += n.byteLength, u()
        })), u()
    }))
}

var sc = [1732584193, 4023233417, 2562383102, 271733878], ac = function () {
    function e() {
        this.state = Uint32Array.from(sc), this.buffer = new DataView(new ArrayBuffer(64)), this.bufferLength = 0, this.bytesHashed = 0, this.finished = !1
    }

    return e.prototype.update = function (e) {
        if (!function (e) {
            if ("string" == typeof e) return 0 === e.length;
            return 0 === e.byteLength
        }(e)) {
            if (this.finished) throw new Error("Attempted to update an already finished hash.");
            var t = function (e) {
                if ("string" == typeof e) return ze(e);
                if (ArrayBuffer.isView(e)) return new Uint8Array(e.buffer, e.byteOffset, e.byteLength / Uint8Array.BYTES_PER_ELEMENT);
                return new Uint8Array(e)
            }(e), n = 0, r = t.byteLength;
            for (this.bytesHashed += r; r > 0;) this.buffer.setUint8(this.bufferLength++, t[n++]), r--, 64 === this.bufferLength && (this.hashBuffer(), this.bufferLength = 0)
        }
    }, e.prototype.digest = function () {
        return j(this, void 0, void 0, (function () {
            var e, t, n, r, i, o, s;
            return F(this, (function (a) {
                if (!this.finished) {
                    if (t = (e = this).buffer, n = e.bufferLength, r = e.bytesHashed, i = 8 * r, t.setUint8(this.bufferLength++, 128), n % 64 >= 56) {
                        for (s = this.bufferLength; s < 64; s++) t.setUint8(s, 0);
                        this.hashBuffer(), this.bufferLength = 0
                    }
                    for (s = this.bufferLength; s < 56; s++) t.setUint8(s, 0);
                    t.setUint32(56, i >>> 0, !0), t.setUint32(60, Math.floor(i / 4294967296), !0), this.hashBuffer(), this.finished = !0
                }
                for (o = new DataView(new ArrayBuffer(16)), s = 0; s < 4; s++) o.setUint32(4 * s, this.state[s], !0);
                return [2, new Uint8Array(o.buffer, o.byteOffset, o.byteLength)]
            }))
        }))
    }, e.prototype.hashBuffer = function () {
        var e = this.buffer, t = this.state, n = t[0], r = t[1], i = t[2], o = t[3];
        n = cc(n, r, i, o, e.getUint32(0, !0), 7, 3614090360), o = cc(o, n, r, i, e.getUint32(4, !0), 12, 3905402710), i = cc(i, o, n, r, e.getUint32(8, !0), 17, 606105819), r = cc(r, i, o, n, e.getUint32(12, !0), 22, 3250441966), n = cc(n, r, i, o, e.getUint32(16, !0), 7, 4118548399), o = cc(o, n, r, i, e.getUint32(20, !0), 12, 1200080426), i = cc(i, o, n, r, e.getUint32(24, !0), 17, 2821735955), r = cc(r, i, o, n, e.getUint32(28, !0), 22, 4249261313), n = cc(n, r, i, o, e.getUint32(32, !0), 7, 1770035416), o = cc(o, n, r, i, e.getUint32(36, !0), 12, 2336552879), i = cc(i, o, n, r, e.getUint32(40, !0), 17, 4294925233), r = cc(r, i, o, n, e.getUint32(44, !0), 22, 2304563134), n = cc(n, r, i, o, e.getUint32(48, !0), 7, 1804603682), o = cc(o, n, r, i, e.getUint32(52, !0), 12, 4254626195), i = cc(i, o, n, r, e.getUint32(56, !0), 17, 2792965006), n = lc(n, r = cc(r, i, o, n, e.getUint32(60, !0), 22, 1236535329), i, o, e.getUint32(4, !0), 5, 4129170786), o = lc(o, n, r, i, e.getUint32(24, !0), 9, 3225465664), i = lc(i, o, n, r, e.getUint32(44, !0), 14, 643717713), r = lc(r, i, o, n, e.getUint32(0, !0), 20, 3921069994), n = lc(n, r, i, o, e.getUint32(20, !0), 5, 3593408605), o = lc(o, n, r, i, e.getUint32(40, !0), 9, 38016083), i = lc(i, o, n, r, e.getUint32(60, !0), 14, 3634488961), r = lc(r, i, o, n, e.getUint32(16, !0), 20, 3889429448), n = lc(n, r, i, o, e.getUint32(36, !0), 5, 568446438), o = lc(o, n, r, i, e.getUint32(56, !0), 9, 3275163606), i = lc(i, o, n, r, e.getUint32(12, !0), 14, 4107603335), r = lc(r, i, o, n, e.getUint32(32, !0), 20, 1163531501), n = lc(n, r, i, o, e.getUint32(52, !0), 5, 2850285829), o = lc(o, n, r, i, e.getUint32(8, !0), 9, 4243563512), i = lc(i, o, n, r, e.getUint32(28, !0), 14, 1735328473), n = fc(n, r = lc(r, i, o, n, e.getUint32(48, !0), 20, 2368359562), i, o, e.getUint32(20, !0), 4, 4294588738), o = fc(o, n, r, i, e.getUint32(32, !0), 11, 2272392833), i = fc(i, o, n, r, e.getUint32(44, !0), 16, 1839030562), r = fc(r, i, o, n, e.getUint32(56, !0), 23, 4259657740), n = fc(n, r, i, o, e.getUint32(4, !0), 4, 2763975236), o = fc(o, n, r, i, e.getUint32(16, !0), 11, 1272893353), i = fc(i, o, n, r, e.getUint32(28, !0), 16, 4139469664), r = fc(r, i, o, n, e.getUint32(40, !0), 23, 3200236656), n = fc(n, r, i, o, e.getUint32(52, !0), 4, 681279174), o = fc(o, n, r, i, e.getUint32(0, !0), 11, 3936430074), i = fc(i, o, n, r, e.getUint32(12, !0), 16, 3572445317), r = fc(r, i, o, n, e.getUint32(24, !0), 23, 76029189), n = fc(n, r, i, o, e.getUint32(36, !0), 4, 3654602809), o = fc(o, n, r, i, e.getUint32(48, !0), 11, 3873151461), i = fc(i, o, n, r, e.getUint32(60, !0), 16, 530742520), n = dc(n, r = fc(r, i, o, n, e.getUint32(8, !0), 23, 3299628645), i, o, e.getUint32(0, !0), 6, 4096336452), o = dc(o, n, r, i, e.getUint32(28, !0), 10, 1126891415), i = dc(i, o, n, r, e.getUint32(56, !0), 15, 2878612391), r = dc(r, i, o, n, e.getUint32(20, !0), 21, 4237533241), n = dc(n, r, i, o, e.getUint32(48, !0), 6, 1700485571), o = dc(o, n, r, i, e.getUint32(12, !0), 10, 2399980690), i = dc(i, o, n, r, e.getUint32(40, !0), 15, 4293915773), r = dc(r, i, o, n, e.getUint32(4, !0), 21, 2240044497), n = dc(n, r, i, o, e.getUint32(32, !0), 6, 1873313359), o = dc(o, n, r, i, e.getUint32(60, !0), 10, 4264355552), i = dc(i, o, n, r, e.getUint32(24, !0), 15, 2734768916), r = dc(r, i, o, n, e.getUint32(52, !0), 21, 1309151649), n = dc(n, r, i, o, e.getUint32(16, !0), 6, 4149444226), o = dc(o, n, r, i, e.getUint32(44, !0), 10, 3174756917), i = dc(i, o, n, r, e.getUint32(8, !0), 15, 718787259), r = dc(r, i, o, n, e.getUint32(36, !0), 21, 3951481745), t[0] = n + t[0] & 4294967295, t[1] = r + t[1] & 4294967295, t[2] = i + t[2] & 4294967295, t[3] = o + t[3] & 4294967295
    }, e
}();

function uc(e, t, n, r, i, o) {
    return ((t = (t + e & 4294967295) + (r + o & 4294967295) & 4294967295) << i | t >>> 32 - i) + n & 4294967295
}

function cc(e, t, n, r, i, o, s) {
    return uc(t & n | ~t & r, e, t, i, o, s)
}

function lc(e, t, n, r, i, o, s) {
    return uc(t & r | n & ~r, e, t, i, o, s)
}

function fc(e, t, n, r, i, o, s) {
    return uc(t ^ n ^ r, e, t, i, o, s)
}

function dc(e, t, n, r, i, o, s) {
    return uc(n ^ (t | ~r), e, t, i, o, s)
}

var hc = new Set(["af-south-1", "ap-east-1", "ap-northeast-1", "ap-northeast-2", "ap-south-1", "ap-southeast-1", "ap-southeast-2", "ca-central-1", "eu-central-1", "eu-north-1", "eu-south-1", "eu-west-1", "eu-west-2", "eu-west-3", "me-south-1", "sa-east-1", "us-east-1", "us-east-2", "us-west-1", "us-west-2"]),
    pc = new Set(["cn-north-1", "cn-northwest-1"]), gc = new Set(["us-iso-east-1"]), vc = new Set(["us-isob-east-1"]),
    mc = new Set(["us-gov-east-1", "us-gov-west-1"]), yc = {
        apiVersion: "2006-03-01", disableHostPrefix: !1, logger: {}, regionInfoProvider: function (e, t) {
            var n = void 0;
            switch (e) {
                case"af-south-1":
                    n = {hostname: "s3.af-south-1.amazonaws.com", partition: "aws"};
                    break;
                case"ap-east-1":
                    n = {hostname: "s3.ap-east-1.amazonaws.com", partition: "aws"};
                    break;
                case"ap-northeast-1":
                    n = {hostname: "s3.ap-northeast-1.amazonaws.com", partition: "aws"};
                    break;
                case"ap-northeast-2":
                    n = {hostname: "s3.ap-northeast-2.amazonaws.com", partition: "aws"};
                    break;
                case"ap-south-1":
                    n = {hostname: "s3.ap-south-1.amazonaws.com", partition: "aws"};
                    break;
                case"ap-southeast-1":
                    n = {hostname: "s3.ap-southeast-1.amazonaws.com", partition: "aws"};
                    break;
                case"ap-southeast-2":
                    n = {hostname: "s3.ap-southeast-2.amazonaws.com", partition: "aws"};
                    break;
                case"aws-global":
                    n = {hostname: "s3.amazonaws.com", partition: "aws", signingRegion: "us-east-1"};
                    break;
                case"ca-central-1":
                    n = {hostname: "s3.ca-central-1.amazonaws.com", partition: "aws"};
                    break;
                case"cn-north-1":
                    n = {hostname: "s3.cn-north-1.amazonaws.com.cn", partition: "aws-cn"};
                    break;
                case"cn-northwest-1":
                    n = {hostname: "s3.cn-northwest-1.amazonaws.com.cn", partition: "aws-cn"};
                    break;
                case"eu-central-1":
                    n = {hostname: "s3.eu-central-1.amazonaws.com", partition: "aws"};
                    break;
                case"eu-north-1":
                    n = {hostname: "s3.eu-north-1.amazonaws.com", partition: "aws"};
                    break;
                case"eu-south-1":
                    n = {hostname: "s3.eu-south-1.amazonaws.com", partition: "aws"};
                    break;
                case"eu-west-1":
                    n = {hostname: "s3.eu-west-1.amazonaws.com", partition: "aws"};
                    break;
                case"eu-west-2":
                    n = {hostname: "s3.eu-west-2.amazonaws.com", partition: "aws"};
                    break;
                case"eu-west-3":
                    n = {hostname: "s3.eu-west-3.amazonaws.com", partition: "aws"};
                    break;
                case"fips-us-gov-west-1":
                    n = {
                        hostname: "s3-fips.us-gov-west-1.amazonaws.com",
                        partition: "aws-us-gov",
                        signingRegion: "us-gov-west-1"
                    };
                    break;
                case"me-south-1":
                    n = {hostname: "s3.me-south-1.amazonaws.com", partition: "aws"};
                    break;
                case"s3-external-1":
                    n = {hostname: "s3-external-1.amazonaws.com", partition: "aws", signingRegion: "us-east-1"};
                    break;
                case"sa-east-1":
                    n = {hostname: "s3.sa-east-1.amazonaws.com", partition: "aws"};
                    break;
                case"us-east-1":
                    n = {hostname: "s3.us-east-1.amazonaws.com", partition: "aws"};
                    break;
                case"us-east-2":
                    n = {hostname: "s3.us-east-2.amazonaws.com", partition: "aws"};
                    break;
                case"us-gov-east-1":
                    n = {hostname: "s3.us-gov-east-1.amazonaws.com", partition: "aws-us-gov"};
                    break;
                case"us-gov-west-1":
                    n = {hostname: "s3.us-gov-west-1.amazonaws.com", partition: "aws-us-gov"};
                    break;
                case"us-iso-east-1":
                    n = {hostname: "s3.us-iso-east-1.c2s.ic.gov", partition: "aws-iso"};
                    break;
                case"us-isob-east-1":
                    n = {hostname: "s3.us-isob-east-1.sc2s.sgov.gov", partition: "aws-iso-b"};
                    break;
                case"us-west-1":
                    n = {hostname: "s3.us-west-1.amazonaws.com", partition: "aws"};
                    break;
                case"us-west-2":
                    n = {hostname: "s3.us-west-2.amazonaws.com", partition: "aws"};
                    break;
                default:
                    hc.has(e) && (n = {
                        hostname: "s3.{region}.amazonaws.com".replace("{region}", e),
                        partition: "aws"
                    }), pc.has(e) && (n = {
                        hostname: "s3.{region}.amazonaws.com.cn".replace("{region}", e),
                        partition: "aws-cn"
                    }), gc.has(e) && (n = {
                        hostname: "s3.{region}.c2s.ic.gov".replace("{region}", e),
                        partition: "aws-iso"
                    }), vc.has(e) && (n = {
                        hostname: "s3.{region}.sc2s.sgov.gov".replace("{region}", e),
                        partition: "aws-iso-b"
                    }), mc.has(e) && (n = {
                        hostname: "s3.{region}.amazonaws.com".replace("{region}", e),
                        partition: "aws-us-gov"
                    }), void 0 === n && (n = {
                        hostname: "s3.{region}.amazonaws.com".replace("{region}", e),
                        partition: "aws"
                    })
            }
            return Promise.resolve(tc({signingService: "s3"}, n))
        }, serviceId: "S3", signingEscapePath: !1, urlParser: qn, useArnRegion: !1
    }, Sc = tc(tc({}, yc), {
        runtime: "browser",
        base64Decoder: en,
        base64Encoder: tn,
        bodyLengthChecker: jn,
        credentialDefaultProvider: function (e) {
            return function () {
                return Promise.reject(new Error("Credential is missing"))
            }
        },
        defaultUserAgentProvider: Kn({serviceId: yc.serviceId, clientVersion: ic}),
        eventStreamSerdeProvider: function (e) {
            return new Zu(e)
        },
        maxAttempts: 3,
        md5: ac,
        region: on("Region is missing"),
        requestHandler: new Gt,
        sha256: Re.Sha256,
        streamCollector: nn,
        streamHasher: function (e, t) {
            return j(this, void 0, void 0, (function () {
                var n;
                return F(this, (function (r) {
                    switch (r.label) {
                        case 0:
                            return n = new e, [4, oc(t, (function (e) {
                                n.update(e)
                            }))];
                        case 1:
                            return r.sent(), [2, n.digest()]
                    }
                }))
            }))
        },
        utf8Decoder: ze,
        utf8Encoder: Ke
    }), wc = function (e) {
        return "string" == typeof e && 0 === e.indexOf("arn:") && e.split(":").length >= 6
    }, bc = /^[a-z0-9][a-z0-9\.\-]{1,61}[a-z0-9]$/, Ec = /(\d+\.){3}\d+/, Cc = /\.\./, _c = /\./,
    Ac = /^(.+\.)?s3[.-]([a-z0-9-]+)\./, Pc = /^s3(-external-1)?\.amazonaws\.com$/, kc = function (e) {
        return Ic(e) ? e.replace(/fips-|-fips/, "") : e
    }, xc = function (e) {
        var t = e.match(Ac);
        return [t[2], e.replace(new RegExp("^" + t[0]), "")]
    }, Ic = function (e) {
        return e.startsWith("fips-") || e.endsWith("-fips")
    }, Tc = function (e, t) {
        return e === t || kc(e) === t || e === kc(t)
    }, Uc = function (e, t) {
        if (void 0 === t && (t = {tlsCompatible: !0}), e.length >= 64 || !/^[a-z0-9][a-z0-9.-]+[a-z0-9]$/.test(e) || /(\d+\.){3}\d+/.test(e) || /[.-]{2}/.test(e) || (null == t ? void 0 : t.tlsCompatible) && _c.test(e)) throw new Error("Invalid DNS label " + e)
    }, Oc = function (e) {
        var t = e.isCustomEndpoint;
        e.baseHostname;
        var n = e.dualstackEndpoint, r = e.accelerateEndpoint;
        if (t) {
            if (n) throw new Error("Dualstack endpoint is not supported with custom endpoint");
            if (r) throw new Error("Accelerate endpoint is not supported with custom endpoint")
        }
        return function (e) {
            return "string" == typeof e.bucketName
        }(e) ? Lc(D(D({}, e), {isCustomEndpoint: t})) : Mc(D(D({}, e), {isCustomEndpoint: t}))
    }, Mc = function (e) {
        var t, n = e.isCustomEndpoint, r = e.baseHostname,
            i = K(n ? [e.clientRegion, r] : (t = r, Pc.test(t) ? [t.replace(".amazonaws.com", ""), "amazonaws.com"] : xc(t)), 2),
            o = i[0], s = i[1], a = e.pathStyleEndpoint, u = e.dualstackEndpoint, c = void 0 !== u && u,
            l = e.accelerateEndpoint, f = void 0 !== l && l, d = e.tlsCompatible, h = void 0 === d || d, p = e.useArnRegion,
            g = e.bucketName, v = e.clientPartition, m = void 0 === v ? "aws" : v, y = e.clientSigningRegion,
            S = void 0 === y ? o : y;
        !function (e) {
            if (e.pathStyleEndpoint) throw new Error("Path-style S3 endpoint is not supported when bucket is an ARN");
            if (e.accelerateEndpoint) throw new Error("Accelerate endpoint is not supported when bucket is an ARN");
            if (!e.tlsCompatible) throw new Error("HTTPS is required when bucket is an ARN")
        }({pathStyleEndpoint: a, accelerateEndpoint: f, tlsCompatible: h});
        var w = g.service, b = g.partition, E = g.accountId, C = g.region, _ = g.resource;
        !function (e) {
            if ("s3" !== e && "s3-outposts" !== e) throw new Error("Expect 's3' or 's3-outposts' in ARN service component")
        }(w), function (e, t) {
            if (e !== t.clientPartition) throw new Error('Partition in ARN is incompatible, got "' + e + '" but expected "' + t.clientPartition + '"')
        }(b, {clientPartition: m}), function (e) {
            if (!/[0-9]{12}/.exec(e)) throw new Error("Access point ARN accountID does not match regex '[0-9]{12}'")
        }(E), function (e, t) {
            if ("" === e) throw new Error("ARN region is empty");
            if (!t.useArnRegion && !Tc(e, t.clientRegion) && !Tc(e, t.clientSigningRegion)) throw new Error("Region in ARN is incompatible, got " + e + " but expected " + t.clientRegion);
            if (t.useArnRegion && Ic(e)) throw new Error("Endpoint does not support FIPS region")
        }(C, {useArnRegion: p, clientRegion: o, clientSigningRegion: S});
        var A = function (e) {
            var t = e.includes(":") ? ":" : "/", n = K(e.split(t)), r = n[0], i = n.slice(1);
            if ("accesspoint" === r) {
                if (1 !== i.length || "" === i[0]) throw new Error("Access Point ARN should have one resource accesspoint" + t + "{accesspointname}");
                return {accesspointName: i[0]}
            }
            if ("outpost" === r) {
                if (!i[0] || "accesspoint" !== i[1] || !i[2] || 3 !== i.length) throw new Error("Outpost ARN should have resource outpost" + t + "{outpostId}" + t + "accesspoint" + t + "{accesspointName}");
                var o = K(i, 3), s = o[0];
                return o[1], {outpostId: s, accesspointName: o[2]}
            }
            throw new Error("ARN resource should begin with 'accesspoint" + t + "' or 'outpost" + t + "'")
        }(_), P = A.accesspointName, k = A.outpostId;
        Uc(P + "-" + E, {tlsCompatible: h});
        var x = p ? C : o, I = p ? C : S;
        return k ? (function (e) {
            if ("s3-outposts" !== e) throw new Error("Expect 's3-posts' in Outpost ARN service component")
        }(w), Uc(k, {tlsCompatible: h}), function (e) {
            if (e) throw new Error("Dualstack endpoint is not supported with Outpost")
        }(c), function (e) {
            if (Ic(null != e ? e : "")) throw new Error("FIPS region is not supported with Outpost, got " + e)
        }(x), {
            bucketEndpoint: !0,
            hostname: P + "-" + E + "." + k + (n ? "" : ".s3-outposts." + x) + "." + s,
            signingRegion: I,
            signingService: "s3-outposts"
        }) : (function (e) {
            if ("s3" !== e) throw new Error("Expect 's3' in Accesspoint ARN service component")
        }(w), {
            bucketEndpoint: !0,
            hostname: P + "-" + E + (n ? "" : ".s3-accesspoint" + (c ? ".dualstack" : "") + "." + x) + "." + s,
            signingRegion: I
        })
    }, Lc = function (e) {
        var t, n = e.accelerateEndpoint, r = void 0 !== n && n, i = e.clientRegion, o = e.baseHostname, s = e.bucketName,
            a = e.dualstackEndpoint, u = void 0 !== a && a, c = e.pathStyleEndpoint, l = void 0 !== c && c,
            f = e.tlsCompatible, d = void 0 === f || f, h = e.isCustomEndpoint,
            p = K(void 0 !== h && h ? [i, o] : (t = o, Pc.test(t) ? ["us-east-1", "amazonaws.com"] : xc(t)), 2), g = p[0],
            v = p[1];
        return l || !function (e) {
            return bc.test(e) && !Ec.test(e) && !Cc.test(e)
        }(s) || d && _c.test(s) ? {
            bucketEndpoint: !1,
            hostname: u ? "s3.dualstack." + g + "." + v : o
        } : (r ? o = "s3-accelerate" + (u ? ".dualstack" : "") + "." + v : u && (o = "s3.dualstack." + g + "." + v), {
            bucketEndpoint: !0,
            hostname: s + "." + o
        })
    }, Rc = function (e) {
        return function (t, n) {
            return function (r) {
                return j(void 0, void 0, void 0, (function () {
                    var i, o, s, a, u, c, l, f, d, h, p, g, v, m, y, S, w, b;
                    return F(this, (function (E) {
                        switch (E.label) {
                            case 0:
                                return i = r.input.Bucket, o = e.bucketEndpoint, s = r.request, Kt.isInstance(s) ? e.bucketEndpoint ? (s.hostname = i, [3, 7]) : [3, 1] : [3, 8];
                            case 1:
                                return wc(i) ? (a = function (e) {
                                    var t = e.split(":");
                                    if (t.length < 6 || "arn" !== t[0]) throw new Error("Malformed ARN");
                                    var n = K(t);
                                    return {
                                        partition: n[1],
                                        service: n[2],
                                        region: n[3],
                                        accountId: n[4],
                                        resource: n.slice(5).join(":")
                                    }
                                }(i), u = kc, [4, e.region()]) : [3, 5];
                            case 2:
                                return m = u.apply(void 0, [E.sent()]), [4, e.regionInfoProvider(m)];
                            case 3:
                                return c = E.sent() || {}, l = c.partition, f = c.signingRegion, d = void 0 === f ? m : f, [4, e.useArnRegion()];
                            case 4:
                                return h = E.sent(), p = Oc({
                                    bucketName: a,
                                    baseHostname: s.hostname,
                                    accelerateEndpoint: e.useAccelerateEndpoint,
                                    dualstackEndpoint: e.useDualstackEndpoint,
                                    pathStyleEndpoint: e.forcePathStyle,
                                    tlsCompatible: "https:" === s.protocol,
                                    useArnRegion: h,
                                    clientPartition: l,
                                    clientSigningRegion: d,
                                    clientRegion: m,
                                    isCustomEndpoint: e.isCustomEndpoint
                                }), w = p.hostname, b = p.bucketEndpoint, g = p.signingRegion, v = p.signingService, g && g !== d && (n.signing_region = g), v && "s3" !== v && (n.signing_service = v), s.hostname = w, o = b, [3, 7];
                            case 5:
                                return y = kc, [4, e.region()];
                            case 6:
                                m = y.apply(void 0, [E.sent()]), S = Oc({
                                    bucketName: i,
                                    clientRegion: m,
                                    baseHostname: s.hostname,
                                    accelerateEndpoint: e.useAccelerateEndpoint,
                                    dualstackEndpoint: e.useDualstackEndpoint,
                                    pathStyleEndpoint: e.forcePathStyle,
                                    tlsCompatible: "https:" === s.protocol,
                                    isCustomEndpoint: e.isCustomEndpoint
                                }), w = S.hostname, b = S.bucketEndpoint, s.hostname = w, o = b, E.label = 7;
                            case 7:
                                o && (s.path = s.path.replace(/^(\/)?[^\/]+/, ""), "" === s.path && (s.path = "/")), E.label = 8;
                            case 8:
                                return [2, t(D(D({}, r), {request: s}))]
                        }
                    }))
                }))
            }
        }
    }, Nc = {
        tags: ["BUCKET_ENDPOINT"],
        name: "bucketEndpointMiddleware",
        relation: "before",
        toMiddleware: "hostHeaderMiddleware",
        override: !0
    }, Dc = function (e) {
        return {
            applyToStack: function (t) {
                t.addRelativeTo(Rc(e), Nc)
            }
        }
    };
var Bc = {
    step: "build",
    tags: ["SET_EXPECT_HEADER", "EXPECT_HEADER"],
    name: "addExpectContinueMiddleware",
    override: !0
}, jc = function (e) {
    return {
        applyToStack: function (t) {
            t.add(function (e) {
                var t = this;
                return function (n) {
                    return function (r) {
                        return j(t, void 0, void 0, (function () {
                            var t;
                            return F(this, (function (i) {
                                return t = r.request, Kt.isInstance(t) && t.body && "node" === e.runtime && (t.headers = D(D({}, t.headers), {Expect: "100-continue"})), [2, n(D(D({}, r), {request: t}))]
                            }))
                        }))
                    }
                }
            }(e), Bc)
        }
    }
};
var Fc, zc, Kc, qc, Hc, Vc, Gc, Wc, $c, Yc, Jc, Zc, Xc, Qc, el, tl, nl, rl, il, ol, sl, al, ul, cl, ll, fl, dl, hl, pl,
    gl, vl, ml, yl, Sl, wl, bl, El, Cl, _l, Al, Pl, kl, xl, Il, Tl, Ul, Ol, Ml, Ll, Rl, Nl, Dl, Bl, jl, Fl, zl, Kl, ql,
    Hl, Vl, Gl, Wl, $l, Yl, Jl, Zl, Xl, Ql, ef, tf, nf, rf, of, sf, af, uf, cf, lf, ff, df, hf, pf, gf, vf, mf, yf, Sf,
    wf, bf, Ef, Cf, _f, Af, Pf, kf, xf, If, Tf, Uf, Of, Mf, Lf, Rf, Nf, Df, Bf, jf, Ff, zf, Kf, qf, Hf, Vf, Gf, Wf, $f,
    Yf, Jf, Zf, Xf, Qf, ed, td, nd, rd, id, od, sd, ad, ud, cd, ld, fd, dd, hd, pd, gd, vd, md, yd, Sd, wd, bd, Ed, Cd,
    _d, Ad, Pd, kd, xd, Id, Td, Ud, Od, Md, Ld, Rd, Nd, Dd, Bd, jd, Fd, zd, Kd, qd, Hd, Vd, Gd, Wd, $d, Yd, Jd, Zd, Xd,
    Qd, eh, th, nh, rh, ih, oh, sh, ah, uh, ch, lh, fh, dh, hh, ph, gh, vh, mh, yh, Sh, wh, bh, Eh, Ch, _h, Ah, Ph, kh,
    xh, Ih, Th, Uh, Oh, Mh, Lh, Rh, Nh, Dh, Bh, jh, Fh, zh, Kh, qh, Hh, Vh, Gh, Wh, $h, Yh, Jh, Zh, Xh, Qh, ep, tp, np,
    rp, ip, op, sp, ap, up, cp, lp, fp, dp, hp, pp, gp, vp, mp, yp, Sp, wp, bp,
    Ep = {step: "initialize", tags: ["VALIDATE_BUCKET_NAME"], name: "validateBucketNameMiddleware", override: !0},
    Cp = function (e) {
        return {
            applyToStack: function (e) {
                e.add(function () {
                    var e = this;
                    return function (t) {
                        return function (n) {
                            return j(e, void 0, void 0, (function () {
                                var e, r;
                                return F(this, (function (i) {
                                    if ("string" == typeof (e = n.input.Bucket) && !wc(e) && e.indexOf("/") >= 0) throw(r = new Error("Bucket name shouldn't contain '/', received '" + e + "'")).name = "InvalidBucketName", r;
                                    return [2, t(D({}, n))]
                                }))
                            }))
                        }
                    }
                }(), Ep)
            }
        }
    }, _p = {step: "build", tags: ["USE_REGIONAL_ENDPOINT", "S3"], name: "useRegionalEndpointMiddleware", override: !0},
    Ap = function (e) {
        return {
            applyToStack: function (t) {
                t.add(function (e) {
                    return function (t) {
                        return function (n) {
                            return j(void 0, void 0, void 0, (function () {
                                var r, i;
                                return F(this, (function (o) {
                                    switch (o.label) {
                                        case 0:
                                            return r = n.request, !Kt.isInstance(r) || e.isCustomEndpoint ? [2, t(D({}, n))] : "s3.amazonaws.com" !== r.hostname ? [3, 1] : (r.hostname = "s3.us-east-1.amazonaws.com", [3, 3]);
                                        case 1:
                                            return i = "aws-global", [4, e.region()];
                                        case 2:
                                            i === o.sent() && (r.hostname = "s3.amazonaws.com"), o.label = 3;
                                        case 3:
                                            return [2, t(D({}, n))]
                                    }
                                }))
                            }))
                        }
                    }
                }(e), _p)
            }
        }
    }, Pp = function (e, t) {
        return void 0 === e && (e = new Uint8Array), e instanceof Uint8Array ? Promise.resolve(e) : t.streamCollector(e) || Promise.resolve(new Uint8Array)
    }, kp = function (e, t) {
        return Pp(e, t).then((function (e) {
            return t.utf8Encoder(e)
        }))
    }, xp = {
        relation: "after",
        toMiddleware: "deserializerMiddleware",
        tags: ["THROW_200_EXCEPTIONS", "S3"],
        name: "throw200ExceptionsMiddleware",
        override: !0
    }, Ip = function (e) {
        return {
            applyToStack: function (t) {
                t.addRelativeTo(function (e) {
                    return function (t) {
                        return function (n) {
                            return j(void 0, void 0, void 0, (function () {
                                var r, i, o, s, a, u, c;
                                return F(this, (function (l) {
                                    switch (l.label) {
                                        case 0:
                                            return [4, t(n)];
                                        case 1:
                                            return r = l.sent(), i = r.response, zt.isInstance(i) ? (o = i.statusCode, s = i.body, o < 200 && o >= 300 ? [2, r] : [4, Pp(s, e)]) : [2, r];
                                        case 2:
                                            return a = l.sent(), [4, kp(a, e)];
                                        case 3:
                                            if (u = l.sent(), 0 === a.length) throw(c = new Error("S3 aborted request")).name = "InternalError", c;
                                            return u && u.match("<Error>") && (i.statusCode = 400), i.body = a, [2, r]
                                    }
                                }))
                            }))
                        }
                    }
                }(e), xp)
            }
        }
    }, Tp = function (e) {
        function t(t) {
            var n, r, i = this, o = tc(tc({}, Sc), t), s = Wn(o), a = _r(Hn(s)), u = function (e) {
                var t = e.bucketEndpoint, n = void 0 !== t && t, r = e.forcePathStyle, i = void 0 !== r && r,
                    o = e.useAccelerateEndpoint, s = void 0 !== o && o, a = e.useDualstackEndpoint, u = void 0 !== a && a,
                    c = e.useArnRegion, l = void 0 !== c && c;
                return D(D({}, e), {
                    bucketEndpoint: n,
                    forcePathStyle: i,
                    useAccelerateEndpoint: s,
                    useDualstackEndpoint: u,
                    useArnRegion: "function" == typeof l ? l : function () {
                        return Promise.resolve(l)
                    }
                })
            }(Dn(a)), c = Ir(u), l = D(D({}, n = c), {eventStreamMarshaller: n.eventStreamSerdeProvider(n)});
            return (i = e.call(this, l) || this).config = l, i.middlewareStack.use((r = i.config, {
                applyToStack: function (e) {
                    e.addRelativeTo(kr(r), xr)
                }
            })), i.middlewareStack.use(an(i.config)), i.middlewareStack.use(Jn(i.config)), i.middlewareStack.use(Xn(i.config)), i.middlewareStack.use(er(i.config)), i.middlewareStack.use(Cp(i.config)), i.middlewareStack.use(Ap(i.config)), i.middlewareStack.use(jc(i.config)), i.middlewareStack.use(Mr(i.config)), i
        }

        return ec(t, e), t.prototype.destroy = function () {
            e.prototype.destroy.call(this)
        }, t
    }(Dr);
!function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}(Fc || (Fc = {})), function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}(zc || (zc = {})), function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}(Kc || (Kc = {})), function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}(qc || (qc = {})), function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}(Hc || (Hc = {})), function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}(Vc || (Vc = {})), function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}(Gc || (Gc = {})), function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}(Wc || (Wc = {})), function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}($c || ($c = {})), function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}(Yc || (Yc = {})), function (e) {
    e.filterSensitiveLog = function (e) {
        return tc(tc({}, e), e.SSEKMSKeyId && {SSEKMSKeyId: Gr})
    }
}(Jc || (Jc = {})), function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}(Zc || (Zc = {})), function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}(Xc || (Xc = {})), function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}(Qc || (Qc = {})), function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}(el || (el = {})), function (e) {
    e.filterSensitiveLog = function (e) {
        return tc(tc(tc({}, e), e.SSEKMSKeyId && {SSEKMSKeyId: Gr}), e.SSEKMSEncryptionContext && {SSEKMSEncryptionContext: Gr})
    }
}(tl || (tl = {})), function (e) {
    e.filterSensitiveLog = function (e) {
        return tc(tc(tc(tc(tc({}, e), e.SSECustomerKey && {SSECustomerKey: Gr}), e.SSEKMSKeyId && {SSEKMSKeyId: Gr}), e.SSEKMSEncryptionContext && {SSEKMSEncryptionContext: Gr}), e.CopySourceSSECustomerKey && {CopySourceSSECustomerKey: Gr})
    }
}(nl || (nl = {})), function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}(rl || (rl = {})), function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}(il || (il = {})), function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}(ol || (ol = {})), function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}(sl || (sl = {})), function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}(al || (al = {})), function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}(ul || (ul = {})), function (e) {
    e.filterSensitiveLog = function (e) {
        return tc(tc(tc({}, e), e.SSEKMSKeyId && {SSEKMSKeyId: Gr}), e.SSEKMSEncryptionContext && {SSEKMSEncryptionContext: Gr})
    }
}(cl || (cl = {})), function (e) {
    e.filterSensitiveLog = function (e) {
        return tc(tc(tc(tc({}, e), e.SSECustomerKey && {SSECustomerKey: Gr}), e.SSEKMSKeyId && {SSEKMSKeyId: Gr}), e.SSEKMSEncryptionContext && {SSEKMSEncryptionContext: Gr})
    }
}(ll || (ll = {})), function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}(fl || (fl = {})), function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}(dl || (dl = {})), function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}(hl || (hl = {})), function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}(pl || (pl = {})), function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}(gl || (gl = {})), function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}(vl || (vl = {})), function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}(ml || (ml = {})), function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}(yl || (yl = {})), function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}(Sl || (Sl = {})), function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}(wl || (wl = {})), function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}(bl || (bl = {})), function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}(El || (El = {})), function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}(Cl || (Cl = {})), function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}(_l || (_l = {})), function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}(Al || (Al = {})), function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}(Pl || (Pl = {})), function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}(kl || (kl = {})), function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}(xl || (xl = {})), function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}(Il || (Il = {})), function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}(Tl || (Tl = {})), function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}(Ul || (Ul = {})), function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}(Ol || (Ol = {})), function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}(Ml || (Ml = {})), function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}(Ll || (Ll = {})), function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}(Rl || (Rl = {})), function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}(Nl || (Nl = {})), function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}(Dl || (Dl = {})), function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}(Bl || (Bl = {})), function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}(jl || (jl = {})), function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}(Fl || (Fl = {})), function (e) {
    e.visit = function (e, t) {
        return void 0 !== e.Prefix ? t.Prefix(e.Prefix) : void 0 !== e.Tag ? t.Tag(e.Tag) : void 0 !== e.And ? t.And(e.And) : t._(e.$unknown[0], e.$unknown[1])
    }, e.filterSensitiveLog = function (e) {
        var t;
        return void 0 !== e.Prefix ? {Prefix: e.Prefix} : void 0 !== e.Tag ? {Tag: jl.filterSensitiveLog(e.Tag)} : void 0 !== e.And ? {And: Fl.filterSensitiveLog(e.And)} : void 0 !== e.$unknown ? ((t = {})[e.$unknown[0]] = "UNKNOWN", t) : void 0
    }
}(zl || (zl = {})), function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}(Kl || (Kl = {})), function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}(ql || (ql = {})), function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}(Hl || (Hl = {})), function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}(Vl || (Vl = {})), function (e) {
    e.filterSensitiveLog = function (e) {
        return tc(tc({}, e), e.Filter && {Filter: zl.filterSensitiveLog(e.Filter)})
    }
}(Gl || (Gl = {})), function (e) {
    e.filterSensitiveLog = function (e) {
        return tc(tc({}, e), e.AnalyticsConfiguration && {AnalyticsConfiguration: Gl.filterSensitiveLog(e.AnalyticsConfiguration)})
    }
}(Wl || (Wl = {})), function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}($l || ($l = {})), function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}(Yl || (Yl = {})), function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}(Jl || (Jl = {})), function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}(Zl || (Zl = {})), function (e) {
    e.filterSensitiveLog = function (e) {
        return tc(tc({}, e), e.KMSMasterKeyID && {KMSMasterKeyID: Gr})
    }
}(Xl || (Xl = {})), function (e) {
    e.filterSensitiveLog = function (e) {
        return tc(tc({}, e), e.ApplyServerSideEncryptionByDefault && {ApplyServerSideEncryptionByDefault: Xl.filterSensitiveLog(e.ApplyServerSideEncryptionByDefault)})
    }
}(Ql || (Ql = {})), function (e) {
    e.filterSensitiveLog = function (e) {
        return tc(tc({}, e), e.Rules && {
            Rules: e.Rules.map((function (e) {
                return Ql.filterSensitiveLog(e)
            }))
        })
    }
}(ef || (ef = {})), function (e) {
    e.filterSensitiveLog = function (e) {
        return tc(tc({}, e), e.ServerSideEncryptionConfiguration && {ServerSideEncryptionConfiguration: ef.filterSensitiveLog(e.ServerSideEncryptionConfiguration)})
    }
}(tf || (tf = {})), function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}(nf || (nf = {})), function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}(rf || (rf = {})), function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}(of || (of = {})), function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}(sf || (sf = {})), function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}(af || (af = {})), function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}(uf || (uf = {})), function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}(cf || (cf = {})), function (e) {
    e.filterSensitiveLog = function (e) {
        return tc(tc({}, e), e.KeyId && {KeyId: Gr})
    }
}(lf || (lf = {})), function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}(ff || (ff = {})), function (e) {
    e.filterSensitiveLog = function (e) {
        return tc(tc({}, e), e.SSEKMS && {SSEKMS: lf.filterSensitiveLog(e.SSEKMS)})
    }
}(df || (df = {})), function (e) {
    e.filterSensitiveLog = function (e) {
        return tc(tc({}, e), e.Encryption && {Encryption: df.filterSensitiveLog(e.Encryption)})
    }
}(hf || (hf = {})), function (e) {
    e.filterSensitiveLog = function (e) {
        return tc(tc({}, e), e.S3BucketDestination && {S3BucketDestination: hf.filterSensitiveLog(e.S3BucketDestination)})
    }
}(pf || (pf = {})), function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}(gf || (gf = {})), function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}(vf || (vf = {})), function (e) {
    e.filterSensitiveLog = function (e) {
        return tc(tc({}, e), e.Destination && {Destination: pf.filterSensitiveLog(e.Destination)})
    }
}(mf || (mf = {})), function (e) {
    e.filterSensitiveLog = function (e) {
        return tc(tc({}, e), e.InventoryConfiguration && {InventoryConfiguration: mf.filterSensitiveLog(e.InventoryConfiguration)})
    }
}(yf || (yf = {})), function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}(Sf || (Sf = {})), function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}(wf || (wf = {})), function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}(bf || (bf = {})), function (e) {
    e.visit = function (e, t) {
        return void 0 !== e.Prefix ? t.Prefix(e.Prefix) : void 0 !== e.Tag ? t.Tag(e.Tag) : void 0 !== e.And ? t.And(e.And) : t._(e.$unknown[0], e.$unknown[1])
    }, e.filterSensitiveLog = function (e) {
        var t;
        return void 0 !== e.Prefix ? {Prefix: e.Prefix} : void 0 !== e.Tag ? {Tag: jl.filterSensitiveLog(e.Tag)} : void 0 !== e.And ? {And: bf.filterSensitiveLog(e.And)} : void 0 !== e.$unknown ? ((t = {})[e.$unknown[0]] = "UNKNOWN", t) : void 0
    }
}(Ef || (Ef = {})), function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}(Cf || (Cf = {})), function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}(_f || (_f = {})), function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}(Af || (Af = {})), function (e) {
    e.filterSensitiveLog = function (e) {
        return tc(tc({}, e), e.Filter && {Filter: Ef.filterSensitiveLog(e.Filter)})
    }
}(Pf || (Pf = {})), function (e) {
    e.filterSensitiveLog = function (e) {
        return tc(tc({}, e), e.Rules && {
            Rules: e.Rules.map((function (e) {
                return Pf.filterSensitiveLog(e)
            }))
        })
    }
}(kf || (kf = {})), function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}(xf || (xf = {})), function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}(If || (If = {})), function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}(Tf || (Tf = {})), function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}(Uf || (Uf = {})), function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}(Of || (Of = {})), function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}(Mf || (Mf = {})),function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}(Lf || (Lf = {})),function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}(Rf || (Rf = {})),function (e) {
    e.visit = function (e, t) {
        return void 0 !== e.Prefix ? t.Prefix(e.Prefix) : void 0 !== e.Tag ? t.Tag(e.Tag) : void 0 !== e.And ? t.And(e.And) : t._(e.$unknown[0], e.$unknown[1])
    }, e.filterSensitiveLog = function (e) {
        var t;
        return void 0 !== e.Prefix ? {Prefix: e.Prefix} : void 0 !== e.Tag ? {Tag: jl.filterSensitiveLog(e.Tag)} : void 0 !== e.And ? {And: Rf.filterSensitiveLog(e.And)} : void 0 !== e.$unknown ? ((t = {})[e.$unknown[0]] = "UNKNOWN", t) : void 0
    }
}(Nf || (Nf = {})),function (e) {
    e.filterSensitiveLog = function (e) {
        return tc(tc({}, e), e.Filter && {Filter: Nf.filterSensitiveLog(e.Filter)})
    }
}(Df || (Df = {})),function (e) {
    e.filterSensitiveLog = function (e) {
        return tc(tc({}, e), e.MetricsConfiguration && {MetricsConfiguration: Df.filterSensitiveLog(e.MetricsConfiguration)})
    }
}(Bf || (Bf = {})),function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}(jf || (jf = {})),function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}(Ff || (Ff = {})),function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}(zf || (zf = {})),function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}(Kf || (Kf = {})),function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}(qf || (qf = {})),function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}(Hf || (Hf = {})),function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}(Vf || (Vf = {})),function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}(Gf || (Gf = {})),function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}(Wf || (Wf = {})),function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}($f || ($f = {})),function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}(Yf || (Yf = {})),function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}(Jf || (Jf = {})),function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}(Zf || (Zf = {})),function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}(Xf || (Xf = {})),function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}(Qf || (Qf = {})),function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}(ed || (ed = {})),function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}(td || (td = {})),function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}(nd || (nd = {})),function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}(rd || (rd = {})),function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}(id || (id = {})),function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}(od || (od = {})),function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}(sd || (sd = {})),function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}(ad || (ad = {})),function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}(ud || (ud = {})),function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}(cd || (cd = {})),function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}(ld || (ld = {})),function (e) {
    e.visit = function (e, t) {
        return void 0 !== e.Prefix ? t.Prefix(e.Prefix) : void 0 !== e.Tag ? t.Tag(e.Tag) : void 0 !== e.And ? t.And(e.And) : t._(e.$unknown[0], e.$unknown[1])
    }, e.filterSensitiveLog = function (e) {
        var t;
        return void 0 !== e.Prefix ? {Prefix: e.Prefix} : void 0 !== e.Tag ? {Tag: jl.filterSensitiveLog(e.Tag)} : void 0 !== e.And ? {And: ld.filterSensitiveLog(e.And)} : void 0 !== e.$unknown ? ((t = {})[e.$unknown[0]] = "UNKNOWN", t) : void 0
    }
}(fd || (fd = {})),function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}(dd || (dd = {})),function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}(hd || (hd = {})),function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}(pd || (pd = {})),function (e) {
    e.filterSensitiveLog = function (e) {
        return tc(tc({}, e), e.Filter && {Filter: fd.filterSensitiveLog(e.Filter)})
    }
}(gd || (gd = {})),function (e) {
    e.filterSensitiveLog = function (e) {
        return tc(tc({}, e), e.Rules && {
            Rules: e.Rules.map((function (e) {
                return gd.filterSensitiveLog(e)
            }))
        })
    }
}(vd || (vd = {})),function (e) {
    e.filterSensitiveLog = function (e) {
        return tc(tc({}, e), e.ReplicationConfiguration && {ReplicationConfiguration: vd.filterSensitiveLog(e.ReplicationConfiguration)})
    }
}(md || (md = {})),function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}(yd || (yd = {})),function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}(Sd || (Sd = {})),function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}(wd || (wd = {})),function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}(bd || (bd = {})),function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}(Ed || (Ed = {})),function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}(Cd || (Cd = {})),function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}(_d || (_d = {})),function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}(Ad || (Ad = {})),function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}(Pd || (Pd = {})),function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}(kd || (kd = {})),function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}(xd || (xd = {})),function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}(Id || (Id = {})),function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}(Td || (Td = {})),function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}(Ud || (Ud = {})),function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}(Od || (Od = {})),function (e) {
    e.filterSensitiveLog = function (e) {
        return tc(tc({}, e), e.SSEKMSKeyId && {SSEKMSKeyId: Gr})
    }
}(Md || (Md = {})),function (e) {
    e.filterSensitiveLog = function (e) {
        return tc(tc({}, e), e.SSECustomerKey && {SSECustomerKey: Gr})
    }
}(Ld || (Ld = {})),function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}(Rd || (Rd = {})),function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}(Nd || (Nd = {})),function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}(Dd || (Dd = {})),function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}(Bd || (Bd = {})),function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}(jd || (jd = {})),function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}(Fd || (Fd = {})),function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}(zd || (zd = {})),function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}(Kd || (Kd = {})),function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}(qd || (qd = {})),function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}(Hd || (Hd = {})),function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}(Vd || (Vd = {})),function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}(Gd || (Gd = {})),function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}(Wd || (Wd = {})),function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}($d || ($d = {})),function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}(Yd || (Yd = {})),function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}(Jd || (Jd = {})),function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}(Zd || (Zd = {})),function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}(Xd || (Xd = {})),function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}(Qd || (Qd = {})),function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}(eh || (eh = {})),function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}(th || (th = {})),function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}(nh || (nh = {})),function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}(rh || (rh = {})),function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}(ih || (ih = {})),function (e) {
    e.filterSensitiveLog = function (e) {
        return tc(tc({}, e), e.SSEKMSKeyId && {SSEKMSKeyId: Gr})
    }
}(oh || (oh = {})),function (e) {
    e.filterSensitiveLog = function (e) {
        return tc(tc({}, e), e.SSECustomerKey && {SSECustomerKey: Gr})
    }
}(sh || (sh = {})),function (e) {
    e.filterSensitiveLog = function (e) {
        return tc(tc({}, e), e.AnalyticsConfigurationList && {
            AnalyticsConfigurationList: e.AnalyticsConfigurationList.map((function (e) {
                return Gl.filterSensitiveLog(e)
            }))
        })
    }
}(ah || (ah = {})),function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}(uh || (uh = {})),function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}(ch || (ch = {})),function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}(lh || (lh = {})),function (e) {
    e.filterSensitiveLog = function (e) {
        return tc(tc({}, e), e.InventoryConfigurationList && {
            InventoryConfigurationList: e.InventoryConfigurationList.map((function (e) {
                return mf.filterSensitiveLog(e)
            }))
        })
    }
}(fh || (fh = {})),function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}(dh || (dh = {})),function (e) {
    e.filterSensitiveLog = function (e) {
        return tc(tc({}, e), e.MetricsConfigurationList && {
            MetricsConfigurationList: e.MetricsConfigurationList.map((function (e) {
                return Df.filterSensitiveLog(e)
            }))
        })
    }
}(hh || (hh = {})),function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}(ph || (ph = {})),function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}(gh || (gh = {})),function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}(vh || (vh = {})),function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}(mh || (mh = {})),function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}(yh || (yh = {})),function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}(Sh || (Sh = {})),function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}(wh || (wh = {})),function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}(bh || (bh = {})),function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}(Eh || (Eh = {})),function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}(Ch || (Ch = {})),function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}(_h || (_h = {})),function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}(Ah || (Ah = {})),function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}(Ph || (Ph = {})),function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}(kh || (kh = {})),function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}(xh || (xh = {})),function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}(Ih || (Ih = {})),function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}(Th || (Th = {})),function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}(Uh || (Uh = {})),function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}(Oh || (Oh = {})),function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}(Mh || (Mh = {})),function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}(Lh || (Lh = {})),function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}(Rh || (Rh = {})),function (e) {
    e.filterSensitiveLog = function (e) {
        return tc(tc({}, e), e.AnalyticsConfiguration && {AnalyticsConfiguration: Gl.filterSensitiveLog(e.AnalyticsConfiguration)})
    }
}(Nh || (Nh = {})),function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}(Dh || (Dh = {})),function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}(Bh || (Bh = {})),function (e) {
    e.filterSensitiveLog = function (e) {
        return tc(tc({}, e), e.ServerSideEncryptionConfiguration && {ServerSideEncryptionConfiguration: ef.filterSensitiveLog(e.ServerSideEncryptionConfiguration)})
    }
}(jh || (jh = {})),function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}(Fh || (Fh = {})),function (e) {
    e.filterSensitiveLog = function (e) {
        return tc(tc({}, e), e.InventoryConfiguration && {InventoryConfiguration: mf.filterSensitiveLog(e.InventoryConfiguration)})
    }
}(zh || (zh = {})),function (e) {
    e.filterSensitiveLog = function (e) {
        return tc(tc({}, e), e.Rules && {
            Rules: e.Rules.map((function (e) {
                return Pf.filterSensitiveLog(e)
            }))
        })
    }
}(Kh || (Kh = {})),function (e) {
    e.filterSensitiveLog = function (e) {
        return tc(tc({}, e), e.LifecycleConfiguration && {LifecycleConfiguration: Kh.filterSensitiveLog(e.LifecycleConfiguration)})
    }
}(qh || (qh = {})),function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}(Hh || (Hh = {})),function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}(Vh || (Vh = {})),function (e) {
    e.filterSensitiveLog = function (e) {
        return tc(tc({}, e), e.MetricsConfiguration && {MetricsConfiguration: Df.filterSensitiveLog(e.MetricsConfiguration)})
    }
}(Gh || (Gh = {})),function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}(Wh || (Wh = {})),function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}($h || ($h = {})),function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}(Yh || (Yh = {})),function (e) {
    e.filterSensitiveLog = function (e) {
        return tc(tc({}, e), e.ReplicationConfiguration && {ReplicationConfiguration: vd.filterSensitiveLog(e.ReplicationConfiguration)})
    }
}(Jh || (Jh = {})),function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}(Zh || (Zh = {})),function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}(Xh || (Xh = {})),function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}(Qh || (Qh = {})),function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}(ep || (ep = {})),function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}(tp || (tp = {})),function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}(np || (np = {})),function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}(rp || (rp = {})),function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}(ip || (ip = {})),function (e) {
    e.filterSensitiveLog = function (e) {
        return tc(tc(tc({}, e), e.SSEKMSKeyId && {SSEKMSKeyId: Gr}), e.SSEKMSEncryptionContext && {SSEKMSEncryptionContext: Gr})
    }
}(op || (op = {})),function (e) {
    e.filterSensitiveLog = function (e) {
        return tc(tc(tc(tc({}, e), e.SSECustomerKey && {SSECustomerKey: Gr}), e.SSEKMSKeyId && {SSEKMSKeyId: Gr}), e.SSEKMSEncryptionContext && {SSEKMSEncryptionContext: Gr})
    }
}(sp || (sp = {})),function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}(ap || (ap = {})),function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}(up || (up = {})),function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}(cp || (cp = {})),function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}(lp || (lp = {})),function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}(fp || (fp = {})),function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}(dp || (dp = {})),function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}(hp || (hp = {})),function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}(pp || (pp = {})),function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}(gp || (gp = {})),function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}(vp || (vp = {})),function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}(mp || (mp = {})),function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}(yp || (yp = {})),function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}(Sp || (Sp = {})),function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}(wp || (wp = {})),function (e) {
    e.filterSensitiveLog = function (e) {
        return tc(tc({}, e), e.KMSKeyId && {KMSKeyId: Gr})
    }
}(bp || (bp = {}));
var Up = function () {
    function e(e, t) {
        void 0 === t && (t = []), this.name = e, this.children = t, this.attributes = {}
    }

    return e.prototype.withName = function (e) {
        return this.name = e, this
    }, e.prototype.addAttribute = function (e, t) {
        return this.attributes[e] = t, this
    }, e.prototype.addChildNode = function (e) {
        return this.children.push(e), this
    }, e.prototype.removeAttribute = function (e) {
        return delete this.attributes[e], this
    }, e.prototype.toString = function () {
        var e, t, n = Boolean(this.children.length), r = "<" + this.name, i = this.attributes;
        try {
            for (var o = z(Object.keys(i)), s = o.next(); !s.done; s = o.next()) {
                var a = s.value, u = i[a];
                null != u && (r += " " + a + '="' + (("" + u).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;") + '"'))
            }
        } catch (t) {
            e = {error: t}
        } finally {
            try {
                s && !s.done && (t = o.return) && t.call(o)
            } finally {
                if (e) throw e.error
            }
        }
        return r + (n ? ">" + this.children.map((function (e) {
            return e.toString()
        })).join("") + "</" + this.name + ">" : "/>")
    }, e
}();
var Op = function () {
    function e(e) {
        this.value = e
    }

    return e.prototype.toString = function () {
        return ("" + this.value).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;")
    }, e
}(), Mp = {}, Lp = {}, Rp = {};
!function (e) {
    const t = ":A-Za-z_\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD",
        n = "[" + t + "][:A-Za-z_\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.\\d\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*",
        r = new RegExp("^" + n + "$");
    e.isExist = function (e) {
        return void 0 !== e
    }, e.isEmptyObject = function (e) {
        return 0 === Object.keys(e).length
    }, e.merge = function (e, t, n) {
        if (t) {
            const r = Object.keys(t), i = r.length;
            for (let o = 0; o < i; o++) e[r[o]] = "strict" === n ? [t[r[o]]] : t[r[o]]
        }
    }, e.getValue = function (t) {
        return e.isExist(t) ? t : ""
    }, e.buildOptions = function (e, t, n) {
        let r = {};
        if (!e) return t;
        for (let i = 0; i < n.length; i++) void 0 !== e[n[i]] ? r[n[i]] = e[n[i]] : r[n[i]] = t[n[i]];
        return r
    }, e.isTagNameInArrayMode = function (e, t, n) {
        return !1 !== t && (t instanceof RegExp ? t.test(e) : "function" == typeof t ? !!t(e, n) : "strict" === t)
    }, e.isName = function (e) {
        const t = r.exec(e);
        return !(null == t)
    }, e.getAllMatches = function (e, t) {
        const n = [];
        let r = t.exec(e);
        for (; r;) {
            const i = [];
            i.startIndex = t.lastIndex - r[0].length;
            const o = r.length;
            for (let e = 0; e < o; e++) i.push(r[e]);
            n.push(i), r = t.exec(e)
        }
        return n
    }, e.nameRegexp = n
}(Rp);
const Np = Rp, Dp = function (e, t, n) {
    const r = {};
    if (!t.alwaysCreateTextNode && (!e.child || Np.isEmptyObject(e.child)) && (!e.attrsMap || Np.isEmptyObject(e.attrsMap))) return Np.isExist(e.val) ? e.val : "";
    if (Np.isExist(e.val) && ("string" != typeof e.val || "" !== e.val && e.val !== t.cdataPositionChar)) {
        const i = Np.isTagNameInArrayMode(e.tagname, t.arrayMode, n);
        r[t.textNodeName] = i ? [e.val] : e.val
    }
    Np.merge(r, e.attrsMap, t.arrayMode);
    const i = Object.keys(e.child);
    for (let o = 0; o < i.length; o++) {
        const s = i[o];
        if (e.child[s] && e.child[s].length > 1) {
            r[s] = [];
            for (let n in e.child[s]) e.child[s].hasOwnProperty(n) && r[s].push(Dp(e.child[s][n], t, s))
        } else {
            const i = Dp(e.child[s][0], t, s),
                o = !0 === t.arrayMode && "object" == typeof i || Np.isTagNameInArrayMode(s, t.arrayMode, n);
            r[s] = o ? [i] : i
        }
    }
    return r
};
Lp.convertToJson = Dp;
var Bp = {};
const jp = /^[-+]?0x[a-fA-F0-9]+$/, Fp = /^([\-\+])?(0*)(\.[0-9]+([eE]\-?[0-9]+)?|[0-9]+(\.[0-9]+([eE]\-?[0-9]+)?)?)$/;
!Number.parseInt && window.parseInt && (Number.parseInt = window.parseInt), !Number.parseFloat && window.parseFloat && (Number.parseFloat = window.parseFloat);
const zp = {hex: !0, leadingZeros: !0, decimalPoint: ".", eNotation: !0};
const Kp = Rp, qp = Rp.buildOptions, Hp = function (e, t, n) {
    this.tagname = e, this.parent = t, this.child = {}, this.attrsMap = {}, this.val = n, this.addChild = function (e) {
        Array.isArray(this.child[e.tagname]) ? this.child[e.tagname].push(e) : this.child[e.tagname] = [e]
    }
}, Vp = function (e, t = {}) {
    if (t = Object.assign({}, zp, t), !e || "string" != typeof e) return e;
    let n = e.trim();
    if (void 0 !== t.skipLike && t.skipLike.test(n)) return e;
    if (t.hex && jp.test(n)) return Number.parseInt(n, 16);
    {
        const r = Fp.exec(n);
        if (r) {
            const i = r[1], o = r[2];
            let s = function (e) {
                if (e && -1 !== e.indexOf(".")) return "." === (e = e.replace(/0+$/, "")) ? e = "0" : "." === e[0] ? e = "0" + e : "." === e[e.length - 1] && (e = e.substr(0, e.length - 1)), e;
                return e
            }(r[3]);
            const a = r[4] || r[6];
            if (!t.leadingZeros && o.length > 0 && i && "." !== n[2]) return e;
            if (!t.leadingZeros && o.length > 0 && !i && "." !== n[1]) return e;
            {
                const r = Number(n), u = "" + r;
                return -1 !== u.search(/[eE]/) || a ? t.eNotation ? r : e : -1 !== n.indexOf(".") ? "0" === u && "" === s || u === s || i && u === "-" + s ? r : e : o ? s === u || i + s === u ? r : e : n === u || n === i + u ? r : e
            }
        }
        return e
    }
};
"<((!\\[CDATA\\[([\\s\\S]*?)(]]>))|((NAME:)?(NAME))([^>]*)>|((\\/)(NAME)\\s*>))([^<]*)".replace(/NAME/g, Kp.nameRegexp), !Number.parseInt && window.parseInt && (Number.parseInt = window.parseInt), !Number.parseFloat && window.parseFloat && (Number.parseFloat = window.parseFloat);
const Gp = {
    attributeNamePrefix: "@_",
    attrNodeName: !1,
    textNodeName: "#text",
    ignoreAttributes: !0,
    ignoreNameSpace: !1,
    allowBooleanAttributes: !1,
    parseNodeValue: !0,
    parseAttributeValue: !1,
    arrayMode: !1,
    trimValues: !0,
    cdataTagName: !1,
    cdataPositionChar: "\\c",
    numParseOptions: {hex: !0, leadingZeros: !0},
    tagValueProcessor: function (e, t) {
        return e
    },
    attrValueProcessor: function (e, t) {
        return e
    },
    stopNodes: [],
    alwaysCreateTextNode: !1
};
Bp.defaultOptions = Gp;
const Wp = ["attributeNamePrefix", "attrNodeName", "textNodeName", "ignoreAttributes", "ignoreNameSpace", "allowBooleanAttributes", "parseNodeValue", "parseAttributeValue", "arrayMode", "trimValues", "cdataTagName", "cdataPositionChar", "tagValueProcessor", "attrValueProcessor", "parseTrueNumberOnly", "numParseOptions", "stopNodes", "alwaysCreateTextNode"];

function $p(e, t, n) {
    return t && (n.trimValues && (t = t.trim()), t = Jp(t = n.tagValueProcessor(t, e), n.parseNodeValue, n.numParseOptions)), t
}

function Yp(e, t) {
    if (t.ignoreNameSpace) {
        const t = e.split(":"), n = "/" === e.charAt(0) ? "/" : "";
        if ("xmlns" === t[0]) return "";
        2 === t.length && (e = n + t[1])
    }
    return e
}

function Jp(e, t, n) {
    if (t && "string" == typeof e) {
        const t = e.trim();
        return "true" === t || "false" !== t && Vp(e, n)
    }
    return Kp.isExist(e) ? e : ""
}

Bp.props = Wp;
const Zp = new RegExp("([^\\s=]+)\\s*(=\\s*(['\"])(.*?)\\3)?", "g");

function Xp(e, t) {
    if (!t.ignoreAttributes && "string" == typeof e) {
        e = e.replace(/\r?\n/g, " ");
        const n = Kp.getAllMatches(e, Zp), r = n.length, i = {};
        for (let e = 0; e < r; e++) {
            const r = Yp(n[e][1], t);
            r.length && (void 0 !== n[e][4] ? (t.trimValues && (n[e][4] = n[e][4].trim()), n[e][4] = t.attrValueProcessor(n[e][4], r), i[t.attributeNamePrefix + r] = Jp(n[e][4], t.parseAttributeValue, t.numParseOptions)) : t.allowBooleanAttributes && (i[t.attributeNamePrefix + r] = !0))
        }
        if (!Object.keys(i).length) return;
        if (t.attrNodeName) {
            const e = {};
            return e[t.attrNodeName] = i, e
        }
        return i
    }
}

function Qp(e, t) {
    let n, r = "";
    for (let i = t; i < e.length; i++) {
        let t = e[i];
        if (n) t === n && (n = ""); else if ('"' === t || "'" === t) n = t; else {
            if (">" === t) return {data: r, index: i};
            "\t" === t && (t = " ")
        }
        r += t
    }
}

function eg(e, t, n, r) {
    const i = e.indexOf(t, n);
    if (-1 === i) throw new Error(r);
    return i + t.length - 1
}

Bp.getTraversalObj = function (e, t) {
    e = e.replace(/\r\n?/g, "\n"), t = qp(t, Gp, Wp);
    const n = new Hp("!xml");
    let r = n, i = "";
    for (let n = 0; n < e.length; n++) {
        if ("<" === e[n]) if ("/" === e[n + 1]) {
            const o = eg(e, ">", n, "Closing Tag is not closed.");
            let s = e.substring(n + 2, o).trim();
            if (t.ignoreNameSpace) {
                const e = s.indexOf(":");
                -1 !== e && (s = s.substr(e + 1))
            }
            r && (r.val ? r.val = Kp.getValue(r.val) + "" + $p(s, i, t) : r.val = $p(s, i, t)), t.stopNodes.length && t.stopNodes.includes(r.tagname) && (r.child = [], null == r.attrsMap && (r.attrsMap = {}), r.val = e.substr(r.startIndex + 1, n - r.startIndex - 1)), r = r.parent, i = "", n = o
        } else if ("?" === e[n + 1]) n = eg(e, "?>", n, "Pi Tag is not closed."); else if ("!--" === e.substr(n + 1, 3)) n = eg(e, "--\x3e", n, "Comment is not closed."); else if ("!D" === e.substr(n + 1, 2)) {
            const t = eg(e, ">", n, "DOCTYPE is not closed.");
            n = e.substring(n, t).indexOf("[") >= 0 ? e.indexOf("]>", n) + 1 : t
        } else if ("![" === e.substr(n + 1, 2)) {
            const o = eg(e, "]]>", n, "CDATA is not closed.") - 2, s = e.substring(n + 9, o);
            if (i && (r.val = Kp.getValue(r.val) + "" + $p(r.tagname, i, t), i = ""), t.cdataTagName) {
                const e = new Hp(t.cdataTagName, r, s);
                r.addChild(e), r.val = Kp.getValue(r.val) + t.cdataPositionChar, s && (e.val = s)
            } else r.val = (r.val || "") + (s || "");
            n = o + 2
        } else {
            const o = Qp(e, n + 1);
            let s = o.data;
            const a = o.index, u = s.indexOf(" ");
            let c = s, l = !0;
            if (-1 !== u && (c = s.substr(0, u).replace(/\s\s*$/, ""), s = s.substr(u + 1)), t.ignoreNameSpace) {
                const e = c.indexOf(":");
                -1 !== e && (c = c.substr(e + 1), l = c !== o.data.substr(e + 1))
            }
            if (r && i && "!xml" !== r.tagname && (r.val = Kp.getValue(r.val) + "" + $p(r.tagname, i, t)), s.length > 0 && s.lastIndexOf("/") === s.length - 1) {
                "/" === c[c.length - 1] ? (c = c.substr(0, c.length - 1), s = c) : s = s.substr(0, s.length - 1);
                const e = new Hp(c, r, "");
                c !== s && (e.attrsMap = Xp(s, t)), r.addChild(e)
            } else {
                const e = new Hp(c, r);
                t.stopNodes.length && t.stopNodes.includes(e.tagname) && (e.startIndex = a), c !== s && l && (e.attrsMap = Xp(s, t)), r.addChild(e), r = e
            }
            i = "", n = a
        } else i += e[n]
    }
    return n
};
var tg = {};
const ng = Rp, rg = {allowBooleanAttributes: !1}, ig = ["allowBooleanAttributes"];

function og(e, t) {
    const n = t;
    for (; t < e.length; t++) if ("?" != e[t] && " " != e[t]) ; else {
        const r = e.substr(n, t - n);
        if (t > 5 && "xml" === r) return fg("InvalidXml", "XML declaration allowed only at the start of the document.", hg(e, t));
        if ("?" == e[t] && ">" == e[t + 1]) {
            t++;
            break
        }
    }
    return t
}

function sg(e, t) {
    if (e.length > t + 5 && "-" === e[t + 1] && "-" === e[t + 2]) {
        for (t += 3; t < e.length; t++) if ("-" === e[t] && "-" === e[t + 1] && ">" === e[t + 2]) {
            t += 2;
            break
        }
    } else if (e.length > t + 8 && "D" === e[t + 1] && "O" === e[t + 2] && "C" === e[t + 3] && "T" === e[t + 4] && "Y" === e[t + 5] && "P" === e[t + 6] && "E" === e[t + 7]) {
        let n = 1;
        for (t += 8; t < e.length; t++) if ("<" === e[t]) n++; else if (">" === e[t] && (n--, 0 === n)) break
    } else if (e.length > t + 9 && "[" === e[t + 1] && "C" === e[t + 2] && "D" === e[t + 3] && "A" === e[t + 4] && "T" === e[t + 5] && "A" === e[t + 6] && "[" === e[t + 7]) for (t += 8; t < e.length; t++) if ("]" === e[t] && "]" === e[t + 1] && ">" === e[t + 2]) {
        t += 2;
        break
    }
    return t
}

tg.validate = function (e, t) {
    t = ng.buildOptions(t, rg, ig);
    const n = [];
    let r = !1, i = !1;
    "\ufeff" === e[0] && (e = e.substr(1));
    for (let s = 0; s < e.length; s++) if ("<" === e[s] && "?" === e[s + 1]) {
        if (s += 2, s = og(e, s), s.err) return s
    } else {
        if ("<" !== e[s]) {
            if (" " === e[s] || "\t" === e[s] || "\n" === e[s] || "\r" === e[s]) continue;
            return fg("InvalidChar", "char '" + e[s] + "' is not expected.", hg(e, s))
        }
        {
            let a = s;
            if (s++, "!" === e[s]) {
                s = sg(e, s);
                continue
            }
            {
                let u = !1;
                "/" === e[s] && (u = !0, s++);
                let c = "";
                for (; s < e.length && ">" !== e[s] && " " !== e[s] && "\t" !== e[s] && "\n" !== e[s] && "\r" !== e[s]; s++) c += e[s];
                if (c = c.trim(), "/" === c[c.length - 1] && (c = c.substring(0, c.length - 1), s--), o = c, !ng.isName(o)) {
                    let t;
                    return t = 0 === c.trim().length ? "Invalid space after '<'." : "Tag '" + c + "' is an invalid name.", fg("InvalidTag", t, hg(e, s))
                }
                const l = ag(e, s);
                if (!1 === l) return fg("InvalidAttr", "Attributes for '" + c + "' have open quote.", hg(e, s));
                let f = l.value;
                if (s = l.index, "/" === f[f.length - 1]) {
                    const n = s - f.length;
                    f = f.substring(0, f.length - 1);
                    const i = cg(f, t);
                    if (!0 !== i) return fg(i.err.code, i.err.msg, hg(e, n + i.err.line));
                    r = !0
                } else if (u) {
                    if (!l.tagClosed) return fg("InvalidTag", "Closing tag '" + c + "' doesn't have proper closing.", hg(e, s));
                    if (f.trim().length > 0) return fg("InvalidTag", "Closing tag '" + c + "' can't have attributes or invalid starting.", hg(e, a));
                    {
                        const t = n.pop();
                        if (c !== t.tagName) {
                            let n = hg(e, t.tagStartPos);
                            return fg("InvalidTag", "Expected closing tag '" + t.tagName + "' (opened in line " + n.line + ", col " + n.col + ") instead of closing tag '" + c + "'.", hg(e, a))
                        }
                        0 == n.length && (i = !0)
                    }
                } else {
                    const o = cg(f, t);
                    if (!0 !== o) return fg(o.err.code, o.err.msg, hg(e, s - f.length + o.err.line));
                    if (!0 === i) return fg("InvalidXml", "Multiple possible root nodes found.", hg(e, s));
                    n.push({tagName: c, tagStartPos: a}), r = !0
                }
                for (s++; s < e.length; s++) if ("<" === e[s]) {
                    if ("!" === e[s + 1]) {
                        s++, s = sg(e, s);
                        continue
                    }
                    if ("?" !== e[s + 1]) break;
                    if (s = og(e, ++s), s.err) return s
                } else if ("&" === e[s]) {
                    const t = lg(e, s);
                    if (-1 == t) return fg("InvalidChar", "char '&' is not expected.", hg(e, s));
                    s = t
                }
                "<" === e[s] && s--
            }
        }
    }
    var o;
    return r ? 1 == n.length ? fg("InvalidTag", "Unclosed tag '" + n[0].tagName + "'.", hg(e, n[0].tagStartPos)) : !(n.length > 0) || fg("InvalidXml", "Invalid '" + JSON.stringify(n.map((e => e.tagName)), null, 4).replace(/\r?\n/g, "") + "' found.", {
        line: 1,
        col: 1
    }) : fg("InvalidXml", "Start tag expected.", 1)
};

function ag(e, t) {
    let n = "", r = "", i = !1;
    for (; t < e.length; t++) {
        if ('"' === e[t] || "'" === e[t]) "" === r ? r = e[t] : r !== e[t] || (r = ""); else if (">" === e[t] && "" === r) {
            i = !0;
            break
        }
        n += e[t]
    }
    return "" === r && {value: n, index: t, tagClosed: i}
}

const ug = new RegExp("(\\s*)([^\\s=]+)(\\s*=)?(\\s*(['\"])(([\\s\\S])*?)\\5)?", "g");

function cg(e, t) {
    const n = ng.getAllMatches(e, ug), r = {};
    for (let e = 0; e < n.length; e++) {
        if (0 === n[e][1].length) return fg("InvalidAttr", "Attribute '" + n[e][2] + "' has no space in starting.", pg(n[e]));
        if (void 0 === n[e][3] && !t.allowBooleanAttributes) return fg("InvalidAttr", "boolean attribute '" + n[e][2] + "' is not allowed.", pg(n[e]));
        const i = n[e][2];
        if (!dg(i)) return fg("InvalidAttr", "Attribute '" + i + "' is an invalid name.", pg(n[e]));
        if (r.hasOwnProperty(i)) return fg("InvalidAttr", "Attribute '" + i + "' is repeated.", pg(n[e]));
        r[i] = 1
    }
    return !0
}

function lg(e, t) {
    if (";" === e[++t]) return -1;
    if ("#" === e[t]) return function (e, t) {
        let n = /\d/;
        for ("x" === e[t] && (t++, n = /[\da-fA-F]/); t < e.length; t++) {
            if (";" === e[t]) return t;
            if (!e[t].match(n)) break
        }
        return -1
    }(e, ++t);
    let n = 0;
    for (; t < e.length; t++, n++) if (!(e[t].match(/\w/) && n < 20)) {
        if (";" === e[t]) break;
        return -1
    }
    return t
}

function fg(e, t, n) {
    return {err: {code: e, msg: t, line: n.line || n, col: n.col}}
}

function dg(e) {
    return ng.isName(e)
}

function hg(e, t) {
    const n = e.substring(0, t).split(/\r?\n/);
    return {line: n.length, col: n[n.length - 1].length + 1}
}

function pg(e) {
    return e.startIndex + e[1].length
}

var gg = {};
const vg = function (e) {
        return String.fromCharCode(e)
    }, mg = {
        nilChar: vg(176),
        missingChar: vg(201),
        nilPremitive: vg(175),
        missingPremitive: vg(200),
        emptyChar: vg(178),
        emptyValue: vg(177),
        boundryChar: vg(179),
        objStart: vg(198),
        arrStart: vg(204),
        arrayEnd: vg(185)
    },
    yg = [mg.nilChar, mg.nilPremitive, mg.missingChar, mg.missingPremitive, mg.boundryChar, mg.emptyChar, mg.emptyValue, mg.arrayEnd, mg.objStart, mg.arrStart],
    Sg = function (e, t, n) {
        if ("string" == typeof t) return e && e[0] && void 0 !== e[0].val ? wg(e[0].val) : wg(e);
        {
            const i = void 0 === (r = e) ? mg.missingChar : null === r ? mg.nilChar : !(r.child && 0 === Object.keys(r.child).length && (!r.attrsMap || 0 === Object.keys(r.attrsMap).length)) || mg.emptyChar;
            if (!0 === i) {
                let r = "";
                if (Array.isArray(t)) {
                    r += mg.arrStart;
                    const i = t[0], o = e.length;
                    if ("string" == typeof i) for (let t = 0; t < o; t++) {
                        const n = wg(e[t].val);
                        r = bg(r, n)
                    } else for (let t = 0; t < o; t++) {
                        const o = Sg(e[t], i, n);
                        r = bg(r, o)
                    }
                    r += mg.arrayEnd
                } else {
                    r += mg.objStart;
                    const i = Object.keys(t);
                    Array.isArray(e) && (e = e[0]);
                    for (let o in i) {
                        const s = i[o];
                        let a;
                        a = !n.ignoreAttributes && e.attrsMap && e.attrsMap[s] ? Sg(e.attrsMap[s], t[s], n) : s === n.textNodeName ? Sg(e.val, t[s], n) : Sg(e.child[s], t[s], n), r = bg(r, a)
                    }
                }
                return r
            }
            return i
        }
        var r
    }, wg = function (e) {
        switch (e) {
            case void 0:
                return mg.missingPremitive;
            case null:
                return mg.nilPremitive;
            case"":
                return mg.emptyValue;
            default:
                return e
        }
    }, bg = function (e, t) {
        return Eg(t[0]) || Eg(e[e.length - 1]) || (e += mg.boundryChar), e + t
    }, Eg = function (e) {
        return -1 !== yg.indexOf(e)
    };
const Cg = Bp, _g = Rp.buildOptions;
gg.convert2nimn = function (e, t, n) {
    return n = _g(n, Cg.defaultOptions, Cg.props), Sg(e, t, n)
};
var Ag = {};
const Pg = Rp, kg = Rp.buildOptions, xg = Bp, Ig = function (e, t, n) {
    let r = "{";
    const i = Object.keys(e.child);
    for (let n = 0; n < i.length; n++) {
        const o = i[n];
        if (e.child[o] && e.child[o].length > 1) {
            r += '"' + o + '" : [ ';
            for (let n in e.child[o]) r += Ig(e.child[o][n], t) + " , ";
            r = r.substr(0, r.length - 1) + " ] "
        } else r += '"' + o + '" : ' + Ig(e.child[o][0], t) + " ,"
    }
    return Pg.merge(r, e.attrsMap), Pg.isEmptyObject(r) ? Pg.isExist(e.val) ? e.val : "" : (Pg.isExist(e.val) && ("string" != typeof e.val || "" !== e.val && e.val !== t.cdataPositionChar) && (r += '"' + t.textNodeName + '" : ' + (!0 !== (o = e.val) && !1 !== o && isNaN(o) ? '"' + o + '"' : o)), "," === r[r.length - 1] && (r = r.substr(0, r.length - 2)), r + "}");
    var o
};
Ag.convertToJsonString = function (e, t) {
    return (t = kg(t, xg.defaultOptions, xg.props)).indentBy = t.indentBy || "", Ig(e, t)
};
const Tg = Rp.buildOptions, Ug = {
        attributeNamePrefix: "@_",
        attrNodeName: !1,
        textNodeName: "#text",
        ignoreAttributes: !0,
        cdataTagName: !1,
        cdataPositionChar: "\\c",
        format: !1,
        indentBy: "  ",
        supressEmptyNode: !1,
        tagValueProcessor: function (e) {
            return e
        },
        attrValueProcessor: function (e) {
            return e
        }
    },
    Og = ["attributeNamePrefix", "attrNodeName", "textNodeName", "ignoreAttributes", "cdataTagName", "cdataPositionChar", "format", "indentBy", "supressEmptyNode", "tagValueProcessor", "attrValueProcessor", "rootNodeName"];

function Mg(e) {
    this.options = Tg(e, Ug, Og), this.options.ignoreAttributes || this.options.attrNodeName ? this.isAttribute = function () {
        return !1
    } : (this.attrPrefixLen = this.options.attributeNamePrefix.length, this.isAttribute = Kg), this.options.cdataTagName ? this.isCDATA = qg : this.isCDATA = function () {
        return !1
    }, this.replaceCDATAstr = Rg, this.replaceCDATAarr = Ng, this.processTextOrObjNode = Lg, this.options.format ? (this.indentate = zg, this.tagEndChar = ">\n", this.newLine = "\n") : (this.indentate = function () {
        return ""
    }, this.tagEndChar = ">", this.newLine = ""), this.options.supressEmptyNode ? (this.buildTextNode = Fg, this.buildObjNode = Bg) : (this.buildTextNode = jg, this.buildObjNode = Dg), this.buildTextValNode = jg, this.buildObjectNode = Dg
}

function Lg(e, t, n) {
    const r = this.j2x(e, n + 1);
    return void 0 !== e[this.options.textNodeName] && 1 === Object.keys(e).length ? this.buildTextNode(r.val, t, r.attrStr, n) : this.buildObjNode(r.val, t, r.attrStr, n)
}

function Rg(e, t) {
    return e = this.options.tagValueProcessor("" + e), "" === this.options.cdataPositionChar || "" === e ? e + "<![CDATA[" + t + "]]" + this.tagEndChar : e.replace(this.options.cdataPositionChar, "<![CDATA[" + t + "]]" + this.tagEndChar)
}

function Ng(e, t) {
    if (e = this.options.tagValueProcessor("" + e), "" === this.options.cdataPositionChar || "" === e) return e + "<![CDATA[" + t.join("]]><![CDATA[") + "]]" + this.tagEndChar;
    for (let n in t) e = e.replace(this.options.cdataPositionChar, "<![CDATA[" + t[n] + "]]>");
    return e + this.newLine
}

function Dg(e, t, n, r) {
    return n && -1 === e.indexOf("<") ? this.indentate(r) + "<" + t + n + ">" + e + "</" + t + this.tagEndChar : this.indentate(r) + "<" + t + n + this.tagEndChar + e + this.indentate(r) + "</" + t + this.tagEndChar
}

function Bg(e, t, n, r) {
    return "" !== e ? this.buildObjectNode(e, t, n, r) : this.indentate(r) + "<" + t + n + "/" + this.tagEndChar
}

function jg(e, t, n, r) {
    return this.indentate(r) + "<" + t + n + ">" + this.options.tagValueProcessor(e) + "</" + t + this.tagEndChar
}

function Fg(e, t, n, r) {
    return "" !== e ? this.buildTextValNode(e, t, n, r) : this.indentate(r) + "<" + t + n + "/" + this.tagEndChar
}

function zg(e) {
    return this.options.indentBy.repeat(e)
}

function Kg(e) {
    return !!e.startsWith(this.options.attributeNamePrefix) && e.substr(this.attrPrefixLen)
}

function qg(e) {
    return e === this.options.cdataTagName
}

Mg.prototype.parse = function (e) {
    return Array.isArray(e) && this.options.rootNodeName && this.options.rootNodeName.length > 1 && (e = {[this.options.rootNodeName]: e}), this.j2x(e, 0).val
}, Mg.prototype.j2x = function (e, t) {
    let n = "", r = "";
    for (let i in e) if (void 0 === e[i]) ; else if (null === e[i]) r += this.indentate(t) + "<" + i + "/" + this.tagEndChar; else if (e[i] instanceof Date) r += this.buildTextNode(e[i], i, "", t); else if ("object" != typeof e[i]) {
        const o = this.isAttribute(i);
        o ? n += " " + o + '="' + this.options.attrValueProcessor("" + e[i]) + '"' : this.isCDATA(i) ? e[this.options.textNodeName] ? r += this.replaceCDATAstr(e[this.options.textNodeName], e[i]) : r += this.replaceCDATAstr("", e[i]) : i === this.options.textNodeName ? e[this.options.cdataTagName] || (r += this.options.tagValueProcessor("" + e[i])) : r += this.buildTextNode(e[i], i, "", t)
    } else if (Array.isArray(e[i])) if (this.isCDATA(i)) r += this.indentate(t), e[this.options.textNodeName] ? r += this.replaceCDATAarr(e[this.options.textNodeName], e[i]) : r += this.replaceCDATAarr("", e[i]); else {
        const n = e[i].length;
        for (let o = 0; o < n; o++) {
            const n = e[i][o];
            void 0 === n || (r += null === n ? this.indentate(t) + "<" + i + "/" + this.tagEndChar : "object" == typeof n ? this.processTextOrObjNode(n, i, t) : this.buildTextNode(n, i, "", t))
        }
    } else if (this.options.attrNodeName && i === this.options.attrNodeName) {
        const t = Object.keys(e[i]), r = t.length;
        for (let o = 0; o < r; o++) n += " " + t[o] + '="' + this.options.attrValueProcessor("" + e[i][t[o]]) + '"'
    } else r += this.processTextOrObjNode(e[i], i, t);
    return {attrStr: n, val: r}
};
var Hg = Mg;
!function (e) {
    const t = Lp, n = Bp, r = Bp, i = Rp.buildOptions, o = tg;
    e.parse = function (e, s = {}, a) {
        if (a) {
            !0 === a && (a = {});
            const t = o.validate(e, a);
            if (!0 !== t) throw Error(t.err.msg)
        }
        s.parseTrueNumberOnly && !1 !== s.parseNodeValue && !s.numParseOptions && (s.numParseOptions = {leadingZeros: !1});
        let u = i(s, r.defaultOptions, r.props);
        const c = n.getTraversalObj(e, u);
        return t.convertToJson(c, u)
    }, e.convertTonimn = gg.convert2nimn, e.getTraversalObj = n.getTraversalObj, e.convertToJson = t.convertToJson, e.convertToJsonString = Ag.convertToJsonString, e.validate = o.validate, e.j2xParser = Hg, e.parseToNimn = function (t, n, r) {
        return e.convertTonimn(e.getTraversalObj(t, r), n, r)
    }
}(Mp);
var Vg = function (e, t) {
    return nc(void 0, void 0, void 0, (function () {
        var n, r, i, o, s, a, u, c;
        return rc(this, (function (l) {
            switch (l.label) {
                case 0:
                    return r = [tc({}, e)], c = {}, [4, yv(e.body, t)];
                case 1:
                    switch (n = tc.apply(void 0, r.concat([(c.body = l.sent(), c)])), o = "UnknownError", o = Sv(e, n.body), o) {
                        case"NoSuchUpload":
                        case"com.amazonaws.s3#NoSuchUpload":
                            return [3, 2]
                    }
                    return [3, 4];
                case 2:
                    return s = [{}], [4, ov(n)];
                case 3:
                    return i = tc.apply(void 0, [tc.apply(void 0, s.concat([l.sent()])), {
                        name: o,
                        $metadata: gv(e)
                    }]), [3, 5];
                case 4:
                    a = n.body, o = a.code || a.Code || o, i = tc(tc({}, a), {
                        name: "" + o,
                        message: a.message || a.Message || o,
                        $fault: "client",
                        $metadata: gv(e)
                    }), l.label = 5;
                case 5:
                    return u = i.message || i.Message || o, i.message = u, delete i.Message, [2, Promise.reject(Object.assign(new Error(u), i))]
            }
        }))
    }))
}, Gg = function (e, t) {
    return nc(void 0, void 0, void 0, (function () {
        var n, r, i, o, s, a, u;
        return rc(this, (function (c) {
            switch (c.label) {
                case 0:
                    return r = [tc({}, e)], u = {}, [4, yv(e.body, t)];
                case 1:
                    return n = tc.apply(void 0, r.concat([(u.body = c.sent(), u)])), o = "UnknownError", o = Sv(e, n.body), s = n.body, o = s.code || s.Code || o, i = tc(tc({}, s), {
                        name: "" + o,
                        message: s.message || s.Message || o,
                        $fault: "client",
                        $metadata: gv(e)
                    }), a = i.message || i.Message || o, i.message = a, delete i.Message, [2, Promise.reject(Object.assign(new Error(a), i))]
            }
        }))
    }))
}, Wg = function (e, t) {
    return nc(void 0, void 0, void 0, (function () {
        var n, r, i, o, s, a, u, c;
        return rc(this, (function (l) {
            switch (l.label) {
                case 0:
                    return r = [tc({}, e)], c = {}, [4, yv(e.body, t)];
                case 1:
                    switch (n = tc.apply(void 0, r.concat([(c.body = l.sent(), c)])), o = "UnknownError", o = Sv(e, n.body), o) {
                        case"ObjectNotInActiveTierError":
                        case"com.amazonaws.s3#ObjectNotInActiveTierError":
                            return [3, 2]
                    }
                    return [3, 4];
                case 2:
                    return s = [{}], [4, sv(n)];
                case 3:
                    return i = tc.apply(void 0, [tc.apply(void 0, s.concat([l.sent()])), {
                        name: o,
                        $metadata: gv(e)
                    }]), [3, 5];
                case 4:
                    a = n.body, o = a.code || a.Code || o, i = tc(tc({}, a), {
                        name: "" + o,
                        message: a.message || a.Message || o,
                        $fault: "client",
                        $metadata: gv(e)
                    }), l.label = 5;
                case 5:
                    return u = i.message || i.Message || o, i.message = u, delete i.Message, [2, Promise.reject(Object.assign(new Error(u), i))]
            }
        }))
    }))
}, $g = function (e, t) {
    return nc(void 0, void 0, void 0, (function () {
        var n, r, i, o, s, a, u;
        return rc(this, (function (c) {
            switch (c.label) {
                case 0:
                    return r = [tc({}, e)], u = {}, [4, yv(e.body, t)];
                case 1:
                    return n = tc.apply(void 0, r.concat([(u.body = c.sent(), u)])), o = "UnknownError", o = Sv(e, n.body), s = n.body, o = s.code || s.Code || o, i = tc(tc({}, s), {
                        name: "" + o,
                        message: s.message || s.Message || o,
                        $fault: "client",
                        $metadata: gv(e)
                    }), a = i.message || i.Message || o, i.message = a, delete i.Message, [2, Promise.reject(Object.assign(new Error(a), i))]
            }
        }))
    }))
}, Yg = function (e, t) {
    return nc(void 0, void 0, void 0, (function () {
        var n, r, i, o, s, a, u;
        return rc(this, (function (c) {
            switch (c.label) {
                case 0:
                    return r = [tc({}, e)], u = {}, [4, yv(e.body, t)];
                case 1:
                    return n = tc.apply(void 0, r.concat([(u.body = c.sent(), u)])), o = "UnknownError", o = Sv(e, n.body), s = n.body, o = s.code || s.Code || o, i = tc(tc({}, s), {
                        name: "" + o,
                        message: s.message || s.Message || o,
                        $fault: "client",
                        $metadata: gv(e)
                    }), a = i.message || i.Message || o, i.message = a, delete i.Message, [2, Promise.reject(Object.assign(new Error(a), i))]
            }
        }))
    }))
}, Jg = function (e, t) {
    return nc(void 0, void 0, void 0, (function () {
        var n, r, i, o, s, a, u, c, l;
        return rc(this, (function (f) {
            switch (f.label) {
                case 0:
                    return r = [tc({}, e)], l = {}, [4, yv(e.body, t)];
                case 1:
                    switch (n = tc.apply(void 0, r.concat([(l.body = f.sent(), l)])), o = "UnknownError", o = Sv(e, n.body), o) {
                        case"InvalidObjectState":
                        case"com.amazonaws.s3#InvalidObjectState":
                            return [3, 2];
                        case"NoSuchKey":
                        case"com.amazonaws.s3#NoSuchKey":
                            return [3, 4]
                    }
                    return [3, 6];
                case 2:
                    return s = [{}], [4, nv(n)];
                case 3:
                    return i = tc.apply(void 0, [tc.apply(void 0, s.concat([f.sent()])), {
                        name: o,
                        $metadata: gv(e)
                    }]), [3, 7];
                case 4:
                    return a = [{}], [4, iv(n)];
                case 5:
                    return i = tc.apply(void 0, [tc.apply(void 0, a.concat([f.sent()])), {
                        name: o,
                        $metadata: gv(e)
                    }]), [3, 7];
                case 6:
                    u = n.body, o = u.code || u.Code || o, i = tc(tc({}, u), {
                        name: "" + o,
                        message: u.message || u.Message || o,
                        $fault: "client",
                        $metadata: gv(e)
                    }), f.label = 7;
                case 7:
                    return c = i.message || i.Message || o, i.message = c, delete i.Message, [2, Promise.reject(Object.assign(new Error(c), i))]
            }
        }))
    }))
}, Zg = function (e, t) {
    return nc(void 0, void 0, void 0, (function () {
        var n, r, i, o, s, a, u, c;
        return rc(this, (function (l) {
            switch (l.label) {
                case 0:
                    return r = [tc({}, e)], c = {}, [4, yv(e.body, t)];
                case 1:
                    switch (n = tc.apply(void 0, r.concat([(c.body = l.sent(), c)])), o = "UnknownError", o = Sv(e, n.body), o) {
                        case"NoSuchBucket":
                        case"com.amazonaws.s3#NoSuchBucket":
                            return [3, 2]
                    }
                    return [3, 4];
                case 2:
                    return s = [{}], [4, rv(n)];
                case 3:
                    return i = tc.apply(void 0, [tc.apply(void 0, s.concat([l.sent()])), {
                        name: o,
                        $metadata: gv(e)
                    }]), [3, 5];
                case 4:
                    a = n.body, o = a.code || a.Code || o, i = tc(tc({}, a), {
                        name: "" + o,
                        message: a.message || a.Message || o,
                        $fault: "client",
                        $metadata: gv(e)
                    }), l.label = 5;
                case 5:
                    return u = i.message || i.Message || o, i.message = u, delete i.Message, [2, Promise.reject(Object.assign(new Error(u), i))]
            }
        }))
    }))
}, Xg = function (e, t) {
    return nc(void 0, void 0, void 0, (function () {
        var n, r, i, o, s, a, u, c;
        return rc(this, (function (l) {
            switch (l.label) {
                case 0:
                    return r = [tc({}, e)], c = {}, [4, yv(e.body, t)];
                case 1:
                    switch (n = tc.apply(void 0, r.concat([(c.body = l.sent(), c)])), o = "UnknownError", o = Sv(e, n.body), o) {
                        case"NoSuchBucket":
                        case"com.amazonaws.s3#NoSuchBucket":
                            return [3, 2]
                    }
                    return [3, 4];
                case 2:
                    return s = [{}], [4, rv(n)];
                case 3:
                    return i = tc.apply(void 0, [tc.apply(void 0, s.concat([l.sent()])), {
                        name: o,
                        $metadata: gv(e)
                    }]), [3, 5];
                case 4:
                    a = n.body, o = a.code || a.Code || o, i = tc(tc({}, a), {
                        name: "" + o,
                        message: a.message || a.Message || o,
                        $fault: "client",
                        $metadata: gv(e)
                    }), l.label = 5;
                case 5:
                    return u = i.message || i.Message || o, i.message = u, delete i.Message, [2, Promise.reject(Object.assign(new Error(u), i))]
            }
        }))
    }))
}, Qg = function (e, t) {
    return nc(void 0, void 0, void 0, (function () {
        var n, r, i, o, s, a, u;
        return rc(this, (function (c) {
            switch (c.label) {
                case 0:
                    return r = [tc({}, e)], u = {}, [4, yv(e.body, t)];
                case 1:
                    return n = tc.apply(void 0, r.concat([(u.body = c.sent(), u)])), o = "UnknownError", o = Sv(e, n.body), s = n.body, o = s.code || s.Code || o, i = tc(tc({}, s), {
                        name: "" + o,
                        message: s.message || s.Message || o,
                        $fault: "client",
                        $metadata: gv(e)
                    }), a = i.message || i.Message || o, i.message = a, delete i.Message, [2, Promise.reject(Object.assign(new Error(a), i))]
            }
        }))
    }))
}, ev = function (e, t) {
    return nc(void 0, void 0, void 0, (function () {
        var n, r, i, o, s, a, u;
        return rc(this, (function (c) {
            switch (c.label) {
                case 0:
                    return r = [tc({}, e)], u = {}, [4, yv(e.body, t)];
                case 1:
                    return n = tc.apply(void 0, r.concat([(u.body = c.sent(), u)])), o = "UnknownError", o = Sv(e, n.body), s = n.body, o = s.code || s.Code || o, i = tc(tc({}, s), {
                        name: "" + o,
                        message: s.message || s.Message || o,
                        $fault: "client",
                        $metadata: gv(e)
                    }), a = i.message || i.Message || o, i.message = a, delete i.Message, [2, Promise.reject(Object.assign(new Error(a), i))]
            }
        }))
    }))
}, tv = function (e, t) {
    return nc(void 0, void 0, void 0, (function () {
        var n, r, i, o, s, a, u;
        return rc(this, (function (c) {
            switch (c.label) {
                case 0:
                    return r = [tc({}, e)], u = {}, [4, yv(e.body, t)];
                case 1:
                    return n = tc.apply(void 0, r.concat([(u.body = c.sent(), u)])), o = "UnknownError", o = Sv(e, n.body), s = n.body, o = s.code || s.Code || o, i = tc(tc({}, s), {
                        name: "" + o,
                        message: s.message || s.Message || o,
                        $fault: "client",
                        $metadata: gv(e)
                    }), a = i.message || i.Message || o, i.message = a, delete i.Message, [2, Promise.reject(Object.assign(new Error(a), i))]
            }
        }))
    }))
}, nv = function (e, t) {
    return nc(void 0, void 0, void 0, (function () {
        var t, n;
        return rc(this, (function (r) {
            return t = {
                name: "InvalidObjectState",
                $fault: "client",
                $metadata: gv(e),
                AccessTier: void 0,
                StorageClass: void 0
            }, void 0 !== (n = e.body).AccessTier && (t.AccessTier = n.AccessTier), void 0 !== n.StorageClass && (t.StorageClass = n.StorageClass), [2, t]
        }))
    }))
}, rv = function (e, t) {
    return nc(void 0, void 0, void 0, (function () {
        return rc(this, (function (t) {
            return [2, {name: "NoSuchBucket", $fault: "client", $metadata: gv(e)}]
        }))
    }))
}, iv = function (e, t) {
    return nc(void 0, void 0, void 0, (function () {
        return rc(this, (function (t) {
            return [2, {name: "NoSuchKey", $fault: "client", $metadata: gv(e)}]
        }))
    }))
}, ov = function (e, t) {
    return nc(void 0, void 0, void 0, (function () {
        return rc(this, (function (t) {
            return [2, {name: "NoSuchUpload", $fault: "client", $metadata: gv(e)}]
        }))
    }))
}, sv = function (e, t) {
    return nc(void 0, void 0, void 0, (function () {
        return rc(this, (function (t) {
            return [2, {name: "ObjectNotInActiveTierError", $fault: "client", $metadata: gv(e)}]
        }))
    }))
}, av = function (e, t) {
    var n = new Up("CompletedMultipartUpload");
    void 0 !== e.Parts && null !== e.Parts && uv(e.Parts).map((function (e) {
        e = e.withName("Part"), n.addChildNode(e)
    }));
    return n
}, uv = function (e, t) {
    return e.filter((function (e) {
        return null != e
    })).map((function (e) {
        if (null === e) return null;
        var t = function (e, t) {
            var n = new Up("CompletedPart");
            if (void 0 !== e.ETag && null !== e.ETag) {
                var r = new Up("ETag").addChildNode(new Op(e.ETag)).withName("ETag");
                n.addChildNode(r)
            }
            void 0 !== e.PartNumber && null !== e.PartNumber && (r = new Up("PartNumber").addChildNode(new Op(String(e.PartNumber))).withName("PartNumber"), n.addChildNode(r));
            return n
        }(e);
        return t.withName("member")
    }))
}, cv = function (e, t) {
    return (e || []).filter((function (e) {
        return null != e
    })).map((function (e) {
        return null === e ? null : function (e, t) {
            var n = {Prefix: void 0};
            return void 0 !== e.Prefix && (n.Prefix = e.Prefix), n
        }(e)
    }))
}, lv = function (e, t) {
    var n = {ETag: void 0, LastModified: void 0};
    return void 0 !== e.ETag && (n.ETag = e.ETag), void 0 !== e.LastModified && (n.LastModified = new Date(e.LastModified)), n
}, fv = function (e, t) {
    var n = {ID: void 0, DisplayName: void 0};
    return void 0 !== e.ID && (n.ID = e.ID), void 0 !== e.DisplayName && (n.DisplayName = e.DisplayName), n
}, dv = function (e, t) {
    return (e || []).filter((function (e) {
        return null != e
    })).map((function (e) {
        return null === e ? null : function (e, t) {
            var n = {
                Key: void 0,
                LastModified: void 0,
                ETag: void 0,
                Size: void 0,
                StorageClass: void 0,
                Owner: void 0
            };
            return void 0 !== e.Key && (n.Key = e.Key), void 0 !== e.LastModified && (n.LastModified = new Date(e.LastModified)), void 0 !== e.ETag && (n.ETag = e.ETag), void 0 !== e.Size && (n.Size = parseInt(e.Size)), void 0 !== e.StorageClass && (n.StorageClass = e.StorageClass), void 0 !== e.Owner && (n.Owner = hv(e.Owner)), n
        }(e)
    }))
}, hv = function (e, t) {
    var n = {DisplayName: void 0, ID: void 0};
    return void 0 !== e.DisplayName && (n.DisplayName = e.DisplayName), void 0 !== e.ID && (n.ID = e.ID), n
}, pv = function (e, t) {
    return (e || []).filter((function (e) {
        return null != e
    })).map((function (e) {
        return null === e ? null : function (e, t) {
            var n = {PartNumber: void 0, LastModified: void 0, ETag: void 0, Size: void 0};
            return void 0 !== e.PartNumber && (n.PartNumber = parseInt(e.PartNumber)), void 0 !== e.LastModified && (n.LastModified = new Date(e.LastModified)), void 0 !== e.ETag && (n.ETag = e.ETag), void 0 !== e.Size && (n.Size = parseInt(e.Size)), n
        }(e)
    }))
}, gv = function (e) {
    var t;
    return {
        httpStatusCode: e.statusCode,
        requestId: null !== (t = e.headers["x-amzn-requestid"]) && void 0 !== t ? t : e.headers["x-amzn-request-id"],
        extendedRequestId: e.headers["x-amz-id-2"],
        cfId: e.headers["x-amz-cf-id"]
    }
}, vv = function (e, t) {
    return void 0 === e && (e = new Uint8Array), e instanceof Uint8Array ? Promise.resolve(e) : t.streamCollector(e) || Promise.resolve(new Uint8Array)
}, mv = function (e) {
    return !(null == e || "" === e || Object.getOwnPropertyNames(e).includes("length") && 0 == e.length || Object.getOwnPropertyNames(e).includes("size") && 0 == e.size)
}, yv = function (e, t) {
    return function (e, t) {
        return vv(e, t).then((function (e) {
            return t.utf8Encoder(e)
        }))
    }(e, t).then((function (e) {
        if (e.length) {
            var t = Mp.parse(e, {
                attributeNamePrefix: "",
                ignoreAttributes: !1,
                parseNodeValue: !1,
                tagValueProcessor: function (e, t) {
                    return e.replace(/&amp;/g, "&").replace(/&apos;/g, "'").replace(/&quot;/g, '"').replace(/&gt;/g, ">").replace(/&lt;/g, "<")
                }
            }), n = Object.keys(t)[0], r = t[n];
            return r["#text"] && (r[n] = r["#text"], delete r["#text"]), zr(r)
        }
        return {}
    }))
}, Sv = function (e, t) {
    return void 0 !== t.Code ? t.Code : 404 == e.statusCode ? "NotFound" : ""
}, wv = function (e) {
    function t(t) {
        var n = e.call(this) || this;
        return n.input = t, n
    }

    return ec(t, e), t.prototype.resolveMiddleware = function (e, t, n) {
        this.middlewareStack.use(Yr(t, this.serialize, this.deserialize)), this.middlewareStack.use(Dc(t));
        var r = e.concat(this.middlewareStack), i = {
            logger: t.logger,
            clientName: "S3Client",
            commandName: "AbortMultipartUploadCommand",
            inputFilterSensitiveLog: Kc.filterSensitiveLog,
            outputFilterSensitiveLog: zc.filterSensitiveLog
        }, o = t.requestHandler;
        return r.resolve((function (e) {
            return o.handle(e.request, n || {})
        }), i)
    }, t.prototype.serialize = function (e, t) {
        return function (e, t) {
            return nc(void 0, void 0, void 0, (function () {
                var n, r, i, o, s, a, u, c, l;
                return rc(this, (function (f) {
                    switch (f.label) {
                        case 0:
                            if (n = tc(tc({}, mv(e.RequestPayer) && {"x-amz-request-payer": e.RequestPayer}), mv(e.ExpectedBucketOwner) && {"x-amz-expected-bucket-owner": e.ExpectedBucketOwner}), r = "/{Bucket}/{Key+}", void 0 === e.Bucket) throw new Error("No value provided for input HTTP label: Bucket.");
                            if ((i = e.Bucket).length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                            if (r = r.replace("{Bucket}", jr(i)), void 0 === e.Key) throw new Error("No value provided for input HTTP label: Key.");
                            if ((i = e.Key).length <= 0) throw new Error("Empty value provided for input HTTP label: Key.");
                            return r = r.replace("{Key+}", i.split("/").map((function (e) {
                                return jr(e)
                            })).join("/")), o = tc({"x-id": "AbortMultipartUpload"}, void 0 !== e.UploadId && {uploadId: e.UploadId}), [4, t.endpoint()];
                        case 1:
                            return s = f.sent(), a = s.hostname, u = s.protocol, c = void 0 === u ? "https" : u, l = s.port, [2, new Kt({
                                protocol: c,
                                hostname: a,
                                port: l,
                                method: "DELETE",
                                headers: n,
                                path: r,
                                query: o,
                                body: void 0
                            })]
                    }
                }))
            }))
        }(e, t)
    }, t.prototype.deserialize = function (e, t) {
        return function (e, t) {
            return nc(void 0, void 0, void 0, (function () {
                var n;
                return rc(this, (function (r) {
                    switch (r.label) {
                        case 0:
                            return 204 !== e.statusCode && e.statusCode >= 300 ? [2, Vg(e, t)] : (n = {
                                $metadata: gv(e),
                                RequestCharged: void 0
                            }, void 0 !== e.headers["x-amz-request-charged"] && (n.RequestCharged = e.headers["x-amz-request-charged"]), [4, vv(e.body, t)]);
                        case 1:
                            return r.sent(), [2, Promise.resolve(n)]
                    }
                }))
            }))
        }(e, t)
    }, t
}(Br), bv = function (e) {
    function t(t) {
        var n = e.call(this) || this;
        return n.input = t, n
    }

    return ec(t, e), t.prototype.resolveMiddleware = function (e, t, n) {
        this.middlewareStack.use(Yr(t, this.serialize, this.deserialize)), this.middlewareStack.use(Ip(t)), this.middlewareStack.use(Dc(t));
        var r = e.concat(this.middlewareStack), i = {
            logger: t.logger,
            clientName: "S3Client",
            commandName: "CompleteMultipartUploadCommand",
            inputFilterSensitiveLog: Qc.filterSensitiveLog,
            outputFilterSensitiveLog: Jc.filterSensitiveLog
        }, o = t.requestHandler;
        return r.resolve((function (e) {
            return o.handle(e.request, n || {})
        }), i)
    }, t.prototype.serialize = function (e, t) {
        return function (e, t) {
            return nc(void 0, void 0, void 0, (function () {
                var n, r, i, o, s, a, u, c, l, f, d;
                return rc(this, (function (h) {
                    switch (h.label) {
                        case 0:
                            if (n = tc(tc({"content-type": "application/xml"}, mv(e.RequestPayer) && {"x-amz-request-payer": e.RequestPayer}), mv(e.ExpectedBucketOwner) && {"x-amz-expected-bucket-owner": e.ExpectedBucketOwner}), r = "/{Bucket}/{Key+}", void 0 === e.Bucket) throw new Error("No value provided for input HTTP label: Bucket.");
                            if ((i = e.Bucket).length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                            if (r = r.replace("{Bucket}", jr(i)), void 0 === e.Key) throw new Error("No value provided for input HTTP label: Key.");
                            if ((i = e.Key).length <= 0) throw new Error("Empty value provided for input HTTP label: Key.");
                            return r = r.replace("{Key+}", i.split("/").map((function (e) {
                                return jr(e)
                            })).join("/")), o = tc({}, void 0 !== e.UploadId && {uploadId: e.UploadId}), void 0 !== e.MultipartUpload && (a = av(e.MultipartUpload), s = '<?xml version="1.0" encoding="UTF-8"?>', a.addAttribute("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/"), s += a.toString()), [4, t.endpoint()];
                        case 1:
                            return u = h.sent(), c = u.hostname, l = u.protocol, f = void 0 === l ? "https" : l, d = u.port, [2, new Kt({
                                protocol: f,
                                hostname: c,
                                port: d,
                                method: "POST",
                                headers: n,
                                path: r,
                                query: o,
                                body: s
                            })]
                    }
                }))
            }))
        }(e, t)
    }, t.prototype.deserialize = function (e, t) {
        return function (e, t) {
            return nc(void 0, void 0, void 0, (function () {
                var n, r;
                return rc(this, (function (i) {
                    switch (i.label) {
                        case 0:
                            return 200 !== e.statusCode && e.statusCode >= 300 ? [2, Gg(e, t)] : (n = {
                                $metadata: gv(e),
                                Bucket: void 0,
                                BucketKeyEnabled: void 0,
                                ETag: void 0,
                                Expiration: void 0,
                                Key: void 0,
                                Location: void 0,
                                RequestCharged: void 0,
                                SSEKMSKeyId: void 0,
                                ServerSideEncryption: void 0,
                                VersionId: void 0
                            }, void 0 !== e.headers["x-amz-expiration"] && (n.Expiration = e.headers["x-amz-expiration"]), void 0 !== e.headers["x-amz-server-side-encryption"] && (n.ServerSideEncryption = e.headers["x-amz-server-side-encryption"]), void 0 !== e.headers["x-amz-version-id"] && (n.VersionId = e.headers["x-amz-version-id"]), void 0 !== e.headers["x-amz-server-side-encryption-aws-kms-key-id"] && (n.SSEKMSKeyId = e.headers["x-amz-server-side-encryption-aws-kms-key-id"]), void 0 !== e.headers["x-amz-server-side-encryption-bucket-key-enabled"] && (n.BucketKeyEnabled = "true" === e.headers["x-amz-server-side-encryption-bucket-key-enabled"]), void 0 !== e.headers["x-amz-request-charged"] && (n.RequestCharged = e.headers["x-amz-request-charged"]), [4, yv(e.body, t)]);
                        case 1:
                            return void 0 !== (r = i.sent()).Bucket && (n.Bucket = r.Bucket), void 0 !== r.ETag && (n.ETag = r.ETag), void 0 !== r.Key && (n.Key = r.Key), void 0 !== r.Location && (n.Location = r.Location), [2, Promise.resolve(n)]
                    }
                }))
            }))
        }(e, t)
    }, t
}(Br);
var Ev, Cv, _v, Av, Pv, kv, xv, Iv, Tv, Uv, Ov, Mv, Lv, Rv, Nv, Dv, Bv, jv, Fv, zv, Kv, qv, Hv, Vv, Gv, Wv, $v, Yv, Jv,
    Zv, Xv, Qv, em, tm, nm = {name: "ssecMiddleware", step: "initialize", tags: ["SSE"], override: !0},
    rm = function (e) {
        return {
            applyToStack: function (t) {
                t.add(function (e) {
                    var t = this;
                    return function (n) {
                        return function (r) {
                            return j(t, void 0, void 0, (function () {
                                var t, i, o, s, a, u, c, l, f, d, h, p, g, v, m, y, S;
                                return F(this, (function (w) {
                                    switch (w.label) {
                                        case 0:
                                            t = D({}, r.input), i = [{
                                                target: "SSECustomerKey",
                                                hash: "SSECustomerKeyMD5"
                                            }, {
                                                target: "CopySourceSSECustomerKey",
                                                hash: "CopySourceSSECustomerKeyMD5"
                                            }], w.label = 1;
                                        case 1:
                                            w.trys.push([1, 6, 7, 8]), o = z(i), s = o.next(), w.label = 2;
                                        case 2:
                                            return s.done ? [3, 5] : (a = s.value, (u = t[a.target]) ? (c = ArrayBuffer.isView(u) ? new Uint8Array(u.buffer, u.byteOffset, u.byteLength) : "string" == typeof u ? e.utf8Decoder(u) : new Uint8Array(u), l = e.base64Encoder(c), (f = new e.md5).update(c), d = [D({}, t)], (S = {})[a.target] = l, h = a.hash, g = (p = e).base64Encoder, [4, f.digest()]) : [3, 4]);
                                        case 3:
                                            t = D.apply(void 0, d.concat([(S[h] = g.apply(p, [w.sent()]), S)])), w.label = 4;
                                        case 4:
                                            return s = o.next(), [3, 2];
                                        case 5:
                                            return [3, 8];
                                        case 6:
                                            return v = w.sent(), m = {error: v}, [3, 8];
                                        case 7:
                                            try {
                                                s && !s.done && (y = o.return) && y.call(o)
                                            } finally {
                                                if (m) throw m.error
                                            }
                                            return [7];
                                        case 8:
                                            return [2, n(D(D({}, r), {input: t}))]
                                    }
                                }))
                            }))
                        }
                    }
                }(e), nm)
            }
        }
    }, im = function (e) {
        function t(t) {
            var n = e.call(this) || this;
            return n.input = t, n
        }

        return ec(t, e), t.prototype.resolveMiddleware = function (e, t, n) {
            this.middlewareStack.use(Yr(t, this.serialize, this.deserialize)), this.middlewareStack.use(Ip(t)), this.middlewareStack.use(rm(t)), this.middlewareStack.use(Dc(t));
            var r = e.concat(this.middlewareStack), i = {
                logger: t.logger,
                clientName: "S3Client",
                commandName: "CopyObjectCommand",
                inputFilterSensitiveLog: nl.filterSensitiveLog,
                outputFilterSensitiveLog: tl.filterSensitiveLog
            }, o = t.requestHandler;
            return r.resolve((function (e) {
                return o.handle(e.request, n || {})
            }), i)
        }, t.prototype.serialize = function (e, t) {
            return function (e, t) {
                return nc(void 0, void 0, void 0, (function () {
                    var n, r, i, o, s, a, u, c, l;
                    return rc(this, (function (f) {
                        switch (f.label) {
                            case 0:
                                if (n = tc(tc(tc(tc(tc(tc(tc(tc(tc(tc(tc(tc(tc(tc(tc(tc(tc(tc(tc(tc(tc(tc(tc(tc(tc(tc(tc(tc(tc(tc(tc(tc(tc(tc(tc(tc(tc(tc({}, mv(e.ACL) && {"x-amz-acl": e.ACL}), mv(e.CacheControl) && {"cache-control": e.CacheControl}), mv(e.ContentDisposition) && {"content-disposition": e.ContentDisposition}), mv(e.ContentEncoding) && {"content-encoding": e.ContentEncoding}), mv(e.ContentLanguage) && {"content-language": e.ContentLanguage}), mv(e.ContentType) && {"content-type": e.ContentType}), mv(e.CopySource) && {"x-amz-copy-source": e.CopySource}), mv(e.CopySourceIfMatch) && {"x-amz-copy-source-if-match": e.CopySourceIfMatch}), mv(e.CopySourceIfModifiedSince) && {"x-amz-copy-source-if-modified-since": Vr(e.CopySourceIfModifiedSince).toString()}), mv(e.CopySourceIfNoneMatch) && {"x-amz-copy-source-if-none-match": e.CopySourceIfNoneMatch}), mv(e.CopySourceIfUnmodifiedSince) && {"x-amz-copy-source-if-unmodified-since": Vr(e.CopySourceIfUnmodifiedSince).toString()}), mv(e.Expires) && {expires: Vr(e.Expires).toString()}), mv(e.GrantFullControl) && {"x-amz-grant-full-control": e.GrantFullControl}), mv(e.GrantRead) && {"x-amz-grant-read": e.GrantRead}), mv(e.GrantReadACP) && {"x-amz-grant-read-acp": e.GrantReadACP}), mv(e.GrantWriteACP) && {"x-amz-grant-write-acp": e.GrantWriteACP}), mv(e.MetadataDirective) && {"x-amz-metadata-directive": e.MetadataDirective}), mv(e.TaggingDirective) && {"x-amz-tagging-directive": e.TaggingDirective}), mv(e.ServerSideEncryption) && {"x-amz-server-side-encryption": e.ServerSideEncryption}), mv(e.StorageClass) && {"x-amz-storage-class": e.StorageClass}), mv(e.WebsiteRedirectLocation) && {"x-amz-website-redirect-location": e.WebsiteRedirectLocation}), mv(e.SSECustomerAlgorithm) && {"x-amz-server-side-encryption-customer-algorithm": e.SSECustomerAlgorithm}), mv(e.SSECustomerKey) && {"x-amz-server-side-encryption-customer-key": e.SSECustomerKey}), mv(e.SSECustomerKeyMD5) && {"x-amz-server-side-encryption-customer-key-md5": e.SSECustomerKeyMD5}), mv(e.SSEKMSKeyId) && {"x-amz-server-side-encryption-aws-kms-key-id": e.SSEKMSKeyId}), mv(e.SSEKMSEncryptionContext) && {"x-amz-server-side-encryption-context": e.SSEKMSEncryptionContext}), mv(e.BucketKeyEnabled) && {"x-amz-server-side-encryption-bucket-key-enabled": e.BucketKeyEnabled.toString()}), mv(e.CopySourceSSECustomerAlgorithm) && {"x-amz-copy-source-server-side-encryption-customer-algorithm": e.CopySourceSSECustomerAlgorithm}), mv(e.CopySourceSSECustomerKey) && {"x-amz-copy-source-server-side-encryption-customer-key": e.CopySourceSSECustomerKey}), mv(e.CopySourceSSECustomerKeyMD5) && {"x-amz-copy-source-server-side-encryption-customer-key-md5": e.CopySourceSSECustomerKeyMD5}), mv(e.RequestPayer) && {"x-amz-request-payer": e.RequestPayer}), mv(e.Tagging) && {"x-amz-tagging": e.Tagging}), mv(e.ObjectLockMode) && {"x-amz-object-lock-mode": e.ObjectLockMode}), mv(e.ObjectLockRetainUntilDate) && {"x-amz-object-lock-retain-until-date": (e.ObjectLockRetainUntilDate.toISOString().split(".")[0] + "Z").toString()}), mv(e.ObjectLockLegalHoldStatus) && {"x-amz-object-lock-legal-hold": e.ObjectLockLegalHoldStatus}), mv(e.ExpectedBucketOwner) && {"x-amz-expected-bucket-owner": e.ExpectedBucketOwner}), mv(e.ExpectedSourceBucketOwner) && {"x-amz-source-expected-bucket-owner": e.ExpectedSourceBucketOwner}), void 0 !== e.Metadata && Object.keys(e.Metadata).reduce((function (t, n) {
                                    var r;
                                    return tc(tc({}, t), ((r = {})["x-amz-meta-" + n.toLowerCase()] = e.Metadata[n], r))
                                }), {})), r = "/{Bucket}/{Key+}", void 0 === e.Bucket) throw new Error("No value provided for input HTTP label: Bucket.");
                                if ((i = e.Bucket).length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                                if (r = r.replace("{Bucket}", jr(i)), void 0 === e.Key) throw new Error("No value provided for input HTTP label: Key.");
                                if ((i = e.Key).length <= 0) throw new Error("Empty value provided for input HTTP label: Key.");
                                return r = r.replace("{Key+}", i.split("/").map((function (e) {
                                    return jr(e)
                                })).join("/")), o = {"x-id": "CopyObject"}, [4, t.endpoint()];
                            case 1:
                                return s = f.sent(), a = s.hostname, u = s.protocol, c = void 0 === u ? "https" : u, l = s.port, [2, new Kt({
                                    protocol: c,
                                    hostname: a,
                                    port: l,
                                    method: "PUT",
                                    headers: n,
                                    path: r,
                                    query: o,
                                    body: void 0
                                })]
                        }
                    }))
                }))
            }(e, t)
        }, t.prototype.deserialize = function (e, t) {
            return function (e, t) {
                return nc(void 0, void 0, void 0, (function () {
                    var n, r;
                    return rc(this, (function (i) {
                        switch (i.label) {
                            case 0:
                                return 200 !== e.statusCode && e.statusCode >= 300 ? [2, Wg(e, t)] : (n = {
                                    $metadata: gv(e),
                                    BucketKeyEnabled: void 0,
                                    CopyObjectResult: void 0,
                                    CopySourceVersionId: void 0,
                                    Expiration: void 0,
                                    RequestCharged: void 0,
                                    SSECustomerAlgorithm: void 0,
                                    SSECustomerKeyMD5: void 0,
                                    SSEKMSEncryptionContext: void 0,
                                    SSEKMSKeyId: void 0,
                                    ServerSideEncryption: void 0,
                                    VersionId: void 0
                                }, void 0 !== e.headers["x-amz-expiration"] && (n.Expiration = e.headers["x-amz-expiration"]), void 0 !== e.headers["x-amz-copy-source-version-id"] && (n.CopySourceVersionId = e.headers["x-amz-copy-source-version-id"]), void 0 !== e.headers["x-amz-version-id"] && (n.VersionId = e.headers["x-amz-version-id"]), void 0 !== e.headers["x-amz-server-side-encryption"] && (n.ServerSideEncryption = e.headers["x-amz-server-side-encryption"]), void 0 !== e.headers["x-amz-server-side-encryption-customer-algorithm"] && (n.SSECustomerAlgorithm = e.headers["x-amz-server-side-encryption-customer-algorithm"]), void 0 !== e.headers["x-amz-server-side-encryption-customer-key-md5"] && (n.SSECustomerKeyMD5 = e.headers["x-amz-server-side-encryption-customer-key-md5"]), void 0 !== e.headers["x-amz-server-side-encryption-aws-kms-key-id"] && (n.SSEKMSKeyId = e.headers["x-amz-server-side-encryption-aws-kms-key-id"]), void 0 !== e.headers["x-amz-server-side-encryption-context"] && (n.SSEKMSEncryptionContext = e.headers["x-amz-server-side-encryption-context"]), void 0 !== e.headers["x-amz-server-side-encryption-bucket-key-enabled"] && (n.BucketKeyEnabled = "true" === e.headers["x-amz-server-side-encryption-bucket-key-enabled"]), void 0 !== e.headers["x-amz-request-charged"] && (n.RequestCharged = e.headers["x-amz-request-charged"]), [4, yv(e.body, t)]);
                            case 1:
                                return r = i.sent(), n.CopyObjectResult = lv(r), [2, Promise.resolve(n)]
                        }
                    }))
                }))
            }(e, t)
        }, t
    }(Br), om = function (e) {
        function t(t) {
            var n = e.call(this) || this;
            return n.input = t, n
        }

        return ec(t, e), t.prototype.resolveMiddleware = function (e, t, n) {
            this.middlewareStack.use(Yr(t, this.serialize, this.deserialize)), this.middlewareStack.use(rm(t)), this.middlewareStack.use(Dc(t));
            var r = e.concat(this.middlewareStack), i = {
                logger: t.logger,
                clientName: "S3Client",
                commandName: "CreateMultipartUploadCommand",
                inputFilterSensitiveLog: ll.filterSensitiveLog,
                outputFilterSensitiveLog: cl.filterSensitiveLog
            }, o = t.requestHandler;
            return r.resolve((function (e) {
                return o.handle(e.request, n || {})
            }), i)
        }, t.prototype.serialize = function (e, t) {
            return function (e, t) {
                return nc(void 0, void 0, void 0, (function () {
                    var n, r, i, o, s, a, u, c, l;
                    return rc(this, (function (f) {
                        switch (f.label) {
                            case 0:
                                if (n = tc(tc(tc(tc(tc(tc(tc(tc(tc(tc(tc(tc(tc(tc(tc(tc(tc(tc(tc(tc(tc(tc(tc(tc(tc(tc(tc({}, mv(e.ACL) && {"x-amz-acl": e.ACL}), mv(e.CacheControl) && {"cache-control": e.CacheControl}), mv(e.ContentDisposition) && {"content-disposition": e.ContentDisposition}), mv(e.ContentEncoding) && {"content-encoding": e.ContentEncoding}), mv(e.ContentLanguage) && {"content-language": e.ContentLanguage}), mv(e.ContentType) && {"content-type": e.ContentType}), mv(e.Expires) && {expires: Vr(e.Expires).toString()}), mv(e.GrantFullControl) && {"x-amz-grant-full-control": e.GrantFullControl}), mv(e.GrantRead) && {"x-amz-grant-read": e.GrantRead}), mv(e.GrantReadACP) && {"x-amz-grant-read-acp": e.GrantReadACP}), mv(e.GrantWriteACP) && {"x-amz-grant-write-acp": e.GrantWriteACP}), mv(e.ServerSideEncryption) && {"x-amz-server-side-encryption": e.ServerSideEncryption}), mv(e.StorageClass) && {"x-amz-storage-class": e.StorageClass}), mv(e.WebsiteRedirectLocation) && {"x-amz-website-redirect-location": e.WebsiteRedirectLocation}), mv(e.SSECustomerAlgorithm) && {"x-amz-server-side-encryption-customer-algorithm": e.SSECustomerAlgorithm}), mv(e.SSECustomerKey) && {"x-amz-server-side-encryption-customer-key": e.SSECustomerKey}), mv(e.SSECustomerKeyMD5) && {"x-amz-server-side-encryption-customer-key-md5": e.SSECustomerKeyMD5}), mv(e.SSEKMSKeyId) && {"x-amz-server-side-encryption-aws-kms-key-id": e.SSEKMSKeyId}), mv(e.SSEKMSEncryptionContext) && {"x-amz-server-side-encryption-context": e.SSEKMSEncryptionContext}), mv(e.BucketKeyEnabled) && {"x-amz-server-side-encryption-bucket-key-enabled": e.BucketKeyEnabled.toString()}), mv(e.RequestPayer) && {"x-amz-request-payer": e.RequestPayer}), mv(e.Tagging) && {"x-amz-tagging": e.Tagging}), mv(e.ObjectLockMode) && {"x-amz-object-lock-mode": e.ObjectLockMode}), mv(e.ObjectLockRetainUntilDate) && {"x-amz-object-lock-retain-until-date": (e.ObjectLockRetainUntilDate.toISOString().split(".")[0] + "Z").toString()}), mv(e.ObjectLockLegalHoldStatus) && {"x-amz-object-lock-legal-hold": e.ObjectLockLegalHoldStatus}), mv(e.ExpectedBucketOwner) && {"x-amz-expected-bucket-owner": e.ExpectedBucketOwner}), void 0 !== e.Metadata && Object.keys(e.Metadata).reduce((function (t, n) {
                                    var r;
                                    return tc(tc({}, t), ((r = {})["x-amz-meta-" + n.toLowerCase()] = e.Metadata[n], r))
                                }), {})), r = "/{Bucket}/{Key+}", void 0 === e.Bucket) throw new Error("No value provided for input HTTP label: Bucket.");
                                if ((i = e.Bucket).length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                                if (r = r.replace("{Bucket}", jr(i)), void 0 === e.Key) throw new Error("No value provided for input HTTP label: Key.");
                                if ((i = e.Key).length <= 0) throw new Error("Empty value provided for input HTTP label: Key.");
                                return r = r.replace("{Key+}", i.split("/").map((function (e) {
                                    return jr(e)
                                })).join("/")), o = {uploads: ""}, [4, t.endpoint()];
                            case 1:
                                return s = f.sent(), a = s.hostname, u = s.protocol, c = void 0 === u ? "https" : u, l = s.port, [2, new Kt({
                                    protocol: c,
                                    hostname: a,
                                    port: l,
                                    method: "POST",
                                    headers: n,
                                    path: r,
                                    query: o,
                                    body: void 0
                                })]
                        }
                    }))
                }))
            }(e, t)
        }, t.prototype.deserialize = function (e, t) {
            return function (e, t) {
                return nc(void 0, void 0, void 0, (function () {
                    var n, r;
                    return rc(this, (function (i) {
                        switch (i.label) {
                            case 0:
                                return 200 !== e.statusCode && e.statusCode >= 300 ? [2, $g(e, t)] : (n = {
                                    $metadata: gv(e),
                                    AbortDate: void 0,
                                    AbortRuleId: void 0,
                                    Bucket: void 0,
                                    BucketKeyEnabled: void 0,
                                    Key: void 0,
                                    RequestCharged: void 0,
                                    SSECustomerAlgorithm: void 0,
                                    SSECustomerKeyMD5: void 0,
                                    SSEKMSEncryptionContext: void 0,
                                    SSEKMSKeyId: void 0,
                                    ServerSideEncryption: void 0,
                                    UploadId: void 0
                                }, void 0 !== e.headers["x-amz-abort-date"] && (n.AbortDate = new Date(e.headers["x-amz-abort-date"])), void 0 !== e.headers["x-amz-abort-rule-id"] && (n.AbortRuleId = e.headers["x-amz-abort-rule-id"]), void 0 !== e.headers["x-amz-server-side-encryption"] && (n.ServerSideEncryption = e.headers["x-amz-server-side-encryption"]), void 0 !== e.headers["x-amz-server-side-encryption-customer-algorithm"] && (n.SSECustomerAlgorithm = e.headers["x-amz-server-side-encryption-customer-algorithm"]), void 0 !== e.headers["x-amz-server-side-encryption-customer-key-md5"] && (n.SSECustomerKeyMD5 = e.headers["x-amz-server-side-encryption-customer-key-md5"]), void 0 !== e.headers["x-amz-server-side-encryption-aws-kms-key-id"] && (n.SSEKMSKeyId = e.headers["x-amz-server-side-encryption-aws-kms-key-id"]), void 0 !== e.headers["x-amz-server-side-encryption-context"] && (n.SSEKMSEncryptionContext = e.headers["x-amz-server-side-encryption-context"]), void 0 !== e.headers["x-amz-server-side-encryption-bucket-key-enabled"] && (n.BucketKeyEnabled = "true" === e.headers["x-amz-server-side-encryption-bucket-key-enabled"]), void 0 !== e.headers["x-amz-request-charged"] && (n.RequestCharged = e.headers["x-amz-request-charged"]), [4, yv(e.body, t)]);
                            case 1:
                                return void 0 !== (r = i.sent()).Bucket && (n.Bucket = r.Bucket), void 0 !== r.Key && (n.Key = r.Key), void 0 !== r.UploadId && (n.UploadId = r.UploadId), [2, Promise.resolve(n)]
                        }
                    }))
                }))
            }(e, t)
        }, t
    }(Br), sm = function (e) {
        function t(t) {
            var n = e.call(this) || this;
            return n.input = t, n
        }

        return ec(t, e), t.prototype.resolveMiddleware = function (e, t, n) {
            this.middlewareStack.use(Yr(t, this.serialize, this.deserialize)), this.middlewareStack.use(Dc(t));
            var r = e.concat(this.middlewareStack), i = {
                logger: t.logger,
                clientName: "S3Client",
                commandName: "DeleteObjectCommand",
                inputFilterSensitiveLog: Al.filterSensitiveLog,
                outputFilterSensitiveLog: _l.filterSensitiveLog
            }, o = t.requestHandler;
            return r.resolve((function (e) {
                return o.handle(e.request, n || {})
            }), i)
        }, t.prototype.serialize = function (e, t) {
            return function (e, t) {
                return nc(void 0, void 0, void 0, (function () {
                    var n, r, i, o, s, a, u, c, l;
                    return rc(this, (function (f) {
                        switch (f.label) {
                            case 0:
                                if (n = tc(tc(tc(tc({}, mv(e.MFA) && {"x-amz-mfa": e.MFA}), mv(e.RequestPayer) && {"x-amz-request-payer": e.RequestPayer}), mv(e.BypassGovernanceRetention) && {"x-amz-bypass-governance-retention": e.BypassGovernanceRetention.toString()}), mv(e.ExpectedBucketOwner) && {"x-amz-expected-bucket-owner": e.ExpectedBucketOwner}), r = "/{Bucket}/{Key+}", void 0 === e.Bucket) throw new Error("No value provided for input HTTP label: Bucket.");
                                if ((i = e.Bucket).length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                                if (r = r.replace("{Bucket}", jr(i)), void 0 === e.Key) throw new Error("No value provided for input HTTP label: Key.");
                                if ((i = e.Key).length <= 0) throw new Error("Empty value provided for input HTTP label: Key.");
                                return r = r.replace("{Key+}", i.split("/").map((function (e) {
                                    return jr(e)
                                })).join("/")), o = tc({"x-id": "DeleteObject"}, void 0 !== e.VersionId && {versionId: e.VersionId}), [4, t.endpoint()];
                            case 1:
                                return s = f.sent(), a = s.hostname, u = s.protocol, c = void 0 === u ? "https" : u, l = s.port, [2, new Kt({
                                    protocol: c,
                                    hostname: a,
                                    port: l,
                                    method: "DELETE",
                                    headers: n,
                                    path: r,
                                    query: o,
                                    body: void 0
                                })]
                        }
                    }))
                }))
            }(e, t)
        }, t.prototype.deserialize = function (e, t) {
            return function (e, t) {
                return nc(void 0, void 0, void 0, (function () {
                    var n;
                    return rc(this, (function (r) {
                        switch (r.label) {
                            case 0:
                                return 204 !== e.statusCode && e.statusCode >= 300 ? [2, Yg(e, t)] : (n = {
                                    $metadata: gv(e),
                                    DeleteMarker: void 0,
                                    RequestCharged: void 0,
                                    VersionId: void 0
                                }, void 0 !== e.headers["x-amz-delete-marker"] && (n.DeleteMarker = "true" === e.headers["x-amz-delete-marker"]), void 0 !== e.headers["x-amz-version-id"] && (n.VersionId = e.headers["x-amz-version-id"]), void 0 !== e.headers["x-amz-request-charged"] && (n.RequestCharged = e.headers["x-amz-request-charged"]), [4, vv(e.body, t)]);
                            case 1:
                                return r.sent(), [2, Promise.resolve(n)]
                        }
                    }))
                }))
            }(e, t)
        }, t
    }(Br), am = function (e) {
        function t(t) {
            var n = e.call(this) || this;
            return n.input = t, n
        }

        return ec(t, e), t.prototype.resolveMiddleware = function (e, t, n) {
            this.middlewareStack.use(Yr(t, this.serialize, this.deserialize)), this.middlewareStack.use(rm(t)), this.middlewareStack.use(Dc(t));
            var r = e.concat(this.middlewareStack), i = {
                logger: t.logger,
                clientName: "S3Client",
                commandName: "GetObjectCommand",
                inputFilterSensitiveLog: Ld.filterSensitiveLog,
                outputFilterSensitiveLog: Md.filterSensitiveLog
            }, o = t.requestHandler;
            return r.resolve((function (e) {
                return o.handle(e.request, n || {})
            }), i)
        }, t.prototype.serialize = function (e, t) {
            return function (e, t) {
                return nc(void 0, void 0, void 0, (function () {
                    var n, r, i, o, s, a, u, c, l;
                    return rc(this, (function (f) {
                        switch (f.label) {
                            case 0:
                                if (n = tc(tc(tc(tc(tc(tc(tc(tc(tc(tc({}, mv(e.IfMatch) && {"if-match": e.IfMatch}), mv(e.IfModifiedSince) && {"if-modified-since": Vr(e.IfModifiedSince).toString()}), mv(e.IfNoneMatch) && {"if-none-match": e.IfNoneMatch}), mv(e.IfUnmodifiedSince) && {"if-unmodified-since": Vr(e.IfUnmodifiedSince).toString()}), mv(e.Range) && {range: e.Range}), mv(e.SSECustomerAlgorithm) && {"x-amz-server-side-encryption-customer-algorithm": e.SSECustomerAlgorithm}), mv(e.SSECustomerKey) && {"x-amz-server-side-encryption-customer-key": e.SSECustomerKey}), mv(e.SSECustomerKeyMD5) && {"x-amz-server-side-encryption-customer-key-md5": e.SSECustomerKeyMD5}), mv(e.RequestPayer) && {"x-amz-request-payer": e.RequestPayer}), mv(e.ExpectedBucketOwner) && {"x-amz-expected-bucket-owner": e.ExpectedBucketOwner}), r = "/{Bucket}/{Key+}", void 0 === e.Bucket) throw new Error("No value provided for input HTTP label: Bucket.");
                                if ((i = e.Bucket).length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                                if (r = r.replace("{Bucket}", jr(i)), void 0 === e.Key) throw new Error("No value provided for input HTTP label: Key.");
                                if ((i = e.Key).length <= 0) throw new Error("Empty value provided for input HTTP label: Key.");
                                return r = r.replace("{Key+}", i.split("/").map((function (e) {
                                    return jr(e)
                                })).join("/")), o = tc(tc(tc(tc(tc(tc(tc(tc({"x-id": "GetObject"}, void 0 !== e.ResponseCacheControl && {"response-cache-control": e.ResponseCacheControl}), void 0 !== e.ResponseContentDisposition && {"response-content-disposition": e.ResponseContentDisposition}), void 0 !== e.ResponseContentEncoding && {"response-content-encoding": e.ResponseContentEncoding}), void 0 !== e.ResponseContentLanguage && {"response-content-language": e.ResponseContentLanguage}), void 0 !== e.ResponseContentType && {"response-content-type": e.ResponseContentType}), void 0 !== e.ResponseExpires && {"response-expires": (e.ResponseExpires.toISOString().split(".")[0] + "Z").toString()}), void 0 !== e.VersionId && {versionId: e.VersionId}), void 0 !== e.PartNumber && {partNumber: e.PartNumber.toString()}), [4, t.endpoint()];
                            case 1:
                                return s = f.sent(), a = s.hostname, u = s.protocol, c = void 0 === u ? "https" : u, l = s.port, [2, new Kt({
                                    protocol: c,
                                    hostname: a,
                                    port: l,
                                    method: "GET",
                                    headers: n,
                                    path: r,
                                    query: o,
                                    body: void 0
                                })]
                        }
                    }))
                }))
            }(e, t)
        }, t.prototype.deserialize = function (e, t) {
            return function (e, t) {
                return nc(void 0, void 0, void 0, (function () {
                    var n, r;
                    return rc(this, (function (i) {
                        return 200 !== e.statusCode && e.statusCode >= 300 ? [2, Jg(e, t)] : (n = {
                            $metadata: gv(e),
                            AcceptRanges: void 0,
                            Body: void 0,
                            BucketKeyEnabled: void 0,
                            CacheControl: void 0,
                            ContentDisposition: void 0,
                            ContentEncoding: void 0,
                            ContentLanguage: void 0,
                            ContentLength: void 0,
                            ContentRange: void 0,
                            ContentType: void 0,
                            DeleteMarker: void 0,
                            ETag: void 0,
                            Expiration: void 0,
                            Expires: void 0,
                            LastModified: void 0,
                            Metadata: void 0,
                            MissingMeta: void 0,
                            ObjectLockLegalHoldStatus: void 0,
                            ObjectLockMode: void 0,
                            ObjectLockRetainUntilDate: void 0,
                            PartsCount: void 0,
                            ReplicationStatus: void 0,
                            RequestCharged: void 0,
                            Restore: void 0,
                            SSECustomerAlgorithm: void 0,
                            SSECustomerKeyMD5: void 0,
                            SSEKMSKeyId: void 0,
                            ServerSideEncryption: void 0,
                            StorageClass: void 0,
                            TagCount: void 0,
                            VersionId: void 0,
                            WebsiteRedirectLocation: void 0
                        }, void 0 !== e.headers["x-amz-delete-marker"] && (n.DeleteMarker = "true" === e.headers["x-amz-delete-marker"]), void 0 !== e.headers["accept-ranges"] && (n.AcceptRanges = e.headers["accept-ranges"]), void 0 !== e.headers["x-amz-expiration"] && (n.Expiration = e.headers["x-amz-expiration"]), void 0 !== e.headers["x-amz-restore"] && (n.Restore = e.headers["x-amz-restore"]), void 0 !== e.headers["last-modified"] && (n.LastModified = new Date(e.headers["last-modified"])), void 0 !== e.headers["content-length"] && (n.ContentLength = parseInt(e.headers["content-length"], 10)), void 0 !== e.headers.etag && (n.ETag = e.headers.etag), void 0 !== e.headers["x-amz-missing-meta"] && (n.MissingMeta = parseInt(e.headers["x-amz-missing-meta"], 10)), void 0 !== e.headers["x-amz-version-id"] && (n.VersionId = e.headers["x-amz-version-id"]), void 0 !== e.headers["cache-control"] && (n.CacheControl = e.headers["cache-control"]), void 0 !== e.headers["content-disposition"] && (n.ContentDisposition = e.headers["content-disposition"]), void 0 !== e.headers["content-encoding"] && (n.ContentEncoding = e.headers["content-encoding"]), void 0 !== e.headers["content-language"] && (n.ContentLanguage = e.headers["content-language"]), void 0 !== e.headers["content-range"] && (n.ContentRange = e.headers["content-range"]), void 0 !== e.headers["content-type"] && (n.ContentType = e.headers["content-type"]), void 0 !== e.headers.expires && (n.Expires = new Date(e.headers.expires)), void 0 !== e.headers["x-amz-website-redirect-location"] && (n.WebsiteRedirectLocation = e.headers["x-amz-website-redirect-location"]), void 0 !== e.headers["x-amz-server-side-encryption"] && (n.ServerSideEncryption = e.headers["x-amz-server-side-encryption"]), void 0 !== e.headers["x-amz-server-side-encryption-customer-algorithm"] && (n.SSECustomerAlgorithm = e.headers["x-amz-server-side-encryption-customer-algorithm"]), void 0 !== e.headers["x-amz-server-side-encryption-customer-key-md5"] && (n.SSECustomerKeyMD5 = e.headers["x-amz-server-side-encryption-customer-key-md5"]), void 0 !== e.headers["x-amz-server-side-encryption-aws-kms-key-id"] && (n.SSEKMSKeyId = e.headers["x-amz-server-side-encryption-aws-kms-key-id"]), void 0 !== e.headers["x-amz-server-side-encryption-bucket-key-enabled"] && (n.BucketKeyEnabled = "true" === e.headers["x-amz-server-side-encryption-bucket-key-enabled"]), void 0 !== e.headers["x-amz-storage-class"] && (n.StorageClass = e.headers["x-amz-storage-class"]), void 0 !== e.headers["x-amz-request-charged"] && (n.RequestCharged = e.headers["x-amz-request-charged"]), void 0 !== e.headers["x-amz-replication-status"] && (n.ReplicationStatus = e.headers["x-amz-replication-status"]), void 0 !== e.headers["x-amz-mp-parts-count"] && (n.PartsCount = parseInt(e.headers["x-amz-mp-parts-count"], 10)), void 0 !== e.headers["x-amz-tagging-count"] && (n.TagCount = parseInt(e.headers["x-amz-tagging-count"], 10)), void 0 !== e.headers["x-amz-object-lock-mode"] && (n.ObjectLockMode = e.headers["x-amz-object-lock-mode"]), void 0 !== e.headers["x-amz-object-lock-retain-until-date"] && (n.ObjectLockRetainUntilDate = new Date(e.headers["x-amz-object-lock-retain-until-date"])), void 0 !== e.headers["x-amz-object-lock-legal-hold"] && (n.ObjectLockLegalHoldStatus = e.headers["x-amz-object-lock-legal-hold"]), Object.keys(e.headers).forEach((function (t) {
                            void 0 === n.Metadata && (n.Metadata = {}), t.startsWith("x-amz-meta-") && (n.Metadata[t.substring(11)] = e.headers[t])
                        })), r = e.body, n.Body = r, [2, Promise.resolve(n)])
                    }))
                }))
            }(e, t)
        }, t
    }(Br), um = function (e) {
        function t(t) {
            var n = e.call(this) || this;
            return n.input = t, n
        }

        return ec(t, e), t.prototype.resolveMiddleware = function (e, t, n) {
            this.middlewareStack.use(Yr(t, this.serialize, this.deserialize)), this.middlewareStack.use(Dc(t));
            var r = e.concat(this.middlewareStack), i = {
                logger: t.logger,
                clientName: "S3Client",
                commandName: "ListObjectsCommand",
                inputFilterSensitiveLog: _h.filterSensitiveLog,
                outputFilterSensitiveLog: Ch.filterSensitiveLog
            }, o = t.requestHandler;
            return r.resolve((function (e) {
                return o.handle(e.request, n || {})
            }), i)
        }, t.prototype.serialize = function (e, t) {
            return function (e, t) {
                return nc(void 0, void 0, void 0, (function () {
                    var n, r, i, o, s, a, u, c, l;
                    return rc(this, (function (f) {
                        switch (f.label) {
                            case 0:
                                if (n = tc(tc({}, mv(e.RequestPayer) && {"x-amz-request-payer": e.RequestPayer}), mv(e.ExpectedBucketOwner) && {"x-amz-expected-bucket-owner": e.ExpectedBucketOwner}), r = "/{Bucket}", void 0 === e.Bucket) throw new Error("No value provided for input HTTP label: Bucket.");
                                if ((i = e.Bucket).length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                                return r = r.replace("{Bucket}", jr(i)), o = tc(tc(tc(tc(tc({}, void 0 !== e.Delimiter && {delimiter: e.Delimiter}), void 0 !== e.EncodingType && {"encoding-type": e.EncodingType}), void 0 !== e.Marker && {marker: e.Marker}), void 0 !== e.MaxKeys && {"max-keys": e.MaxKeys.toString()}), void 0 !== e.Prefix && {prefix: e.Prefix}), [4, t.endpoint()];
                            case 1:
                                return s = f.sent(), a = s.hostname, u = s.protocol, c = void 0 === u ? "https" : u, l = s.port, [2, new Kt({
                                    protocol: c,
                                    hostname: a,
                                    port: l,
                                    method: "GET",
                                    headers: n,
                                    path: r,
                                    query: o,
                                    body: void 0
                                })]
                        }
                    }))
                }))
            }(e, t)
        }, t.prototype.deserialize = function (e, t) {
            return function (e, t) {
                return nc(void 0, void 0, void 0, (function () {
                    var n, r;
                    return rc(this, (function (i) {
                        switch (i.label) {
                            case 0:
                                return 200 !== e.statusCode && e.statusCode >= 300 ? [2, Zg(e, t)] : (n = {
                                    $metadata: gv(e),
                                    CommonPrefixes: void 0,
                                    Contents: void 0,
                                    Delimiter: void 0,
                                    EncodingType: void 0,
                                    IsTruncated: void 0,
                                    Marker: void 0,
                                    MaxKeys: void 0,
                                    Name: void 0,
                                    NextMarker: void 0,
                                    Prefix: void 0
                                }, [4, yv(e.body, t)]);
                            case 1:
                                return "" === (r = i.sent()).CommonPrefixes && (n.CommonPrefixes = []), void 0 !== r.CommonPrefixes && (n.CommonPrefixes = cv(Fr(r.CommonPrefixes))), "" === r.Contents && (n.Contents = []), void 0 !== r.Contents && (n.Contents = dv(Fr(r.Contents))), void 0 !== r.Delimiter && (n.Delimiter = r.Delimiter), void 0 !== r.EncodingType && (n.EncodingType = r.EncodingType), void 0 !== r.IsTruncated && (n.IsTruncated = "true" == r.IsTruncated), void 0 !== r.Marker && (n.Marker = r.Marker), void 0 !== r.MaxKeys && (n.MaxKeys = parseInt(r.MaxKeys)), void 0 !== r.Name && (n.Name = r.Name), void 0 !== r.NextMarker && (n.NextMarker = r.NextMarker), void 0 !== r.Prefix && (n.Prefix = r.Prefix), [2, Promise.resolve(n)]
                        }
                    }))
                }))
            }(e, t)
        }, t
    }(Br), cm = function (e) {
        function t(t) {
            var n = e.call(this) || this;
            return n.input = t, n
        }

        return ec(t, e), t.prototype.resolveMiddleware = function (e, t, n) {
            this.middlewareStack.use(Yr(t, this.serialize, this.deserialize)), this.middlewareStack.use(Dc(t));
            var r = e.concat(this.middlewareStack), i = {
                logger: t.logger,
                clientName: "S3Client",
                commandName: "ListObjectsV2Command",
                inputFilterSensitiveLog: Ph.filterSensitiveLog,
                outputFilterSensitiveLog: Ah.filterSensitiveLog
            }, o = t.requestHandler;
            return r.resolve((function (e) {
                return o.handle(e.request, n || {})
            }), i)
        }, t.prototype.serialize = function (e, t) {
            return function (e, t) {
                return nc(void 0, void 0, void 0, (function () {
                    var n, r, i, o, s, a, u, c, l;
                    return rc(this, (function (f) {
                        switch (f.label) {
                            case 0:
                                if (n = tc(tc({}, mv(e.RequestPayer) && {"x-amz-request-payer": e.RequestPayer}), mv(e.ExpectedBucketOwner) && {"x-amz-expected-bucket-owner": e.ExpectedBucketOwner}), r = "/{Bucket}", void 0 === e.Bucket) throw new Error("No value provided for input HTTP label: Bucket.");
                                if ((i = e.Bucket).length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                                return r = r.replace("{Bucket}", jr(i)), o = tc(tc(tc(tc(tc(tc(tc({"list-type": "2"}, void 0 !== e.Delimiter && {delimiter: e.Delimiter}), void 0 !== e.EncodingType && {"encoding-type": e.EncodingType}), void 0 !== e.MaxKeys && {"max-keys": e.MaxKeys.toString()}), void 0 !== e.Prefix && {prefix: e.Prefix}), void 0 !== e.ContinuationToken && {"continuation-token": e.ContinuationToken}), void 0 !== e.FetchOwner && {"fetch-owner": e.FetchOwner.toString()}), void 0 !== e.StartAfter && {"start-after": e.StartAfter}), [4, t.endpoint()];
                            case 1:
                                return s = f.sent(), a = s.hostname, u = s.protocol, c = void 0 === u ? "https" : u, l = s.port, [2, new Kt({
                                    protocol: c,
                                    hostname: a,
                                    port: l,
                                    method: "GET",
                                    headers: n,
                                    path: r,
                                    query: o,
                                    body: void 0
                                })]
                        }
                    }))
                }))
            }(e, t)
        }, t.prototype.deserialize = function (e, t) {
            return function (e, t) {
                return nc(void 0, void 0, void 0, (function () {
                    var n, r;
                    return rc(this, (function (i) {
                        switch (i.label) {
                            case 0:
                                return 200 !== e.statusCode && e.statusCode >= 300 ? [2, Xg(e, t)] : (n = {
                                    $metadata: gv(e),
                                    CommonPrefixes: void 0,
                                    Contents: void 0,
                                    ContinuationToken: void 0,
                                    Delimiter: void 0,
                                    EncodingType: void 0,
                                    IsTruncated: void 0,
                                    KeyCount: void 0,
                                    MaxKeys: void 0,
                                    Name: void 0,
                                    NextContinuationToken: void 0,
                                    Prefix: void 0,
                                    StartAfter: void 0
                                }, [4, yv(e.body, t)]);
                            case 1:
                                return "" === (r = i.sent()).CommonPrefixes && (n.CommonPrefixes = []), void 0 !== r.CommonPrefixes && (n.CommonPrefixes = cv(Fr(r.CommonPrefixes))), "" === r.Contents && (n.Contents = []), void 0 !== r.Contents && (n.Contents = dv(Fr(r.Contents))), void 0 !== r.ContinuationToken && (n.ContinuationToken = r.ContinuationToken), void 0 !== r.Delimiter && (n.Delimiter = r.Delimiter), void 0 !== r.EncodingType && (n.EncodingType = r.EncodingType), void 0 !== r.IsTruncated && (n.IsTruncated = "true" == r.IsTruncated), void 0 !== r.KeyCount && (n.KeyCount = parseInt(r.KeyCount)), void 0 !== r.MaxKeys && (n.MaxKeys = parseInt(r.MaxKeys)), void 0 !== r.Name && (n.Name = r.Name), void 0 !== r.NextContinuationToken && (n.NextContinuationToken = r.NextContinuationToken), void 0 !== r.Prefix && (n.Prefix = r.Prefix), void 0 !== r.StartAfter && (n.StartAfter = r.StartAfter), [2, Promise.resolve(n)]
                        }
                    }))
                }))
            }(e, t)
        }, t
    }(Br), lm = function (e) {
        function t(t) {
            var n = e.call(this) || this;
            return n.input = t, n
        }

        return ec(t, e), t.prototype.resolveMiddleware = function (e, t, n) {
            this.middlewareStack.use(Yr(t, this.serialize, this.deserialize)), this.middlewareStack.use(Dc(t));
            var r = e.concat(this.middlewareStack), i = {
                logger: t.logger,
                clientName: "S3Client",
                commandName: "ListPartsCommand",
                inputFilterSensitiveLog: Mh.filterSensitiveLog,
                outputFilterSensitiveLog: Oh.filterSensitiveLog
            }, o = t.requestHandler;
            return r.resolve((function (e) {
                return o.handle(e.request, n || {})
            }), i)
        }, t.prototype.serialize = function (e, t) {
            return function (e, t) {
                return nc(void 0, void 0, void 0, (function () {
                    var n, r, i, o, s, a, u, c, l;
                    return rc(this, (function (f) {
                        switch (f.label) {
                            case 0:
                                if (n = tc(tc({}, mv(e.RequestPayer) && {"x-amz-request-payer": e.RequestPayer}), mv(e.ExpectedBucketOwner) && {"x-amz-expected-bucket-owner": e.ExpectedBucketOwner}), r = "/{Bucket}/{Key+}", void 0 === e.Bucket) throw new Error("No value provided for input HTTP label: Bucket.");
                                if ((i = e.Bucket).length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                                if (r = r.replace("{Bucket}", jr(i)), void 0 === e.Key) throw new Error("No value provided for input HTTP label: Key.");
                                if ((i = e.Key).length <= 0) throw new Error("Empty value provided for input HTTP label: Key.");
                                return r = r.replace("{Key+}", i.split("/").map((function (e) {
                                    return jr(e)
                                })).join("/")), o = tc(tc(tc({"x-id": "ListParts"}, void 0 !== e.MaxParts && {"max-parts": e.MaxParts.toString()}), void 0 !== e.PartNumberMarker && {"part-number-marker": e.PartNumberMarker}), void 0 !== e.UploadId && {uploadId: e.UploadId}), [4, t.endpoint()];
                            case 1:
                                return s = f.sent(), a = s.hostname, u = s.protocol, c = void 0 === u ? "https" : u, l = s.port, [2, new Kt({
                                    protocol: c,
                                    hostname: a,
                                    port: l,
                                    method: "GET",
                                    headers: n,
                                    path: r,
                                    query: o,
                                    body: void 0
                                })]
                        }
                    }))
                }))
            }(e, t)
        }, t.prototype.deserialize = function (e, t) {
            return function (e, t) {
                return nc(void 0, void 0, void 0, (function () {
                    var n, r;
                    return rc(this, (function (i) {
                        switch (i.label) {
                            case 0:
                                return 200 !== e.statusCode && e.statusCode >= 300 ? [2, Qg(e, t)] : (n = {
                                    $metadata: gv(e),
                                    AbortDate: void 0,
                                    AbortRuleId: void 0,
                                    Bucket: void 0,
                                    Initiator: void 0,
                                    IsTruncated: void 0,
                                    Key: void 0,
                                    MaxParts: void 0,
                                    NextPartNumberMarker: void 0,
                                    Owner: void 0,
                                    PartNumberMarker: void 0,
                                    Parts: void 0,
                                    RequestCharged: void 0,
                                    StorageClass: void 0,
                                    UploadId: void 0
                                }, void 0 !== e.headers["x-amz-abort-date"] && (n.AbortDate = new Date(e.headers["x-amz-abort-date"])), void 0 !== e.headers["x-amz-abort-rule-id"] && (n.AbortRuleId = e.headers["x-amz-abort-rule-id"]), void 0 !== e.headers["x-amz-request-charged"] && (n.RequestCharged = e.headers["x-amz-request-charged"]), [4, yv(e.body, t)]);
                            case 1:
                                return void 0 !== (r = i.sent()).Bucket && (n.Bucket = r.Bucket), void 0 !== r.Initiator && (n.Initiator = fv(r.Initiator)), void 0 !== r.IsTruncated && (n.IsTruncated = "true" == r.IsTruncated), void 0 !== r.Key && (n.Key = r.Key), void 0 !== r.MaxParts && (n.MaxParts = parseInt(r.MaxParts)), void 0 !== r.NextPartNumberMarker && (n.NextPartNumberMarker = r.NextPartNumberMarker), void 0 !== r.Owner && (n.Owner = hv(r.Owner)), void 0 !== r.PartNumberMarker && (n.PartNumberMarker = r.PartNumberMarker), "" === r.Part && (n.Parts = []), void 0 !== r.Part && (n.Parts = pv(Fr(r.Part))), void 0 !== r.StorageClass && (n.StorageClass = r.StorageClass), void 0 !== r.UploadId && (n.UploadId = r.UploadId), [2, Promise.resolve(n)]
                        }
                    }))
                }))
            }(e, t)
        }, t
    }(Br), fm = function (e) {
        function t(t) {
            var n = e.call(this) || this;
            return n.input = t, n
        }

        return ec(t, e), t.prototype.resolveMiddleware = function (e, t, n) {
            this.middlewareStack.use(Yr(t, this.serialize, this.deserialize)), this.middlewareStack.use(rm(t)), this.middlewareStack.use(Dc(t));
            var r = e.concat(this.middlewareStack), i = {
                logger: t.logger,
                clientName: "S3Client",
                commandName: "PutObjectCommand",
                inputFilterSensitiveLog: sp.filterSensitiveLog,
                outputFilterSensitiveLog: op.filterSensitiveLog
            }, o = t.requestHandler;
            return r.resolve((function (e) {
                return o.handle(e.request, n || {})
            }), i)
        }, t.prototype.serialize = function (e, t) {
            return function (e, t) {
                return nc(void 0, void 0, void 0, (function () {
                    var n, r, i, o, s, a, u, c, l, f, d;
                    return rc(this, (function (h) {
                        switch (h.label) {
                            case 0:
                                if (n = tc(tc(tc(tc(tc(tc(tc(tc(tc(tc(tc(tc(tc(tc(tc(tc(tc(tc(tc(tc(tc(tc(tc(tc(tc(tc(tc(tc(tc({"content-type": "application/octet-stream"}, mv(e.ACL) && {"x-amz-acl": e.ACL}), mv(e.CacheControl) && {"cache-control": e.CacheControl}), mv(e.ContentDisposition) && {"content-disposition": e.ContentDisposition}), mv(e.ContentEncoding) && {"content-encoding": e.ContentEncoding}), mv(e.ContentLanguage) && {"content-language": e.ContentLanguage}), mv(e.ContentLength) && {"content-length": e.ContentLength.toString()}), mv(e.ContentMD5) && {"content-md5": e.ContentMD5}), mv(e.ContentType) && {"content-type": e.ContentType}), mv(e.Expires) && {expires: Vr(e.Expires).toString()}), mv(e.GrantFullControl) && {"x-amz-grant-full-control": e.GrantFullControl}), mv(e.GrantRead) && {"x-amz-grant-read": e.GrantRead}), mv(e.GrantReadACP) && {"x-amz-grant-read-acp": e.GrantReadACP}), mv(e.GrantWriteACP) && {"x-amz-grant-write-acp": e.GrantWriteACP}), mv(e.ServerSideEncryption) && {"x-amz-server-side-encryption": e.ServerSideEncryption}), mv(e.StorageClass) && {"x-amz-storage-class": e.StorageClass}), mv(e.WebsiteRedirectLocation) && {"x-amz-website-redirect-location": e.WebsiteRedirectLocation}), mv(e.SSECustomerAlgorithm) && {"x-amz-server-side-encryption-customer-algorithm": e.SSECustomerAlgorithm}), mv(e.SSECustomerKey) && {"x-amz-server-side-encryption-customer-key": e.SSECustomerKey}), mv(e.SSECustomerKeyMD5) && {"x-amz-server-side-encryption-customer-key-md5": e.SSECustomerKeyMD5}), mv(e.SSEKMSKeyId) && {"x-amz-server-side-encryption-aws-kms-key-id": e.SSEKMSKeyId}), mv(e.SSEKMSEncryptionContext) && {"x-amz-server-side-encryption-context": e.SSEKMSEncryptionContext}), mv(e.BucketKeyEnabled) && {"x-amz-server-side-encryption-bucket-key-enabled": e.BucketKeyEnabled.toString()}), mv(e.RequestPayer) && {"x-amz-request-payer": e.RequestPayer}), mv(e.Tagging) && {"x-amz-tagging": e.Tagging}), mv(e.ObjectLockMode) && {"x-amz-object-lock-mode": e.ObjectLockMode}), mv(e.ObjectLockRetainUntilDate) && {"x-amz-object-lock-retain-until-date": (e.ObjectLockRetainUntilDate.toISOString().split(".")[0] + "Z").toString()}), mv(e.ObjectLockLegalHoldStatus) && {"x-amz-object-lock-legal-hold": e.ObjectLockLegalHoldStatus}), mv(e.ExpectedBucketOwner) && {"x-amz-expected-bucket-owner": e.ExpectedBucketOwner}), void 0 !== e.Metadata && Object.keys(e.Metadata).reduce((function (t, n) {
                                    var r;
                                    return tc(tc({}, t), ((r = {})["x-amz-meta-" + n.toLowerCase()] = e.Metadata[n], r))
                                }), {})), r = "/{Bucket}/{Key+}", void 0 === e.Bucket) throw new Error("No value provided for input HTTP label: Bucket.");
                                if ((i = e.Bucket).length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                                if (r = r.replace("{Bucket}", jr(i)), void 0 === e.Key) throw new Error("No value provided for input HTTP label: Key.");
                                if ((i = e.Key).length <= 0) throw new Error("Empty value provided for input HTTP label: Key.");
                                return r = r.replace("{Key+}", i.split("/").map((function (e) {
                                    return jr(e)
                                })).join("/")), o = {"x-id": "PutObject"}, void 0 !== e.Body && (a = e.Body, s = a), [4, t.endpoint()];
                            case 1:
                                return u = h.sent(), c = u.hostname, l = u.protocol, f = void 0 === l ? "https" : l, d = u.port, [2, new Kt({
                                    protocol: f,
                                    hostname: c,
                                    port: d,
                                    method: "PUT",
                                    headers: n,
                                    path: r,
                                    query: o,
                                    body: s
                                })]
                        }
                    }))
                }))
            }(e, t)
        }, t.prototype.deserialize = function (e, t) {
            return function (e, t) {
                return nc(void 0, void 0, void 0, (function () {
                    var n;
                    return rc(this, (function (r) {
                        switch (r.label) {
                            case 0:
                                return 200 !== e.statusCode && e.statusCode >= 300 ? [2, ev(e, t)] : (n = {
                                    $metadata: gv(e),
                                    BucketKeyEnabled: void 0,
                                    ETag: void 0,
                                    Expiration: void 0,
                                    RequestCharged: void 0,
                                    SSECustomerAlgorithm: void 0,
                                    SSECustomerKeyMD5: void 0,
                                    SSEKMSEncryptionContext: void 0,
                                    SSEKMSKeyId: void 0,
                                    ServerSideEncryption: void 0,
                                    VersionId: void 0
                                }, void 0 !== e.headers["x-amz-expiration"] && (n.Expiration = e.headers["x-amz-expiration"]), void 0 !== e.headers.etag && (n.ETag = e.headers.etag), void 0 !== e.headers["x-amz-server-side-encryption"] && (n.ServerSideEncryption = e.headers["x-amz-server-side-encryption"]), void 0 !== e.headers["x-amz-version-id"] && (n.VersionId = e.headers["x-amz-version-id"]), void 0 !== e.headers["x-amz-server-side-encryption-customer-algorithm"] && (n.SSECustomerAlgorithm = e.headers["x-amz-server-side-encryption-customer-algorithm"]), void 0 !== e.headers["x-amz-server-side-encryption-customer-key-md5"] && (n.SSECustomerKeyMD5 = e.headers["x-amz-server-side-encryption-customer-key-md5"]), void 0 !== e.headers["x-amz-server-side-encryption-aws-kms-key-id"] && (n.SSEKMSKeyId = e.headers["x-amz-server-side-encryption-aws-kms-key-id"]), void 0 !== e.headers["x-amz-server-side-encryption-context"] && (n.SSEKMSEncryptionContext = e.headers["x-amz-server-side-encryption-context"]), void 0 !== e.headers["x-amz-server-side-encryption-bucket-key-enabled"] && (n.BucketKeyEnabled = "true" === e.headers["x-amz-server-side-encryption-bucket-key-enabled"]), void 0 !== e.headers["x-amz-request-charged"] && (n.RequestCharged = e.headers["x-amz-request-charged"]), [4, vv(e.body, t)]);
                            case 1:
                                return r.sent(), [2, Promise.resolve(n)]
                        }
                    }))
                }))
            }(e, t)
        }, t
    }(Br);
!function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}(Ev || (Ev = {})), function (e) {
    e.filterSensitiveLog = function (e) {
        return tc(tc({}, e), e.Encryption && {Encryption: bp.filterSensitiveLog(e.Encryption)})
    }
}(Cv || (Cv = {})), function (e) {
    e.filterSensitiveLog = function (e) {
        return tc(tc({}, e), e.S3 && {S3: Cv.filterSensitiveLog(e.S3)})
    }
}(_v || (_v = {})), function (e) {
    e.IGNORE = "IGNORE", e.NONE = "NONE", e.USE = "USE"
}(Av || (Av = {})), function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}(Pv || (Pv = {})), function (e) {
    e.DOCUMENT = "DOCUMENT", e.LINES = "LINES"
}(kv || (kv = {})), function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}(xv || (xv = {})), function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}(Iv || (Iv = {})), function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}(Tv || (Tv = {})), function (e) {
    e.ALWAYS = "ALWAYS", e.ASNEEDED = "ASNEEDED"
}(Uv || (Uv = {})), function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}(Ov || (Ov = {})), function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}(Mv || (Mv = {})), function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}(Lv || (Lv = {})), function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}(Rv || (Rv = {})), function (e) {
    e.SELECT = "SELECT"
}(Nv || (Nv = {})), function (e) {
    e.filterSensitiveLog = function (e) {
        return tc(tc({}, e), e.OutputLocation && {OutputLocation: _v.filterSensitiveLog(e.OutputLocation)})
    }
}(Dv || (Dv = {})), function (e) {
    e.filterSensitiveLog = function (e) {
        return tc(tc({}, e), e.RestoreRequest && {RestoreRequest: Dv.filterSensitiveLog(e.RestoreRequest)})
    }
}(Bv || (Bv = {})), function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}(jv || (jv = {})), function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}(Fv || (Fv = {})), function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}(zv || (zv = {})), function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}(Kv || (Kv = {})), function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}(qv || (qv = {})), function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}(Hv || (Hv = {})), function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}(Vv || (Vv = {})), function (e) {
    e.visit = function (e, t) {
        return void 0 !== e.Records ? t.Records(e.Records) : void 0 !== e.Stats ? t.Stats(e.Stats) : void 0 !== e.Progress ? t.Progress(e.Progress) : void 0 !== e.Cont ? t.Cont(e.Cont) : void 0 !== e.End ? t.End(e.End) : t._(e.$unknown[0], e.$unknown[1])
    }, e.filterSensitiveLog = function (e) {
        var t;
        return void 0 !== e.Records ? {Records: qv.filterSensitiveLog(e.Records)} : void 0 !== e.Stats ? {Stats: Vv.filterSensitiveLog(e.Stats)} : void 0 !== e.Progress ? {Progress: Kv.filterSensitiveLog(e.Progress)} : void 0 !== e.Cont ? {Cont: jv.filterSensitiveLog(e.Cont)} : void 0 !== e.End ? {End: Fv.filterSensitiveLog(e.End)} : void 0 !== e.$unknown ? ((t = {})[e.$unknown[0]] = "UNKNOWN", t) : void 0
    }
}(Gv || (Gv = {})), function (e) {
    e.filterSensitiveLog = function (e) {
        return tc(tc({}, e), e.Payload && {Payload: "STREAMING_CONTENT"})
    }
}(Wv || (Wv = {})), function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}($v || ($v = {})), function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}(Yv || (Yv = {})), function (e) {
    e.filterSensitiveLog = function (e) {
        return tc(tc({}, e), e.SSECustomerKey && {SSECustomerKey: Gr})
    }
}(Jv || (Jv = {})), function (e) {
    e.filterSensitiveLog = function (e) {
        return tc(tc({}, e), e.SSEKMSKeyId && {SSEKMSKeyId: Gr})
    }
}(Zv || (Zv = {})), function (e) {
    e.filterSensitiveLog = function (e) {
        return tc(tc({}, e), e.SSECustomerKey && {SSECustomerKey: Gr})
    }
}(Xv || (Xv = {})), function (e) {
    e.filterSensitiveLog = function (e) {
        return tc({}, e)
    }
}(Qv || (Qv = {})), function (e) {
    e.filterSensitiveLog = function (e) {
        return tc(tc({}, e), e.SSEKMSKeyId && {SSEKMSKeyId: Gr})
    }
}(em || (em = {})), function (e) {
    e.filterSensitiveLog = function (e) {
        return tc(tc(tc({}, e), e.SSECustomerKey && {SSECustomerKey: Gr}), e.CopySourceSSECustomerKey && {CopySourceSSECustomerKey: Gr})
    }
}(tm || (tm = {}));
var dm = function (e) {
    function t(t) {
        var n = e.call(this) || this;
        return n.input = t, n
    }

    return ec(t, e), t.prototype.resolveMiddleware = function (e, t, n) {
        this.middlewareStack.use(Yr(t, this.serialize, this.deserialize)), this.middlewareStack.use(rm(t)), this.middlewareStack.use(Dc(t));
        var r = e.concat(this.middlewareStack), i = {
            logger: t.logger,
            clientName: "S3Client",
            commandName: "UploadPartCommand",
            inputFilterSensitiveLog: Xv.filterSensitiveLog,
            outputFilterSensitiveLog: Zv.filterSensitiveLog
        }, o = t.requestHandler;
        return r.resolve((function (e) {
            return o.handle(e.request, n || {})
        }), i)
    }, t.prototype.serialize = function (e, t) {
        return function (e, t) {
            return nc(void 0, void 0, void 0, (function () {
                var n, r, i, o, s, a, u, c, l, f, d;
                return rc(this, (function (h) {
                    switch (h.label) {
                        case 0:
                            if (n = tc(tc(tc(tc(tc(tc(tc({"content-type": "application/octet-stream"}, mv(e.ContentLength) && {"content-length": e.ContentLength.toString()}), mv(e.ContentMD5) && {"content-md5": e.ContentMD5}), mv(e.SSECustomerAlgorithm) && {"x-amz-server-side-encryption-customer-algorithm": e.SSECustomerAlgorithm}), mv(e.SSECustomerKey) && {"x-amz-server-side-encryption-customer-key": e.SSECustomerKey}), mv(e.SSECustomerKeyMD5) && {"x-amz-server-side-encryption-customer-key-md5": e.SSECustomerKeyMD5}), mv(e.RequestPayer) && {"x-amz-request-payer": e.RequestPayer}), mv(e.ExpectedBucketOwner) && {"x-amz-expected-bucket-owner": e.ExpectedBucketOwner}), r = "/{Bucket}/{Key+}", void 0 === e.Bucket) throw new Error("No value provided for input HTTP label: Bucket.");
                            if ((i = e.Bucket).length <= 0) throw new Error("Empty value provided for input HTTP label: Bucket.");
                            if (r = r.replace("{Bucket}", jr(i)), void 0 === e.Key) throw new Error("No value provided for input HTTP label: Key.");
                            if ((i = e.Key).length <= 0) throw new Error("Empty value provided for input HTTP label: Key.");
                            return r = r.replace("{Key+}", i.split("/").map((function (e) {
                                return jr(e)
                            })).join("/")), o = tc(tc({"x-id": "UploadPart"}, void 0 !== e.PartNumber && {partNumber: e.PartNumber.toString()}), void 0 !== e.UploadId && {uploadId: e.UploadId}), void 0 !== e.Body && (a = e.Body, s = a), [4, t.endpoint()];
                        case 1:
                            return u = h.sent(), c = u.hostname, l = u.protocol, f = void 0 === l ? "https" : l, d = u.port, [2, new Kt({
                                protocol: f,
                                hostname: c,
                                port: d,
                                method: "PUT",
                                headers: n,
                                path: r,
                                query: o,
                                body: s
                            })]
                    }
                }))
            }))
        }(e, t)
    }, t.prototype.deserialize = function (e, t) {
        return function (e, t) {
            return nc(void 0, void 0, void 0, (function () {
                var n;
                return rc(this, (function (r) {
                    switch (r.label) {
                        case 0:
                            return 200 !== e.statusCode && e.statusCode >= 300 ? [2, tv(e, t)] : (n = {
                                $metadata: gv(e),
                                BucketKeyEnabled: void 0,
                                ETag: void 0,
                                RequestCharged: void 0,
                                SSECustomerAlgorithm: void 0,
                                SSECustomerKeyMD5: void 0,
                                SSEKMSKeyId: void 0,
                                ServerSideEncryption: void 0
                            }, void 0 !== e.headers["x-amz-server-side-encryption"] && (n.ServerSideEncryption = e.headers["x-amz-server-side-encryption"]), void 0 !== e.headers.etag && (n.ETag = e.headers.etag), void 0 !== e.headers["x-amz-server-side-encryption-customer-algorithm"] && (n.SSECustomerAlgorithm = e.headers["x-amz-server-side-encryption-customer-algorithm"]), void 0 !== e.headers["x-amz-server-side-encryption-customer-key-md5"] && (n.SSECustomerKeyMD5 = e.headers["x-amz-server-side-encryption-customer-key-md5"]), void 0 !== e.headers["x-amz-server-side-encryption-aws-kms-key-id"] && (n.SSEKMSKeyId = e.headers["x-amz-server-side-encryption-aws-kms-key-id"]), void 0 !== e.headers["x-amz-server-side-encryption-bucket-key-enabled"] && (n.BucketKeyEnabled = "true" === e.headers["x-amz-server-side-encryption-bucket-key-enabled"]), void 0 !== e.headers["x-amz-request-charged"] && (n.RequestCharged = e.headers["x-amz-request-charged"]), [4, vv(e.body, t)]);
                        case 1:
                            return r.sent(), [2, Promise.resolve(n)]
                    }
                }))
            }))
        }(e, t)
    }, t
}(Br);

function hm(e) {
    var t = e.port, n = e.query, r = e.protocol, i = e.path, o = e.hostname;
    r && ":" !== r.substr(-1) && (r += ":"), t && (o += ":" + t), i && "/" !== i.charAt(0) && (i = "/" + i);
    var s = n ? Vt(n) : "";
    return s && "?" !== s[0] && (s = "?" + s), r + "//" + o + i + s
}

function pm(e, t) {
    return j(this, void 0, void 0, (function () {
        var n, r, i = this;
        return F(this, (function (o) {
            switch (o.label) {
                case 0:
                    return n = function (e) {
                        return function (e) {
                            return j(i, void 0, void 0, (function () {
                                return F(this, (function (t) {
                                    return [2, {output: {request: e.request}, response: void 0}]
                                }))
                            }))
                        }
                    }, (r = e.middlewareStack.clone()).add(n, {
                        step: "build",
                        priority: "low"
                    }), [4, t.resolveMiddleware(r, e.config, void 0)(t).then((function (e) {
                        return e.output.request
                    }))];
                case 1:
                    return [2, o.sent()]
            }
        }))
    }))
}

var gm = function () {
    function e(e) {
        var t = D({service: e.signingName || e.service || "s3", uriEscapePath: e.uriEscapePath || !1}, e);
        this.signer = new Sr(t)
    }

    return e.prototype.presign = function (e, t) {
        void 0 === t && (t = {});
        var n = t.unsignableHeaders, r = void 0 === n ? new Set : n, i = t.unhoistableHeaders,
            o = void 0 === i ? new Set : i, s = B(t, ["unsignableHeaders", "unhoistableHeaders"]);
        return j(this, void 0, void 0, (function () {
            return F(this, (function (t) {
                return r.add("content-type"), Object.keys(e.headers).map((function (e) {
                    return e.toLowerCase()
                })).filter((function (e) {
                    return e.startsWith("x-amz-server-side-encryption")
                })).forEach((function (e) {
                    o.add(e)
                })), e.headers["X-Amz-Content-Sha256"] = "UNSIGNED-PAYLOAD", e.headers.host || (e.headers.host = e.hostname), [2, this.signer.presign(e, D({
                    expiresIn: 900,
                    unsignableHeaders: r,
                    unhoistableHeaders: o
                }, s))]
            }))
        }))
    }, e
}(), vm = {exports: {}}, mm = function (e, t) {
    return function () {
        for (var n = new Array(arguments.length), r = 0; r < n.length; r++) n[r] = arguments[r];
        return e.apply(t, n)
    }
}, ym = mm, Sm = Object.prototype.toString;

function wm(e) {
    return "[object Array]" === Sm.call(e)
}

function bm(e) {
    return void 0 === e
}

function Em(e) {
    return null !== e && "object" == typeof e
}

function Cm(e) {
    if ("[object Object]" !== Sm.call(e)) return !1;
    var t = Object.getPrototypeOf(e);
    return null === t || t === Object.prototype
}

function _m(e) {
    return "[object Function]" === Sm.call(e)
}

function Am(e, t) {
    if (null != e) if ("object" != typeof e && (e = [e]), wm(e)) for (var n = 0, r = e.length; n < r; n++) t.call(null, e[n], n, e); else for (var i in e) Object.prototype.hasOwnProperty.call(e, i) && t.call(null, e[i], i, e)
}

var Pm = {
    isArray: wm, isArrayBuffer: function (e) {
        return "[object ArrayBuffer]" === Sm.call(e)
    }, isBuffer: function (e) {
        return null !== e && !bm(e) && null !== e.constructor && !bm(e.constructor) && "function" == typeof e.constructor.isBuffer && e.constructor.isBuffer(e)
    }, isFormData: function (e) {
        return "undefined" != typeof FormData && e instanceof FormData
    }, isArrayBufferView: function (e) {
        return "undefined" != typeof ArrayBuffer && ArrayBuffer.isView ? ArrayBuffer.isView(e) : e && e.buffer && e.buffer instanceof ArrayBuffer
    }, isString: function (e) {
        return "string" == typeof e
    }, isNumber: function (e) {
        return "number" == typeof e
    }, isObject: Em, isPlainObject: Cm, isUndefined: bm, isDate: function (e) {
        return "[object Date]" === Sm.call(e)
    }, isFile: function (e) {
        return "[object File]" === Sm.call(e)
    }, isBlob: function (e) {
        return "[object Blob]" === Sm.call(e)
    }, isFunction: _m, isStream: function (e) {
        return Em(e) && _m(e.pipe)
    }, isURLSearchParams: function (e) {
        return "undefined" != typeof URLSearchParams && e instanceof URLSearchParams
    }, isStandardBrowserEnv: function () {
        return ("undefined" == typeof navigator || "ReactNative" !== navigator.product && "NativeScript" !== navigator.product && "NS" !== navigator.product) && ("undefined" != typeof window && "undefined" != typeof document)
    }, forEach: Am, merge: function e() {
        var t = {};

        function n(n, r) {
            Cm(t[r]) && Cm(n) ? t[r] = e(t[r], n) : Cm(n) ? t[r] = e({}, n) : wm(n) ? t[r] = n.slice() : t[r] = n
        }

        for (var r = 0, i = arguments.length; r < i; r++) Am(arguments[r], n);
        return t
    }, extend: function (e, t, n) {
        return Am(t, (function (t, r) {
            e[r] = n && "function" == typeof t ? ym(t, n) : t
        })), e
    }, trim: function (e) {
        return e.trim ? e.trim() : e.replace(/^\s+|\s+$/g, "")
    }, stripBOM: function (e) {
        return 65279 === e.charCodeAt(0) && (e = e.slice(1)), e
    }
}, km = Pm;

function xm(e) {
    return encodeURIComponent(e).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]")
}

var Im = function (e, t, n) {
    if (!t) return e;
    var r;
    if (n) r = n(t); else if (km.isURLSearchParams(t)) r = t.toString(); else {
        var i = [];
        km.forEach(t, (function (e, t) {
            null != e && (km.isArray(e) ? t += "[]" : e = [e], km.forEach(e, (function (e) {
                km.isDate(e) ? e = e.toISOString() : km.isObject(e) && (e = JSON.stringify(e)), i.push(xm(t) + "=" + xm(e))
            })))
        })), r = i.join("&")
    }
    if (r) {
        var o = e.indexOf("#");
        -1 !== o && (e = e.slice(0, o)), e += (-1 === e.indexOf("?") ? "?" : "&") + r
    }
    return e
}, Tm = Pm;

function Um() {
    this.handlers = []
}

Um.prototype.use = function (e, t, n) {
    return this.handlers.push({
        fulfilled: e,
        rejected: t,
        synchronous: !!n && n.synchronous,
        runWhen: n ? n.runWhen : null
    }), this.handlers.length - 1
}, Um.prototype.eject = function (e) {
    this.handlers[e] && (this.handlers[e] = null)
}, Um.prototype.forEach = function (e) {
    Tm.forEach(this.handlers, (function (t) {
        null !== t && e(t)
    }))
};
var Om = Um, Mm = Pm, Lm = function (e, t, n, r, i) {
        return e.config = t, n && (e.code = n), e.request = r, e.response = i, e.isAxiosError = !0, e.toJSON = function () {
            return {
                message: this.message,
                name: this.name,
                description: this.description,
                number: this.number,
                fileName: this.fileName,
                lineNumber: this.lineNumber,
                columnNumber: this.columnNumber,
                stack: this.stack,
                config: this.config,
                code: this.code
            }
        }, e
    }, Rm = Lm, Nm = function (e, t, n, r, i) {
        var o = new Error(e);
        return Rm(o, t, n, r, i)
    }, Dm = Nm, Bm = Pm, jm = Bm.isStandardBrowserEnv() ? {
        write: function (e, t, n, r, i, o) {
            var s = [];
            s.push(e + "=" + encodeURIComponent(t)), Bm.isNumber(n) && s.push("expires=" + new Date(n).toGMTString()), Bm.isString(r) && s.push("path=" + r), Bm.isString(i) && s.push("domain=" + i), !0 === o && s.push("secure"), document.cookie = s.join("; ")
        }, read: function (e) {
            var t = document.cookie.match(new RegExp("(^|;\\s*)(" + e + ")=([^;]*)"));
            return t ? decodeURIComponent(t[3]) : null
        }, remove: function (e) {
            this.write(e, "", Date.now() - 864e5)
        }
    } : {
        write: function () {
        }, read: function () {
            return null
        }, remove: function () {
        }
    }, Fm = function (e) {
        return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(e)
    }, zm = function (e, t) {
        return t ? e.replace(/\/+$/, "") + "/" + t.replace(/^\/+/, "") : e
    }, Km = Pm,
    qm = ["age", "authorization", "content-length", "content-type", "etag", "expires", "from", "host", "if-modified-since", "if-unmodified-since", "last-modified", "location", "max-forwards", "proxy-authorization", "referer", "retry-after", "user-agent"],
    Hm = Pm, Vm = Hm.isStandardBrowserEnv() ? function () {
        var e, t = /(msie|trident)/i.test(navigator.userAgent), n = document.createElement("a");

        function r(e) {
            var r = e;
            return t && (n.setAttribute("href", r), r = n.href), n.setAttribute("href", r), {
                href: n.href,
                protocol: n.protocol ? n.protocol.replace(/:$/, "") : "",
                host: n.host,
                search: n.search ? n.search.replace(/^\?/, "") : "",
                hash: n.hash ? n.hash.replace(/^#/, "") : "",
                hostname: n.hostname,
                port: n.port,
                pathname: "/" === n.pathname.charAt(0) ? n.pathname : "/" + n.pathname
            }
        }

        return e = r(window.location.href), function (t) {
            var n = Hm.isString(t) ? r(t) : t;
            return n.protocol === e.protocol && n.host === e.host
        }
    }() : function () {
        return !0
    }, Gm = Pm, Wm = function (e, t, n) {
        var r = n.config.validateStatus;
        n.status && r && !r(n.status) ? t(Dm("Request failed with status code " + n.status, n.config, null, n.request, n)) : e(n)
    }, $m = jm, Ym = Im, Jm = function (e, t) {
        return e && !Fm(t) ? zm(e, t) : t
    }, Zm = function (e) {
        var t, n, r, i = {};
        return e ? (Km.forEach(e.split("\n"), (function (e) {
            if (r = e.indexOf(":"), t = Km.trim(e.substr(0, r)).toLowerCase(), n = Km.trim(e.substr(r + 1)), t) {
                if (i[t] && qm.indexOf(t) >= 0) return;
                i[t] = "set-cookie" === t ? (i[t] ? i[t] : []).concat([n]) : i[t] ? i[t] + ", " + n : n
            }
        })), i) : i
    }, Xm = Vm, Qm = Nm, ey = function (e) {
        return new Promise((function (t, n) {
            var r = e.data, i = e.headers, o = e.responseType;
            Gm.isFormData(r) && delete i["Content-Type"];
            var s = new XMLHttpRequest;
            if (e.auth) {
                var a = e.auth.username || "", u = e.auth.password ? unescape(encodeURIComponent(e.auth.password)) : "";
                i.Authorization = "Basic " + btoa(a + ":" + u)
            }
            var c = Jm(e.baseURL, e.url);

            function l() {
                if (s) {
                    var r = "getAllResponseHeaders" in s ? Zm(s.getAllResponseHeaders()) : null, i = {
                        data: o && "text" !== o && "json" !== o ? s.response : s.responseText,
                        status: s.status,
                        statusText: s.statusText,
                        headers: r,
                        config: e,
                        request: s
                    };
                    Wm(t, n, i), s = null
                }
            }

            if (s.open(e.method.toUpperCase(), Ym(c, e.params, e.paramsSerializer), !0), s.timeout = e.timeout, "onloadend" in s ? s.onloadend = l : s.onreadystatechange = function () {
                s && 4 === s.readyState && (0 !== s.status || s.responseURL && 0 === s.responseURL.indexOf("file:")) && setTimeout(l)
            }, s.onabort = function () {
                s && (n(Qm("Request aborted", e, "ECONNABORTED", s)), s = null)
            }, s.onerror = function () {
                n(Qm("Network Error", e, null, s)), s = null
            }, s.ontimeout = function () {
                var t = "timeout of " + e.timeout + "ms exceeded";
                e.timeoutErrorMessage && (t = e.timeoutErrorMessage), n(Qm(t, e, e.transitional && e.transitional.clarifyTimeoutError ? "ETIMEDOUT" : "ECONNABORTED", s)), s = null
            }, Gm.isStandardBrowserEnv()) {
                var f = (e.withCredentials || Xm(c)) && e.xsrfCookieName ? $m.read(e.xsrfCookieName) : void 0;
                f && (i[e.xsrfHeaderName] = f)
            }
            "setRequestHeader" in s && Gm.forEach(i, (function (e, t) {
                void 0 === r && "content-type" === t.toLowerCase() ? delete i[t] : s.setRequestHeader(t, e)
            })), Gm.isUndefined(e.withCredentials) || (s.withCredentials = !!e.withCredentials), o && "json" !== o && (s.responseType = e.responseType), "function" == typeof e.onDownloadProgress && s.addEventListener("progress", e.onDownloadProgress), "function" == typeof e.onUploadProgress && s.upload && s.upload.addEventListener("progress", e.onUploadProgress), e.cancelToken && e.cancelToken.promise.then((function (e) {
                s && (s.abort(), n(e), s = null)
            })), r || (r = null), s.send(r)
        }))
    }, ty = Pm, ny = function (e, t) {
        Mm.forEach(e, (function (n, r) {
            r !== t && r.toUpperCase() === t.toUpperCase() && (e[t] = n, delete e[r])
        }))
    }, ry = Lm, iy = {"Content-Type": "application/x-www-form-urlencoded"};

function oy(e, t) {
    !ty.isUndefined(e) && ty.isUndefined(e["Content-Type"]) && (e["Content-Type"] = t)
}

var sy, ay = {
    transitional: {silentJSONParsing: !0, forcedJSONParsing: !0, clarifyTimeoutError: !1},
    adapter: (("undefined" != typeof XMLHttpRequest || "undefined" != typeof process && "[object process]" === Object.prototype.toString.call(process)) && (sy = ey), sy),
    transformRequest: [function (e, t) {
        return ny(t, "Accept"), ny(t, "Content-Type"), ty.isFormData(e) || ty.isArrayBuffer(e) || ty.isBuffer(e) || ty.isStream(e) || ty.isFile(e) || ty.isBlob(e) ? e : ty.isArrayBufferView(e) ? e.buffer : ty.isURLSearchParams(e) ? (oy(t, "application/x-www-form-urlencoded;charset=utf-8"), e.toString()) : ty.isObject(e) || t && "application/json" === t["Content-Type"] ? (oy(t, "application/json"), function (e, t, n) {
            if (ty.isString(e)) try {
                return (t || JSON.parse)(e), ty.trim(e)
            } catch (e) {
                if ("SyntaxError" !== e.name) throw e
            }
            return (n || JSON.stringify)(e)
        }(e)) : e
    }],
    transformResponse: [function (e) {
        var t = this.transitional, n = t && t.silentJSONParsing, r = t && t.forcedJSONParsing,
            i = !n && "json" === this.responseType;
        if (i || r && ty.isString(e) && e.length) try {
            return JSON.parse(e)
        } catch (e) {
            if (i) {
                if ("SyntaxError" === e.name) throw ry(e, this, "E_JSON_PARSE");
                throw e
            }
        }
        return e
    }],
    timeout: 0,
    xsrfCookieName: "XSRF-TOKEN",
    xsrfHeaderName: "X-XSRF-TOKEN",
    maxContentLength: -1,
    maxBodyLength: -1,
    validateStatus: function (e) {
        return e >= 200 && e < 300
    }
};
ay.headers = {common: {Accept: "application/json, text/plain, */*"}}, ty.forEach(["delete", "get", "head"], (function (e) {
    ay.headers[e] = {}
})), ty.forEach(["post", "put", "patch"], (function (e) {
    ay.headers[e] = ty.merge(iy)
}));
var uy = ay, cy = Pm, ly = uy, fy = function (e) {
    return !(!e || !e.__CANCEL__)
}, dy = Pm, hy = function (e, t, n) {
    var r = this || ly;
    return cy.forEach(n, (function (n) {
        e = n.call(r, e, t)
    })), e
}, py = fy, gy = uy;

function vy(e) {
    e.cancelToken && e.cancelToken.throwIfRequested()
}

var my = Pm, yy = function (e, t) {
    t = t || {};
    var n = {}, r = ["url", "method", "data"], i = ["headers", "auth", "proxy", "params"],
        o = ["baseURL", "transformRequest", "transformResponse", "paramsSerializer", "timeout", "timeoutMessage", "withCredentials", "adapter", "responseType", "xsrfCookieName", "xsrfHeaderName", "onUploadProgress", "onDownloadProgress", "decompress", "maxContentLength", "maxBodyLength", "maxRedirects", "transport", "httpAgent", "httpsAgent", "cancelToken", "socketPath", "responseEncoding"],
        s = ["validateStatus"];

    function a(e, t) {
        return my.isPlainObject(e) && my.isPlainObject(t) ? my.merge(e, t) : my.isPlainObject(t) ? my.merge({}, t) : my.isArray(t) ? t.slice() : t
    }

    function u(r) {
        my.isUndefined(t[r]) ? my.isUndefined(e[r]) || (n[r] = a(void 0, e[r])) : n[r] = a(e[r], t[r])
    }

    my.forEach(r, (function (e) {
        my.isUndefined(t[e]) || (n[e] = a(void 0, t[e]))
    })), my.forEach(i, u), my.forEach(o, (function (r) {
        my.isUndefined(t[r]) ? my.isUndefined(e[r]) || (n[r] = a(void 0, e[r])) : n[r] = a(void 0, t[r])
    })), my.forEach(s, (function (r) {
        r in t ? n[r] = a(e[r], t[r]) : r in e && (n[r] = a(void 0, e[r]))
    }));
    var c = r.concat(i).concat(o).concat(s), l = Object.keys(e).concat(Object.keys(t)).filter((function (e) {
        return -1 === c.indexOf(e)
    }));
    return my.forEach(l, u), n
}, Sy = {
    name: "axios",
    version: "0.21.4",
    description: "Promise based HTTP client for the browser and node.js",
    main: "index.js",
    scripts: {
        test: "grunt test",
        start: "node ./sandbox/server.js",
        build: "NODE_ENV=production grunt build",
        preversion: "npm test",
        version: "npm run build && grunt version && git add -A dist && git add CHANGELOG.md bower.json package.json",
        postversion: "git push && git push --tags",
        examples: "node ./examples/server.js",
        coveralls: "cat coverage/lcov.info | ./node_modules/coveralls/bin/coveralls.js",
        fix: "eslint --fix lib/**/*.js"
    },
    repository: {type: "git", url: "https://github.com/axios/axios.git"},
    keywords: ["xhr", "http", "ajax", "promise", "node"],
    author: "Matt Zabriskie",
    license: "MIT",
    bugs: {url: "https://github.com/axios/axios/issues"},
    homepage: "https://axios-http.com",
    devDependencies: {
        coveralls: "^3.0.0",
        "es6-promise": "^4.2.4",
        grunt: "^1.3.0",
        "grunt-banner": "^0.6.0",
        "grunt-cli": "^1.2.0",
        "grunt-contrib-clean": "^1.1.0",
        "grunt-contrib-watch": "^1.0.0",
        "grunt-eslint": "^23.0.0",
        "grunt-karma": "^4.0.0",
        "grunt-mocha-test": "^0.13.3",
        "grunt-ts": "^6.0.0-beta.19",
        "grunt-webpack": "^4.0.2",
        "istanbul-instrumenter-loader": "^1.0.0",
        "jasmine-core": "^2.4.1",
        karma: "^6.3.2",
        "karma-chrome-launcher": "^3.1.0",
        "karma-firefox-launcher": "^2.1.0",
        "karma-jasmine": "^1.1.1",
        "karma-jasmine-ajax": "^0.1.13",
        "karma-safari-launcher": "^1.0.0",
        "karma-sauce-launcher": "^4.3.6",
        "karma-sinon": "^1.0.5",
        "karma-sourcemap-loader": "^0.3.8",
        "karma-webpack": "^4.0.2",
        "load-grunt-tasks": "^3.5.2",
        minimist: "^1.2.0",
        mocha: "^8.2.1",
        sinon: "^4.5.0",
        "terser-webpack-plugin": "^4.2.3",
        typescript: "^4.0.5",
        "url-search-params": "^0.10.0",
        webpack: "^4.44.2",
        "webpack-dev-server": "^3.11.0"
    },
    browser: {"./lib/adapters/http.js": "./lib/adapters/xhr.js"},
    jsdelivr: "dist/axios.min.js",
    unpkg: "dist/axios.min.js",
    typings: "./index.d.ts",
    dependencies: {"follow-redirects": "^1.14.0"},
    bundlesize: [{path: "./dist/axios.min.js", threshold: "5kB"}]
}, wy = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach((function (e, t) {
    wy[e] = function (n) {
        return typeof n === e || "a" + (t < 1 ? "n " : " ") + e
    }
}));
var by = {}, Ey = Sy.version.split(".");

function Cy(e, t) {
    for (var n = t ? t.split(".") : Ey, r = e.split("."), i = 0; i < 3; i++) {
        if (n[i] > r[i]) return !0;
        if (n[i] < r[i]) return !1
    }
    return !1
}

wy.transitional = function (e, t, n) {
    var r = t && Cy(t);

    function i(e, t) {
        return "[Axios v" + Sy.version + "] Transitional option '" + e + "'" + t + (n ? ". " + n : "")
    }

    return function (n, o, s) {
        if (!1 === e) throw new Error(i(o, " has been removed in " + t));
        return r && !by[o] && (by[o] = !0, console.warn(i(o, " has been deprecated since v" + t + " and will be removed in the near future"))), !e || e(n, o, s)
    }
};
var _y = {
    isOlderVersion: Cy, assertOptions: function (e, t, n) {
        if ("object" != typeof e) throw new TypeError("options must be an object");
        for (var r = Object.keys(e), i = r.length; i-- > 0;) {
            var o = r[i], s = t[o];
            if (s) {
                var a = e[o], u = void 0 === a || s(a, o, e);
                if (!0 !== u) throw new TypeError("option " + o + " must be " + u)
            } else if (!0 !== n) throw Error("Unknown option " + o)
        }
    }, validators: wy
}, Ay = Pm, Py = Im, ky = Om, xy = function (e) {
    return vy(e), e.headers = e.headers || {}, e.data = hy.call(e, e.data, e.headers, e.transformRequest), e.headers = dy.merge(e.headers.common || {}, e.headers[e.method] || {}, e.headers), dy.forEach(["delete", "get", "head", "post", "put", "patch", "common"], (function (t) {
        delete e.headers[t]
    })), (e.adapter || gy.adapter)(e).then((function (t) {
        return vy(e), t.data = hy.call(e, t.data, t.headers, e.transformResponse), t
    }), (function (t) {
        return py(t) || (vy(e), t && t.response && (t.response.data = hy.call(e, t.response.data, t.response.headers, e.transformResponse))), Promise.reject(t)
    }))
}, Iy = yy, Ty = _y, Uy = Ty.validators;

function Oy(e) {
    this.defaults = e, this.interceptors = {request: new ky, response: new ky}
}

Oy.prototype.request = function (e) {
    "string" == typeof e ? (e = arguments[1] || {}).url = arguments[0] : e = e || {}, (e = Iy(this.defaults, e)).method ? e.method = e.method.toLowerCase() : this.defaults.method ? e.method = this.defaults.method.toLowerCase() : e.method = "get";
    var t = e.transitional;
    void 0 !== t && Ty.assertOptions(t, {
        silentJSONParsing: Uy.transitional(Uy.boolean, "1.0.0"),
        forcedJSONParsing: Uy.transitional(Uy.boolean, "1.0.0"),
        clarifyTimeoutError: Uy.transitional(Uy.boolean, "1.0.0")
    }, !1);
    var n = [], r = !0;
    this.interceptors.request.forEach((function (t) {
        "function" == typeof t.runWhen && !1 === t.runWhen(e) || (r = r && t.synchronous, n.unshift(t.fulfilled, t.rejected))
    }));
    var i, o = [];
    if (this.interceptors.response.forEach((function (e) {
        o.push(e.fulfilled, e.rejected)
    })), !r) {
        var s = [xy, void 0];
        for (Array.prototype.unshift.apply(s, n), s = s.concat(o), i = Promise.resolve(e); s.length;) i = i.then(s.shift(), s.shift());
        return i
    }
    for (var a = e; n.length;) {
        var u = n.shift(), c = n.shift();
        try {
            a = u(a)
        } catch (e) {
            c(e);
            break
        }
    }
    try {
        i = xy(a)
    } catch (e) {
        return Promise.reject(e)
    }
    for (; o.length;) i = i.then(o.shift(), o.shift());
    return i
}, Oy.prototype.getUri = function (e) {
    return e = Iy(this.defaults, e), Py(e.url, e.params, e.paramsSerializer).replace(/^\?/, "")
}, Ay.forEach(["delete", "get", "head", "options"], (function (e) {
    Oy.prototype[e] = function (t, n) {
        return this.request(Iy(n || {}, {method: e, url: t, data: (n || {}).data}))
    }
})), Ay.forEach(["post", "put", "patch"], (function (e) {
    Oy.prototype[e] = function (t, n, r) {
        return this.request(Iy(r || {}, {method: e, url: t, data: n}))
    }
}));
var My = Oy;

function Ly(e) {
    this.message = e
}

Ly.prototype.toString = function () {
    return "Cancel" + (this.message ? ": " + this.message : "")
}, Ly.prototype.__CANCEL__ = !0;
var Ry = Ly, Ny = Ry;

function Dy(e) {
    if ("function" != typeof e) throw new TypeError("executor must be a function.");
    var t;
    this.promise = new Promise((function (e) {
        t = e
    }));
    var n = this;
    e((function (e) {
        n.reason || (n.reason = new Ny(e), t(n.reason))
    }))
}

Dy.prototype.throwIfRequested = function () {
    if (this.reason) throw this.reason
}, Dy.source = function () {
    var e;
    return {
        token: new Dy((function (t) {
            e = t
        })), cancel: e
    }
};
var By = Dy, jy = Pm, Fy = mm, zy = My, Ky = yy;

function qy(e) {
    var t = new zy(e), n = Fy(zy.prototype.request, t);
    return jy.extend(n, zy.prototype, t), jy.extend(n, t), n
}

var Hy = qy(uy);
Hy.Axios = zy, Hy.create = function (e) {
    return qy(Ky(Hy.defaults, e))
}, Hy.Cancel = Ry, Hy.CancelToken = By, Hy.isCancel = fy, Hy.all = function (e) {
    return Promise.all(e)
}, Hy.spread = function (e) {
    return function (t) {
        return e.apply(null, t)
    }
}, Hy.isAxiosError = function (e) {
    return "object" == typeof e && !0 === e.isAxiosError
}, vm.exports = Hy, vm.exports.default = Hy;
var Vy, Gy, Wy, $y = vm.exports;
!function (e) {
    e.NO_CREDENTIALS = "No credentials", e.NO_SRC_KEY = 'source param should be an object with the property "key" with value of type string', e.NO_DEST_KEY = 'destination param should be an object with the property "key" with value of type string', e.INVALID_BLOB = "Object must be an instance of Blob"
}(Vy || (Vy = {})), function (e) {
    e.CLEANUP_FAILED = "Multipart copy clean up failed", e.NO_OBJECT_FOUND = "Object does not exist", e.INVALID_QUEUESIZE = "Queue size must be a positive number", e.NO_COPYSOURCE = "You must specify a copy source", e.MAX_NUM_PARTS_EXCEEDED = "Only a maximum of 10000 parts are allowed"
}(Gy || (Gy = {})), function (e) {
    e.UPLOAD_PAUSED_MESSAGE = "paused"
}(Wy || (Wy = {}));
var Yy = function (e) {
    var t = "function" == typeof Symbol && Symbol.iterator, n = t && e[t], r = 0;
    if (n) return n.call(e);
    if (e && "number" == typeof e.length) return {
        next: function () {
            return e && r >= e.length && (e = void 0), {value: e && e[r++], done: !e}
        }
    };
    throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.")
}, Jy = function (e, t) {
    var n = "function" == typeof Symbol && e[Symbol.iterator];
    if (!n) return e;
    var r, i, o = n.call(e), s = [];
    try {
        for (; (void 0 === t || t-- > 0) && !(r = o.next()).done;) s.push(r.value)
    } catch (e) {
        i = {error: e}
    } finally {
        try {
            r && !r.done && (n = o.return) && n.call(o)
        } finally {
            if (i) throw i.error
        }
    }
    return s
}, Zy = new o("axios-http-handler");
var Xy = function (e, t) {
    var n, r;
    try {
        for (var i = Yy(Object.entries(e)), o = i.next(); !o.done; o = i.next()) {
            var s = Jy(o.value, 2), a = s[0], u = s[1];
            a !== t && a.toUpperCase() === t.toUpperCase() && (e[t] = u, delete e[a])
        }
    } catch (e) {
        n = {error: e}
    } finally {
        try {
            o && !o.done && (r = i.return) && r.call(i)
        } finally {
            if (n) throw n.error
        }
    }
}, Qy = [function (e, t) {
    return n = e, "undefined" != typeof Blob && n instanceof Blob ? (Xy(t, "Content-Type"), Xy(t, "Accept"), e) : $y.defaults.transformRequest[0].call(null, e, t);
    var n
}], eS = function () {
    function e(e, t, n) {
        void 0 === e && (e = {}), this.httpOptions = e, this.emitter = t, this.cancelTokenSource = n
    }

    return e.prototype.destroy = function () {
    }, e.prototype.handle = function (e, t) {
        var n = this.httpOptions.requestTimeout, r = t.emitter || this.emitter, i = e.path;
        if (e.query) {
            var o = Vt(e.query);
            o && (i += "?" + o)
        }
        var s = e.port, a = e.protocol + "//" + e.hostname + (s ? ":" + s : "") + i, u = {};
        u.url = a, u.method = e.method, u.headers = e.headers, delete u.headers.host, e.body ? u.data = e.body : u.headers[Object.keys(u.headers).find((function (e) {
            return "content-type" === e.toLowerCase()
        }))] && (u.data = null), r && (u.onUploadProgress = function (e) {
            r.emit("sendUploadProgress", e), Zy.debug(e)
        }, u.onDownloadProgress = function (e) {
            r.emit("sendDownloadProgress", e), Zy.debug(e)
        }), this.cancelTokenSource && (u.cancelToken = this.cancelTokenSource.token), t.cancelTokenSource && (u.cancelToken = t.cancelTokenSource.token), u.responseType = "blob", c.isReactNative && (u.transformRequest = Qy);
        var l = [$y.request(u).then((function (e) {
            return {response: new zt({headers: e.headers, statusCode: e.status, body: e.data})}
        })).catch((function (e) {
            var t, n, r;
            if (e.message !== Wy.UPLOAD_PAUSED_MESSAGE && Zy.error(e.message), $y.isCancel(e)) throw e;
            return {
                response: new zt({
                    statusCode: null === (t = e.response) || void 0 === t ? void 0 : t.status,
                    body: null === (n = e.response) || void 0 === n ? void 0 : n.data,
                    headers: null === (r = e.response) || void 0 === r ? void 0 : r.headers
                })
            }
        })), tS(n)];
        return Promise.race(l)
    }, e
}();

function tS(e) {
    return void 0 === e && (e = 0), new Promise((function (t, n) {
        e && setTimeout((function () {
            var t = new Error("Request did not complete within " + e + " ms");
            t.name = "TimeoutError", n(t)
        }), e)
    }))
}

var nS,
    rS = "undefined" != typeof Symbol && "function" == typeof Symbol.for ? Symbol.for("amplify_default") : "@@amplify_default",
    iS = function (e, t, n, r, i) {
        if (e) {
            var o = {attrs: n};
            r && (o.metrics = r), m.dispatch("storage", {event: t, data: o, message: i}, "Storage", rS)
        }
    }, oS = function (e) {
        return void 0 !== e && e instanceof Blob
    }, sS = function (e) {
        return void 0 !== e && e instanceof ArrayBuffer
    }, aS = function () {
        return aS = Object.assign || function (e) {
            for (var t, n = 1, r = arguments.length; n < r; n++) for (var i in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
            return e
        }, aS.apply(this, arguments)
    }, uS = function (e, t, n, r) {
        return new (n || (n = Promise))((function (i, o) {
            function s(e) {
                try {
                    u(r.next(e))
                } catch (e) {
                    o(e)
                }
            }

            function a(e) {
                try {
                    u(r.throw(e))
                } catch (e) {
                    o(e)
                }
            }

            function u(e) {
                var t;
                e.done ? i(e.value) : (t = e.value, t instanceof n ? t : new n((function (e) {
                    e(t)
                }))).then(s, a)
            }

            u((r = r.apply(e, t || [])).next())
        }))
    }, cS = function (e, t) {
        var n, r, i, o, s = {
            label: 0, sent: function () {
                if (1 & i[0]) throw i[1];
                return i[1]
            }, trys: [], ops: []
        };
        return o = {
            next: a(0),
            throw: a(1),
            return: a(2)
        }, "function" == typeof Symbol && (o[Symbol.iterator] = function () {
            return this
        }), o;

        function a(o) {
            return function (a) {
                return function (o) {
                    if (n) throw new TypeError("Generator is already executing.");
                    for (; s;) try {
                        if (n = 1, r && (i = 2 & o[0] ? r.return : o[0] ? r.throw || ((i = r.return) && i.call(r), 0) : r.next) && !(i = i.call(r, o[1])).done) return i;
                        switch (r = 0, i && (o = [2 & o[0], i.value]), o[0]) {
                            case 0:
                            case 1:
                                i = o;
                                break;
                            case 4:
                                return s.label++, {value: o[1], done: !1};
                            case 5:
                                s.label++, r = o[1], o = [0];
                                continue;
                            case 7:
                                o = s.ops.pop(), s.trys.pop();
                                continue;
                            default:
                                if (!(i = s.trys, (i = i.length > 0 && i[i.length - 1]) || 6 !== o[0] && 2 !== o[0])) {
                                    s = 0;
                                    continue
                                }
                                if (3 === o[0] && (!i || o[1] > i[0] && o[1] < i[3])) {
                                    s.label = o[1];
                                    break
                                }
                                if (6 === o[0] && s.label < i[1]) {
                                    s.label = i[1], i = o;
                                    break
                                }
                                if (i && s.label < i[2]) {
                                    s.label = i[2], s.ops.push(o);
                                    break
                                }
                                i[2] && s.ops.pop(), s.trys.pop();
                                continue
                        }
                        o = t.call(e, s)
                    } catch (e) {
                        o = [6, e], r = 0
                    } finally {
                        n = i = 0
                    }
                    if (5 & o[0]) throw o[1];
                    return {value: o[0] ? o[1] : void 0, done: !0}
                }([o, a])
            }
        }
    }, lS = new o("S3ClientUtils"), fS = {accessKeyId: "", secretAccessKey: ""}, dS = function (e) {
        var t = e.credentials, n = e.level, r = e.customPrefix || {}, i = e.identityId || t.identityId,
            o = (void 0 !== r.private ? r.private : "private/") + i + "/",
            s = (void 0 !== r.protected ? r.protected : "protected/") + i + "/",
            a = void 0 !== r.public ? r.public : "public/";
        switch (n) {
            case"private":
                return o;
            case"protected":
                return s;
            default:
                return a
        }
    }, hS = function (e, t) {
        return function (n, r) {
            return function (r) {
                return uS(void 0, void 0, void 0, (function () {
                    var i, o, s, a;
                    return cS(this, (function (u) {
                        switch (u.label) {
                            case 0:
                                return [4, Ss.get()];
                            case 1:
                                return i = u.sent(), o = Ss.shear(i), s = dS(aS(aS({}, e), {credentials: o})), a = Object.assign({}, r.input), Object.prototype.hasOwnProperty.call(r.input, "Key") ? (a.Key = s + t, r.input = a) : Object.prototype.hasOwnProperty.call(r.input, "Prefix") && (a.Prefix = s + t, r.input = a), [2, n(r)]
                        }
                    }))
                }))
            }
        }
    }, pS = function (e) {
        return function (t, n) {
            return function (n) {
                return uS(void 0, void 0, void 0, (function () {
                    var r, i;
                    return cS(this, (function (o) {
                        switch (o.label) {
                            case 0:
                                return o.trys.push([0, 2, , 3]), [4, t(n)];
                            case 1:
                                return [2, o.sent()];
                            case 2:
                                throw r = o.sent(), (s = r).ServerTime && "string" == typeof s.Code && "RequestTimeTooSkewed" === s.Code && (i = new Date(r.ServerTime), e.systemClockOffset = i.getTime() - Date.now()), r;
                            case 3:
                                return [2]
                        }
                        var s
                    }))
                }))
            }
        }
    }, gS = {step: "finalizeRequest", name: "autoAdjustClockskewMiddleware"},
    vS = {step: "initialize", name: "addPrefixMiddleware"}, mS = function () {
        return uS(void 0, void 0, void 0, (function () {
            var e, t, n;
            return cS(this, (function (r) {
                switch (r.label) {
                    case 0:
                        return r.trys.push([0, 2, , 3]), [4, Ss.get()];
                    case 1:
                        return (e = r.sent()) ? (t = Ss.shear(e), lS.debug("credentials provider get credentials", t), [2, t]) : [2, fS];
                    case 2:
                        return n = r.sent(), lS.warn("credentials provider error", n), [2, fS];
                    case 3:
                        return [2]
                }
            }))
        }))
    }, yS = function (e, t) {
        var n = e.region, r = e.cancelTokenSource, i = e.dangerouslyConnectToHttpEndpointForTesting,
            o = e.useAccelerateEndpoint, s = {};
        i && (s = {endpoint: "http://localhost:20005", tls: !1, bucketEndpoint: !1, forcePathStyle: !0});
        var a = new Tp(aS(aS({region: n, credentials: mS, customUserAgent: l()}, s), {
            requestHandler: new eS({}, t, r),
            useAccelerateEndpoint: o
        }));
        return a.middlewareStack.remove("contentLengthMiddleware"), a
    }, SS = {exports: {}}, wS = "object" == typeof Reflect ? Reflect : null,
    bS = wS && "function" == typeof wS.apply ? wS.apply : function (e, t, n) {
        return Function.prototype.apply.call(e, t, n)
    };
nS = wS && "function" == typeof wS.ownKeys ? wS.ownKeys : Object.getOwnPropertySymbols ? function (e) {
    return Object.getOwnPropertyNames(e).concat(Object.getOwnPropertySymbols(e))
} : function (e) {
    return Object.getOwnPropertyNames(e)
};
var ES = Number.isNaN || function (e) {
    return e != e
};

function CS() {
    CS.init.call(this)
}

SS.exports = CS, SS.exports.once = function (e, t) {
    return new Promise((function (n, r) {
        function i(n) {
            e.removeListener(t, o), r(n)
        }

        function o() {
            "function" == typeof e.removeListener && e.removeListener("error", i), n([].slice.call(arguments))
        }

        MS(e, t, o, {once: !0}), "error" !== t && function (e, t, n) {
            "function" == typeof e.on && MS(e, "error", t, n)
        }(e, i, {once: !0})
    }))
}, CS.EventEmitter = CS, CS.prototype._events = void 0, CS.prototype._eventsCount = 0, CS.prototype._maxListeners = void 0;
var _S = 10;

function AS(e) {
    if ("function" != typeof e) throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof e)
}

function PS(e) {
    return void 0 === e._maxListeners ? CS.defaultMaxListeners : e._maxListeners
}

function kS(e, t, n, r) {
    var i, o, s, a;
    if (AS(n), void 0 === (o = e._events) ? (o = e._events = Object.create(null), e._eventsCount = 0) : (void 0 !== o.newListener && (e.emit("newListener", t, n.listener ? n.listener : n), o = e._events), s = o[t]), void 0 === s) s = o[t] = n, ++e._eventsCount; else if ("function" == typeof s ? s = o[t] = r ? [n, s] : [s, n] : r ? s.unshift(n) : s.push(n), (i = PS(e)) > 0 && s.length > i && !s.warned) {
        s.warned = !0;
        var u = new Error("Possible EventEmitter memory leak detected. " + s.length + " " + String(t) + " listeners added. Use emitter.setMaxListeners() to increase limit");
        u.name = "MaxListenersExceededWarning", u.emitter = e, u.type = t, u.count = s.length, a = u, console && console.warn && console.warn(a)
    }
    return e
}

function xS() {
    if (!this.fired) return this.target.removeListener(this.type, this.wrapFn), this.fired = !0, 0 === arguments.length ? this.listener.call(this.target) : this.listener.apply(this.target, arguments)
}

function IS(e, t, n) {
    var r = {fired: !1, wrapFn: void 0, target: e, type: t, listener: n}, i = xS.bind(r);
    return i.listener = n, r.wrapFn = i, i
}

function TS(e, t, n) {
    var r = e._events;
    if (void 0 === r) return [];
    var i = r[t];
    return void 0 === i ? [] : "function" == typeof i ? n ? [i.listener || i] : [i] : n ? function (e) {
        for (var t = new Array(e.length), n = 0; n < t.length; ++n) t[n] = e[n].listener || e[n];
        return t
    }(i) : OS(i, i.length)
}

function US(e) {
    var t = this._events;
    if (void 0 !== t) {
        var n = t[e];
        if ("function" == typeof n) return 1;
        if (void 0 !== n) return n.length
    }
    return 0
}

function OS(e, t) {
    for (var n = new Array(t), r = 0; r < t; ++r) n[r] = e[r];
    return n
}

function MS(e, t, n, r) {
    if ("function" == typeof e.on) r.once ? e.once(t, n) : e.on(t, n); else {
        if ("function" != typeof e.addEventListener) throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof e);
        e.addEventListener(t, (function i(o) {
            r.once && e.removeEventListener(t, i), n(o)
        }))
    }
}

Object.defineProperty(CS, "defaultMaxListeners", {
    enumerable: !0, get: function () {
        return _S
    }, set: function (e) {
        if ("number" != typeof e || e < 0 || ES(e)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + e + ".");
        _S = e
    }
}), CS.init = function () {
    void 0 !== this._events && this._events !== Object.getPrototypeOf(this)._events || (this._events = Object.create(null), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0
}, CS.prototype.setMaxListeners = function (e) {
    if ("number" != typeof e || e < 0 || ES(e)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + e + ".");
    return this._maxListeners = e, this
}, CS.prototype.getMaxListeners = function () {
    return PS(this)
}, CS.prototype.emit = function (e) {
    for (var t = [], n = 1; n < arguments.length; n++) t.push(arguments[n]);
    var r = "error" === e, i = this._events;
    if (void 0 !== i) r = r && void 0 === i.error; else if (!r) return !1;
    if (r) {
        var o;
        if (t.length > 0 && (o = t[0]), o instanceof Error) throw o;
        var s = new Error("Unhandled error." + (o ? " (" + o.message + ")" : ""));
        throw s.context = o, s
    }
    var a = i[e];
    if (void 0 === a) return !1;
    if ("function" == typeof a) bS(a, this, t); else {
        var u = a.length, c = OS(a, u);
        for (n = 0; n < u; ++n) bS(c[n], this, t)
    }
    return !0
}, CS.prototype.addListener = function (e, t) {
    return kS(this, e, t, !1)
}, CS.prototype.on = CS.prototype.addListener, CS.prototype.prependListener = function (e, t) {
    return kS(this, e, t, !0)
}, CS.prototype.once = function (e, t) {
    return AS(t), this.on(e, IS(this, e, t)), this
}, CS.prototype.prependOnceListener = function (e, t) {
    return AS(t), this.prependListener(e, IS(this, e, t)), this
}, CS.prototype.removeListener = function (e, t) {
    var n, r, i, o, s;
    if (AS(t), void 0 === (r = this._events)) return this;
    if (void 0 === (n = r[e])) return this;
    if (n === t || n.listener === t) 0 == --this._eventsCount ? this._events = Object.create(null) : (delete r[e], r.removeListener && this.emit("removeListener", e, n.listener || t)); else if ("function" != typeof n) {
        for (i = -1, o = n.length - 1; o >= 0; o--) if (n[o] === t || n[o].listener === t) {
            s = n[o].listener, i = o;
            break
        }
        if (i < 0) return this;
        0 === i ? n.shift() : function (e, t) {
            for (; t + 1 < e.length; t++) e[t] = e[t + 1];
            e.pop()
        }(n, i), 1 === n.length && (r[e] = n[0]), void 0 !== r.removeListener && this.emit("removeListener", e, s || t)
    }
    return this
}, CS.prototype.off = CS.prototype.removeListener, CS.prototype.removeAllListeners = function (e) {
    var t, n, r;
    if (void 0 === (n = this._events)) return this;
    if (void 0 === n.removeListener) return 0 === arguments.length ? (this._events = Object.create(null), this._eventsCount = 0) : void 0 !== n[e] && (0 == --this._eventsCount ? this._events = Object.create(null) : delete n[e]), this;
    if (0 === arguments.length) {
        var i, o = Object.keys(n);
        for (r = 0; r < o.length; ++r) "removeListener" !== (i = o[r]) && this.removeAllListeners(i);
        return this.removeAllListeners("removeListener"), this._events = Object.create(null), this._eventsCount = 0, this
    }
    if ("function" == typeof (t = n[e])) this.removeListener(e, t); else if (void 0 !== t) for (r = t.length - 1; r >= 0; r--) this.removeListener(e, t[r]);
    return this
}, CS.prototype.listeners = function (e) {
    return TS(this, e, !0)
}, CS.prototype.rawListeners = function (e) {
    return TS(this, e, !1)
}, CS.listenerCount = function (e, t) {
    return "function" == typeof e.listenerCount ? e.listenerCount(t) : US.call(e, t)
}, CS.prototype.listenerCount = US, CS.prototype.eventNames = function () {
    return this._eventsCount > 0 ? nS(this._events) : []
};
var LS, RS, NS = function () {
    return NS = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var i in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
        return e
    }, NS.apply(this, arguments)
}, DS = function (e, t, n, r) {
    return new (n || (n = Promise))((function (i, o) {
        function s(e) {
            try {
                u(r.next(e))
            } catch (e) {
                o(e)
            }
        }

        function a(e) {
            try {
                u(r.throw(e))
            } catch (e) {
                o(e)
            }
        }

        function u(e) {
            var t;
            e.done ? i(e.value) : (t = e.value, t instanceof n ? t : new n((function (e) {
                e(t)
            }))).then(s, a)
        }

        u((r = r.apply(e, t || [])).next())
    }))
}, BS = function (e, t) {
    var n, r, i, o, s = {
        label: 0, sent: function () {
            if (1 & i[0]) throw i[1];
            return i[1]
        }, trys: [], ops: []
    };
    return o = {
        next: a(0),
        throw: a(1),
        return: a(2)
    }, "function" == typeof Symbol && (o[Symbol.iterator] = function () {
        return this
    }), o;

    function a(o) {
        return function (a) {
            return function (o) {
                if (n) throw new TypeError("Generator is already executing.");
                for (; s;) try {
                    if (n = 1, r && (i = 2 & o[0] ? r.return : o[0] ? r.throw || ((i = r.return) && i.call(r), 0) : r.next) && !(i = i.call(r, o[1])).done) return i;
                    switch (r = 0, i && (o = [2 & o[0], i.value]), o[0]) {
                        case 0:
                        case 1:
                            i = o;
                            break;
                        case 4:
                            return s.label++, {value: o[1], done: !1};
                        case 5:
                            s.label++, r = o[1], o = [0];
                            continue;
                        case 7:
                            o = s.ops.pop(), s.trys.pop();
                            continue;
                        default:
                            if (!(i = s.trys, (i = i.length > 0 && i[i.length - 1]) || 6 !== o[0] && 2 !== o[0])) {
                                s = 0;
                                continue
                            }
                            if (3 === o[0] && (!i || o[1] > i[0] && o[1] < i[3])) {
                                s.label = o[1];
                                break
                            }
                            if (6 === o[0] && s.label < i[1]) {
                                s.label = i[1], i = o;
                                break
                            }
                            if (i && s.label < i[2]) {
                                s.label = i[2], s.ops.push(o);
                                break
                            }
                            i[2] && s.ops.pop(), s.trys.pop();
                            continue
                    }
                    o = t.call(e, s)
                } catch (e) {
                    o = [6, e], r = 0
                } finally {
                    n = i = 0
                }
                if (5 & o[0]) throw o[1];
                return {value: o[0] ? o[1] : void 0, done: !0}
            }([o, a])
        }
    }
}, jS = new o("AWSS3ProviderManagedUpload"), FS = function () {
    function e(e, t, n) {
        this.minPartSize = 5242880, this.queueSize = 4, this.body = null, this.params = null, this.opts = null, this.completedParts = [], this.cancel = !1, this.bytesUploaded = 0, this.totalBytesToUpload = 0, this.emitter = null, this.params = e, this.opts = t, this.emitter = n, this.s3client = this._createNewS3Client(t, n)
    }

    return e.prototype.upload = function () {
        return DS(this, void 0, void 0, (function () {
            var e, t, n, r, i, o, s = this;
            return BS(this, (function (a) {
                switch (a.label) {
                    case 0:
                        return e = this, [4, this.validateAndSanitizeBody(this.params.Body)];
                    case 1:
                        return e.body = a.sent(), this.totalBytesToUpload = this.byteLength(this.body), this.totalBytesToUpload <= this.minPartSize ? (this.params.Body = this.body, t = new fm(this.params), [2, this.s3client.send(t)]) : [3, 2];
                    case 2:
                        return [4, this.createMultiPartUpload()];
                    case 3:
                        n = a.sent(), r = Math.ceil(this.totalBytesToUpload / this.minPartSize), i = this.createParts(), o = 0, a.label = 4;
                    case 4:
                        return o < r ? [4, this.checkIfUploadCancelled(n)] : [3, 9];
                    case 5:
                        return a.sent(), [4, this.uploadParts(n, i.slice(o, o + this.queueSize))];
                    case 6:
                        return a.sent(), [4, this.checkIfUploadCancelled(n)];
                    case 7:
                        a.sent(), a.label = 8;
                    case 8:
                        return o += this.queueSize, [3, 4];
                    case 9:
                        return i.map((function (e) {
                            s.removeEventListener(e)
                        })), [4, this.finishMultiPartUpload(n)];
                    case 10:
                        return [2, a.sent()]
                }
            }))
        }))
    }, e.prototype.createParts = function () {
        for (var e = [], t = 0; t < this.totalBytesToUpload;) {
            var n = Math.min(t + this.minPartSize, this.totalBytesToUpload);
            e.push({
                bodyPart: this.body.slice(t, n),
                partNumber: e.length + 1,
                emitter: new SS.exports.EventEmitter,
                _lastUploadedBytes: 0
            }), t += this.minPartSize
        }
        return e
    }, e.prototype.createMultiPartUpload = function () {
        return DS(this, void 0, void 0, (function () {
            var e, t;
            return BS(this, (function (n) {
                switch (n.label) {
                    case 0:
                        return e = new om(this.params), [4, this.s3client.send(e)];
                    case 1:
                        return t = n.sent(), jS.debug(t.UploadId), [2, t.UploadId]
                }
            }))
        }))
    }, e.prototype.uploadParts = function (e, t) {
        return DS(this, void 0, void 0, (function () {
            var n, r, i, o = this;
            return BS(this, (function (s) {
                switch (s.label) {
                    case 0:
                        return s.trys.push([0, 2, , 3]), [4, Promise.all(t.map((function (t) {
                            return DS(o, void 0, void 0, (function () {
                                var n, r, i, o, s, a, u;
                                return BS(this, (function (c) {
                                    switch (c.label) {
                                        case 0:
                                            return this.setupEventListener(t), n = {emitter: t.emitter}, r = this.params, i = r.Key, o = r.Bucket, s = r.SSECustomerAlgorithm, a = r.SSECustomerKey, u = r.SSECustomerKeyMD5, [4, this.s3client.send(new dm(NS(NS(NS({
                                                PartNumber: t.partNumber,
                                                Body: t.bodyPart,
                                                UploadId: e,
                                                Key: i,
                                                Bucket: o
                                            }, s && {SSECustomerAlgorithm: s}), a && {SSECustomerKey: a}), u && {SSECustomerKeyMD5: u})), n)];
                                        case 1:
                                            return [2, c.sent()]
                                    }
                                }))
                            }))
                        })))];
                    case 1:
                        for (n = s.sent(), r = 0; r < n.length; r++) this.completedParts.push({
                            PartNumber: t[r].partNumber,
                            ETag: n[r].ETag
                        });
                        return [3, 3];
                    case 2:
                        return i = s.sent(), jS.error("error happened while uploading a part. Cancelling the multipart upload", i), this.cancelUpload(), [2];
                    case 3:
                        return [2]
                }
            }))
        }))
    }, e.prototype.finishMultiPartUpload = function (e) {
        return DS(this, void 0, void 0, (function () {
            var t, n, r;
            return BS(this, (function (i) {
                switch (i.label) {
                    case 0:
                        t = {
                            Bucket: this.params.Bucket,
                            Key: this.params.Key,
                            UploadId: e,
                            MultipartUpload: {Parts: this.completedParts}
                        }, n = new bv(t), i.label = 1;
                    case 1:
                        return i.trys.push([1, 3, , 4]), [4, this.s3client.send(n)];
                    case 2:
                        return [2, i.sent().Key];
                    case 3:
                        return r = i.sent(), jS.error("error happened while finishing the upload. Cancelling the multipart upload", r), this.cancelUpload(), [2];
                    case 4:
                        return [2]
                }
            }))
        }))
    }, e.prototype.checkIfUploadCancelled = function (e) {
        return DS(this, void 0, void 0, (function () {
            var t, n;
            return BS(this, (function (r) {
                switch (r.label) {
                    case 0:
                        if (!this.cancel) return [3, 5];
                        t = "Upload was cancelled.", r.label = 1;
                    case 1:
                        return r.trys.push([1, 3, , 4]), [4, this.cleanup(e)];
                    case 2:
                        return r.sent(), [3, 4];
                    case 3:
                        return n = r.sent(), t += " " + n.message, [3, 4];
                    case 4:
                        throw new Error(t);
                    case 5:
                        return [2]
                }
            }))
        }))
    }, e.prototype.cancelUpload = function () {
        this.cancel = !0
    }, e.prototype.cleanup = function (e) {
        return DS(this, void 0, void 0, (function () {
            var t, n;
            return BS(this, (function (r) {
                switch (r.label) {
                    case 0:
                        return this.body = null, this.completedParts = [], this.bytesUploaded = 0, this.totalBytesToUpload = 0, t = {
                            Bucket: this.params.Bucket,
                            Key: this.params.Key,
                            UploadId: e
                        }, [4, this.s3client.send(new wv(t))];
                    case 1:
                        return r.sent(), [4, this.s3client.send(new lm(t))];
                    case 2:
                        if ((n = r.sent()) && n.Parts && n.Parts.length > 0) throw new Error("Multi Part upload clean up failed");
                        return [2]
                }
            }))
        }))
    }, e.prototype.removeEventListener = function (e) {
        e.emitter.removeAllListeners("sendUploadProgress"), e.emitter.removeAllListeners("sendDownloadProgress")
    }, e.prototype.setupEventListener = function (e) {
        var t = this;
        e.emitter.on("sendUploadProgress", (function (n) {
            t.progressChanged(e.partNumber, n.loaded - e._lastUploadedBytes), e._lastUploadedBytes = n.loaded
        }))
    }, e.prototype.progressChanged = function (e, t) {
        this.bytesUploaded += t, this.emitter.emit("sendUploadProgress", {
            loaded: this.bytesUploaded,
            total: this.totalBytesToUpload,
            part: e,
            key: this.params.Key
        })
    }, e.prototype.byteLength = function (e) {
        if (null == e) return 0;
        if ("number" == typeof e.byteLength) return e.byteLength;
        if ("number" == typeof e.length) return e.length;
        if ("number" == typeof e.size) return e.size;
        if ("string" != typeof e.path) throw new Error("Cannot determine length of " + e)
    }, e.prototype.validateAndSanitizeBody = function (e) {
        return DS(this, void 0, void 0, (function () {
            return BS(this, (function (t) {
                return this.isGenericObject(e) ? [2, JSON.stringify(e)] : [2, e]
            }))
        }))
    }, e.prototype.isGenericObject = function (e) {
        if (null !== e && "object" == typeof e) try {
            return !(this.byteLength(e) >= 0)
        } catch (e) {
            return !0
        }
        return !1
    }, e.prototype._createNewS3Client = function (e, t) {
        var n = yS(e, t);
        return n.middlewareStack.add(hS(this.opts, this.params.Key), vS), n.middlewareStack.add(pS(n.config), gS), n
    }, e
}(), zS = function (e, t, n, r) {
    return new (n || (n = Promise))((function (i, o) {
        function s(e) {
            try {
                u(r.next(e))
            } catch (e) {
                o(e)
            }
        }

        function a(e) {
            try {
                u(r.throw(e))
            } catch (e) {
                o(e)
            }
        }

        function u(e) {
            var t;
            e.done ? i(e.value) : (t = e.value, t instanceof n ? t : new n((function (e) {
                e(t)
            }))).then(s, a)
        }

        u((r = r.apply(e, t || [])).next())
    }))
}, KS = function (e, t) {
    var n, r, i, o, s = {
        label: 0, sent: function () {
            if (1 & i[0]) throw i[1];
            return i[1]
        }, trys: [], ops: []
    };
    return o = {
        next: a(0),
        throw: a(1),
        return: a(2)
    }, "function" == typeof Symbol && (o[Symbol.iterator] = function () {
        return this
    }), o;

    function a(o) {
        return function (a) {
            return function (o) {
                if (n) throw new TypeError("Generator is already executing.");
                for (; s;) try {
                    if (n = 1, r && (i = 2 & o[0] ? r.return : o[0] ? r.throw || ((i = r.return) && i.call(r), 0) : r.next) && !(i = i.call(r, o[1])).done) return i;
                    switch (r = 0, i && (o = [2 & o[0], i.value]), o[0]) {
                        case 0:
                        case 1:
                            i = o;
                            break;
                        case 4:
                            return s.label++, {value: o[1], done: !1};
                        case 5:
                            s.label++, r = o[1], o = [0];
                            continue;
                        case 7:
                            o = s.ops.pop(), s.trys.pop();
                            continue;
                        default:
                            if (!(i = s.trys, (i = i.length > 0 && i[i.length - 1]) || 6 !== o[0] && 2 !== o[0])) {
                                s = 0;
                                continue
                            }
                            if (3 === o[0] && (!i || o[1] > i[0] && o[1] < i[3])) {
                                s.label = o[1];
                                break
                            }
                            if (6 === o[0] && s.label < i[1]) {
                                s.label = i[1], i = o;
                                break
                            }
                            if (i && s.label < i[2]) {
                                s.label = i[2], s.ops.push(o);
                                break
                            }
                            i[2] && s.ops.pop(), s.trys.pop();
                            continue
                    }
                    o = t.call(e, s)
                } catch (e) {
                    o = [6, e], r = 0
                } finally {
                    n = i = 0
                }
                if (5 & o[0]) throw o[1];
                return {value: o[0] ? o[1] : void 0, done: !0}
            }([o, a])
        }
    }
}, qS = function (e, t) {
    var n = "function" == typeof Symbol && e[Symbol.iterator];
    if (!n) return e;
    var r, i, o = n.call(e), s = [];
    try {
        for (; (void 0 === t || t-- > 0) && !(r = o.next()).done;) s.push(r.value)
    } catch (e) {
        i = {error: e}
    } finally {
        try {
            r && !r.done && (n = o.return) && n.call(o)
        } finally {
            if (i) throw i.error
        }
    }
    return s
}, HS = function () {
    for (var e = [], t = 0; t < arguments.length; t++) e = e.concat(qS(arguments[t]));
    return e
}, VS = new o("AWSS3UploadTask");
!function (e) {
    e[e.INIT = 0] = "INIT", e[e.IN_PROGRESS = 1] = "IN_PROGRESS", e[e.PAUSED = 2] = "PAUSED", e[e.CANCELLED = 3] = "CANCELLED", e[e.COMPLETED = 4] = "COMPLETED"
}(LS || (LS = {})), function (e) {
    e.CANCEL = "cancel", e.UPLOAD_COMPLETE = "uploadComplete", e.UPLOAD_PROGRESS = "uploadPartProgress", e.ERROR = "error"
}(RS || (RS = {}));

function GS(e, t) {
    return e.PartNumber - t.PartNumber
}

var WS = function () {
    function e(e) {
        var t = e.s3Client, n = e.file, r = e.emitter, i = e.storage, o = e.params, s = e.level, a = e.prefixPromise;
        this.partSize = 5242880, this.queueSize = 4, this.inProgress = [], this.completedParts = [], this.queued = [], this.bytesUploaded = 0, this.totalBytes = 0, this.state = LS.INIT, this.prefixPromise = a, this.s3client = t, this.s3client.middlewareStack.remove("contentLengthMiddleware"), this.storage = i, this.storageSync = Promise.resolve(), "function" == typeof this.storage.sync && (this.storageSync = this.storage.sync()), this.params = o, this.file = n, this.totalBytes = this.file.size, this.bytesUploaded = 0, this.emitter = r, this.queued = [], this.fileId = this._getFileId(s), this._validateParams(), this.emitter.on(RS.ERROR, (function () {
        }))
    }

    return Object.defineProperty(e.prototype, "percent", {
        get: function () {
            return this.bytesUploaded / this.totalBytes * 100
        }, enumerable: !0, configurable: !0
    }), Object.defineProperty(e.prototype, "isInProgress", {
        get: function () {
            return this.state === LS.IN_PROGRESS
        }, enumerable: !0, configurable: !0
    }), e.prototype._listSingleFile = function (e) {
        var t = e.key, n = e.bucket;
        return zS(this, void 0, void 0, (function () {
            var e, r, i, o;
            return KS(this, (function (s) {
                switch (s.label) {
                    case 0:
                        return [4, this.s3client.send(new cm({Bucket: n, Prefix: t}))];
                    case 1:
                        return e = s.sent(), r = e.Contents, i = void 0 === r ? [] : r, [4, this.prefixPromise];
                    case 2:
                        return o = s.sent(), [2, i.find((function (e) {
                            return e.Key === "" + o + t
                        }))]
                }
            }))
        }))
    }, e.prototype._getFileId = function (e) {
        return void 0 !== (t = this.file) && t instanceof File ? [this.file.name, this.file.lastModified, this.file.size, this.file.type, this.params.Bucket, e, this.params.Key].join("-") : [this.file.size, this.file.type, this.params.Bucket, e, this.params.Key].join("-");
        var t
    }, e.prototype._findCachedUploadParts = function () {
        return zS(this, void 0, void 0, (function () {
            var e, t;
            return KS(this, (function (n) {
                switch (n.label) {
                    case 0:
                        return [4, this._listCachedUploadTasks()];
                    case 1:
                        return e = n.sent(), 0 !== Object.keys(e).length && Object.prototype.hasOwnProperty.call(e, this.fileId) ? ((t = e[this.fileId]).lastTouched = Date.now(), this.storage.setItem("__uploadInProgress", JSON.stringify(e)), [4, this.s3client.send(new lm({
                            Bucket: this.params.Bucket,
                            Key: this.params.Key,
                            UploadId: t.uploadId
                        }))]) : [2, {parts: [], uploadId: null}];
                    case 2:
                        return [2, {parts: n.sent().Parts || [], uploadId: t.uploadId}]
                }
            }))
        }))
    }, e.prototype._emitEvent = function (e, t) {
        this.emitter.emit(e, t)
    }, e.prototype._validateParams = function () {
        if (this.file.size / this.partSize > 1e4) throw new Error("Too many parts. Number of parts is " + this.file.size / this.partSize + ", maximum is 10000.")
    }, e.prototype._listCachedUploadTasks = function () {
        return zS(this, void 0, void 0, (function () {
            var e;
            return KS(this, (function (t) {
                switch (t.label) {
                    case 0:
                        return [4, this.storageSync];
                    case 1:
                        return t.sent(), e = this.storage.getItem("__uploadInProgress") || "{}", [2, JSON.parse(e)]
                }
            }))
        }))
    }, e.prototype._cache = function (e) {
        return zS(this, void 0, void 0, (function () {
            var t;
            return KS(this, (function (n) {
                switch (n.label) {
                    case 0:
                        return [4, this._listCachedUploadTasks()];
                    case 1:
                        return (t = n.sent())[this.fileId] = e, this.storage.setItem("__uploadInProgress", JSON.stringify(t)), [2]
                }
            }))
        }))
    }, e.prototype._isCached = function () {
        return zS(this, void 0, void 0, (function () {
            var e, t;
            return KS(this, (function (n) {
                switch (n.label) {
                    case 0:
                        return t = (e = Object.prototype.hasOwnProperty).call, [4, this._listCachedUploadTasks()];
                    case 1:
                        return [2, t.apply(e, [n.sent(), this.fileId])]
                }
            }))
        }))
    }, e.prototype._removeFromCache = function () {
        return zS(this, void 0, void 0, (function () {
            var e;
            return KS(this, (function (t) {
                switch (t.label) {
                    case 0:
                        return [4, this._listCachedUploadTasks()];
                    case 1:
                        return delete (e = t.sent())[this.fileId], this.storage.setItem("__uploadInProgress", JSON.stringify(e)), [2]
                }
            }))
        }))
    }, e.prototype._onPartUploadCompletion = function (e) {
        var t = e.eTag, n = e.partNumber, r = e.chunk;
        return zS(this, void 0, void 0, (function () {
            return KS(this, (function (e) {
                return this.completedParts.push({ETag: t, PartNumber: n}), this.bytesUploaded += function (e) {
                    if ("string" == typeof e) return e.length;
                    if (sS(e)) return e.byteLength;
                    if (oS(e)) return e.size;
                    throw new Error("Cannot determine byte length of " + e)
                }(r), this._emitEvent(RS.UPLOAD_PROGRESS, {
                    loaded: this.bytesUploaded,
                    total: this.totalBytes
                }), this.inProgress = this.inProgress.filter((function (e) {
                    return e.uploadPartInput.PartNumber !== n
                })), this.queued.length && this.state !== LS.PAUSED && this._startNextPart(), this._isDone() && this._completeUpload(), [2]
            }))
        }))
    }, e.prototype._completeUpload = function () {
        return zS(this, void 0, void 0, (function () {
            var e;
            return KS(this, (function (t) {
                switch (t.label) {
                    case 0:
                        return t.trys.push([0, 2, , 3]), [4, this.s3client.send(new bv({
                            Bucket: this.params.Bucket,
                            Key: this.params.Key,
                            UploadId: this.uploadId,
                            MultipartUpload: {Parts: this.completedParts.sort(GS)}
                        }))];
                    case 1:
                        return t.sent(), this._verifyFileSize(), this._emitEvent(RS.UPLOAD_COMPLETE, {key: this.params.Bucket + "/" + this.params.Key}), this._removeFromCache(), this.state = LS.COMPLETED, [3, 3];
                    case 2:
                        return e = t.sent(), VS.error("error completing upload", e), this._emitEvent(RS.ERROR, e), [3, 3];
                    case 3:
                        return [2]
                }
            }))
        }))
    }, e.prototype._makeUploadPartRequest = function (e, t) {
        return zS(this, void 0, void 0, (function () {
            var n, r;
            return KS(this, (function (i) {
                switch (i.label) {
                    case 0:
                        return i.trys.push([0, 3, , 4]), [4, this.s3client.send(new dm(e), {cancelTokenSource: t})];
                    case 1:
                        return n = i.sent(), [4, this._onPartUploadCompletion({
                            eTag: n.ETag,
                            partNumber: e.PartNumber,
                            chunk: e.Body
                        })];
                    case 2:
                        return i.sent(), [3, 4];
                    case 3:
                        return r = i.sent(), this.state === LS.PAUSED ? VS.log("upload paused") : this.state === LS.CANCELLED ? VS.log("upload aborted") : VS.error("error starting next part of upload: ", r), $y.isCancel(r) || r.message === Wy.UPLOAD_PAUSED_MESSAGE || (this._emitEvent(RS.ERROR, r), this.pause()), [3, 4];
                    case 4:
                        return [2]
                }
            }))
        }))
    }, e.prototype._startNextPart = function () {
        if (this.queued.length > 0 && this.state !== LS.PAUSED) {
            var e = $y.CancelToken.source(), t = this.queued.shift();
            this.inProgress.push({uploadPartInput: t, s3Request: this._makeUploadPartRequest(t, e), cancel: e.cancel})
        }
    }, e.prototype._verifyFileSize = function () {
        return zS(this, void 0, void 0, (function () {
            var e, t;
            return KS(this, (function (n) {
                switch (n.label) {
                    case 0:
                        return [4, this._listSingleFile({key: this.params.Key, bucket: this.params.Bucket})];
                    case 1:
                        if (e = n.sent(), !(t = Boolean(e && e.Size === this.file.size))) throw new Error("File size does not match between local file and file on s3");
                        return [2, t]
                }
            }))
        }))
    }, e.prototype._isDone = function () {
        return !this.queued.length && !this.inProgress.length && this.bytesUploaded === this.totalBytes
    }, e.prototype._createParts = function () {
        for (var e = this.file.size, t = [], n = 0; n < e;) {
            var r = Math.min(n + this.partSize, e);
            t.push({
                Body: this.file.slice(n, r),
                Key: this.params.Key,
                Bucket: this.params.Bucket,
                PartNumber: t.length + 1,
                UploadId: this.uploadId
            }), n += this.partSize
        }
        return t
    }, e.prototype._initCachedUploadParts = function (e) {
        this.bytesUploaded += e.reduce((function (e, t) {
            return e + t.Size
        }), 0);
        var t = new Set(e.map((function (e) {
            return e.PartNumber
        })));
        this.queued = this.queued.filter((function (e) {
            return !t.has(e.PartNumber)
        })), this.completedParts = e.map((function (e) {
            return {PartNumber: e.PartNumber, ETag: e.ETag}
        })), this._emitEvent(RS.UPLOAD_PROGRESS, {loaded: this.bytesUploaded, total: this.totalBytes})
    }, e.prototype._initMultipartUpload = function () {
        return zS(this, void 0, void 0, (function () {
            var e;
            return KS(this, (function (t) {
                switch (t.label) {
                    case 0:
                        return [4, this.s3client.send(new om(this.params))];
                    case 1:
                        return e = t.sent(), this._cache({
                            uploadId: e.UploadId,
                            lastTouched: Date.now(),
                            bucket: this.params.Bucket,
                            key: this.params.Key,
                            fileName: this.file instanceof File ? this.file.name : ""
                        }), [2, e.UploadId]
                }
            }))
        }))
    }, e.prototype._initializeUploadTask = function () {
        return zS(this, void 0, void 0, (function () {
            var e, t, n, r;
            return KS(this, (function (i) {
                switch (i.label) {
                    case 0:
                        this.state = LS.IN_PROGRESS, i.label = 1;
                    case 1:
                        return i.trys.push([1, 7, , 8]), [4, this._isCached()];
                    case 2:
                        return i.sent() ? [4, this._findCachedUploadParts()] : [3, 4];
                    case 3:
                        return e = i.sent(), t = e.parts, n = e.uploadId, this.uploadId = n, this.queued = this._createParts(), this._initCachedUploadParts(t), this._startUpload(), [3, 6];
                    case 4:
                        return this.uploadId ? [3, 6] : [4, this._initMultipartUpload()];
                    case 5:
                        n = i.sent(), this.uploadId = n, this.queued = this._createParts(), this._startUpload(), i.label = 6;
                    case 6:
                        return [3, 8];
                    case 7:
                        return r = i.sent(), $y.isCancel(r) || VS.error("Error initializing the upload task", r), [3, 8];
                    case 8:
                        return [2]
                }
            }))
        }))
    }, e.prototype.resume = function () {
        this.state === LS.CANCELLED ? VS.warn("This task has already been cancelled") : this.state === LS.COMPLETED ? VS.warn("This task has already been completed") : this.state === LS.IN_PROGRESS ? VS.warn("Upload task already in progress") : this.uploadId ? this._startUpload() : this._initializeUploadTask()
    }, e.prototype._startUpload = function () {
        this.state = LS.IN_PROGRESS;
        for (var e = 0; e < this.queueSize; e++) this._startNextPart()
    }, e.prototype._cancel = function () {
        return zS(this, void 0, void 0, (function () {
            var e;
            return KS(this, (function (t) {
                switch (t.label) {
                    case 0:
                        return this.state !== LS.CANCELLED ? [3, 1] : (VS.warn("This task has already been cancelled"), [2, !1]);
                    case 1:
                        return this.state !== LS.COMPLETED ? [3, 2] : (VS.warn("This task has already been completed"), [2, !1]);
                    case 2:
                        this.pause(), this.queued = [], this.completedParts = [], this.bytesUploaded = 0, this.state = LS.CANCELLED, t.label = 3;
                    case 3:
                        return t.trys.push([3, 6, , 7]), [4, this.s3client.send(new wv({
                            Bucket: this.params.Bucket,
                            Key: this.params.Key,
                            UploadId: this.uploadId
                        }))];
                    case 4:
                        return t.sent(), [4, this._removeFromCache()];
                    case 5:
                        return t.sent(), [2, !0];
                    case 6:
                        return e = t.sent(), VS.error("Error cancelling upload task", e), [2, !1];
                    case 7:
                        return [2]
                }
            }))
        }))
    }, e.prototype.pause = function () {
        var e;
        this.state === LS.CANCELLED ? VS.warn("This task has already been cancelled") : this.state === LS.COMPLETED ? VS.warn("This task has already been completed") : this.state === LS.PAUSED && VS.warn("This task is already paused"), this.state = LS.PAUSED;
        var t = this.inProgress.splice(0, this.inProgress.length);
        t.forEach((function (e) {
            e.cancel(Wy.UPLOAD_PAUSED_MESSAGE)
        })), (e = this.queued).unshift.apply(e, HS(t.map((function (e) {
            return e.uploadPartInput
        }))))
    }, e
}(), $S = function () {
    return $S = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var i in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
        return e
    }, $S.apply(this, arguments)
}, YS = function (e, t, n, r) {
    return new (n || (n = Promise))((function (i, o) {
        function s(e) {
            try {
                u(r.next(e))
            } catch (e) {
                o(e)
            }
        }

        function a(e) {
            try {
                u(r.throw(e))
            } catch (e) {
                o(e)
            }
        }

        function u(e) {
            var t;
            e.done ? i(e.value) : (t = e.value, t instanceof n ? t : new n((function (e) {
                e(t)
            }))).then(s, a)
        }

        u((r = r.apply(e, t || [])).next())
    }))
}, JS = function (e, t) {
    var n, r, i, o, s = {
        label: 0, sent: function () {
            if (1 & i[0]) throw i[1];
            return i[1]
        }, trys: [], ops: []
    };
    return o = {
        next: a(0),
        throw: a(1),
        return: a(2)
    }, "function" == typeof Symbol && (o[Symbol.iterator] = function () {
        return this
    }), o;

    function a(o) {
        return function (a) {
            return function (o) {
                if (n) throw new TypeError("Generator is already executing.");
                for (; s;) try {
                    if (n = 1, r && (i = 2 & o[0] ? r.return : o[0] ? r.throw || ((i = r.return) && i.call(r), 0) : r.next) && !(i = i.call(r, o[1])).done) return i;
                    switch (r = 0, i && (o = [2 & o[0], i.value]), o[0]) {
                        case 0:
                        case 1:
                            i = o;
                            break;
                        case 4:
                            return s.label++, {value: o[1], done: !1};
                        case 5:
                            s.label++, r = o[1], o = [0];
                            continue;
                        case 7:
                            o = s.ops.pop(), s.trys.pop();
                            continue;
                        default:
                            if (!(i = s.trys, (i = i.length > 0 && i[i.length - 1]) || 6 !== o[0] && 2 !== o[0])) {
                                s = 0;
                                continue
                            }
                            if (3 === o[0] && (!i || o[1] > i[0] && o[1] < i[3])) {
                                s.label = o[1];
                                break
                            }
                            if (6 === o[0] && s.label < i[1]) {
                                s.label = i[1], i = o;
                                break
                            }
                            if (i && s.label < i[2]) {
                                s.label = i[2], s.ops.push(o);
                                break
                            }
                            i[2] && s.ops.pop(), s.trys.pop();
                            continue
                    }
                    o = t.call(e, s)
                } catch (e) {
                    o = [6, e], r = 0
                } finally {
                    n = i = 0
                }
                if (5 & o[0]) throw o[1];
                return {value: o[0] ? o[1] : void 0, done: !0}
            }([o, a])
        }
    }
}, ZS = new o("AWSS3Provider"), XS = function () {
    function e(e) {
        var t = this;
        this._config = e || {}, this._storage = (new li).getStorage(), m.listen("auth", (function (e) {
            var n = e.payload;
            "signOut" !== n.event && "signIn" !== n.event || t._storage.removeItem("__uploadInProgress")
        })), ZS.debug("Storage Options", this._config)
    }

    return e.prototype.getCategory = function () {
        return e.CATEGORY
    }, e.prototype.getProviderName = function () {
        return e.PROVIDER_NAME
    }, e.prototype.configure = function (e) {
        if (ZS.debug("configure Storage", e), !e) return this._config;
        var t = Le.parseMobilehubConfig(e);
        return this._config = Object.assign({}, this._config, t.Storage), this._config.bucket || ZS.debug("Do not have bucket yet"), this._config
    }, e.prototype.startResumableUpload = function (e, t) {
        var n = e.s3Client, r = e.emitter, i = e.key, o = e.file, s = e.params, a = t.progressCallback,
            u = t.completeCallback, c = t.errorCallback, l = t.track, f = void 0 !== l && l;
        if (!(o instanceof Blob)) throw new Error(Vy.INVALID_BLOB);
        r.on(RS.UPLOAD_PROGRESS, (function (e) {
            a && ("function" == typeof a ? a(e) : ZS.warn("progressCallback should be a function, not a " + typeof a))
        })), r.on(RS.UPLOAD_COMPLETE, (function (e) {
            u && ("function" == typeof u ? u(e) : ZS.warn("completeCallback should be a function, not a " + typeof u))
        })), r.on(RS.ERROR, (function (e) {
            c && ("function" == typeof c ? c(e) : ZS.warn("errorCallback should be a function, not a " + typeof c))
        }));
        var d = Ss.get().then((function (e) {
            var n = Ss.shear(e);
            return dS($S($S({}, t), {credentials: n}))
        })), h = new WS({
            s3Client: n,
            file: o,
            emitter: r,
            level: t.level,
            storage: this._storage,
            params: s,
            prefixPromise: d
        });
        return iS(f, "upload", {
            method: "put",
            result: "success"
        }, null, "Upload Task created successfully for " + i), h.resume(), h
    }, e.prototype.copy = function (e, t, n) {
        return YS(this, void 0, void 0, (function () {
            var r, i, o, s, a, u, c, l, f, d, h, p, g, v, m, y, S, w, b, E, C, _, A, P, k;
            return JS(this, (function (x) {
                switch (x.label) {
                    case 0:
                        return [4, this._ensureCredentials()];
                    case 1:
                        if (!x.sent() || !this._isWithCredentials(this._config)) throw new Error(Vy.NO_CREDENTIALS);
                        if (r = Object.assign({}, this._config, n), i = r.acl, o = r.bucket, s = r.cacheControl, a = r.expires, u = r.track, c = r.serverSideEncryption, l = r.SSECustomerAlgorithm, f = r.SSECustomerKey, d = r.SSECustomerKeyMD5, h = r.SSEKMSKeyId, p = e.level, g = void 0 === p ? "public" : p, v = e.identityId, m = e.key, y = t.level, S = void 0 === y ? "public" : y, w = t.key, !m || "string" != typeof m) throw new Error(Vy.NO_SRC_KEY);
                        if (!w || "string" != typeof w) throw new Error(Vy.NO_DEST_KEY);
                        "protected" !== g && v && ZS.warn('You may copy files from another user if the source level is "protected", currently it\'s ' + g), b = this._prefix($S($S($S({}, r), {level: g}), v && {identityId: v})), E = this._prefix($S($S({}, r), {level: S})), C = o + "/" + b + m, _ = "" + E + w, ZS.debug("copying " + C + " to " + _), A = {
                            Bucket: o,
                            CopySource: C,
                            Key: _,
                            MetadataDirective: "COPY"
                        }, s && (A.CacheControl = s), a && (A.Expires = a), c && (A.ServerSideEncryption = c), l && (A.SSECustomerAlgorithm = l), f && (A.SSECustomerKey = f), d && (A.SSECustomerKeyMD5 = d), h && (A.SSEKMSKeyId = h), i && (A.ACL = i), P = this._createNewS3Client(r), x.label = 2;
                    case 2:
                        return x.trys.push([2, 4, , 5]), [4, P.send(new im(A))];
                    case 3:
                        return x.sent(), iS(u, "copy", {
                            method: "copy",
                            result: "success"
                        }, null, "Copy success from " + m + " to " + w), [2, {key: w}];
                    case 4:
                        throw k = x.sent(), iS(u, "copy", {
                            method: "copy",
                            result: "failed"
                        }, null, "Copy failed from " + m + " to " + w), k;
                    case 5:
                        return [2]
                }
            }))
        }))
    }, e.prototype.get = function (e, t) {
        return YS(this, void 0, void 0, (function () {
            var n, r, i, o, s, a, u, c, l, f, d, h, p, g, v, m, y, S, w, b, E, C, _, A, P, k, x;
            return JS(this, (function (I) {
                switch (I.label) {
                    case 0:
                        return [4, this._ensureCredentials()];
                    case 1:
                        if (!I.sent() || !this._isWithCredentials(this._config)) throw new Error(Vy.NO_CREDENTIALS);
                        if (n = Object.assign({}, this._config, t), r = n.bucket, i = n.download, o = n.cacheControl, s = n.contentDisposition, a = n.contentEncoding, u = n.contentLanguage, c = n.contentType, l = n.expires, f = n.track, d = n.SSECustomerAlgorithm, h = n.SSECustomerKey, p = n.SSECustomerKeyMD5, g = n.progressCallback, v = this._prefix(n), m = v + e, y = new SS.exports.EventEmitter, S = this._createNewS3Client(n, y), ZS.debug("get " + e + " from " + m), w = {
                            Bucket: r,
                            Key: m
                        }, o && (w.ResponseCacheControl = o), s && (w.ResponseContentDisposition = s), a && (w.ResponseContentEncoding = a), u && (w.ResponseContentLanguage = u), c && (w.ResponseContentType = c), d && (w.SSECustomerAlgorithm = d), h && (w.SSECustomerKey = h), p && (w.SSECustomerKeyMD5 = p), !0 !== i) return [3, 5];
                        b = new am(w), I.label = 2;
                    case 2:
                        return I.trys.push([2, 4, , 5]), g && ("function" == typeof g ? y.on("sendDownloadProgress", (function (e) {
                            g(e)
                        })) : ZS.warn("progressCallback should be a function, not a " + typeof g)), [4, S.send(b)];
                    case 3:
                        return E = I.sent(), y.removeAllListeners("sendDownloadProgress"), iS(f, "download", {
                            method: "get",
                            result: "success"
                        }, {fileSize: Number(E.Body.size || E.Body.length)}, "Download success for " + e), [2, E];
                    case 4:
                        throw C = I.sent(), iS(f, "download", {
                            method: "get",
                            result: "failed"
                        }, null, "Download failed with " + C.message), C;
                    case 5:
                        return I.trys.push([5, 8, , 9]), _ = new gm($S({}, S.config)), [4, pm(S, new am(w))];
                    case 6:
                        return A = I.sent(), k = hm, [4, _.presign(A, {expiresIn: l || 900})];
                    case 7:
                        return P = k.apply(void 0, [I.sent()]), iS(f, "getSignedUrl", {
                            method: "get",
                            result: "success"
                        }, null, "Signed URL: " + P), [2, P];
                    case 8:
                        throw x = I.sent(), ZS.warn("get signed url error", x), iS(f, "getSignedUrl", {
                            method: "get",
                            result: "failed"
                        }, null, "Could not get a signed URL for " + e), x;
                    case 9:
                        return [2]
                }
            }))
        }))
    }, e.prototype.put = function (e, t, n) {
        var r = Object.assign({}, this._config, n), i = r.bucket, o = r.track, s = r.progressCallback, a = r.level,
            u = r.resumable, c = r.contentType, l = r.contentDisposition, f = r.contentEncoding, d = r.cacheControl,
            h = r.expires, p = r.metadata, g = r.tagging, v = r.acl, m = r.serverSideEncryption,
            y = r.SSECustomerAlgorithm, S = r.SSECustomerKey, w = r.SSECustomerKeyMD5, b = r.SSEKMSKeyId,
            E = {Bucket: i, Key: e, Body: t, ContentType: c || "binary/octet-stream"};
        d && (E.CacheControl = d), l && (E.ContentDisposition = l), f && (E.ContentEncoding = f), h && (E.Expires = h), p && (E.Metadata = p), g && (E.Tagging = g), m && (E.ServerSideEncryption = m), y && (E.SSECustomerAlgorithm = y), S && (E.SSECustomerKey = S), w && (E.SSECustomerKeyMD5 = w), b && (E.SSEKMSKeyId = b);
        var C = new SS.exports.EventEmitter, _ = new FS(E, r, C);
        if (v && (E.ACL = v), !0 === u) {
            var A = this._createNewS3Client(r);
            A.middlewareStack.add(hS(r, e), vS);
            var P = {bucket: i, key: e, s3Client: A, file: t, emitter: C, accessLevel: a, params: E};
            return this.startResumableUpload(P, n)
        }
        try {
            return s && ("function" == typeof s ? C.on("sendUploadProgress", (function (e) {
                s(e)
            })) : ZS.warn("progressCallback should be a function, not a " + typeof s)), _.upload().then((function (t) {
                return ZS.debug("upload result", t), iS(o, "upload", {
                    method: "put",
                    result: "success"
                }, null, "Upload success for " + e), {key: e}
            }))
        } catch (t) {
            throw ZS.warn("error uploading", t), iS(o, "upload", {
                method: "put",
                result: "failed"
            }, null, "Error uploading " + e), t
        }
    }, e.prototype.remove = function (e, t) {
        return YS(this, void 0, void 0, (function () {
            var n, r, i, o, s, a, u, c, l;
            return JS(this, (function (f) {
                switch (f.label) {
                    case 0:
                        return [4, this._ensureCredentials()];
                    case 1:
                        if (!f.sent() || !this._isWithCredentials(this._config)) throw new Error(Vy.NO_CREDENTIALS);
                        n = Object.assign({}, this._config, t), r = n.bucket, i = n.track, o = this._prefix(n), s = o + e, a = this._createNewS3Client(n), ZS.debug("remove " + e + " from " + s), u = new sm({
                            Bucket: r,
                            Key: s
                        }), f.label = 2;
                    case 2:
                        return f.trys.push([2, 4, , 5]), [4, a.send(u)];
                    case 3:
                        return c = f.sent(), iS(i, "delete", {
                            method: "remove",
                            result: "success"
                        }, null, "Deleted " + e + " successfully"), [2, c];
                    case 4:
                        throw l = f.sent(), iS(i, "delete", {
                            method: "remove",
                            result: "failed"
                        }, null, "Deletion of " + e + " failed with " + l), l;
                    case 5:
                        return [2]
                }
            }))
        }))
    }, e.prototype.list = function (e, t) {
        return YS(this, void 0, void 0, (function () {
            var n, r, i, o, s, a, u, c, l, f, d;
            return JS(this, (function (h) {
                switch (h.label) {
                    case 0:
                        return [4, this._ensureCredentials()];
                    case 1:
                        if (!h.sent() || !this._isWithCredentials(this._config)) throw new Error(Vy.NO_CREDENTIALS);
                        n = Object.assign({}, this._config, t), r = n.bucket, i = n.track, o = n.maxKeys, s = this._prefix(n), a = s + e, u = this._createNewS3Client(n), ZS.debug("list " + e + " from " + a), c = new um({
                            Bucket: r,
                            Prefix: a,
                            MaxKeys: o
                        }), h.label = 2;
                    case 2:
                        return h.trys.push([2, 4, , 5]), [4, u.send(c)];
                    case 3:
                        return l = h.sent(), f = [], l && l.Contents && (f = l.Contents.map((function (e) {
                            return {
                                key: e.Key.substr(s.length),
                                eTag: e.ETag,
                                lastModified: e.LastModified,
                                size: e.Size
                            }
                        }))), iS(i, "list", {
                            method: "list",
                            result: "success"
                        }, null, f.length + " items returned from list operation"), ZS.debug("list", f), [2, f];
                    case 4:
                        throw d = h.sent(), ZS.warn("list error", d), iS(i, "list", {
                            method: "list",
                            result: "failed"
                        }, null, "Listing items failed: " + d.message), d;
                    case 5:
                        return [2]
                }
            }))
        }))
    }, e.prototype._ensureCredentials = function () {
        return YS(this, void 0, void 0, (function () {
            var e, t, n;
            return JS(this, (function (r) {
                switch (r.label) {
                    case 0:
                        return r.trys.push([0, 2, , 3]), [4, Ss.get()];
                    case 1:
                        return (e = r.sent()) ? (t = Ss.shear(e), ZS.debug("set credentials for storage", t), this._config.credentials = t, [2, !0]) : [2, !1];
                    case 2:
                        return n = r.sent(), ZS.warn("ensure credentials error", n), [2, !1];
                    case 3:
                        return [2]
                }
            }))
        }))
    }, e.prototype._isWithCredentials = function (e) {
        return "object" == typeof e && e.hasOwnProperty("credentials")
    }, e.prototype._prefix = function (e) {
        var t = e.credentials, n = e.level, r = e.customPrefix || {}, i = e.identityId || t.identityId,
            o = (void 0 !== r.private ? r.private : "private/") + i + "/",
            s = (void 0 !== r.protected ? r.protected : "protected/") + i + "/",
            a = void 0 !== r.public ? r.public : "public/";
        switch (n) {
            case"private":
                return o;
            case"protected":
                return s;
            default:
                return a
        }
    }, e.prototype._createNewS3Client = function (e, t) {
        var n = yS(e, t);
        return n.middlewareStack.add(pS(n.config), gS), n
    }, e.CATEGORY = "Storage", e.PROVIDER_NAME = "AWSS3", e
}(), QS = function () {
    return QS = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var i in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
        return e
    }, QS.apply(this, arguments)
}, ew = function (e, t) {
    var n = "function" == typeof Symbol && e[Symbol.iterator];
    if (!n) return e;
    var r, i, o = n.call(e), s = [];
    try {
        for (; (void 0 === t || t-- > 0) && !(r = o.next()).done;) s.push(r.value)
    } catch (e) {
        i = {error: e}
    } finally {
        try {
            r && !r.done && (n = o.return) && n.call(o)
        } finally {
            if (i) throw i.error
        }
    }
    return s
}, tw = new o("StorageClass"), nw = function () {
    function e() {
        this._config = {}, this._pluggables = [], this._cancelTokenSourceMap = new WeakMap, tw.debug("Storage Options", this._config), this.get = this.get.bind(this), this.put = this.put.bind(this), this.remove = this.remove.bind(this), this.list = this.list.bind(this)
    }

    return e.prototype.getModuleName = function () {
        return "Storage"
    }, e.prototype.addPluggable = function (e) {
        if (e && "Storage" === e.getCategory()) {
            this._pluggables.push(e);
            return e.configure(this._config[e.getProviderName()])
        }
    }, e.prototype.getPluggable = function (e) {
        var t = this._pluggables.find((function (t) {
            return t.getProviderName() === e
        }));
        return void 0 === t ? (tw.debug("No plugin found with providerName", e), null) : t
    }, e.prototype.removePluggable = function (e) {
        this._pluggables = this._pluggables.filter((function (t) {
            return t.getProviderName() !== e
        }))
    }, e.prototype.configure = function (e) {
        var t = this;
        if (tw.debug("configure Storage"), !e) return this._config;
        var n = Le.parseMobilehubConfig(e), r = Object.keys(n.Storage),
            i = ["bucket", "region", "level", "track", "customPrefix", "serverSideEncryption", "SSECustomerAlgorithm", "SSECustomerKey", "SSECustomerKeyMD5", "SSEKMSKeyId"],
            o = function (e) {
                return i.some((function (t) {
                    return t === e
                }))
            };
        return r && r.find((function (e) {
            return o(e)
        })) && !n.Storage.AWSS3 && (n.Storage.AWSS3 = {}), Object.entries(n.Storage).map((function (e) {
            var t = ew(e, 2), r = t[0], i = t[1];
            r && o(r) && void 0 !== i && (n.Storage.AWSS3[r] = i, delete n.Storage[r])
        })), Object.keys(n.Storage).forEach((function (e) {
            "string" != typeof n.Storage[e] && (t._config[e] = QS(QS({}, t._config[e]), n.Storage[e]))
        })), this._pluggables.forEach((function (e) {
            e.configure(t._config[e.getProviderName()])
        })), 0 === this._pluggables.length && this.addPluggable(new XS), this._config
    }, e.prototype.getCancellableTokenSource = function () {
        return $y.CancelToken.source()
    }, e.prototype.updateRequestToBeCancellable = function (e, t) {
        this._cancelTokenSourceMap.set(e, t)
    }, e.prototype.isUploadTask = function (e) {
        return void 0 !== e && "function" == typeof e.pause && "function" == typeof e.resume
    }, e.prototype.cancel = function (e, t) {
        if (e instanceof WS) return e._cancel();
        var n = this._cancelTokenSourceMap.get(e);
        n ? n.cancel(t) : tw.debug("The request does not map to any cancel token")
    }, e.prototype.copy = function (e, t, n) {
        var r = (null == n ? void 0 : n.provider) || "AWSS3", i = this._pluggables.find((function (e) {
            return e.getProviderName() === r
        }));
        if (void 0 === i) return tw.debug("No plugin found with providerName", r), Promise.reject("No plugin found in Storage for the provider");
        var o = this.getCancellableTokenSource();
        if ("function" != typeof i.copy) return Promise.reject(".copy is not implemented on provider " + i.getProviderName());
        var s = i.copy(e, t, QS(QS({}, n), {cancelTokenSource: o}));
        return this.updateRequestToBeCancellable(s, o), s
    }, e.prototype.get = function (e, t) {
        var n = (null == t ? void 0 : t.provider) || "AWSS3", r = this._pluggables.find((function (e) {
            return e.getProviderName() === n
        }));
        if (void 0 === r) return tw.debug("No plugin found with providerName", n), Promise.reject("No plugin found in Storage for the provider");
        var i = this.getCancellableTokenSource(), o = r.get(e, QS(QS({}, t), {cancelTokenSource: i}));
        return this.updateRequestToBeCancellable(o, i), o
    }, e.prototype.isCancelError = function (e) {
        return $y.isCancel(e)
    }, e.prototype.put = function (e, t, n) {
        var r = (null == n ? void 0 : n.provider) || "AWSS3", i = this._pluggables.find((function (e) {
            return e.getProviderName() === r
        }));
        if (void 0 === i) return tw.debug("No plugin found with providerName", r), Promise.reject("No plugin found in Storage for the provider");
        var o = this.getCancellableTokenSource(), s = i.put(e, t, QS(QS({}, n), {cancelTokenSource: o}));
        return this.isUploadTask(s) || this.updateRequestToBeCancellable(s, o), s
    }, e.prototype.remove = function (e, t) {
        var n = (null == t ? void 0 : t.provider) || "AWSS3", r = this._pluggables.find((function (e) {
            return e.getProviderName() === n
        }));
        return void 0 === r ? (tw.debug("No plugin found with providerName", n), Promise.reject("No plugin found in Storage for the provider")) : r.remove(e, t)
    }, e.prototype.list = function (e, t) {
        var n = (null == t ? void 0 : t.provider) || "AWSS3", r = this._pluggables.find((function (e) {
            return e.getProviderName() === n
        }));
        return void 0 === r ? (tw.debug("No plugin found with providerName", n), Promise.reject("No plugin found in Storage for the provider")) : r.list(e, t)
    }, e
}(), rw = function () {
    return rw = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var i in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
        return e
    }, rw.apply(this, arguments)
}, iw = new o("Storage"), ow = null, sw = function () {
    if (ow) return ow;
    iw.debug("Create Storage Instance, debug"), (ow = new nw).vault = new nw;
    var e = ow.configure;
    return ow.configure = function (t) {
        iw.debug("storage configure called");
        var n = rw({}, e.call(ow, t));
        Object.keys(n).forEach((function (e) {
            "string" != typeof n[e] && (n[e] = rw(rw({}, n[e]), {level: "private"}))
        })), iw.debug("storage vault configure called"), ow.vault.configure(n)
    }, ow
}();
u.register(sw);
var aw = {exports: {}}, uw = (aw.exports = function (e) {
    var t = {};

    function n(r) {
        if (t[r]) return t[r].exports;
        var i = t[r] = {i: r, l: !1, exports: {}};
        return e[r].call(i.exports, i, i.exports, n), i.l = !0, i.exports
    }

    return n.m = e, n.c = t, n.d = function (e, t, r) {
        n.o(e, t) || Object.defineProperty(e, t, {enumerable: !0, get: r})
    }, n.r = function (e) {
        "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {value: "Module"}), Object.defineProperty(e, "__esModule", {value: !0})
    }, n.t = function (e, t) {
        if (1 & t && (e = n(e)), 8 & t) return e;
        if (4 & t && "object" == typeof e && e && e.__esModule) return e;
        var r = Object.create(null);
        if (n.r(r), Object.defineProperty(r, "default", {
            enumerable: !0,
            value: e
        }), 2 & t && "string" != typeof e) for (var i in e) n.d(r, i, function (t) {
            return e[t]
        }.bind(null, i));
        return r
    }, n.n = function (e) {
        var t = e && e.__esModule ? function () {
            return e.default
        } : function () {
            return e
        };
        return n.d(t, "a", t), t
    }, n.o = function (e, t) {
        return Object.prototype.hasOwnProperty.call(e, t)
    }, n.p = "", n(n.s = 0)
}([function (e, t, n) {
    function r(e) {
        for (var n in e) t.hasOwnProperty(n) || (t[n] = e[n])
    }

    Object.defineProperty(t, "__esModule", {value: !0}), r(n(1)), r(n(2)), r(n(3)), r(n(4)), r(n(5)), r(n(6)), r(n(7)), r(n(8)), r(n(9)), r(n(10)), r(n(11)), r(n(12)), r(n(13))
}, function (e, t, n) {
    e.exports = {a: "Anchor__a___1_Iz8"}
}, function (e, t, n) {
    e.exports = {
        button: "Button__button___vS7Mv",
        signInButton: "Button__signInButton___3bUH-",
        googleSignInButton: "Button__googleSignInButton___1YiCu",
        signInButtonIcon: "Button__signInButtonIcon___ihN75",
        auth0SignInButton: "Button__auth0SignInButton___znnCj",
        facebookSignInButton: "Button__facebookSignInButton___34Txh",
        amazonSignInButton: "Button__amazonSignInButton___2EMtl",
        oAuthSignInButton: "Button__oAuthSignInButton___3UGOl",
        signInButtonContent: "Button__signInButtonContent___xqTXJ"
    }
}, function (e, t, n) {
    e.exports = {
        formContainer: "Form__formContainer___1GA3x",
        formSection: "Form__formSection___1PPvW",
        formField: "Form__formField___38Ikl",
        formRow: "Form__formRow___2mwRs"
    }
}, function (e, t, n) {
    e.exports = {hint: "Hint__hint___2XngB"}
}, function (e, t, n) {
    e.exports = {
        input: "Input__input___3e_bf",
        inputLabel: "Input__inputLabel___3VF0S",
        label: "Input__label___23sO8",
        radio: "Input__radio___2hllK"
    }
}, function (e, t, n) {
    e.exports = {
        navBar: "Nav__navBar___xtCFA",
        navRight: "Nav__navRight___1QG2J",
        nav: "Nav__nav___2Dx2Y",
        navItem: "Nav__navItem___1LtFQ"
    }
}, function (e, t, n) {
    e.exports = {
        photoPickerButton: "PhotoPicker__photoPickerButton___2XdVn",
        photoPlaceholder: "PhotoPicker__photoPlaceholder___2JXO4",
        photoPlaceholderIcon: "PhotoPicker__photoPlaceholderIcon___3Et71"
    }
}, function (e, t, n) {
    e.exports = {
        container: "Section__container___3YYTG",
        actionRow: "Section__actionRow___2LWSU",
        sectionHeader: "Section__sectionHeader___2djyg",
        sectionHeaderHint: "Section__sectionHeaderHint___3Wxdc",
        sectionBody: "Section__sectionBody___ihqqd",
        sectionHeaderContent: "Section__sectionHeaderContent___1UCqa",
        sectionFooter: "Section__sectionFooter___1T54C",
        sectionFooterPrimaryContent: "Section__sectionFooterPrimaryContent___2r9ZX",
        sectionFooterSecondaryContent: "Section__sectionFooterSecondaryContent___Nj41Q"
    }
}, function (e, t, n) {
    e.exports = {selectInput: "SelectInput__selectInput___3efO4"}
}, function (e, t, n) {
    e.exports = {strike: "Strike__strike___1XV1b", strikeContent: "Strike__strikeContent___10gLb"}
}, function (e, t, n) {
    e.exports = {toast: "Toast__toast___XXr3v", toastClose: "Toast__toastClose___18lU4"}
}, function (e, t, n) {
    e.exports = {totpQrcode: "Totp__totpQrcode___1crLx"}
}, function (e, t, n) {
    e.exports = {
        sumerianSceneContainer: "XR__sumerianSceneContainer___3nVMt",
        sumerianScene: "XR__sumerianScene___2Tt7-",
        loadingOverlay: "XR__loadingOverlay___IbqcI",
        loadingContainer: "XR__loadingContainer___2Itxb",
        loadingLogo: "XR__loadingLogo___Ub7xQ",
        loadingSceneName: "XR__loadingSceneName___3__ne",
        loadingBar: "XR__loadingBar___2vcke",
        loadingBarFill: "XR__loadingBarFill___3M-D9",
        sceneErrorText: "XR__sceneErrorText___2y0tp",
        sceneBar: "XR__sceneBar___2ShrP",
        sceneName: "XR__sceneName___1ApHr",
        sceneActions: "XR__sceneActions___7plGs",
        actionButton: "XR__actionButton___2poIM",
        tooltip: "XR__tooltip___UYyhn",
        actionIcon: "XR__actionIcon___2qnd2",
        autoShowTooltip: "XR__autoShowTooltip___V1QH7"
    }
}])).Credentials;
export {
    u as Amplify,
    xu as Auth,
    Aa as CognitoAccessToken,
    ka as CognitoIdToken,
    xa as CognitoRefreshToken,
    Ua as CognitoUserSession,
    uw as Credentials,
    sw as Storage
};
